const base$1 = "";
const base = "";
const index$9 = "";
const index$8 = "";
const index$7 = "";
const index$6 = "";
const index$5 = "";
const index$4 = "";
const index$3 = "";
const index$2 = "";
const index$1 = "";
const index = "";
function makeMap(str, expectsLowerCase) {
  const map2 = /* @__PURE__ */ Object.create(null);
  const list = str.split(",");
  for (let i = 0; i < list.length; i++) {
    map2[list[i]] = true;
  }
  return expectsLowerCase ? (val) => !!map2[val.toLowerCase()] : (val) => !!map2[val];
}
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
function includeBooleanAttr(value) {
  return !!value || value === "";
}
function normalizeStyle(value) {
  if (isArray$1(value)) {
    const res = {};
    for (let i = 0; i < value.length; i++) {
      const item = value[i];
      const normalized = isString$1(item) ? parseStringStyle(item) : normalizeStyle(item);
      if (normalized) {
        for (const key in normalized) {
          res[key] = normalized[key];
        }
      }
    }
    return res;
  } else if (isString$1(value)) {
    return value;
  } else if (isObject$2(value)) {
    return value;
  }
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:(.+)/;
function parseStringStyle(cssText) {
  const ret = {};
  cssText.split(listDelimiterRE).forEach((item) => {
    if (item) {
      const tmp = item.split(propertyDelimiterRE);
      tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return ret;
}
function normalizeClass(value) {
  let res = "";
  if (isString$1(value)) {
    res = value;
  } else if (isArray$1(value)) {
    for (let i = 0; i < value.length; i++) {
      const normalized = normalizeClass(value[i]);
      if (normalized) {
        res += normalized + " ";
      }
    }
  } else if (isObject$2(value)) {
    for (const name2 in value) {
      if (value[name2]) {
        res += name2 + " ";
      }
    }
  }
  return res.trim();
}
const HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistanceLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
const isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
const toDisplayString = (val) => {
  return isString$1(val) ? val : val == null ? "" : isArray$1(val) || isObject$2(val) && (val.toString === objectToString || !isFunction$2(val.toString)) ? JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val) => {
  if (val && val.__v_isRef) {
    return replacer(_key, val.value);
  } else if (isMap(val)) {
    return {
      [`Map(${val.size})`]: [...val.entries()].reduce((entries, [key, val2]) => {
        entries[`${key} =>`] = val2;
        return entries;
      }, {})
    };
  } else if (isSet(val)) {
    return {
      [`Set(${val.size})`]: [...val.values()]
    };
  } else if (isObject$2(val) && !isArray$1(val) && !isPlainObject$1(val)) {
    return String(val);
  }
  return val;
};
const EMPTY_OBJ = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};
const EMPTY_ARR = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [];
const NOOP = () => {
};
const NO = () => false;
const onRE = /^on[^a-z]/;
const isOn = (key) => onRE.test(key);
const isModelListener = (key) => key.startsWith("onUpdate:");
const extend$2 = Object.assign;
const remove = (arr, el) => {
  const i = arr.indexOf(el);
  if (i > -1) {
    arr.splice(i, 1);
  }
};
const hasOwnProperty$1 = Object.prototype.hasOwnProperty;
const hasOwn = (val, key) => hasOwnProperty$1.call(val, key);
const isArray$1 = Array.isArray;
const isMap = (val) => toTypeString(val) === "[object Map]";
const isSet = (val) => toTypeString(val) === "[object Set]";
const isFunction$2 = (val) => typeof val === "function";
const isString$1 = (val) => typeof val === "string";
const isSymbol = (val) => typeof val === "symbol";
const isObject$2 = (val) => val !== null && typeof val === "object";
const isPromise$1 = (val) => {
  return isObject$2(val) && isFunction$2(val.then) && isFunction$2(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
const isPlainObject$1 = (val) => toTypeString(val) === "[object Object]";
const isIntegerKey = (key) => isString$1(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
);
const isBuiltInDirective = /* @__PURE__ */ makeMap("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
const camelizeRE$1 = /-(\w)/g;
const camelize$1 = cacheStringFunction((str) => {
  return str.replace(camelizeRE$1, (_, c) => c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str) => str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize = cacheStringFunction((str) => str.charAt(0).toUpperCase() + str.slice(1));
const toHandlerKey = cacheStringFunction((str) => str ? `on${capitalize(str)}` : ``);
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
const invokeArrayFns = (fns, arg) => {
  for (let i = 0; i < fns.length; i++) {
    fns[i](arg);
  }
};
const def = (obj, key, value) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    value
  });
};
const toNumber = (val) => {
  const n = parseFloat(val);
  return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = () => {
  return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function warn$1(msg, ...args) {
  console.warn(`[Vue warn] ${msg}`, ...args);
}
let activeEffectScope;
class EffectScope {
  constructor(detached = false) {
    this.active = true;
    this.effects = [];
    this.cleanups = [];
    if (!detached && activeEffectScope) {
      this.parent = activeEffectScope;
      this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
  }
  run(fn) {
    if (this.active) {
      const currentEffectScope = activeEffectScope;
      try {
        activeEffectScope = this;
        return fn();
      } finally {
        activeEffectScope = currentEffectScope;
      }
    } else if (process.env.NODE_ENV !== "production") {
      warn$1(`cannot run an inactive effect scope.`);
    }
  }
  on() {
    activeEffectScope = this;
  }
  off() {
    activeEffectScope = this.parent;
  }
  stop(fromParent) {
    if (this.active) {
      let i, l;
      for (i = 0, l = this.effects.length; i < l; i++) {
        this.effects[i].stop();
      }
      for (i = 0, l = this.cleanups.length; i < l; i++) {
        this.cleanups[i]();
      }
      if (this.scopes) {
        for (i = 0, l = this.scopes.length; i < l; i++) {
          this.scopes[i].stop(true);
        }
      }
      if (this.parent && !fromParent) {
        const last = this.parent.scopes.pop();
        if (last && last !== this) {
          this.parent.scopes[this.index] = last;
          last.index = this.index;
        }
      }
      this.active = false;
    }
  }
}
function recordEffectScope(effect, scope = activeEffectScope) {
  if (scope && scope.active) {
    scope.effects.push(effect);
  }
}
const createDep = (effects) => {
  const dep = new Set(effects);
  dep.w = 0;
  dep.n = 0;
  return dep;
};
const wasTracked = (dep) => (dep.w & trackOpBit) > 0;
const newTracked = (dep) => (dep.n & trackOpBit) > 0;
const initDepMarkers = ({ deps }) => {
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].w |= trackOpBit;
    }
  }
};
const finalizeDepMarkers = (effect) => {
  const { deps } = effect;
  if (deps.length) {
    let ptr = 0;
    for (let i = 0; i < deps.length; i++) {
      const dep = deps[i];
      if (wasTracked(dep) && !newTracked(dep)) {
        dep.delete(effect);
      } else {
        deps[ptr++] = dep;
      }
      dep.w &= ~trackOpBit;
      dep.n &= ~trackOpBit;
    }
    deps.length = ptr;
  }
};
const targetMap = /* @__PURE__ */ new WeakMap();
let effectTrackDepth = 0;
let trackOpBit = 1;
const maxMarkerBits = 30;
let activeEffect;
const ITERATE_KEY = Symbol(process.env.NODE_ENV !== "production" ? "iterate" : "");
const MAP_KEY_ITERATE_KEY = Symbol(process.env.NODE_ENV !== "production" ? "Map key iterate" : "");
class ReactiveEffect {
  constructor(fn, scheduler = null, scope) {
    this.fn = fn;
    this.scheduler = scheduler;
    this.active = true;
    this.deps = [];
    this.parent = void 0;
    recordEffectScope(this, scope);
  }
  run() {
    if (!this.active) {
      return this.fn();
    }
    let parent = activeEffect;
    let lastShouldTrack = shouldTrack;
    while (parent) {
      if (parent === this) {
        return;
      }
      parent = parent.parent;
    }
    try {
      this.parent = activeEffect;
      activeEffect = this;
      shouldTrack = true;
      trackOpBit = 1 << ++effectTrackDepth;
      if (effectTrackDepth <= maxMarkerBits) {
        initDepMarkers(this);
      } else {
        cleanupEffect(this);
      }
      return this.fn();
    } finally {
      if (effectTrackDepth <= maxMarkerBits) {
        finalizeDepMarkers(this);
      }
      trackOpBit = 1 << --effectTrackDepth;
      activeEffect = this.parent;
      shouldTrack = lastShouldTrack;
      this.parent = void 0;
      if (this.deferStop) {
        this.stop();
      }
    }
  }
  stop() {
    if (activeEffect === this) {
      this.deferStop = true;
    } else if (this.active) {
      cleanupEffect(this);
      if (this.onStop) {
        this.onStop();
      }
      this.active = false;
    }
  }
}
function cleanupEffect(effect) {
  const { deps } = effect;
  if (deps.length) {
    for (let i = 0; i < deps.length; i++) {
      deps[i].delete(effect);
    }
    deps.length = 0;
  }
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function track(target, type, key) {
  if (shouldTrack && activeEffect) {
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = createDep());
    }
    const eventInfo = process.env.NODE_ENV !== "production" ? { effect: activeEffect, target, type, key } : void 0;
    trackEffects(dep, eventInfo);
  }
}
function trackEffects(dep, debuggerEventExtraInfo) {
  let shouldTrack2 = false;
  if (effectTrackDepth <= maxMarkerBits) {
    if (!newTracked(dep)) {
      dep.n |= trackOpBit;
      shouldTrack2 = !wasTracked(dep);
    }
  } else {
    shouldTrack2 = !dep.has(activeEffect);
  }
  if (shouldTrack2) {
    dep.add(activeEffect);
    activeEffect.deps.push(dep);
    if (process.env.NODE_ENV !== "production" && activeEffect.onTrack) {
      activeEffect.onTrack(Object.assign({ effect: activeEffect }, debuggerEventExtraInfo));
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    return;
  }
  let deps = [];
  if (type === "clear") {
    deps = [...depsMap.values()];
  } else if (key === "length" && isArray$1(target)) {
    depsMap.forEach((dep, key2) => {
      if (key2 === "length" || key2 >= newValue) {
        deps.push(dep);
      }
    });
  } else {
    if (key !== void 0) {
      deps.push(depsMap.get(key));
    }
    switch (type) {
      case "add":
        if (!isArray$1(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        } else if (isIntegerKey(key)) {
          deps.push(depsMap.get("length"));
        }
        break;
      case "delete":
        if (!isArray$1(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
          if (isMap(target)) {
            deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
          }
        }
        break;
      case "set":
        if (isMap(target)) {
          deps.push(depsMap.get(ITERATE_KEY));
        }
        break;
    }
  }
  const eventInfo = process.env.NODE_ENV !== "production" ? { target, type, key, newValue, oldValue, oldTarget } : void 0;
  if (deps.length === 1) {
    if (deps[0]) {
      if (process.env.NODE_ENV !== "production") {
        triggerEffects(deps[0], eventInfo);
      } else {
        triggerEffects(deps[0]);
      }
    }
  } else {
    const effects = [];
    for (const dep of deps) {
      if (dep) {
        effects.push(...dep);
      }
    }
    if (process.env.NODE_ENV !== "production") {
      triggerEffects(createDep(effects), eventInfo);
    } else {
      triggerEffects(createDep(effects));
    }
  }
}
function triggerEffects(dep, debuggerEventExtraInfo) {
  const effects = isArray$1(dep) ? dep : [...dep];
  for (const effect of effects) {
    if (effect.computed) {
      triggerEffect(effect, debuggerEventExtraInfo);
    }
  }
  for (const effect of effects) {
    if (!effect.computed) {
      triggerEffect(effect, debuggerEventExtraInfo);
    }
  }
}
function triggerEffect(effect, debuggerEventExtraInfo) {
  if (effect !== activeEffect || effect.allowRecurse) {
    if (process.env.NODE_ENV !== "production" && effect.onTrigger) {
      effect.onTrigger(extend$2({ effect }, debuggerEventExtraInfo));
    }
    if (effect.scheduler) {
      effect.scheduler();
    } else {
      effect.run();
    }
  }
}
const isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
);
const get$1 = /* @__PURE__ */ createGetter();
const shallowGet = /* @__PURE__ */ createGetter(false, true);
const readonlyGet = /* @__PURE__ */ createGetter(true);
const shallowReadonlyGet = /* @__PURE__ */ createGetter(true, true);
const arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
  const instrumentations = {};
  ["includes", "indexOf", "lastIndexOf"].forEach((key) => {
    instrumentations[key] = function(...args) {
      const arr = toRaw(this);
      for (let i = 0, l = this.length; i < l; i++) {
        track(arr, "get", i + "");
      }
      const res = arr[key](...args);
      if (res === -1 || res === false) {
        return arr[key](...args.map(toRaw));
      } else {
        return res;
      }
    };
  });
  ["push", "pop", "shift", "unshift", "splice"].forEach((key) => {
    instrumentations[key] = function(...args) {
      pauseTracking();
      const res = toRaw(this)[key].apply(this, args);
      resetTracking();
      return res;
    };
  });
  return instrumentations;
}
function createGetter(isReadonly2 = false, shallow = false) {
  return function get2(target, key, receiver) {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_isShallow") {
      return shallow;
    } else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? shallowReadonlyMap : readonlyMap : shallow ? shallowReactiveMap : reactiveMap).get(target)) {
      return target;
    }
    const targetIsArray = isArray$1(target);
    if (!isReadonly2 && targetIsArray && hasOwn(arrayInstrumentations, key)) {
      return Reflect.get(arrayInstrumentations, key, receiver);
    }
    const res = Reflect.get(target, key, receiver);
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly2) {
      track(target, "get", key);
    }
    if (shallow) {
      return res;
    }
    if (isRef(res)) {
      return targetIsArray && isIntegerKey(key) ? res : res.value;
    }
    if (isObject$2(res)) {
      return isReadonly2 ? readonly(res) : reactive(res);
    }
    return res;
  };
}
const set = /* @__PURE__ */ createSetter();
const shallowSet = /* @__PURE__ */ createSetter(true);
function createSetter(shallow = false) {
  return function set2(target, key, value, receiver) {
    let oldValue = target[key];
    if (isReadonly(oldValue) && isRef(oldValue) && !isRef(value)) {
      return false;
    }
    if (!shallow && !isReadonly(value)) {
      if (!isShallow$1(value)) {
        value = toRaw(value);
        oldValue = toRaw(oldValue);
      }
      if (!isArray$1(target) && isRef(oldValue) && !isRef(value)) {
        oldValue.value = value;
        return true;
      }
    }
    const hadKey = isArray$1(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(target, key, value, receiver);
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value, oldValue);
      }
    }
    return result;
  };
}
function deleteProperty(target, key) {
  const hadKey = hasOwn(target, key);
  const oldValue = target[key];
  const result = Reflect.deleteProperty(target, key);
  if (result && hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function has(target, key) {
  const result = Reflect.has(target, key);
  if (!isSymbol(key) || !builtInSymbols.has(key)) {
    track(target, "has", key);
  }
  return result;
}
function ownKeys(target) {
  track(target, "iterate", isArray$1(target) ? "length" : ITERATE_KEY);
  return Reflect.ownKeys(target);
}
const mutableHandlers = {
  get: get$1,
  set,
  deleteProperty,
  has,
  ownKeys
};
const readonlyHandlers = {
  get: readonlyGet,
  set(target, key) {
    if (process.env.NODE_ENV !== "production") {
      warn$1(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  },
  deleteProperty(target, key) {
    if (process.env.NODE_ENV !== "production") {
      warn$1(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
    }
    return true;
  }
};
const shallowReactiveHandlers = /* @__PURE__ */ extend$2({}, mutableHandlers, {
  get: shallowGet,
  set: shallowSet
});
const shallowReadonlyHandlers = /* @__PURE__ */ extend$2({}, readonlyHandlers, {
  get: shallowReadonlyGet
});
const toShallow = (value) => value;
const getProto = (v) => Reflect.getPrototypeOf(v);
function get$1$1(target, key, isReadonly2 = false, isShallow2 = false) {
  target = target["__v_raw"];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (!isReadonly2) {
    if (key !== rawKey) {
      track(rawTarget, "get", key);
    }
    track(rawTarget, "get", rawKey);
  }
  const { has: has2 } = getProto(rawTarget);
  const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
  if (has2.call(rawTarget, key)) {
    return wrap(target.get(key));
  } else if (has2.call(rawTarget, rawKey)) {
    return wrap(target.get(rawKey));
  } else if (target !== rawTarget) {
    target.get(key);
  }
}
function has$1(key, isReadonly2 = false) {
  const target = this["__v_raw"];
  const rawTarget = toRaw(target);
  const rawKey = toRaw(key);
  if (!isReadonly2) {
    if (key !== rawKey) {
      track(rawTarget, "has", key);
    }
    track(rawTarget, "has", rawKey);
  }
  return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly2 = false) {
  target = target["__v_raw"];
  !isReadonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
  return Reflect.get(target, "size", target);
}
function add(value) {
  value = toRaw(value);
  const target = toRaw(this);
  const proto = getProto(target);
  const hadKey = proto.has.call(target, value);
  if (!hadKey) {
    target.add(value);
    trigger(target, "add", value, value);
  }
  return this;
}
function set$1(key, value) {
  value = toRaw(value);
  const target = toRaw(this);
  const { has: has2, get: get2 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else if (process.env.NODE_ENV !== "production") {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get2.call(target, key);
  target.set(key, value);
  if (!hadKey) {
    trigger(target, "add", key, value);
  } else if (hasChanged(value, oldValue)) {
    trigger(target, "set", key, value, oldValue);
  }
  return this;
}
function deleteEntry(key) {
  const target = toRaw(this);
  const { has: has2, get: get2 } = getProto(target);
  let hadKey = has2.call(target, key);
  if (!hadKey) {
    key = toRaw(key);
    hadKey = has2.call(target, key);
  } else if (process.env.NODE_ENV !== "production") {
    checkIdentityKeys(target, has2, key);
  }
  const oldValue = get2 ? get2.call(target, key) : void 0;
  const result = target.delete(key);
  if (hadKey) {
    trigger(target, "delete", key, void 0, oldValue);
  }
  return result;
}
function clear() {
  const target = toRaw(this);
  const hadItems = target.size !== 0;
  const oldTarget = process.env.NODE_ENV !== "production" ? isMap(target) ? new Map(target) : new Set(target) : void 0;
  const result = target.clear();
  if (hadItems) {
    trigger(target, "clear", void 0, void 0, oldTarget);
  }
  return result;
}
function createForEach(isReadonly2, isShallow2) {
  return function forEach3(callback, thisArg) {
    const observed = this;
    const target = observed["__v_raw"];
    const rawTarget = toRaw(target);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(rawTarget, "iterate", ITERATE_KEY);
    return target.forEach((value, key) => {
      return callback.call(thisArg, wrap(value), wrap(key), observed);
    });
  };
}
function createIterableMethod(method, isReadonly2, isShallow2) {
  return function(...args) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
    return {
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    if (process.env.NODE_ENV !== "production") {
      const key = args[0] ? `on key "${args[0]}" ` : ``;
      console.warn(`${capitalize(type)} operation ${key}failed: target is readonly.`, toRaw(this));
    }
    return type === "delete" ? false : this;
  };
}
function createInstrumentations() {
  const mutableInstrumentations2 = {
    get(key) {
      return get$1$1(this, key);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, false)
  };
  const shallowInstrumentations2 = {
    get(key) {
      return get$1$1(this, key, false, true);
    },
    get size() {
      return size(this);
    },
    has: has$1,
    add,
    set: set$1,
    delete: deleteEntry,
    clear,
    forEach: createForEach(false, true)
  };
  const readonlyInstrumentations2 = {
    get(key) {
      return get$1$1(this, key, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, false)
  };
  const shallowReadonlyInstrumentations2 = {
    get(key) {
      return get$1$1(this, key, true, true);
    },
    get size() {
      return size(this, true);
    },
    has(key) {
      return has$1.call(this, key, true);
    },
    add: createReadonlyMethod("add"),
    set: createReadonlyMethod("set"),
    delete: createReadonlyMethod("delete"),
    clear: createReadonlyMethod("clear"),
    forEach: createForEach(true, true)
  };
  const iteratorMethods = ["keys", "values", "entries", Symbol.iterator];
  iteratorMethods.forEach((method) => {
    mutableInstrumentations2[method] = createIterableMethod(method, false, false);
    readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
    shallowInstrumentations2[method] = createIterableMethod(method, false, true);
    shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
  });
  return [
    mutableInstrumentations2,
    readonlyInstrumentations2,
    shallowInstrumentations2,
    shallowReadonlyInstrumentations2
  ];
}
const [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly2, shallow) {
  const instrumentations = shallow ? isReadonly2 ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly2 ? readonlyInstrumentations : mutableInstrumentations;
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
  };
}
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has2, key) {
  const rawKey = toRaw(key);
  if (rawKey !== key && has2.call(target, rawKey)) {
    const type = toRawType(target);
    console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
  }
}
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive(target) {
  if (isReadonly(target)) {
    return target;
  }
  return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
  return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
  return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
  return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject$2(target)) {
    if (process.env.NODE_ENV !== "production") {
      console.warn(`value cannot be made reactive: ${String(target)}`);
    }
    return target;
  }
  if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
  proxyMap.set(target, proxy);
  return proxy;
}
function isReactive(value) {
  if (isReadonly(value)) {
    return isReactive(value["__v_raw"]);
  }
  return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
  return !!(value && value["__v_isReadonly"]);
}
function isShallow$1(value) {
  return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
  return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
  const raw = observed && observed["__v_raw"];
  return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
  def(value, "__v_skip", true);
  return value;
}
const toReactive = (value) => isObject$2(value) ? reactive(value) : value;
const toReadonly = (value) => isObject$2(value) ? readonly(value) : value;
function trackRefValue(ref2) {
  if (shouldTrack && activeEffect) {
    ref2 = toRaw(ref2);
    if (process.env.NODE_ENV !== "production") {
      trackEffects(ref2.dep || (ref2.dep = createDep()), {
        target: ref2,
        type: "get",
        key: "value"
      });
    } else {
      trackEffects(ref2.dep || (ref2.dep = createDep()));
    }
  }
}
function triggerRefValue(ref2, newVal) {
  ref2 = toRaw(ref2);
  if (ref2.dep) {
    if (process.env.NODE_ENV !== "production") {
      triggerEffects(ref2.dep, {
        target: ref2,
        type: "set",
        key: "value",
        newValue: newVal
      });
    } else {
      triggerEffects(ref2.dep);
    }
  }
}
function isRef(r) {
  return !!(r && r.__v_isRef === true);
}
function ref(value) {
  return createRef(value, false);
}
function createRef(rawValue, shallow) {
  if (isRef(rawValue)) {
    return rawValue;
  }
  return new RefImpl(rawValue, shallow);
}
class RefImpl {
  constructor(value, __v_isShallow) {
    this.__v_isShallow = __v_isShallow;
    this.dep = void 0;
    this.__v_isRef = true;
    this._rawValue = __v_isShallow ? value : toRaw(value);
    this._value = __v_isShallow ? value : toReactive(value);
  }
  get value() {
    trackRefValue(this);
    return this._value;
  }
  set value(newVal) {
    newVal = this.__v_isShallow ? newVal : toRaw(newVal);
    if (hasChanged(newVal, this._rawValue)) {
      this._rawValue = newVal;
      this._value = this.__v_isShallow ? newVal : toReactive(newVal);
      triggerRefValue(this, newVal);
    }
  }
}
function unref(ref2) {
  return isRef(ref2) ? ref2.value : ref2;
}
const shallowUnwrapHandlers = {
  get: (target, key, receiver) => unref(Reflect.get(target, key, receiver)),
  set: (target, key, value, receiver) => {
    const oldValue = target[key];
    if (isRef(oldValue) && !isRef(value)) {
      oldValue.value = value;
      return true;
    } else {
      return Reflect.set(target, key, value, receiver);
    }
  }
};
function proxyRefs(objectWithRefs) {
  return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class ObjectRefImpl {
  constructor(_object, _key, _defaultValue) {
    this._object = _object;
    this._key = _key;
    this._defaultValue = _defaultValue;
    this.__v_isRef = true;
  }
  get value() {
    const val = this._object[this._key];
    return val === void 0 ? this._defaultValue : val;
  }
  set value(newVal) {
    this._object[this._key] = newVal;
  }
}
function toRef(object, key, defaultValue) {
  const val = object[key];
  return isRef(val) ? val : new ObjectRefImpl(object, key, defaultValue);
}
class ComputedRefImpl {
  constructor(getter, _setter, isReadonly2, isSSR) {
    this._setter = _setter;
    this.dep = void 0;
    this.__v_isRef = true;
    this._dirty = true;
    this.effect = new ReactiveEffect(getter, () => {
      if (!this._dirty) {
        this._dirty = true;
        triggerRefValue(this);
      }
    });
    this.effect.computed = this;
    this.effect.active = this._cacheable = !isSSR;
    this["__v_isReadonly"] = isReadonly2;
  }
  get value() {
    const self2 = toRaw(this);
    trackRefValue(self2);
    if (self2._dirty || !self2._cacheable) {
      self2._dirty = false;
      self2._value = self2.effect.run();
    }
    return self2._value;
  }
  set value(newValue) {
    this._setter(newValue);
  }
}
function computed$1(getterOrOptions, debugOptions, isSSR = false) {
  let getter;
  let setter;
  const onlyGetter = isFunction$2(getterOrOptions);
  if (onlyGetter) {
    getter = getterOrOptions;
    setter = process.env.NODE_ENV !== "production" ? () => {
      console.warn("Write operation failed: computed value is readonly");
    } : NOOP;
  } else {
    getter = getterOrOptions.get;
    setter = getterOrOptions.set;
  }
  const cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
  if (process.env.NODE_ENV !== "production" && debugOptions && !isSSR) {
    cRef.effect.onTrack = debugOptions.onTrack;
    cRef.effect.onTrigger = debugOptions.onTrigger;
  }
  return cRef;
}
const stack = [];
function pushWarningContext(vnode) {
  stack.push(vnode);
}
function popWarningContext() {
  stack.pop();
}
function warn(msg, ...args) {
  pauseTracking();
  const instance2 = stack.length ? stack[stack.length - 1].component : null;
  const appWarnHandler = instance2 && instance2.appContext.config.warnHandler;
  const trace = getComponentTrace();
  if (appWarnHandler) {
    callWithErrorHandling(appWarnHandler, instance2, 11, [
      msg + args.join(""),
      instance2 && instance2.proxy,
      trace.map(({ vnode }) => `at <${formatComponentName(instance2, vnode.type)}>`).join("\n"),
      trace
    ]);
  } else {
    const warnArgs = [`[Vue warn]: ${msg}`, ...args];
    if (trace.length && true) {
      warnArgs.push(`
`, ...formatTrace(trace));
    }
    console.warn(...warnArgs);
  }
  resetTracking();
}
function getComponentTrace() {
  let currentVNode = stack[stack.length - 1];
  if (!currentVNode) {
    return [];
  }
  const normalizedStack = [];
  while (currentVNode) {
    const last = normalizedStack[0];
    if (last && last.vnode === currentVNode) {
      last.recurseCount++;
    } else {
      normalizedStack.push({
        vnode: currentVNode,
        recurseCount: 0
      });
    }
    const parentInstance = currentVNode.component && currentVNode.component.parent;
    currentVNode = parentInstance && parentInstance.vnode;
  }
  return normalizedStack;
}
function formatTrace(trace) {
  const logs = [];
  trace.forEach((entry, i) => {
    logs.push(...i === 0 ? [] : [`
`], ...formatTraceEntry(entry));
  });
  return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
  const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
  const isRoot = vnode.component ? vnode.component.parent == null : false;
  const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
  const close = `>` + postfix;
  return vnode.props ? [open, ...formatProps(vnode.props), close] : [open + close];
}
function formatProps(props) {
  const res = [];
  const keys = Object.keys(props);
  keys.slice(0, 3).forEach((key) => {
    res.push(...formatProp(key, props[key]));
  });
  if (keys.length > 3) {
    res.push(` ...`);
  }
  return res;
}
function formatProp(key, value, raw) {
  if (isString$1(value)) {
    value = JSON.stringify(value);
    return raw ? value : [`${key}=${value}`];
  } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
    return raw ? value : [`${key}=${value}`];
  } else if (isRef(value)) {
    value = formatProp(key, toRaw(value.value), true);
    return raw ? value : [`${key}=Ref<`, value, `>`];
  } else if (isFunction$2(value)) {
    return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
  } else {
    value = toRaw(value);
    return raw ? value : [`${key}=`, value];
  }
}
const ErrorTypeStrings = {
  ["sp"]: "serverPrefetch hook",
  ["bc"]: "beforeCreate hook",
  ["c"]: "created hook",
  ["bm"]: "beforeMount hook",
  ["m"]: "mounted hook",
  ["bu"]: "beforeUpdate hook",
  ["u"]: "updated",
  ["bum"]: "beforeUnmount hook",
  ["um"]: "unmounted hook",
  ["a"]: "activated hook",
  ["da"]: "deactivated hook",
  ["ec"]: "errorCaptured hook",
  ["rtc"]: "renderTracked hook",
  ["rtg"]: "renderTriggered hook",
  [0]: "setup function",
  [1]: "render function",
  [2]: "watcher getter",
  [3]: "watcher callback",
  [4]: "watcher cleanup function",
  [5]: "native event handler",
  [6]: "component event handler",
  [7]: "vnode hook",
  [8]: "directive hook",
  [9]: "transition hook",
  [10]: "app errorHandler",
  [11]: "app warnHandler",
  [12]: "ref function",
  [13]: "async component loader",
  [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function callWithErrorHandling(fn, instance2, type, args) {
  let res;
  try {
    res = args ? fn(...args) : fn();
  } catch (err) {
    handleError(err, instance2, type);
  }
  return res;
}
function callWithAsyncErrorHandling(fn, instance2, type, args) {
  if (isFunction$2(fn)) {
    const res = callWithErrorHandling(fn, instance2, type, args);
    if (res && isPromise$1(res)) {
      res.catch((err) => {
        handleError(err, instance2, type);
      });
    }
    return res;
  }
  const values = [];
  for (let i = 0; i < fn.length; i++) {
    values.push(callWithAsyncErrorHandling(fn[i], instance2, type, args));
  }
  return values;
}
function handleError(err, instance2, type, throwInDev = true) {
  const contextVNode = instance2 ? instance2.vnode : null;
  if (instance2) {
    let cur = instance2.parent;
    const exposedInstance = instance2.proxy;
    const errorInfo = process.env.NODE_ENV !== "production" ? ErrorTypeStrings[type] : type;
    while (cur) {
      const errorCapturedHooks = cur.ec;
      if (errorCapturedHooks) {
        for (let i = 0; i < errorCapturedHooks.length; i++) {
          if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
            return;
          }
        }
      }
      cur = cur.parent;
    }
    const appErrorHandler = instance2.appContext.config.errorHandler;
    if (appErrorHandler) {
      callWithErrorHandling(appErrorHandler, null, 10, [err, exposedInstance, errorInfo]);
      return;
    }
  }
  logError(err, type, contextVNode, throwInDev);
}
function logError(err, type, contextVNode, throwInDev = true) {
  if (process.env.NODE_ENV !== "production") {
    const info = ErrorTypeStrings[type];
    if (contextVNode) {
      pushWarningContext(contextVNode);
    }
    warn(`Unhandled error${info ? ` during execution of ${info}` : ``}`);
    if (contextVNode) {
      popWarningContext();
    }
    if (throwInDev) {
      throw err;
    } else {
      console.error(err);
    }
  } else {
    console.error(err);
  }
}
let isFlushing = false;
let isFlushPending = false;
const queue = [];
let flushIndex = 0;
const pendingPreFlushCbs = [];
let activePreFlushCbs = null;
let preFlushIndex = 0;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
let currentPreFlushParentJob = null;
const RECURSION_LIMIT = 100;
function nextTick(fn) {
  const p2 = currentFlushPromise || resolvedPromise;
  return fn ? p2.then(this ? fn.bind(this) : fn) : p2;
}
function findInsertionIndex(id) {
  let start = flushIndex + 1;
  let end = queue.length;
  while (start < end) {
    const middle = start + end >>> 1;
    const middleJobId = getId(queue[middle]);
    middleJobId < id ? start = middle + 1 : end = middle;
  }
  return start;
}
function queueJob(job) {
  if ((!queue.length || !queue.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) && job !== currentPreFlushParentJob) {
    if (job.id == null) {
      queue.push(job);
    } else {
      queue.splice(findInsertionIndex(job.id), 0, job);
    }
    queueFlush();
  }
}
function queueFlush() {
  if (!isFlushing && !isFlushPending) {
    isFlushPending = true;
    currentFlushPromise = resolvedPromise.then(flushJobs);
  }
}
function invalidateJob(job) {
  const i = queue.indexOf(job);
  if (i > flushIndex) {
    queue.splice(i, 1);
  }
}
function queueCb(cb, activeQueue, pendingQueue, index2) {
  if (!isArray$1(cb)) {
    if (!activeQueue || !activeQueue.includes(cb, cb.allowRecurse ? index2 + 1 : index2)) {
      pendingQueue.push(cb);
    }
  } else {
    pendingQueue.push(...cb);
  }
  queueFlush();
}
function queuePreFlushCb(cb) {
  queueCb(cb, activePreFlushCbs, pendingPreFlushCbs, preFlushIndex);
}
function queuePostFlushCb(cb) {
  queueCb(cb, activePostFlushCbs, pendingPostFlushCbs, postFlushIndex);
}
function flushPreFlushCbs(seen, parentJob = null) {
  if (pendingPreFlushCbs.length) {
    currentPreFlushParentJob = parentJob;
    activePreFlushCbs = [...new Set(pendingPreFlushCbs)];
    pendingPreFlushCbs.length = 0;
    if (process.env.NODE_ENV !== "production") {
      seen = seen || /* @__PURE__ */ new Map();
    }
    for (preFlushIndex = 0; preFlushIndex < activePreFlushCbs.length; preFlushIndex++) {
      if (process.env.NODE_ENV !== "production" && checkRecursiveUpdates(seen, activePreFlushCbs[preFlushIndex])) {
        continue;
      }
      activePreFlushCbs[preFlushIndex]();
    }
    activePreFlushCbs = null;
    preFlushIndex = 0;
    currentPreFlushParentJob = null;
    flushPreFlushCbs(seen, parentJob);
  }
}
function flushPostFlushCbs(seen) {
  flushPreFlushCbs();
  if (pendingPostFlushCbs.length) {
    const deduped = [...new Set(pendingPostFlushCbs)];
    pendingPostFlushCbs.length = 0;
    if (activePostFlushCbs) {
      activePostFlushCbs.push(...deduped);
      return;
    }
    activePostFlushCbs = deduped;
    if (process.env.NODE_ENV !== "production") {
      seen = seen || /* @__PURE__ */ new Map();
    }
    activePostFlushCbs.sort((a, b) => getId(a) - getId(b));
    for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
      if (process.env.NODE_ENV !== "production" && checkRecursiveUpdates(seen, activePostFlushCbs[postFlushIndex])) {
        continue;
      }
      activePostFlushCbs[postFlushIndex]();
    }
    activePostFlushCbs = null;
    postFlushIndex = 0;
  }
}
const getId = (job) => job.id == null ? Infinity : job.id;
function flushJobs(seen) {
  isFlushPending = false;
  isFlushing = true;
  if (process.env.NODE_ENV !== "production") {
    seen = seen || /* @__PURE__ */ new Map();
  }
  flushPreFlushCbs(seen);
  queue.sort((a, b) => getId(a) - getId(b));
  const check = process.env.NODE_ENV !== "production" ? (job) => checkRecursiveUpdates(seen, job) : NOOP;
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job && job.active !== false) {
        if (process.env.NODE_ENV !== "production" && check(job)) {
          continue;
        }
        callWithErrorHandling(job, null, 14);
      }
    }
  } finally {
    flushIndex = 0;
    queue.length = 0;
    flushPostFlushCbs(seen);
    isFlushing = false;
    currentFlushPromise = null;
    if (queue.length || pendingPreFlushCbs.length || pendingPostFlushCbs.length) {
      flushJobs(seen);
    }
  }
}
function checkRecursiveUpdates(seen, fn) {
  if (!seen.has(fn)) {
    seen.set(fn, 1);
  } else {
    const count = seen.get(fn);
    if (count > RECURSION_LIMIT) {
      const instance2 = fn.ownerInstance;
      const componentName = instance2 && getComponentName(instance2.type);
      warn(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
      return true;
    } else {
      seen.set(fn, count + 1);
    }
  }
}
let isHmrUpdating = false;
const hmrDirtyComponents = /* @__PURE__ */ new Set();
if (process.env.NODE_ENV !== "production") {
  getGlobalThis().__VUE_HMR_RUNTIME__ = {
    createRecord: tryWrap(createRecord),
    rerender: tryWrap(rerender),
    reload: tryWrap(reload)
  };
}
const map = /* @__PURE__ */ new Map();
function registerHMR(instance2) {
  const id = instance2.type.__hmrId;
  let record = map.get(id);
  if (!record) {
    createRecord(id, instance2.type);
    record = map.get(id);
  }
  record.instances.add(instance2);
}
function unregisterHMR(instance2) {
  map.get(instance2.type.__hmrId).instances.delete(instance2);
}
function createRecord(id, initialDef) {
  if (map.has(id)) {
    return false;
  }
  map.set(id, {
    initialDef: normalizeClassComponent(initialDef),
    instances: /* @__PURE__ */ new Set()
  });
  return true;
}
function normalizeClassComponent(component) {
  return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
  const record = map.get(id);
  if (!record) {
    return;
  }
  record.initialDef.render = newRender;
  [...record.instances].forEach((instance2) => {
    if (newRender) {
      instance2.render = newRender;
      normalizeClassComponent(instance2.type).render = newRender;
    }
    instance2.renderCache = [];
    isHmrUpdating = true;
    instance2.update();
    isHmrUpdating = false;
  });
}
function reload(id, newComp) {
  const record = map.get(id);
  if (!record)
    return;
  newComp = normalizeClassComponent(newComp);
  updateComponentDef(record.initialDef, newComp);
  const instances = [...record.instances];
  for (const instance2 of instances) {
    const oldComp = normalizeClassComponent(instance2.type);
    if (!hmrDirtyComponents.has(oldComp)) {
      if (oldComp !== record.initialDef) {
        updateComponentDef(oldComp, newComp);
      }
      hmrDirtyComponents.add(oldComp);
    }
    instance2.appContext.optionsCache.delete(instance2.type);
    if (instance2.ceReload) {
      hmrDirtyComponents.add(oldComp);
      instance2.ceReload(newComp.styles);
      hmrDirtyComponents.delete(oldComp);
    } else if (instance2.parent) {
      queueJob(instance2.parent.update);
      if (instance2.parent.type.__asyncLoader && instance2.parent.ceReload) {
        instance2.parent.ceReload(newComp.styles);
      }
    } else if (instance2.appContext.reload) {
      instance2.appContext.reload();
    } else if (typeof window !== "undefined") {
      window.location.reload();
    } else {
      console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
  }
  queuePostFlushCb(() => {
    for (const instance2 of instances) {
      hmrDirtyComponents.delete(normalizeClassComponent(instance2.type));
    }
  });
}
function updateComponentDef(oldComp, newComp) {
  extend$2(oldComp, newComp);
  for (const key in oldComp) {
    if (key !== "__file" && !(key in newComp)) {
      delete oldComp[key];
    }
  }
}
function tryWrap(fn) {
  return (id, arg) => {
    try {
      return fn(id, arg);
    } catch (e) {
      console.error(e);
      console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
    }
  };
}
let devtools;
let buffer = [];
let devtoolsNotInstalled = false;
function emit(event, ...args) {
  if (devtools) {
    devtools.emit(event, ...args);
  } else if (!devtoolsNotInstalled) {
    buffer.push({ event, args });
  }
}
function setDevtoolsHook(hook, target) {
  var _a2, _b;
  devtools = hook;
  if (devtools) {
    devtools.enabled = true;
    buffer.forEach(({ event, args }) => devtools.emit(event, ...args));
    buffer = [];
  } else if (typeof window !== "undefined" && window.HTMLElement && !((_b = (_a2 = window.navigator) === null || _a2 === void 0 ? void 0 : _a2.userAgent) === null || _b === void 0 ? void 0 : _b.includes("jsdom"))) {
    const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
    replay.push((newHook) => {
      setDevtoolsHook(newHook, target);
    });
    setTimeout(() => {
      if (!devtools) {
        target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
        devtoolsNotInstalled = true;
        buffer = [];
      }
    }, 3e3);
  } else {
    devtoolsNotInstalled = true;
    buffer = [];
  }
}
function devtoolsInitApp(app, version2) {
  emit("app:init", app, version2, {
    Fragment,
    Text,
    Comment,
    Static
  });
}
function devtoolsUnmountApp(app) {
  emit("app:unmount", app);
}
const devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added");
const devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated");
const devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed");
function createDevtoolsComponentHook(hook) {
  return (component) => {
    emit(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
  };
}
const devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start");
const devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end");
function createDevtoolsPerformanceHook(hook) {
  return (component, type, time) => {
    emit(hook, component.appContext.app, component.uid, component, type, time);
  };
}
function devtoolsComponentEmit(component, event, params) {
  emit("component:emit", component.appContext.app, component, event, params);
}
function emit$1(instance2, event, ...rawArgs) {
  if (instance2.isUnmounted)
    return;
  const props = instance2.vnode.props || EMPTY_OBJ;
  if (process.env.NODE_ENV !== "production") {
    const { emitsOptions, propsOptions: [propsOptions] } = instance2;
    if (emitsOptions) {
      if (!(event in emitsOptions) && true) {
        if (!propsOptions || !(toHandlerKey(event) in propsOptions)) {
          warn(`Component emitted event "${event}" but it is neither declared in the emits option nor as an "${toHandlerKey(event)}" prop.`);
        }
      } else {
        const validator2 = emitsOptions[event];
        if (isFunction$2(validator2)) {
          const isValid = validator2(...rawArgs);
          if (!isValid) {
            warn(`Invalid event arguments: event validation failed for event "${event}".`);
          }
        }
      }
    }
  }
  let args = rawArgs;
  const isModelListener2 = event.startsWith("update:");
  const modelArg = isModelListener2 && event.slice(7);
  if (modelArg && modelArg in props) {
    const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
    const { number, trim: trim2 } = props[modifiersKey] || EMPTY_OBJ;
    if (trim2) {
      args = rawArgs.map((a) => a.trim());
    }
    if (number) {
      args = rawArgs.map(toNumber);
    }
  }
  if (process.env.NODE_ENV !== "production" || false) {
    devtoolsComponentEmit(instance2, event, args);
  }
  if (process.env.NODE_ENV !== "production") {
    const lowerCaseEvent = event.toLowerCase();
    if (lowerCaseEvent !== event && props[toHandlerKey(lowerCaseEvent)]) {
      warn(`Event "${lowerCaseEvent}" is emitted in component ${formatComponentName(instance2, instance2.type)} but the handler is registered for "${event}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${hyphenate(event)}" instead of "${event}".`);
    }
  }
  let handlerName;
  let handler = props[handlerName = toHandlerKey(event)] || props[handlerName = toHandlerKey(camelize$1(event))];
  if (!handler && isModelListener2) {
    handler = props[handlerName = toHandlerKey(hyphenate(event))];
  }
  if (handler) {
    callWithAsyncErrorHandling(handler, instance2, 6, args);
  }
  const onceHandler = props[handlerName + `Once`];
  if (onceHandler) {
    if (!instance2.emitted) {
      instance2.emitted = {};
    } else if (instance2.emitted[handlerName]) {
      return;
    }
    instance2.emitted[handlerName] = true;
    callWithAsyncErrorHandling(onceHandler, instance2, 6, args);
  }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
  const cache = appContext.emitsCache;
  const cached = cache.get(comp);
  if (cached !== void 0) {
    return cached;
  }
  const raw = comp.emits;
  let normalized = {};
  let hasExtends = false;
  if (!isFunction$2(comp)) {
    const extendEmits = (raw2) => {
      const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
      if (normalizedFromExtend) {
        hasExtends = true;
        extend$2(normalized, normalizedFromExtend);
      }
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendEmits);
    }
    if (comp.extends) {
      extendEmits(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendEmits);
    }
  }
  if (!raw && !hasExtends) {
    cache.set(comp, null);
    return null;
  }
  if (isArray$1(raw)) {
    raw.forEach((key) => normalized[key] = null);
  } else {
    extend$2(normalized, raw);
  }
  cache.set(comp, normalized);
  return normalized;
}
function isEmitListener(options, key) {
  if (!options || !isOn(key)) {
    return false;
  }
  key = key.slice(2).replace(/Once$/, "");
  return hasOwn(options, key[0].toLowerCase() + key.slice(1)) || hasOwn(options, hyphenate(key)) || hasOwn(options, key);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance2) {
  const prev = currentRenderingInstance;
  currentRenderingInstance = instance2;
  currentScopeId = instance2 && instance2.type.__scopeId || null;
  return prev;
}
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
  if (!ctx)
    return fn;
  if (fn._n) {
    return fn;
  }
  const renderFnWithContext = (...args) => {
    if (renderFnWithContext._d) {
      setBlockTracking(-1);
    }
    const prevInstance = setCurrentRenderingInstance(ctx);
    const res = fn(...args);
    setCurrentRenderingInstance(prevInstance);
    if (renderFnWithContext._d) {
      setBlockTracking(1);
    }
    if (process.env.NODE_ENV !== "production" || false) {
      devtoolsComponentUpdated(ctx);
    }
    return res;
  };
  renderFnWithContext._n = true;
  renderFnWithContext._c = true;
  renderFnWithContext._d = true;
  return renderFnWithContext;
}
let accessedAttrs = false;
function markAttrsAccessed() {
  accessedAttrs = true;
}
function renderComponentRoot(instance2) {
  const { type: Component, vnode, proxy, withProxy, props, propsOptions: [propsOptions], slots, attrs, emit: emit2, render: render2, renderCache, data: data2, setupState, ctx, inheritAttrs } = instance2;
  let result;
  let fallthroughAttrs;
  const prev = setCurrentRenderingInstance(instance2);
  if (process.env.NODE_ENV !== "production") {
    accessedAttrs = false;
  }
  try {
    if (vnode.shapeFlag & 4) {
      const proxyToUse = withProxy || proxy;
      result = normalizeVNode(render2.call(proxyToUse, proxyToUse, renderCache, props, setupState, data2, ctx));
      fallthroughAttrs = attrs;
    } else {
      const render3 = Component;
      if (process.env.NODE_ENV !== "production" && attrs === props) {
        markAttrsAccessed();
      }
      result = normalizeVNode(render3.length > 1 ? render3(props, process.env.NODE_ENV !== "production" ? {
        get attrs() {
          markAttrsAccessed();
          return attrs;
        },
        slots,
        emit: emit2
      } : { attrs, slots, emit: emit2 }) : render3(props, null));
      fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
    }
  } catch (err) {
    blockStack.length = 0;
    handleError(err, instance2, 1);
    result = createVNode(Comment);
  }
  let root = result;
  let setRoot = void 0;
  if (process.env.NODE_ENV !== "production" && result.patchFlag > 0 && result.patchFlag & 2048) {
    [root, setRoot] = getChildRoot(result);
  }
  if (fallthroughAttrs && inheritAttrs !== false) {
    const keys = Object.keys(fallthroughAttrs);
    const { shapeFlag } = root;
    if (keys.length) {
      if (shapeFlag & (1 | 6)) {
        if (propsOptions && keys.some(isModelListener)) {
          fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
        }
        root = cloneVNode(root, fallthroughAttrs);
      } else if (process.env.NODE_ENV !== "production" && !accessedAttrs && root.type !== Comment) {
        const allAttrs = Object.keys(attrs);
        const eventAttrs = [];
        const extraAttrs = [];
        for (let i = 0, l = allAttrs.length; i < l; i++) {
          const key = allAttrs[i];
          if (isOn(key)) {
            if (!isModelListener(key)) {
              eventAttrs.push(key[2].toLowerCase() + key.slice(3));
            }
          } else {
            extraAttrs.push(key);
          }
        }
        if (extraAttrs.length) {
          warn(`Extraneous non-props attributes (${extraAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`);
        }
        if (eventAttrs.length) {
          warn(`Extraneous non-emits event listeners (${eventAttrs.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`);
        }
      }
    }
  }
  if (vnode.dirs) {
    if (process.env.NODE_ENV !== "production" && !isElementRoot(root)) {
      warn(`Runtime directive used on component with non-element root node. The directives will not function as intended.`);
    }
    root = cloneVNode(root);
    root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
  }
  if (vnode.transition) {
    if (process.env.NODE_ENV !== "production" && !isElementRoot(root)) {
      warn(`Component inside <Transition> renders non-element root node that cannot be animated.`);
    }
    root.transition = vnode.transition;
  }
  if (process.env.NODE_ENV !== "production" && setRoot) {
    setRoot(root);
  } else {
    result = root;
  }
  setCurrentRenderingInstance(prev);
  return result;
}
const getChildRoot = (vnode) => {
  const rawChildren = vnode.children;
  const dynamicChildren = vnode.dynamicChildren;
  const childRoot = filterSingleRoot(rawChildren);
  if (!childRoot) {
    return [vnode, void 0];
  }
  const index2 = rawChildren.indexOf(childRoot);
  const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
  const setRoot = (updatedRoot) => {
    rawChildren[index2] = updatedRoot;
    if (dynamicChildren) {
      if (dynamicIndex > -1) {
        dynamicChildren[dynamicIndex] = updatedRoot;
      } else if (updatedRoot.patchFlag > 0) {
        vnode.dynamicChildren = [...dynamicChildren, updatedRoot];
      }
    }
  };
  return [normalizeVNode(childRoot), setRoot];
};
function filterSingleRoot(children) {
  let singleRoot;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (isVNode(child)) {
      if (child.type !== Comment || child.children === "v-if") {
        if (singleRoot) {
          return;
        } else {
          singleRoot = child;
        }
      }
    } else {
      return;
    }
  }
  return singleRoot;
}
const getFunctionalFallthrough = (attrs) => {
  let res;
  for (const key in attrs) {
    if (key === "class" || key === "style" || isOn(key)) {
      (res || (res = {}))[key] = attrs[key];
    }
  }
  return res;
};
const filterModelListeners = (attrs, props) => {
  const res = {};
  for (const key in attrs) {
    if (!isModelListener(key) || !(key.slice(9) in props)) {
      res[key] = attrs[key];
    }
  }
  return res;
};
const isElementRoot = (vnode) => {
  return vnode.shapeFlag & (6 | 1) || vnode.type === Comment;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
  const { props: prevProps, children: prevChildren, component } = prevVNode;
  const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
  const emits = component.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (prevChildren || nextChildren) && isHmrUpdating) {
    return true;
  }
  if (nextVNode.dirs || nextVNode.transition) {
    return true;
  }
  if (optimized && patchFlag >= 0) {
    if (patchFlag & 1024) {
      return true;
    }
    if (patchFlag & 16) {
      if (!prevProps) {
        return !!nextProps;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    } else if (patchFlag & 8) {
      const dynamicProps = nextVNode.dynamicProps;
      for (let i = 0; i < dynamicProps.length; i++) {
        const key = dynamicProps[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
          return true;
        }
      }
    }
  } else {
    if (prevChildren || nextChildren) {
      if (!nextChildren || !nextChildren.$stable) {
        return true;
      }
    }
    if (prevProps === nextProps) {
      return false;
    }
    if (!prevProps) {
      return !!nextProps;
    }
    if (!nextProps) {
      return true;
    }
    return hasPropsChanged(prevProps, nextProps, emits);
  }
  return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
  const nextKeys = Object.keys(nextProps);
  if (nextKeys.length !== Object.keys(prevProps).length) {
    return true;
  }
  for (let i = 0; i < nextKeys.length; i++) {
    const key = nextKeys[i];
    if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
      return true;
    }
  }
  return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
  while (parent && parent.subTree === vnode) {
    (vnode = parent.vnode).el = el;
    parent = parent.parent;
  }
}
const isSuspense = (type) => type.__isSuspense;
function queueEffectWithSuspense(fn, suspense) {
  if (suspense && suspense.pendingBranch) {
    if (isArray$1(fn)) {
      suspense.effects.push(...fn);
    } else {
      suspense.effects.push(fn);
    }
  } else {
    queuePostFlushCb(fn);
  }
}
function provide(key, value) {
  if (!currentInstance) {
    if (process.env.NODE_ENV !== "production") {
      warn(`provide() can only be used inside setup().`);
    }
  } else {
    let provides = currentInstance.provides;
    const parentProvides = currentInstance.parent && currentInstance.parent.provides;
    if (parentProvides === provides) {
      provides = currentInstance.provides = Object.create(parentProvides);
    }
    provides[key] = value;
  }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
  const instance2 = currentInstance || currentRenderingInstance;
  if (instance2) {
    const provides = instance2.parent == null ? instance2.vnode.appContext && instance2.vnode.appContext.provides : instance2.parent.provides;
    if (provides && key in provides) {
      return provides[key];
    } else if (arguments.length > 1) {
      return treatDefaultAsFactory && isFunction$2(defaultValue) ? defaultValue.call(instance2.proxy) : defaultValue;
    } else if (process.env.NODE_ENV !== "production") {
      warn(`injection "${String(key)}" not found.`);
    }
  } else if (process.env.NODE_ENV !== "production") {
    warn(`inject() can only be used inside setup() or functional components.`);
  }
}
const INITIAL_WATCHER_VALUE = {};
function watch(source, cb, options) {
  if (process.env.NODE_ENV !== "production" && !isFunction$2(cb)) {
    warn(`\`watch(fn, options?)\` signature has been moved to a separate API. Use \`watchEffect(fn, options?)\` instead. \`watch\` now only supports \`watch(source, cb, options?) signature.`);
  }
  return doWatch(source, cb, options);
}
function doWatch(source, cb, { immediate, deep, flush, onTrack, onTrigger } = EMPTY_OBJ) {
  if (process.env.NODE_ENV !== "production" && !cb) {
    if (immediate !== void 0) {
      warn(`watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.`);
    }
    if (deep !== void 0) {
      warn(`watch() "deep" option is only respected when using the watch(source, callback, options?) signature.`);
    }
  }
  const warnInvalidSource = (s) => {
    warn(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
  };
  const instance2 = currentInstance;
  let getter;
  let forceTrigger = false;
  let isMultiSource = false;
  if (isRef(source)) {
    getter = () => source.value;
    forceTrigger = isShallow$1(source);
  } else if (isReactive(source)) {
    getter = () => source;
    deep = true;
  } else if (isArray$1(source)) {
    isMultiSource = true;
    forceTrigger = source.some((s) => isReactive(s) || isShallow$1(s));
    getter = () => source.map((s) => {
      if (isRef(s)) {
        return s.value;
      } else if (isReactive(s)) {
        return traverse(s);
      } else if (isFunction$2(s)) {
        return callWithErrorHandling(s, instance2, 2);
      } else {
        process.env.NODE_ENV !== "production" && warnInvalidSource(s);
      }
    });
  } else if (isFunction$2(source)) {
    if (cb) {
      getter = () => callWithErrorHandling(source, instance2, 2);
    } else {
      getter = () => {
        if (instance2 && instance2.isUnmounted) {
          return;
        }
        if (cleanup) {
          cleanup();
        }
        return callWithAsyncErrorHandling(source, instance2, 3, [onCleanup]);
      };
    }
  } else {
    getter = NOOP;
    process.env.NODE_ENV !== "production" && warnInvalidSource(source);
  }
  if (cb && deep) {
    const baseGetter = getter;
    getter = () => traverse(baseGetter());
  }
  let cleanup;
  let onCleanup = (fn) => {
    cleanup = effect.onStop = () => {
      callWithErrorHandling(fn, instance2, 4);
    };
  };
  if (isInSSRComponentSetup) {
    onCleanup = NOOP;
    if (!cb) {
      getter();
    } else if (immediate) {
      callWithAsyncErrorHandling(cb, instance2, 3, [
        getter(),
        isMultiSource ? [] : void 0,
        onCleanup
      ]);
    }
    return NOOP;
  }
  let oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
  const job = () => {
    if (!effect.active) {
      return;
    }
    if (cb) {
      const newValue = effect.run();
      if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue)) || false) {
        if (cleanup) {
          cleanup();
        }
        callWithAsyncErrorHandling(cb, instance2, 3, [
          newValue,
          oldValue === INITIAL_WATCHER_VALUE ? void 0 : oldValue,
          onCleanup
        ]);
        oldValue = newValue;
      }
    } else {
      effect.run();
    }
  };
  job.allowRecurse = !!cb;
  let scheduler;
  if (flush === "sync") {
    scheduler = job;
  } else if (flush === "post") {
    scheduler = () => queuePostRenderEffect(job, instance2 && instance2.suspense);
  } else {
    scheduler = () => queuePreFlushCb(job);
  }
  const effect = new ReactiveEffect(getter, scheduler);
  if (process.env.NODE_ENV !== "production") {
    effect.onTrack = onTrack;
    effect.onTrigger = onTrigger;
  }
  if (cb) {
    if (immediate) {
      job();
    } else {
      oldValue = effect.run();
    }
  } else if (flush === "post") {
    queuePostRenderEffect(effect.run.bind(effect), instance2 && instance2.suspense);
  } else {
    effect.run();
  }
  return () => {
    effect.stop();
    if (instance2 && instance2.scope) {
      remove(instance2.scope.effects, effect);
    }
  };
}
function instanceWatch(source, value, options) {
  const publicThis = this.proxy;
  const getter = isString$1(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
  let cb;
  if (isFunction$2(value)) {
    cb = value;
  } else {
    cb = value.handler;
    options = value;
  }
  const cur = currentInstance;
  setCurrentInstance(this);
  const res = doWatch(getter, cb.bind(publicThis), options);
  if (cur) {
    setCurrentInstance(cur);
  } else {
    unsetCurrentInstance();
  }
  return res;
}
function createPathGetter(ctx, path) {
  const segments = path.split(".");
  return () => {
    let cur = ctx;
    for (let i = 0; i < segments.length && cur; i++) {
      cur = cur[segments[i]];
    }
    return cur;
  };
}
function traverse(value, seen) {
  if (!isObject$2(value) || value["__v_skip"]) {
    return value;
  }
  seen = seen || /* @__PURE__ */ new Set();
  if (seen.has(value)) {
    return value;
  }
  seen.add(value);
  if (isRef(value)) {
    traverse(value.value, seen);
  } else if (isArray$1(value)) {
    for (let i = 0; i < value.length; i++) {
      traverse(value[i], seen);
    }
  } else if (isSet(value) || isMap(value)) {
    value.forEach((v) => {
      traverse(v, seen);
    });
  } else if (isPlainObject$1(value)) {
    for (const key in value) {
      traverse(value[key], seen);
    }
  }
  return value;
}
function useTransitionState() {
  const state2 = {
    isMounted: false,
    isLeaving: false,
    isUnmounting: false,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  onMounted(() => {
    state2.isMounted = true;
  });
  onBeforeUnmount(() => {
    state2.isUnmounting = true;
  });
  return state2;
}
const TransitionHookValidator = [Function, Array];
const BaseTransitionImpl = {
  name: `BaseTransition`,
  props: {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
  },
  setup(props, { slots }) {
    const instance2 = getCurrentInstance();
    const state2 = useTransitionState();
    let prevTransitionKey;
    return () => {
      const children = slots.default && getTransitionRawChildren(slots.default(), true);
      if (!children || !children.length) {
        return;
      }
      let child = children[0];
      if (children.length > 1) {
        let hasFound = false;
        for (const c of children) {
          if (c.type !== Comment) {
            if (process.env.NODE_ENV !== "production" && hasFound) {
              warn("<transition> can only be used on a single element or component. Use <transition-group> for lists.");
              break;
            }
            child = c;
            hasFound = true;
            if (!(process.env.NODE_ENV !== "production"))
              break;
          }
        }
      }
      const rawProps = toRaw(props);
      const { mode } = rawProps;
      if (process.env.NODE_ENV !== "production" && mode && mode !== "in-out" && mode !== "out-in" && mode !== "default") {
        warn(`invalid <transition> mode: ${mode}`);
      }
      if (state2.isLeaving) {
        return emptyPlaceholder(child);
      }
      const innerChild = getKeepAliveChild(child);
      if (!innerChild) {
        return emptyPlaceholder(child);
      }
      const enterHooks = resolveTransitionHooks(innerChild, rawProps, state2, instance2);
      setTransitionHooks(innerChild, enterHooks);
      const oldChild = instance2.subTree;
      const oldInnerChild = oldChild && getKeepAliveChild(oldChild);
      let transitionKeyChanged = false;
      const { getTransitionKey } = innerChild.type;
      if (getTransitionKey) {
        const key = getTransitionKey();
        if (prevTransitionKey === void 0) {
          prevTransitionKey = key;
        } else if (key !== prevTransitionKey) {
          prevTransitionKey = key;
          transitionKeyChanged = true;
        }
      }
      if (oldInnerChild && oldInnerChild.type !== Comment && (!isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
        const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state2, instance2);
        setTransitionHooks(oldInnerChild, leavingHooks);
        if (mode === "out-in") {
          state2.isLeaving = true;
          leavingHooks.afterLeave = () => {
            state2.isLeaving = false;
            instance2.update();
          };
          return emptyPlaceholder(child);
        } else if (mode === "in-out" && innerChild.type !== Comment) {
          leavingHooks.delayLeave = (el, earlyRemove, delayedLeave) => {
            const leavingVNodesCache = getLeavingNodesForType(state2, oldInnerChild);
            leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
            el._leaveCb = () => {
              earlyRemove();
              el._leaveCb = void 0;
              delete enterHooks.delayedLeave;
            };
            enterHooks.delayedLeave = delayedLeave;
          };
        }
      }
      return child;
    };
  }
};
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state2, vnode) {
  const { leavingVNodes } = state2;
  let leavingVNodesCache = leavingVNodes.get(vnode.type);
  if (!leavingVNodesCache) {
    leavingVNodesCache = /* @__PURE__ */ Object.create(null);
    leavingVNodes.set(vnode.type, leavingVNodesCache);
  }
  return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state2, instance2) {
  const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
  const key = String(vnode.key);
  const leavingVNodesCache = getLeavingNodesForType(state2, vnode);
  const callHook2 = (hook, args) => {
    hook && callWithAsyncErrorHandling(hook, instance2, 9, args);
  };
  const callAsyncHook = (hook, args) => {
    const done = args[1];
    callHook2(hook, args);
    if (isArray$1(hook)) {
      if (hook.every((hook2) => hook2.length <= 1))
        done();
    } else if (hook.length <= 1) {
      done();
    }
  };
  const hooks = {
    mode,
    persisted,
    beforeEnter(el) {
      let hook = onBeforeEnter;
      if (!state2.isMounted) {
        if (appear) {
          hook = onBeforeAppear || onBeforeEnter;
        } else {
          return;
        }
      }
      if (el._leaveCb) {
        el._leaveCb(true);
      }
      const leavingVNode = leavingVNodesCache[key];
      if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) {
        leavingVNode.el._leaveCb();
      }
      callHook2(hook, [el]);
    },
    enter(el) {
      let hook = onEnter;
      let afterHook = onAfterEnter;
      let cancelHook = onEnterCancelled;
      if (!state2.isMounted) {
        if (appear) {
          hook = onAppear || onEnter;
          afterHook = onAfterAppear || onAfterEnter;
          cancelHook = onAppearCancelled || onEnterCancelled;
        } else {
          return;
        }
      }
      let called = false;
      const done = el._enterCb = (cancelled) => {
        if (called)
          return;
        called = true;
        if (cancelled) {
          callHook2(cancelHook, [el]);
        } else {
          callHook2(afterHook, [el]);
        }
        if (hooks.delayedLeave) {
          hooks.delayedLeave();
        }
        el._enterCb = void 0;
      };
      if (hook) {
        callAsyncHook(hook, [el, done]);
      } else {
        done();
      }
    },
    leave(el, remove2) {
      const key2 = String(vnode.key);
      if (el._enterCb) {
        el._enterCb(true);
      }
      if (state2.isUnmounting) {
        return remove2();
      }
      callHook2(onBeforeLeave, [el]);
      let called = false;
      const done = el._leaveCb = (cancelled) => {
        if (called)
          return;
        called = true;
        remove2();
        if (cancelled) {
          callHook2(onLeaveCancelled, [el]);
        } else {
          callHook2(onAfterLeave, [el]);
        }
        el._leaveCb = void 0;
        if (leavingVNodesCache[key2] === vnode) {
          delete leavingVNodesCache[key2];
        }
      };
      leavingVNodesCache[key2] = vnode;
      if (onLeave) {
        callAsyncHook(onLeave, [el, done]);
      } else {
        done();
      }
    },
    clone(vnode2) {
      return resolveTransitionHooks(vnode2, props, state2, instance2);
    }
  };
  return hooks;
}
function emptyPlaceholder(vnode) {
  if (isKeepAlive(vnode)) {
    vnode = cloneVNode(vnode);
    vnode.children = null;
    return vnode;
  }
}
function getKeepAliveChild(vnode) {
  return isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function setTransitionHooks(vnode, hooks) {
  if (vnode.shapeFlag & 6 && vnode.component) {
    setTransitionHooks(vnode.component.subTree, hooks);
  } else if (vnode.shapeFlag & 128) {
    vnode.ssContent.transition = hooks.clone(vnode.ssContent);
    vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
  } else {
    vnode.transition = hooks;
  }
}
function getTransitionRawChildren(children, keepComment = false, parentKey) {
  let ret = [];
  let keyedFragmentCount = 0;
  for (let i = 0; i < children.length; i++) {
    let child = children[i];
    const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
    if (child.type === Fragment) {
      if (child.patchFlag & 128)
        keyedFragmentCount++;
      ret = ret.concat(getTransitionRawChildren(child.children, keepComment, key));
    } else if (keepComment || child.type !== Comment) {
      ret.push(key != null ? cloneVNode(child, { key }) : child);
    }
  }
  if (keyedFragmentCount > 1) {
    for (let i = 0; i < ret.length; i++) {
      ret[i].patchFlag = -2;
    }
  }
  return ret;
}
function defineComponent(options) {
  return isFunction$2(options) ? { setup: options, name: options.name } : options;
}
const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
function onActivated(hook, target) {
  registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
  registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
  const wrappedHook = hook.__wdc || (hook.__wdc = () => {
    let current = target;
    while (current) {
      if (current.isDeactivated) {
        return;
      }
      current = current.parent;
    }
    return hook();
  });
  injectHook(type, wrappedHook, target);
  if (target) {
    let current = target.parent;
    while (current && current.parent) {
      if (isKeepAlive(current.parent.vnode)) {
        injectToKeepAliveRoot(wrappedHook, type, target, current);
      }
      current = current.parent;
    }
  }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
  const injected = injectHook(type, hook, keepAliveRoot, true);
  onUnmounted(() => {
    remove(keepAliveRoot[type], injected);
  }, target);
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
  if (target) {
    const hooks = target[type] || (target[type] = []);
    const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
      if (target.isUnmounted) {
        return;
      }
      pauseTracking();
      setCurrentInstance(target);
      const res = callWithAsyncErrorHandling(hook, target, type, args);
      unsetCurrentInstance();
      resetTracking();
      return res;
    });
    if (prepend) {
      hooks.unshift(wrappedHook);
    } else {
      hooks.push(wrappedHook);
    }
    return wrappedHook;
  } else if (process.env.NODE_ENV !== "production") {
    const apiName = toHandlerKey(ErrorTypeStrings[type].replace(/ hook$/, ""));
    warn(`${apiName} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`);
  }
}
const createHook = (lifecycle) => (hook, target = currentInstance) => (!isInSSRComponentSetup || lifecycle === "sp") && injectHook(lifecycle, hook, target);
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
  injectHook("ec", hook, target);
}
function validateDirectiveName(name2) {
  if (isBuiltInDirective(name2)) {
    warn("Do not use built-in directive ids as custom directive id: " + name2);
  }
}
function withDirectives(vnode, directives) {
  const internalInstance = currentRenderingInstance;
  if (internalInstance === null) {
    process.env.NODE_ENV !== "production" && warn(`withDirectives can only be used inside render functions.`);
    return vnode;
  }
  const instance2 = getExposeProxy(internalInstance) || internalInstance.proxy;
  const bindings = vnode.dirs || (vnode.dirs = []);
  for (let i = 0; i < directives.length; i++) {
    let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i];
    if (isFunction$2(dir)) {
      dir = {
        mounted: dir,
        updated: dir
      };
    }
    if (dir.deep) {
      traverse(value);
    }
    bindings.push({
      dir,
      instance: instance2,
      value,
      oldValue: void 0,
      arg,
      modifiers
    });
  }
  return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance2, name2) {
  const bindings = vnode.dirs;
  const oldBindings = prevVNode && prevVNode.dirs;
  for (let i = 0; i < bindings.length; i++) {
    const binding = bindings[i];
    if (oldBindings) {
      binding.oldValue = oldBindings[i].value;
    }
    let hook = binding.dir[name2];
    if (hook) {
      pauseTracking();
      callWithAsyncErrorHandling(hook, instance2, 8, [
        vnode.el,
        binding,
        vnode,
        prevVNode
      ]);
      resetTracking();
    }
  }
}
const COMPONENTS = "components";
const NULL_DYNAMIC_COMPONENT = Symbol();
function resolveDynamicComponent(component) {
  if (isString$1(component)) {
    return resolveAsset(COMPONENTS, component, false) || component;
  } else {
    return component || NULL_DYNAMIC_COMPONENT;
  }
}
function resolveAsset(type, name2, warnMissing = true, maybeSelfReference = false) {
  const instance2 = currentRenderingInstance || currentInstance;
  if (instance2) {
    const Component = instance2.type;
    if (type === COMPONENTS) {
      const selfName = getComponentName(Component, false);
      if (selfName && (selfName === name2 || selfName === camelize$1(name2) || selfName === capitalize(camelize$1(name2)))) {
        return Component;
      }
    }
    const res = resolve(instance2[type] || Component[type], name2) || resolve(instance2.appContext[type], name2);
    if (!res && maybeSelfReference) {
      return Component;
    }
    if (process.env.NODE_ENV !== "production" && warnMissing && !res) {
      const extra = type === COMPONENTS ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : ``;
      warn(`Failed to resolve ${type.slice(0, -1)}: ${name2}${extra}`);
    }
    return res;
  } else if (process.env.NODE_ENV !== "production") {
    warn(`resolve${capitalize(type.slice(0, -1))} can only be used in render() or setup().`);
  }
}
function resolve(registry, name2) {
  return registry && (registry[name2] || registry[camelize$1(name2)] || registry[capitalize(camelize$1(name2))]);
}
function renderList(source, renderItem, cache, index2) {
  let ret;
  const cached = cache && cache[index2];
  if (isArray$1(source) || isString$1(source)) {
    ret = new Array(source.length);
    for (let i = 0, l = source.length; i < l; i++) {
      ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    }
  } else if (typeof source === "number") {
    if (process.env.NODE_ENV !== "production" && !Number.isInteger(source)) {
      warn(`The v-for range expect an integer value but got ${source}.`);
    }
    ret = new Array(source);
    for (let i = 0; i < source; i++) {
      ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    }
  } else if (isObject$2(source)) {
    if (source[Symbol.iterator]) {
      ret = Array.from(source, (item, i) => renderItem(item, i, void 0, cached && cached[i]));
    } else {
      const keys = Object.keys(source);
      ret = new Array(keys.length);
      for (let i = 0, l = keys.length; i < l; i++) {
        const key = keys[i];
        ret[i] = renderItem(source[key], key, i, cached && cached[i]);
      }
    }
  } else {
    ret = [];
  }
  if (cache) {
    cache[index2] = ret;
  }
  return ret;
}
function renderSlot(slots, name2, props = {}, fallback, noSlotted) {
  if (currentRenderingInstance.isCE || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.isCE) {
    return createVNode("slot", name2 === "default" ? null : { name: name2 }, fallback && fallback());
  }
  let slot = slots[name2];
  if (process.env.NODE_ENV !== "production" && slot && slot.length > 1) {
    warn(`SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template.`);
    slot = () => [];
  }
  if (slot && slot._c) {
    slot._d = false;
  }
  openBlock();
  const validSlotContent = slot && ensureValidVNode(slot(props));
  const rendered = createBlock(Fragment, { key: props.key || `_${name2}` }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
  if (!noSlotted && rendered.scopeId) {
    rendered.slotScopeIds = [rendered.scopeId + "-s"];
  }
  if (slot && slot._c) {
    slot._d = true;
  }
  return rendered;
}
function ensureValidVNode(vnodes) {
  return vnodes.some((child) => {
    if (!isVNode(child))
      return true;
    if (child.type === Comment)
      return false;
    if (child.type === Fragment && !ensureValidVNode(child.children))
      return false;
    return true;
  }) ? vnodes : null;
}
const getPublicInstance = (i) => {
  if (!i)
    return null;
  if (isStatefulComponent(i))
    return getExposeProxy(i) || i.proxy;
  return getPublicInstance(i.parent);
};
const publicPropertiesMap = /* @__PURE__ */ extend$2(/* @__PURE__ */ Object.create(null), {
  $: (i) => i,
  $el: (i) => i.vnode.el,
  $data: (i) => i.data,
  $props: (i) => process.env.NODE_ENV !== "production" ? shallowReadonly(i.props) : i.props,
  $attrs: (i) => process.env.NODE_ENV !== "production" ? shallowReadonly(i.attrs) : i.attrs,
  $slots: (i) => process.env.NODE_ENV !== "production" ? shallowReadonly(i.slots) : i.slots,
  $refs: (i) => process.env.NODE_ENV !== "production" ? shallowReadonly(i.refs) : i.refs,
  $parent: (i) => getPublicInstance(i.parent),
  $root: (i) => getPublicInstance(i.root),
  $emit: (i) => i.emit,
  $options: (i) => resolveMergedOptions(i),
  $forceUpdate: (i) => i.f || (i.f = () => queueJob(i.update)),
  $nextTick: (i) => i.n || (i.n = nextTick.bind(i.proxy)),
  $watch: (i) => instanceWatch.bind(i)
});
const isReservedPrefix = (key) => key === "_" || key === "$";
const PublicInstanceProxyHandlers = {
  get({ _: instance2 }, key) {
    const { ctx, setupState, data: data2, props, accessCache, type, appContext } = instance2;
    if (process.env.NODE_ENV !== "production" && key === "__isVue") {
      return true;
    }
    if (process.env.NODE_ENV !== "production" && setupState !== EMPTY_OBJ && setupState.__isScriptSetup && hasOwn(setupState, key)) {
      return setupState[key];
    }
    let normalizedProps;
    if (key[0] !== "$") {
      const n = accessCache[key];
      if (n !== void 0) {
        switch (n) {
          case 1:
            return setupState[key];
          case 2:
            return data2[key];
          case 4:
            return ctx[key];
          case 3:
            return props[key];
        }
      } else if (setupState !== EMPTY_OBJ && hasOwn(setupState, key)) {
        accessCache[key] = 1;
        return setupState[key];
      } else if (data2 !== EMPTY_OBJ && hasOwn(data2, key)) {
        accessCache[key] = 2;
        return data2[key];
      } else if ((normalizedProps = instance2.propsOptions[0]) && hasOwn(normalizedProps, key)) {
        accessCache[key] = 3;
        return props[key];
      } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
        accessCache[key] = 4;
        return ctx[key];
      } else if (shouldCacheAccess) {
        accessCache[key] = 0;
      }
    }
    const publicGetter = publicPropertiesMap[key];
    let cssModule, globalProperties;
    if (publicGetter) {
      if (key === "$attrs") {
        track(instance2, "get", key);
        process.env.NODE_ENV !== "production" && markAttrsAccessed();
      }
      return publicGetter(instance2);
    } else if ((cssModule = type.__cssModules) && (cssModule = cssModule[key])) {
      return cssModule;
    } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
      accessCache[key] = 4;
      return ctx[key];
    } else if (globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)) {
      {
        return globalProperties[key];
      }
    } else if (process.env.NODE_ENV !== "production" && currentRenderingInstance && (!isString$1(key) || key.indexOf("__v") !== 0)) {
      if (data2 !== EMPTY_OBJ && isReservedPrefix(key[0]) && hasOwn(data2, key)) {
        warn(`Property ${JSON.stringify(key)} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`);
      } else if (instance2 === currentRenderingInstance) {
        warn(`Property ${JSON.stringify(key)} was accessed during render but is not defined on instance.`);
      }
    }
  },
  set({ _: instance2 }, key, value) {
    const { data: data2, setupState, ctx } = instance2;
    if (setupState !== EMPTY_OBJ && hasOwn(setupState, key)) {
      setupState[key] = value;
      return true;
    } else if (data2 !== EMPTY_OBJ && hasOwn(data2, key)) {
      data2[key] = value;
      return true;
    } else if (hasOwn(instance2.props, key)) {
      process.env.NODE_ENV !== "production" && warn(`Attempting to mutate prop "${key}". Props are readonly.`, instance2);
      return false;
    }
    if (key[0] === "$" && key.slice(1) in instance2) {
      process.env.NODE_ENV !== "production" && warn(`Attempting to mutate public property "${key}". Properties starting with $ are reserved and readonly.`, instance2);
      return false;
    } else {
      if (process.env.NODE_ENV !== "production" && key in instance2.appContext.config.globalProperties) {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          value
        });
      } else {
        ctx[key] = value;
      }
    }
    return true;
  },
  has({ _: { data: data2, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
    let normalizedProps;
    return !!accessCache[key] || data2 !== EMPTY_OBJ && hasOwn(data2, key) || setupState !== EMPTY_OBJ && hasOwn(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn(normalizedProps, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key);
  },
  defineProperty(target, key, descriptor) {
    if (descriptor.get != null) {
      target._.accessCache[key] = 0;
    } else if (hasOwn(descriptor, "value")) {
      this.set(target, key, descriptor.value, null);
    }
    return Reflect.defineProperty(target, key, descriptor);
  }
};
if (process.env.NODE_ENV !== "production" && true) {
  PublicInstanceProxyHandlers.ownKeys = (target) => {
    warn(`Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead.`);
    return Reflect.ownKeys(target);
  };
}
function createDevRenderContext(instance2) {
  const target = {};
  Object.defineProperty(target, `_`, {
    configurable: true,
    enumerable: false,
    get: () => instance2
  });
  Object.keys(publicPropertiesMap).forEach((key) => {
    Object.defineProperty(target, key, {
      configurable: true,
      enumerable: false,
      get: () => publicPropertiesMap[key](instance2),
      set: NOOP
    });
  });
  return target;
}
function exposePropsOnRenderContext(instance2) {
  const { ctx, propsOptions: [propsOptions] } = instance2;
  if (propsOptions) {
    Object.keys(propsOptions).forEach((key) => {
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => instance2.props[key],
        set: NOOP
      });
    });
  }
}
function exposeSetupStateOnRenderContext(instance2) {
  const { ctx, setupState } = instance2;
  Object.keys(toRaw(setupState)).forEach((key) => {
    if (!setupState.__isScriptSetup) {
      if (isReservedPrefix(key[0])) {
        warn(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
        return;
      }
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => setupState[key],
        set: NOOP
      });
    }
  });
}
function createDuplicateChecker() {
  const cache = /* @__PURE__ */ Object.create(null);
  return (type, key) => {
    if (cache[key]) {
      warn(`${type} property "${key}" is already defined in ${cache[key]}.`);
    } else {
      cache[key] = type;
    }
  };
}
let shouldCacheAccess = true;
function applyOptions(instance2) {
  const options = resolveMergedOptions(instance2);
  const publicThis = instance2.proxy;
  const ctx = instance2.ctx;
  shouldCacheAccess = false;
  if (options.beforeCreate) {
    callHook$1(options.beforeCreate, instance2, "bc");
  }
  const {
    data: dataOptions,
    computed: computedOptions,
    methods,
    watch: watchOptions,
    provide: provideOptions,
    inject: injectOptions,
    created,
    beforeMount,
    mounted,
    beforeUpdate,
    updated,
    activated,
    deactivated,
    beforeDestroy,
    beforeUnmount,
    destroyed,
    unmounted,
    render: render2,
    renderTracked,
    renderTriggered,
    errorCaptured,
    serverPrefetch,
    expose,
    inheritAttrs,
    components,
    directives,
    filters
  } = options;
  const checkDuplicateProperties = process.env.NODE_ENV !== "production" ? createDuplicateChecker() : null;
  if (process.env.NODE_ENV !== "production") {
    const [propsOptions] = instance2.propsOptions;
    if (propsOptions) {
      for (const key in propsOptions) {
        checkDuplicateProperties("Props", key);
      }
    }
  }
  if (injectOptions) {
    resolveInjections(injectOptions, ctx, checkDuplicateProperties, instance2.appContext.config.unwrapInjectedRef);
  }
  if (methods) {
    for (const key in methods) {
      const methodHandler = methods[key];
      if (isFunction$2(methodHandler)) {
        if (process.env.NODE_ENV !== "production") {
          Object.defineProperty(ctx, key, {
            value: methodHandler.bind(publicThis),
            configurable: true,
            enumerable: true,
            writable: true
          });
        } else {
          ctx[key] = methodHandler.bind(publicThis);
        }
        if (process.env.NODE_ENV !== "production") {
          checkDuplicateProperties("Methods", key);
        }
      } else if (process.env.NODE_ENV !== "production") {
        warn(`Method "${key}" has type "${typeof methodHandler}" in the component definition. Did you reference the function correctly?`);
      }
    }
  }
  if (dataOptions) {
    if (process.env.NODE_ENV !== "production" && !isFunction$2(dataOptions)) {
      warn(`The data option must be a function. Plain object usage is no longer supported.`);
    }
    const data2 = dataOptions.call(publicThis, publicThis);
    if (process.env.NODE_ENV !== "production" && isPromise$1(data2)) {
      warn(`data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>.`);
    }
    if (!isObject$2(data2)) {
      process.env.NODE_ENV !== "production" && warn(`data() should return an object.`);
    } else {
      instance2.data = reactive(data2);
      if (process.env.NODE_ENV !== "production") {
        for (const key in data2) {
          checkDuplicateProperties("Data", key);
          if (!isReservedPrefix(key[0])) {
            Object.defineProperty(ctx, key, {
              configurable: true,
              enumerable: true,
              get: () => data2[key],
              set: NOOP
            });
          }
        }
      }
    }
  }
  shouldCacheAccess = true;
  if (computedOptions) {
    for (const key in computedOptions) {
      const opt = computedOptions[key];
      const get2 = isFunction$2(opt) ? opt.bind(publicThis, publicThis) : isFunction$2(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
      if (process.env.NODE_ENV !== "production" && get2 === NOOP) {
        warn(`Computed property "${key}" has no getter.`);
      }
      const set2 = !isFunction$2(opt) && isFunction$2(opt.set) ? opt.set.bind(publicThis) : process.env.NODE_ENV !== "production" ? () => {
        warn(`Write operation failed: computed property "${key}" is readonly.`);
      } : NOOP;
      const c = computed({
        get: get2,
        set: set2
      });
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => c.value,
        set: (v) => c.value = v
      });
      if (process.env.NODE_ENV !== "production") {
        checkDuplicateProperties("Computed", key);
      }
    }
  }
  if (watchOptions) {
    for (const key in watchOptions) {
      createWatcher(watchOptions[key], ctx, publicThis, key);
    }
  }
  if (provideOptions) {
    const provides = isFunction$2(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
    Reflect.ownKeys(provides).forEach((key) => {
      provide(key, provides[key]);
    });
  }
  if (created) {
    callHook$1(created, instance2, "c");
  }
  function registerLifecycleHook(register, hook) {
    if (isArray$1(hook)) {
      hook.forEach((_hook) => register(_hook.bind(publicThis)));
    } else if (hook) {
      register(hook.bind(publicThis));
    }
  }
  registerLifecycleHook(onBeforeMount, beforeMount);
  registerLifecycleHook(onMounted, mounted);
  registerLifecycleHook(onBeforeUpdate, beforeUpdate);
  registerLifecycleHook(onUpdated, updated);
  registerLifecycleHook(onActivated, activated);
  registerLifecycleHook(onDeactivated, deactivated);
  registerLifecycleHook(onErrorCaptured, errorCaptured);
  registerLifecycleHook(onRenderTracked, renderTracked);
  registerLifecycleHook(onRenderTriggered, renderTriggered);
  registerLifecycleHook(onBeforeUnmount, beforeUnmount);
  registerLifecycleHook(onUnmounted, unmounted);
  registerLifecycleHook(onServerPrefetch, serverPrefetch);
  if (isArray$1(expose)) {
    if (expose.length) {
      const exposed = instance2.exposed || (instance2.exposed = {});
      expose.forEach((key) => {
        Object.defineProperty(exposed, key, {
          get: () => publicThis[key],
          set: (val) => publicThis[key] = val
        });
      });
    } else if (!instance2.exposed) {
      instance2.exposed = {};
    }
  }
  if (render2 && instance2.render === NOOP) {
    instance2.render = render2;
  }
  if (inheritAttrs != null) {
    instance2.inheritAttrs = inheritAttrs;
  }
  if (components)
    instance2.components = components;
  if (directives)
    instance2.directives = directives;
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP, unwrapRef = false) {
  if (isArray$1(injectOptions)) {
    injectOptions = normalizeInject(injectOptions);
  }
  for (const key in injectOptions) {
    const opt = injectOptions[key];
    let injected;
    if (isObject$2(opt)) {
      if ("default" in opt) {
        injected = inject(opt.from || key, opt.default, true);
      } else {
        injected = inject(opt.from || key);
      }
    } else {
      injected = inject(opt);
    }
    if (isRef(injected)) {
      if (unwrapRef) {
        Object.defineProperty(ctx, key, {
          enumerable: true,
          configurable: true,
          get: () => injected.value,
          set: (v) => injected.value = v
        });
      } else {
        if (process.env.NODE_ENV !== "production") {
          warn(`injected property "${key}" is a ref and will be auto-unwrapped and no longer needs \`.value\` in the next minor release. To opt-in to the new behavior now, set \`app.config.unwrapInjectedRef = true\` (this config is temporary and will not be needed in the future.)`);
        }
        ctx[key] = injected;
      }
    } else {
      ctx[key] = injected;
    }
    if (process.env.NODE_ENV !== "production") {
      checkDuplicateProperties("Inject", key);
    }
  }
}
function callHook$1(hook, instance2, type) {
  callWithAsyncErrorHandling(isArray$1(hook) ? hook.map((h2) => h2.bind(instance2.proxy)) : hook.bind(instance2.proxy), instance2, type);
}
function createWatcher(raw, ctx, publicThis, key) {
  const getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
  if (isString$1(raw)) {
    const handler = ctx[raw];
    if (isFunction$2(handler)) {
      watch(getter, handler);
    } else if (process.env.NODE_ENV !== "production") {
      warn(`Invalid watch handler specified by key "${raw}"`, handler);
    }
  } else if (isFunction$2(raw)) {
    watch(getter, raw.bind(publicThis));
  } else if (isObject$2(raw)) {
    if (isArray$1(raw)) {
      raw.forEach((r) => createWatcher(r, ctx, publicThis, key));
    } else {
      const handler = isFunction$2(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
      if (isFunction$2(handler)) {
        watch(getter, handler, raw);
      } else if (process.env.NODE_ENV !== "production") {
        warn(`Invalid watch handler specified by key "${raw.handler}"`, handler);
      }
    }
  } else if (process.env.NODE_ENV !== "production") {
    warn(`Invalid watch option: "${key}"`, raw);
  }
}
function resolveMergedOptions(instance2) {
  const base2 = instance2.type;
  const { mixins, extends: extendsOptions } = base2;
  const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance2.appContext;
  const cached = cache.get(base2);
  let resolved;
  if (cached) {
    resolved = cached;
  } else if (!globalMixins.length && !mixins && !extendsOptions) {
    {
      resolved = base2;
    }
  } else {
    resolved = {};
    if (globalMixins.length) {
      globalMixins.forEach((m) => mergeOptions(resolved, m, optionMergeStrategies, true));
    }
    mergeOptions(resolved, base2, optionMergeStrategies);
  }
  cache.set(base2, resolved);
  return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
  const { mixins, extends: extendsOptions } = from;
  if (extendsOptions) {
    mergeOptions(to, extendsOptions, strats, true);
  }
  if (mixins) {
    mixins.forEach((m) => mergeOptions(to, m, strats, true));
  }
  for (const key in from) {
    if (asMixin && key === "expose") {
      process.env.NODE_ENV !== "production" && warn(`"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.`);
    } else {
      const strat = internalOptionMergeStrats[key] || strats && strats[key];
      to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
  }
  return to;
}
const internalOptionMergeStrats = {
  data: mergeDataFn,
  props: mergeObjectOptions,
  emits: mergeObjectOptions,
  methods: mergeObjectOptions,
  computed: mergeObjectOptions,
  beforeCreate: mergeAsArray,
  created: mergeAsArray,
  beforeMount: mergeAsArray,
  mounted: mergeAsArray,
  beforeUpdate: mergeAsArray,
  updated: mergeAsArray,
  beforeDestroy: mergeAsArray,
  beforeUnmount: mergeAsArray,
  destroyed: mergeAsArray,
  unmounted: mergeAsArray,
  activated: mergeAsArray,
  deactivated: mergeAsArray,
  errorCaptured: mergeAsArray,
  serverPrefetch: mergeAsArray,
  components: mergeObjectOptions,
  directives: mergeObjectOptions,
  watch: mergeWatchOptions,
  provide: mergeDataFn,
  inject: mergeInject
};
function mergeDataFn(to, from) {
  if (!from) {
    return to;
  }
  if (!to) {
    return from;
  }
  return function mergedDataFn() {
    return extend$2(isFunction$2(to) ? to.call(this, this) : to, isFunction$2(from) ? from.call(this, this) : from);
  };
}
function mergeInject(to, from) {
  return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
  if (isArray$1(raw)) {
    const res = {};
    for (let i = 0; i < raw.length; i++) {
      res[raw[i]] = raw[i];
    }
    return res;
  }
  return raw;
}
function mergeAsArray(to, from) {
  return to ? [...new Set([].concat(to, from))] : from;
}
function mergeObjectOptions(to, from) {
  return to ? extend$2(extend$2(/* @__PURE__ */ Object.create(null), to), from) : from;
}
function mergeWatchOptions(to, from) {
  if (!to)
    return from;
  if (!from)
    return to;
  const merged = extend$2(/* @__PURE__ */ Object.create(null), to);
  for (const key in from) {
    merged[key] = mergeAsArray(to[key], from[key]);
  }
  return merged;
}
function initProps(instance2, rawProps, isStateful, isSSR = false) {
  const props = {};
  const attrs = {};
  def(attrs, InternalObjectKey, 1);
  instance2.propsDefaults = /* @__PURE__ */ Object.create(null);
  setFullProps(instance2, rawProps, props, attrs);
  for (const key in instance2.propsOptions[0]) {
    if (!(key in props)) {
      props[key] = void 0;
    }
  }
  if (process.env.NODE_ENV !== "production") {
    validateProps(rawProps || {}, props, instance2);
  }
  if (isStateful) {
    instance2.props = isSSR ? props : shallowReactive(props);
  } else {
    if (!instance2.type.props) {
      instance2.props = attrs;
    } else {
      instance2.props = props;
    }
  }
  instance2.attrs = attrs;
}
function updateProps(instance2, rawProps, rawPrevProps, optimized) {
  const { props, attrs, vnode: { patchFlag } } = instance2;
  const rawCurrentProps = toRaw(props);
  const [options] = instance2.propsOptions;
  let hasAttrsChanged = false;
  if (!(process.env.NODE_ENV !== "production" && (instance2.type.__hmrId || instance2.parent && instance2.parent.type.__hmrId)) && (optimized || patchFlag > 0) && !(patchFlag & 16)) {
    if (patchFlag & 8) {
      const propsToUpdate = instance2.vnode.dynamicProps;
      for (let i = 0; i < propsToUpdate.length; i++) {
        let key = propsToUpdate[i];
        if (isEmitListener(instance2.emitsOptions, key)) {
          continue;
        }
        const value = rawProps[key];
        if (options) {
          if (hasOwn(attrs, key)) {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          } else {
            const camelizedKey = camelize$1(key);
            props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance2, false);
          }
        } else {
          if (value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
  } else {
    if (setFullProps(instance2, rawProps, props, attrs)) {
      hasAttrsChanged = true;
    }
    let kebabKey;
    for (const key in rawCurrentProps) {
      if (!rawProps || !hasOwn(rawProps, key) && ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
        if (options) {
          if (rawPrevProps && (rawPrevProps[key] !== void 0 || rawPrevProps[kebabKey] !== void 0)) {
            props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance2, true);
          }
        } else {
          delete props[key];
        }
      }
    }
    if (attrs !== rawCurrentProps) {
      for (const key in attrs) {
        if (!rawProps || !hasOwn(rawProps, key) && true) {
          delete attrs[key];
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (hasAttrsChanged) {
    trigger(instance2, "set", "$attrs");
  }
  if (process.env.NODE_ENV !== "production") {
    validateProps(rawProps || {}, props, instance2);
  }
}
function setFullProps(instance2, rawProps, props, attrs) {
  const [options, needCastKeys] = instance2.propsOptions;
  let hasAttrsChanged = false;
  let rawCastValues;
  if (rawProps) {
    for (let key in rawProps) {
      if (isReservedProp(key)) {
        continue;
      }
      const value = rawProps[key];
      let camelKey;
      if (options && hasOwn(options, camelKey = camelize$1(key))) {
        if (!needCastKeys || !needCastKeys.includes(camelKey)) {
          props[camelKey] = value;
        } else {
          (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        }
      } else if (!isEmitListener(instance2.emitsOptions, key)) {
        if (!(key in attrs) || value !== attrs[key]) {
          attrs[key] = value;
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (needCastKeys) {
    const rawCurrentProps = toRaw(props);
    const castValues = rawCastValues || EMPTY_OBJ;
    for (let i = 0; i < needCastKeys.length; i++) {
      const key = needCastKeys[i];
      props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance2, !hasOwn(castValues, key));
    }
  }
  return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance2, isAbsent) {
  const opt = options[key];
  if (opt != null) {
    const hasDefault = hasOwn(opt, "default");
    if (hasDefault && value === void 0) {
      const defaultValue = opt.default;
      if (opt.type !== Function && isFunction$2(defaultValue)) {
        const { propsDefaults } = instance2;
        if (key in propsDefaults) {
          value = propsDefaults[key];
        } else {
          setCurrentInstance(instance2);
          value = propsDefaults[key] = defaultValue.call(null, props);
          unsetCurrentInstance();
        }
      } else {
        value = defaultValue;
      }
    }
    if (opt[0]) {
      if (isAbsent && !hasDefault) {
        value = false;
      } else if (opt[1] && (value === "" || value === hyphenate(key))) {
        value = true;
      }
    }
  }
  return value;
}
function normalizePropsOptions(comp, appContext, asMixin = false) {
  const cache = appContext.propsCache;
  const cached = cache.get(comp);
  if (cached) {
    return cached;
  }
  const raw = comp.props;
  const normalized = {};
  const needCastKeys = [];
  let hasExtends = false;
  if (!isFunction$2(comp)) {
    const extendProps = (raw2) => {
      hasExtends = true;
      const [props, keys] = normalizePropsOptions(raw2, appContext, true);
      extend$2(normalized, props);
      if (keys)
        needCastKeys.push(...keys);
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendProps);
    }
    if (comp.extends) {
      extendProps(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendProps);
    }
  }
  if (!raw && !hasExtends) {
    cache.set(comp, EMPTY_ARR);
    return EMPTY_ARR;
  }
  if (isArray$1(raw)) {
    for (let i = 0; i < raw.length; i++) {
      if (process.env.NODE_ENV !== "production" && !isString$1(raw[i])) {
        warn(`props must be strings when using array syntax.`, raw[i]);
      }
      const normalizedKey = camelize$1(raw[i]);
      if (validatePropName(normalizedKey)) {
        normalized[normalizedKey] = EMPTY_OBJ;
      }
    }
  } else if (raw) {
    if (process.env.NODE_ENV !== "production" && !isObject$2(raw)) {
      warn(`invalid props options`, raw);
    }
    for (const key in raw) {
      const normalizedKey = camelize$1(key);
      if (validatePropName(normalizedKey)) {
        const opt = raw[key];
        const prop = normalized[normalizedKey] = isArray$1(opt) || isFunction$2(opt) ? { type: opt } : opt;
        if (prop) {
          const booleanIndex = getTypeIndex(Boolean, prop.type);
          const stringIndex = getTypeIndex(String, prop.type);
          prop[0] = booleanIndex > -1;
          prop[1] = stringIndex < 0 || booleanIndex < stringIndex;
          if (booleanIndex > -1 || hasOwn(prop, "default")) {
            needCastKeys.push(normalizedKey);
          }
        }
      }
    }
  }
  const res = [normalized, needCastKeys];
  cache.set(comp, res);
  return res;
}
function validatePropName(key) {
  if (key[0] !== "$") {
    return true;
  } else if (process.env.NODE_ENV !== "production") {
    warn(`Invalid prop name: "${key}" is a reserved property.`);
  }
  return false;
}
function getType(ctor) {
  const match = ctor && ctor.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ctor === null ? "null" : "";
}
function isSameType(a, b) {
  return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
  if (isArray$1(expectedTypes)) {
    return expectedTypes.findIndex((t2) => isSameType(t2, type));
  } else if (isFunction$2(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1;
  }
  return -1;
}
function validateProps(rawProps, props, instance2) {
  const resolvedValues = toRaw(props);
  const options = instance2.propsOptions[0];
  for (const key in options) {
    let opt = options[key];
    if (opt == null)
      continue;
    validateProp(key, resolvedValues[key], opt, !hasOwn(rawProps, key) && !hasOwn(rawProps, hyphenate(key)));
  }
}
function validateProp(name2, value, prop, isAbsent) {
  const { type, required, validator: validator2 } = prop;
  if (required && isAbsent) {
    warn('Missing required prop: "' + name2 + '"');
    return;
  }
  if (value == null && !prop.required) {
    return;
  }
  if (type != null && type !== true) {
    let isValid = false;
    const types = isArray$1(type) ? type : [type];
    const expectedTypes = [];
    for (let i = 0; i < types.length && !isValid; i++) {
      const { valid, expectedType } = assertType(value, types[i]);
      expectedTypes.push(expectedType || "");
      isValid = valid;
    }
    if (!isValid) {
      warn(getInvalidTypeMessage(name2, value, expectedTypes));
      return;
    }
  }
  if (validator2 && !validator2(value)) {
    warn('Invalid prop: custom validator check failed for prop "' + name2 + '".');
  }
}
const isSimpleType = /* @__PURE__ */ makeMap("String,Number,Boolean,Function,Symbol,BigInt");
function assertType(value, type) {
  let valid;
  const expectedType = getType(type);
  if (isSimpleType(expectedType)) {
    const t2 = typeof value;
    valid = t2 === expectedType.toLowerCase();
    if (!valid && t2 === "object") {
      valid = value instanceof type;
    }
  } else if (expectedType === "Object") {
    valid = isObject$2(value);
  } else if (expectedType === "Array") {
    valid = isArray$1(value);
  } else if (expectedType === "null") {
    valid = value === null;
  } else {
    valid = value instanceof type;
  }
  return {
    valid,
    expectedType
  };
}
function getInvalidTypeMessage(name2, value, expectedTypes) {
  let message = `Invalid prop: type check failed for prop "${name2}". Expected ${expectedTypes.map(capitalize).join(" | ")}`;
  const expectedType = expectedTypes[0];
  const receivedType = toRawType(value);
  const expectedValue = styleValue(value, expectedType);
  const receivedValue = styleValue(value, receivedType);
  if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) {
    message += ` with value ${expectedValue}`;
  }
  message += `, got ${receivedType} `;
  if (isExplicable(receivedType)) {
    message += `with value ${receivedValue}.`;
  }
  return message;
}
function styleValue(value, type) {
  if (type === "String") {
    return `"${value}"`;
  } else if (type === "Number") {
    return `${Number(value)}`;
  } else {
    return `${value}`;
  }
}
function isExplicable(type) {
  const explicitTypes = ["string", "number", "boolean"];
  return explicitTypes.some((elem) => type.toLowerCase() === elem);
}
function isBoolean(...args) {
  return args.some((elem) => elem.toLowerCase() === "boolean");
}
const isInternalKey = (key) => key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value) => isArray$1(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
const normalizeSlot = (key, rawSlot, ctx) => {
  if (rawSlot._n) {
    return rawSlot;
  }
  const normalized = withCtx((...args) => {
    if (process.env.NODE_ENV !== "production" && currentInstance) {
      warn(`Slot "${key}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`);
    }
    return normalizeSlotValue(rawSlot(...args));
  }, ctx);
  normalized._c = false;
  return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance2) => {
  const ctx = rawSlots._ctx;
  for (const key in rawSlots) {
    if (isInternalKey(key))
      continue;
    const value = rawSlots[key];
    if (isFunction$2(value)) {
      slots[key] = normalizeSlot(key, value, ctx);
    } else if (value != null) {
      if (process.env.NODE_ENV !== "production" && true) {
        warn(`Non-function value encountered for slot "${key}". Prefer function slots for better performance.`);
      }
      const normalized = normalizeSlotValue(value);
      slots[key] = () => normalized;
    }
  }
};
const normalizeVNodeSlots = (instance2, children) => {
  if (process.env.NODE_ENV !== "production" && !isKeepAlive(instance2.vnode) && true) {
    warn(`Non-function value encountered for default slot. Prefer function slots for better performance.`);
  }
  const normalized = normalizeSlotValue(children);
  instance2.slots.default = () => normalized;
};
const initSlots = (instance2, children) => {
  if (instance2.vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      instance2.slots = toRaw(children);
      def(children, "_", type);
    } else {
      normalizeObjectSlots(children, instance2.slots = {});
    }
  } else {
    instance2.slots = {};
    if (children) {
      normalizeVNodeSlots(instance2, children);
    }
  }
  def(instance2.slots, InternalObjectKey, 1);
};
const updateSlots = (instance2, children, optimized) => {
  const { vnode, slots } = instance2;
  let needDeletionCheck = true;
  let deletionComparisonTarget = EMPTY_OBJ;
  if (vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      if (process.env.NODE_ENV !== "production" && isHmrUpdating) {
        extend$2(slots, children);
      } else if (optimized && type === 1) {
        needDeletionCheck = false;
      } else {
        extend$2(slots, children);
        if (!optimized && type === 1) {
          delete slots._;
        }
      }
    } else {
      needDeletionCheck = !children.$stable;
      normalizeObjectSlots(children, slots);
    }
    deletionComparisonTarget = children;
  } else if (children) {
    normalizeVNodeSlots(instance2, children);
    deletionComparisonTarget = { default: 1 };
  }
  if (needDeletionCheck) {
    for (const key in slots) {
      if (!isInternalKey(key) && !(key in deletionComparisonTarget)) {
        delete slots[key];
      }
    }
  }
};
function createAppContext() {
  return {
    app: null,
    config: {
      isNativeTag: NO,
      performance: false,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let uid = 0;
function createAppAPI(render2, hydrate) {
  return function createApp2(rootComponent, rootProps = null) {
    if (!isFunction$2(rootComponent)) {
      rootComponent = Object.assign({}, rootComponent);
    }
    if (rootProps != null && !isObject$2(rootProps)) {
      process.env.NODE_ENV !== "production" && warn(`root props passed to app.mount() must be an object.`);
      rootProps = null;
    }
    const context = createAppContext();
    const installedPlugins = /* @__PURE__ */ new Set();
    let isMounted = false;
    const app = context.app = {
      _uid: uid++,
      _component: rootComponent,
      _props: rootProps,
      _container: null,
      _context: context,
      _instance: null,
      version,
      get config() {
        return context.config;
      },
      set config(v) {
        if (process.env.NODE_ENV !== "production") {
          warn(`app.config cannot be replaced. Modify individual options instead.`);
        }
      },
      use(plugin, ...options) {
        if (installedPlugins.has(plugin)) {
          process.env.NODE_ENV !== "production" && warn(`Plugin has already been applied to target app.`);
        } else if (plugin && isFunction$2(plugin.install)) {
          installedPlugins.add(plugin);
          plugin.install(app, ...options);
        } else if (isFunction$2(plugin)) {
          installedPlugins.add(plugin);
          plugin(app, ...options);
        } else if (process.env.NODE_ENV !== "production") {
          warn(`A plugin must either be a function or an object with an "install" function.`);
        }
        return app;
      },
      mixin(mixin) {
        {
          if (!context.mixins.includes(mixin)) {
            context.mixins.push(mixin);
          } else if (process.env.NODE_ENV !== "production") {
            warn("Mixin has already been applied to target app" + (mixin.name ? `: ${mixin.name}` : ""));
          }
        }
        return app;
      },
      component(name2, component) {
        if (process.env.NODE_ENV !== "production") {
          validateComponentName(name2, context.config);
        }
        if (!component) {
          return context.components[name2];
        }
        if (process.env.NODE_ENV !== "production" && context.components[name2]) {
          warn(`Component "${name2}" has already been registered in target app.`);
        }
        context.components[name2] = component;
        return app;
      },
      directive(name2, directive) {
        if (process.env.NODE_ENV !== "production") {
          validateDirectiveName(name2);
        }
        if (!directive) {
          return context.directives[name2];
        }
        if (process.env.NODE_ENV !== "production" && context.directives[name2]) {
          warn(`Directive "${name2}" has already been registered in target app.`);
        }
        context.directives[name2] = directive;
        return app;
      },
      mount(rootContainer, isHydrate, isSVG) {
        if (!isMounted) {
          if (process.env.NODE_ENV !== "production" && rootContainer.__vue_app__) {
            warn(`There is already an app instance mounted on the host container.
 If you want to mount another app on the same host container, you need to unmount the previous app by calling \`app.unmount()\` first.`);
          }
          const vnode = createVNode(rootComponent, rootProps);
          vnode.appContext = context;
          if (process.env.NODE_ENV !== "production") {
            context.reload = () => {
              render2(cloneVNode(vnode), rootContainer, isSVG);
            };
          }
          if (isHydrate && hydrate) {
            hydrate(vnode, rootContainer);
          } else {
            render2(vnode, rootContainer, isSVG);
          }
          isMounted = true;
          app._container = rootContainer;
          rootContainer.__vue_app__ = app;
          if (process.env.NODE_ENV !== "production" || false) {
            app._instance = vnode.component;
            devtoolsInitApp(app, version);
          }
          return getExposeProxy(vnode.component) || vnode.component.proxy;
        } else if (process.env.NODE_ENV !== "production") {
          warn(`App has already been mounted.
If you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. \`const createMyApp = () => createApp(App)\``);
        }
      },
      unmount() {
        if (isMounted) {
          render2(null, app._container);
          if (process.env.NODE_ENV !== "production" || false) {
            app._instance = null;
            devtoolsUnmountApp(app);
          }
          delete app._container.__vue_app__;
        } else if (process.env.NODE_ENV !== "production") {
          warn(`Cannot unmount an app that is not mounted.`);
        }
      },
      provide(key, value) {
        if (process.env.NODE_ENV !== "production" && key in context.provides) {
          warn(`App already provides property with key "${String(key)}". It will be overwritten with the new value.`);
        }
        context.provides[key] = value;
        return app;
      }
    };
    return app;
  };
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
  if (isArray$1(rawRef)) {
    rawRef.forEach((r, i) => setRef(r, oldRawRef && (isArray$1(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
    return;
  }
  if (isAsyncWrapper(vnode) && !isUnmount) {
    return;
  }
  const refValue = vnode.shapeFlag & 4 ? getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
  const value = isUnmount ? null : refValue;
  const { i: owner, r: ref2 } = rawRef;
  if (process.env.NODE_ENV !== "production" && !owner) {
    warn(`Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function.`);
    return;
  }
  const oldRef = oldRawRef && oldRawRef.r;
  const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
  const setupState = owner.setupState;
  if (oldRef != null && oldRef !== ref2) {
    if (isString$1(oldRef)) {
      refs[oldRef] = null;
      if (hasOwn(setupState, oldRef)) {
        setupState[oldRef] = null;
      }
    } else if (isRef(oldRef)) {
      oldRef.value = null;
    }
  }
  if (isFunction$2(ref2)) {
    callWithErrorHandling(ref2, owner, 12, [value, refs]);
  } else {
    const _isString = isString$1(ref2);
    const _isRef = isRef(ref2);
    if (_isString || _isRef) {
      const doSet = () => {
        if (rawRef.f) {
          const existing = _isString ? refs[ref2] : ref2.value;
          if (isUnmount) {
            isArray$1(existing) && remove(existing, refValue);
          } else {
            if (!isArray$1(existing)) {
              if (_isString) {
                refs[ref2] = [refValue];
                if (hasOwn(setupState, ref2)) {
                  setupState[ref2] = refs[ref2];
                }
              } else {
                ref2.value = [refValue];
                if (rawRef.k)
                  refs[rawRef.k] = ref2.value;
              }
            } else if (!existing.includes(refValue)) {
              existing.push(refValue);
            }
          }
        } else if (_isString) {
          refs[ref2] = value;
          if (hasOwn(setupState, ref2)) {
            setupState[ref2] = value;
          }
        } else if (_isRef) {
          ref2.value = value;
          if (rawRef.k)
            refs[rawRef.k] = value;
        } else if (process.env.NODE_ENV !== "production") {
          warn("Invalid template ref type:", ref2, `(${typeof ref2})`);
        }
      };
      if (value) {
        doSet.id = -1;
        queuePostRenderEffect(doSet, parentSuspense);
      } else {
        doSet();
      }
    } else if (process.env.NODE_ENV !== "production") {
      warn("Invalid template ref type:", ref2, `(${typeof ref2})`);
    }
  }
}
let supported;
let perf;
function startMeasure(instance2, type) {
  if (instance2.appContext.config.performance && isSupported()) {
    perf.mark(`vue-${type}-${instance2.uid}`);
  }
  if (process.env.NODE_ENV !== "production" || false) {
    devtoolsPerfStart(instance2, type, isSupported() ? perf.now() : Date.now());
  }
}
function endMeasure(instance2, type) {
  if (instance2.appContext.config.performance && isSupported()) {
    const startTag = `vue-${type}-${instance2.uid}`;
    const endTag = startTag + `:end`;
    perf.mark(endTag);
    perf.measure(`<${formatComponentName(instance2, instance2.type)}> ${type}`, startTag, endTag);
    perf.clearMarks(startTag);
    perf.clearMarks(endTag);
  }
  if (process.env.NODE_ENV !== "production" || false) {
    devtoolsPerfEnd(instance2, type, isSupported() ? perf.now() : Date.now());
  }
}
function isSupported() {
  if (supported !== void 0) {
    return supported;
  }
  if (typeof window !== "undefined" && window.performance) {
    supported = true;
    perf = window.performance;
  } else {
    supported = false;
  }
  return supported;
}
function initFeatureFlags() {
  const needWarn = [];
  if (process.env.NODE_ENV !== "production" && needWarn.length) {
    const multi = needWarn.length > 1;
    console.warn(`Feature flag${multi ? `s` : ``} ${needWarn.join(", ")} ${multi ? `are` : `is`} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`);
  }
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
  return baseCreateRenderer(options);
}
function baseCreateRenderer(options, createHydrationFns) {
  {
    initFeatureFlags();
  }
  const target = getGlobalThis();
  target.__VUE__ = true;
  if (process.env.NODE_ENV !== "production" || false) {
    setDevtoolsHook(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
  }
  const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = NOOP, cloneNode: hostCloneNode, insertStaticContent: hostInsertStaticContent } = options;
  const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = process.env.NODE_ENV !== "production" && isHmrUpdating ? false : !!n2.dynamicChildren) => {
    if (n1 === n2) {
      return;
    }
    if (n1 && !isSameVNodeType(n1, n2)) {
      anchor = getNextHostNode(n1);
      unmount2(n1, parentComponent, parentSuspense, true);
      n1 = null;
    }
    if (n2.patchFlag === -2) {
      optimized = false;
      n2.dynamicChildren = null;
    }
    const { type, ref: ref2, shapeFlag } = n2;
    switch (type) {
      case Text:
        processText(n1, n2, container, anchor);
        break;
      case Comment:
        processCommentNode(n1, n2, container, anchor);
        break;
      case Static:
        if (n1 == null) {
          mountStaticNode(n2, container, anchor, isSVG);
        } else if (process.env.NODE_ENV !== "production") {
          patchStaticNode(n1, n2, container, isSVG);
        }
        break;
      case Fragment:
        processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        break;
      default:
        if (shapeFlag & 1) {
          processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (shapeFlag & 6) {
          processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (shapeFlag & 64) {
          type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        } else if (shapeFlag & 128) {
          type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        } else if (process.env.NODE_ENV !== "production") {
          warn("Invalid VNode type:", type, `(${typeof type})`);
        }
    }
    if (ref2 != null && parentComponent) {
      setRef(ref2, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    }
  };
  const processText = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
    } else {
      const el = n2.el = n1.el;
      if (n2.children !== n1.children) {
        hostSetText(el, n2.children);
      }
    }
  };
  const processCommentNode = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
    } else {
      n2.el = n1.el;
    }
  };
  const mountStaticNode = (n2, container, anchor, isSVG) => {
    [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
  };
  const patchStaticNode = (n1, n2, container, isSVG) => {
    if (n2.children !== n1.children) {
      const anchor = hostNextSibling(n1.anchor);
      removeStaticNode(n1);
      [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
    } else {
      n2.el = n1.el;
      n2.anchor = n1.anchor;
    }
  };
  const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostInsert(el, container, nextSibling);
      el = next;
    }
    hostInsert(anchor, container, nextSibling);
  };
  const removeStaticNode = ({ el, anchor }) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostRemove(el);
      el = next;
    }
    hostRemove(anchor);
  };
  const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    isSVG = isSVG || n2.type === "svg";
    if (n1 == null) {
      mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    } else {
      patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
  };
  const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    let el;
    let vnodeHook;
    const { type, props, shapeFlag, transition, patchFlag, dirs } = vnode;
    if (!(process.env.NODE_ENV !== "production") && vnode.el && hostCloneNode !== void 0 && patchFlag === -1) {
      el = vnode.el = hostCloneNode(vnode.el);
    } else {
      el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
      if (shapeFlag & 8) {
        hostSetElementText(el, vnode.children);
      } else if (shapeFlag & 16) {
        mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
      }
      if (dirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "created");
      }
      if (props) {
        for (const key in props) {
          if (key !== "value" && !isReservedProp(key)) {
            hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
          }
        }
        if ("value" in props) {
          hostPatchProp(el, "value", null, props.value);
        }
        if (vnodeHook = props.onVnodeBeforeMount) {
          invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
      }
      setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
    }
    if (process.env.NODE_ENV !== "production" || false) {
      Object.defineProperty(el, "__vnode", {
        value: vnode,
        enumerable: false
      });
      Object.defineProperty(el, "__vueParentComponent", {
        value: parentComponent,
        enumerable: false
      });
    }
    if (dirs) {
      invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
    }
    const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
    if (needCallTransitionHooks) {
      transition.beforeEnter(el);
    }
    hostInsert(el, container, anchor);
    if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        needCallTransitionHooks && transition.enter(el);
        dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
      }, parentSuspense);
    }
  };
  const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
    if (scopeId) {
      hostSetScopeId(el, scopeId);
    }
    if (slotScopeIds) {
      for (let i = 0; i < slotScopeIds.length; i++) {
        hostSetScopeId(el, slotScopeIds[i]);
      }
    }
    if (parentComponent) {
      let subTree = parentComponent.subTree;
      if (process.env.NODE_ENV !== "production" && subTree.patchFlag > 0 && subTree.patchFlag & 2048) {
        subTree = filterSingleRoot(subTree.children) || subTree;
      }
      if (vnode === subTree) {
        const parentVNode = parentComponent.vnode;
        setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
      }
    }
  };
  const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0) => {
    for (let i = start; i < children.length; i++) {
      const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
      patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
  };
  const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    const el = n2.el = n1.el;
    let { patchFlag, dynamicChildren, dirs } = n2;
    patchFlag |= n1.patchFlag & 16;
    const oldProps = n1.props || EMPTY_OBJ;
    const newProps = n2.props || EMPTY_OBJ;
    let vnodeHook;
    parentComponent && toggleRecurse(parentComponent, false);
    if (vnodeHook = newProps.onVnodeBeforeUpdate) {
      invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
    }
    if (dirs) {
      invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
    }
    parentComponent && toggleRecurse(parentComponent, true);
    if (process.env.NODE_ENV !== "production" && isHmrUpdating) {
      patchFlag = 0;
      optimized = false;
      dynamicChildren = null;
    }
    const areChildrenSVG = isSVG && n2.type !== "foreignObject";
    if (dynamicChildren) {
      patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
      if (process.env.NODE_ENV !== "production" && parentComponent && parentComponent.type.__hmrId) {
        traverseStaticChildren(n1, n2);
      }
    } else if (!optimized) {
      patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
    }
    if (patchFlag > 0) {
      if (patchFlag & 16) {
        patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
      } else {
        if (patchFlag & 2) {
          if (oldProps.class !== newProps.class) {
            hostPatchProp(el, "class", null, newProps.class, isSVG);
          }
        }
        if (patchFlag & 4) {
          hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
        }
        if (patchFlag & 8) {
          const propsToUpdate = n2.dynamicProps;
          for (let i = 0; i < propsToUpdate.length; i++) {
            const key = propsToUpdate[i];
            const prev = oldProps[key];
            const next = newProps[key];
            if (next !== prev || key === "value") {
              hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
            }
          }
        }
      }
      if (patchFlag & 1) {
        if (n1.children !== n2.children) {
          hostSetElementText(el, n2.children);
        }
      }
    } else if (!optimized && dynamicChildren == null) {
      patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
    }
    if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
      }, parentSuspense);
    }
  };
  const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds) => {
    for (let i = 0; i < newChildren.length; i++) {
      const oldVNode = oldChildren[i];
      const newVNode = newChildren[i];
      const container = oldVNode.el && (oldVNode.type === Fragment || !isSameVNodeType(oldVNode, newVNode) || oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : fallbackContainer;
      patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
    }
  };
  const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) => {
    if (oldProps !== newProps) {
      for (const key in newProps) {
        if (isReservedProp(key))
          continue;
        const next = newProps[key];
        const prev = oldProps[key];
        if (next !== prev && key !== "value") {
          hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
        }
      }
      if (oldProps !== EMPTY_OBJ) {
        for (const key in oldProps) {
          if (!isReservedProp(key) && !(key in newProps)) {
            hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
          }
        }
      }
      if ("value" in newProps) {
        hostPatchProp(el, "value", oldProps.value, newProps.value);
      }
    }
  };
  const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
    const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
    let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
    if (process.env.NODE_ENV !== "production" && (isHmrUpdating || patchFlag & 2048)) {
      patchFlag = 0;
      optimized = false;
      dynamicChildren = null;
    }
    if (fragmentSlotScopeIds) {
      slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
    }
    if (n1 == null) {
      hostInsert(fragmentStartAnchor, container, anchor);
      hostInsert(fragmentEndAnchor, container, anchor);
      mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    } else {
      if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && n1.dynamicChildren) {
        patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
        if (process.env.NODE_ENV !== "production" && parentComponent && parentComponent.type.__hmrId) {
          traverseStaticChildren(n1, n2);
        } else if (n2.key != null || parentComponent && n2 === parentComponent.subTree) {
          traverseStaticChildren(n1, n2, true);
        }
      } else {
        patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      }
    }
  };
  const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    n2.slotScopeIds = slotScopeIds;
    if (n1 == null) {
      if (n2.shapeFlag & 512) {
        parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
      } else {
        mountComponent2(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
      }
    } else {
      updateComponent(n1, n2, optimized);
    }
  };
  const mountComponent2 = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) => {
    const instance2 = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
    if (process.env.NODE_ENV !== "production" && instance2.type.__hmrId) {
      registerHMR(instance2);
    }
    if (process.env.NODE_ENV !== "production") {
      pushWarningContext(initialVNode);
      startMeasure(instance2, `mount`);
    }
    if (isKeepAlive(initialVNode)) {
      instance2.ctx.renderer = internals;
    }
    {
      if (process.env.NODE_ENV !== "production") {
        startMeasure(instance2, `init`);
      }
      setupComponent(instance2);
      if (process.env.NODE_ENV !== "production") {
        endMeasure(instance2, `init`);
      }
    }
    if (instance2.asyncDep) {
      parentSuspense && parentSuspense.registerDep(instance2, setupRenderEffect);
      if (!initialVNode.el) {
        const placeholder = instance2.subTree = createVNode(Comment);
        processCommentNode(null, placeholder, container, anchor);
      }
      return;
    }
    setupRenderEffect(instance2, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    if (process.env.NODE_ENV !== "production") {
      popWarningContext();
      endMeasure(instance2, `mount`);
    }
  };
  const updateComponent = (n1, n2, optimized) => {
    const instance2 = n2.component = n1.component;
    if (shouldUpdateComponent(n1, n2, optimized)) {
      if (instance2.asyncDep && !instance2.asyncResolved) {
        if (process.env.NODE_ENV !== "production") {
          pushWarningContext(n2);
        }
        updateComponentPreRender(instance2, n2, optimized);
        if (process.env.NODE_ENV !== "production") {
          popWarningContext();
        }
        return;
      } else {
        instance2.next = n2;
        invalidateJob(instance2.update);
        instance2.update();
      }
    } else {
      n2.el = n1.el;
      instance2.vnode = n2;
    }
  };
  const setupRenderEffect = (instance2, initialVNode, container, anchor, parentSuspense, isSVG, optimized) => {
    const componentUpdateFn = () => {
      if (!instance2.isMounted) {
        let vnodeHook;
        const { el, props } = initialVNode;
        const { bm, m, parent } = instance2;
        const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
        toggleRecurse(instance2, false);
        if (bm) {
          invokeArrayFns(bm);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
          invokeVNodeHook(vnodeHook, parent, initialVNode);
        }
        toggleRecurse(instance2, true);
        if (el && hydrateNode) {
          const hydrateSubTree = () => {
            if (process.env.NODE_ENV !== "production") {
              startMeasure(instance2, `render`);
            }
            instance2.subTree = renderComponentRoot(instance2);
            if (process.env.NODE_ENV !== "production") {
              endMeasure(instance2, `render`);
            }
            if (process.env.NODE_ENV !== "production") {
              startMeasure(instance2, `hydrate`);
            }
            hydrateNode(el, instance2.subTree, instance2, parentSuspense, null);
            if (process.env.NODE_ENV !== "production") {
              endMeasure(instance2, `hydrate`);
            }
          };
          if (isAsyncWrapperVNode) {
            initialVNode.type.__asyncLoader().then(
              () => !instance2.isUnmounted && hydrateSubTree()
            );
          } else {
            hydrateSubTree();
          }
        } else {
          if (process.env.NODE_ENV !== "production") {
            startMeasure(instance2, `render`);
          }
          const subTree = instance2.subTree = renderComponentRoot(instance2);
          if (process.env.NODE_ENV !== "production") {
            endMeasure(instance2, `render`);
          }
          if (process.env.NODE_ENV !== "production") {
            startMeasure(instance2, `patch`);
          }
          patch(null, subTree, container, anchor, instance2, parentSuspense, isSVG);
          if (process.env.NODE_ENV !== "production") {
            endMeasure(instance2, `patch`);
          }
          initialVNode.el = subTree.el;
        }
        if (m) {
          queuePostRenderEffect(m, parentSuspense);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
          const scopedInitialVNode = initialVNode;
          queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
        }
        if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) {
          instance2.a && queuePostRenderEffect(instance2.a, parentSuspense);
        }
        instance2.isMounted = true;
        if (process.env.NODE_ENV !== "production" || false) {
          devtoolsComponentAdded(instance2);
        }
        initialVNode = container = anchor = null;
      } else {
        let { next, bu, u, parent, vnode } = instance2;
        let originNext = next;
        let vnodeHook;
        if (process.env.NODE_ENV !== "production") {
          pushWarningContext(next || instance2.vnode);
        }
        toggleRecurse(instance2, false);
        if (next) {
          next.el = vnode.el;
          updateComponentPreRender(instance2, next, optimized);
        } else {
          next = vnode;
        }
        if (bu) {
          invokeArrayFns(bu);
        }
        if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
          invokeVNodeHook(vnodeHook, parent, next, vnode);
        }
        toggleRecurse(instance2, true);
        if (process.env.NODE_ENV !== "production") {
          startMeasure(instance2, `render`);
        }
        const nextTree = renderComponentRoot(instance2);
        if (process.env.NODE_ENV !== "production") {
          endMeasure(instance2, `render`);
        }
        const prevTree = instance2.subTree;
        instance2.subTree = nextTree;
        if (process.env.NODE_ENV !== "production") {
          startMeasure(instance2, `patch`);
        }
        patch(
          prevTree,
          nextTree,
          hostParentNode(prevTree.el),
          getNextHostNode(prevTree),
          instance2,
          parentSuspense,
          isSVG
        );
        if (process.env.NODE_ENV !== "production") {
          endMeasure(instance2, `patch`);
        }
        next.el = nextTree.el;
        if (originNext === null) {
          updateHOCHostEl(instance2, nextTree.el);
        }
        if (u) {
          queuePostRenderEffect(u, parentSuspense);
        }
        if (vnodeHook = next.props && next.props.onVnodeUpdated) {
          queuePostRenderEffect(() => invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
        }
        if (process.env.NODE_ENV !== "production" || false) {
          devtoolsComponentUpdated(instance2);
        }
        if (process.env.NODE_ENV !== "production") {
          popWarningContext();
        }
      }
    };
    const effect = instance2.effect = new ReactiveEffect(
      componentUpdateFn,
      () => queueJob(update),
      instance2.scope
    );
    const update = instance2.update = () => effect.run();
    update.id = instance2.uid;
    toggleRecurse(instance2, true);
    if (process.env.NODE_ENV !== "production") {
      effect.onTrack = instance2.rtc ? (e) => invokeArrayFns(instance2.rtc, e) : void 0;
      effect.onTrigger = instance2.rtg ? (e) => invokeArrayFns(instance2.rtg, e) : void 0;
      update.ownerInstance = instance2;
    }
    update();
  };
  const updateComponentPreRender = (instance2, nextVNode, optimized) => {
    nextVNode.component = instance2;
    const prevProps = instance2.vnode.props;
    instance2.vnode = nextVNode;
    instance2.next = null;
    updateProps(instance2, nextVNode.props, prevProps, optimized);
    updateSlots(instance2, nextVNode.children, optimized);
    pauseTracking();
    flushPreFlushCbs(void 0, instance2.update);
    resetTracking();
  };
  const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false) => {
    const c1 = n1 && n1.children;
    const prevShapeFlag = n1 ? n1.shapeFlag : 0;
    const c2 = n2.children;
    const { patchFlag, shapeFlag } = n2;
    if (patchFlag > 0) {
      if (patchFlag & 128) {
        patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        return;
      } else if (patchFlag & 256) {
        patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        return;
      }
    }
    if (shapeFlag & 8) {
      if (prevShapeFlag & 16) {
        unmountChildren(c1, parentComponent, parentSuspense);
      }
      if (c2 !== c1) {
        hostSetElementText(container, c2);
      }
    } else {
      if (prevShapeFlag & 16) {
        if (shapeFlag & 16) {
          patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else {
          unmountChildren(c1, parentComponent, parentSuspense, true);
        }
      } else {
        if (prevShapeFlag & 8) {
          hostSetElementText(container, "");
        }
        if (shapeFlag & 16) {
          mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
      }
    }
  };
  const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    c1 = c1 || EMPTY_ARR;
    c2 = c2 || EMPTY_ARR;
    const oldLength = c1.length;
    const newLength = c2.length;
    const commonLength = Math.min(oldLength, newLength);
    let i;
    for (i = 0; i < commonLength; i++) {
      const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    }
    if (oldLength > newLength) {
      unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
    } else {
      mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    }
  };
  const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) => {
    let i = 0;
    const l2 = c2.length;
    let e1 = c1.length - 1;
    let e2 = l2 - 1;
    while (i <= e1 && i <= e2) {
      const n1 = c1[i];
      const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      if (isSameVNodeType(n1, n2)) {
        patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        break;
      }
      i++;
    }
    while (i <= e1 && i <= e2) {
      const n1 = c1[e1];
      const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
      if (isSameVNodeType(n1, n2)) {
        patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
      } else {
        break;
      }
      e1--;
      e2--;
    }
    if (i > e1) {
      if (i <= e2) {
        const nextPos = e2 + 1;
        const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
        while (i <= e2) {
          patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          i++;
        }
      }
    } else if (i > e2) {
      while (i <= e1) {
        unmount2(c1[i], parentComponent, parentSuspense, true);
        i++;
      }
    } else {
      const s1 = i;
      const s2 = i;
      const keyToNewIndexMap = /* @__PURE__ */ new Map();
      for (i = s2; i <= e2; i++) {
        const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        if (nextChild.key != null) {
          if (process.env.NODE_ENV !== "production" && keyToNewIndexMap.has(nextChild.key)) {
            warn(`Duplicate keys found during update:`, JSON.stringify(nextChild.key), `Make sure keys are unique.`);
          }
          keyToNewIndexMap.set(nextChild.key, i);
        }
      }
      let j;
      let patched = 0;
      const toBePatched = e2 - s2 + 1;
      let moved = false;
      let maxNewIndexSoFar = 0;
      const newIndexToOldIndexMap = new Array(toBePatched);
      for (i = 0; i < toBePatched; i++)
        newIndexToOldIndexMap[i] = 0;
      for (i = s1; i <= e1; i++) {
        const prevChild = c1[i];
        if (patched >= toBePatched) {
          unmount2(prevChild, parentComponent, parentSuspense, true);
          continue;
        }
        let newIndex;
        if (prevChild.key != null) {
          newIndex = keyToNewIndexMap.get(prevChild.key);
        } else {
          for (j = s2; j <= e2; j++) {
            if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
              newIndex = j;
              break;
            }
          }
        }
        if (newIndex === void 0) {
          unmount2(prevChild, parentComponent, parentSuspense, true);
        } else {
          newIndexToOldIndexMap[newIndex - s2] = i + 1;
          if (newIndex >= maxNewIndexSoFar) {
            maxNewIndexSoFar = newIndex;
          } else {
            moved = true;
          }
          patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
          patched++;
        }
      }
      const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
      j = increasingNewIndexSequence.length - 1;
      for (i = toBePatched - 1; i >= 0; i--) {
        const nextIndex = s2 + i;
        const nextChild = c2[nextIndex];
        const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
        if (newIndexToOldIndexMap[i] === 0) {
          patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (moved) {
          if (j < 0 || i !== increasingNewIndexSequence[j]) {
            move(nextChild, container, anchor, 2);
          } else {
            j--;
          }
        }
      }
    }
  };
  const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
    const { el, type, transition, children, shapeFlag } = vnode;
    if (shapeFlag & 6) {
      move(vnode.component.subTree, container, anchor, moveType);
      return;
    }
    if (shapeFlag & 128) {
      vnode.suspense.move(container, anchor, moveType);
      return;
    }
    if (shapeFlag & 64) {
      type.move(vnode, container, anchor, internals);
      return;
    }
    if (type === Fragment) {
      hostInsert(el, container, anchor);
      for (let i = 0; i < children.length; i++) {
        move(children[i], container, anchor, moveType);
      }
      hostInsert(vnode.anchor, container, anchor);
      return;
    }
    if (type === Static) {
      moveStaticNode(vnode, container, anchor);
      return;
    }
    const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
    if (needTransition) {
      if (moveType === 0) {
        transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        queuePostRenderEffect(() => transition.enter(el), parentSuspense);
      } else {
        const { leave, delayLeave, afterLeave } = transition;
        const remove3 = () => hostInsert(el, container, anchor);
        const performLeave = () => {
          leave(el, () => {
            remove3();
            afterLeave && afterLeave();
          });
        };
        if (delayLeave) {
          delayLeave(el, remove3, performLeave);
        } else {
          performLeave();
        }
      }
    } else {
      hostInsert(el, container, anchor);
    }
  };
  const unmount2 = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
    const { type, props, ref: ref2, children, dynamicChildren, shapeFlag, patchFlag, dirs } = vnode;
    if (ref2 != null) {
      setRef(ref2, null, parentSuspense, vnode, true);
    }
    if (shapeFlag & 256) {
      parentComponent.ctx.deactivate(vnode);
      return;
    }
    const shouldInvokeDirs = shapeFlag & 1 && dirs;
    const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
    let vnodeHook;
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
      invokeVNodeHook(vnodeHook, parentComponent, vnode);
    }
    if (shapeFlag & 6) {
      unmountComponent(vnode.component, parentSuspense, doRemove);
    } else {
      if (shapeFlag & 128) {
        vnode.suspense.unmount(parentSuspense, doRemove);
        return;
      }
      if (shouldInvokeDirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
      }
      if (shapeFlag & 64) {
        vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
      } else if (dynamicChildren && (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
        unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
      } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
        unmountChildren(children, parentComponent, parentSuspense);
      }
      if (doRemove) {
        remove2(vnode);
      }
    }
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
      }, parentSuspense);
    }
  };
  const remove2 = (vnode) => {
    const { type, el, anchor, transition } = vnode;
    if (type === Fragment) {
      if (process.env.NODE_ENV !== "production" && vnode.patchFlag > 0 && vnode.patchFlag & 2048 && transition && !transition.persisted) {
        vnode.children.forEach((child) => {
          if (child.type === Comment) {
            hostRemove(child.el);
          } else {
            remove2(child);
          }
        });
      } else {
        removeFragment(el, anchor);
      }
      return;
    }
    if (type === Static) {
      removeStaticNode(vnode);
      return;
    }
    const performRemove = () => {
      hostRemove(el);
      if (transition && !transition.persisted && transition.afterLeave) {
        transition.afterLeave();
      }
    };
    if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
      const { leave, delayLeave } = transition;
      const performLeave = () => leave(el, performRemove);
      if (delayLeave) {
        delayLeave(vnode.el, performRemove, performLeave);
      } else {
        performLeave();
      }
    } else {
      performRemove();
    }
  };
  const removeFragment = (cur, end) => {
    let next;
    while (cur !== end) {
      next = hostNextSibling(cur);
      hostRemove(cur);
      cur = next;
    }
    hostRemove(end);
  };
  const unmountComponent = (instance2, parentSuspense, doRemove) => {
    if (process.env.NODE_ENV !== "production" && instance2.type.__hmrId) {
      unregisterHMR(instance2);
    }
    const { bum, scope, update, subTree, um } = instance2;
    if (bum) {
      invokeArrayFns(bum);
    }
    scope.stop();
    if (update) {
      update.active = false;
      unmount2(subTree, instance2, parentSuspense, doRemove);
    }
    if (um) {
      queuePostRenderEffect(um, parentSuspense);
    }
    queuePostRenderEffect(() => {
      instance2.isUnmounted = true;
    }, parentSuspense);
    if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance2.asyncDep && !instance2.asyncResolved && instance2.suspenseId === parentSuspense.pendingId) {
      parentSuspense.deps--;
      if (parentSuspense.deps === 0) {
        parentSuspense.resolve();
      }
    }
    if (process.env.NODE_ENV !== "production" || false) {
      devtoolsComponentRemoved(instance2);
    }
  };
  const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
    for (let i = start; i < children.length; i++) {
      unmount2(children[i], parentComponent, parentSuspense, doRemove, optimized);
    }
  };
  const getNextHostNode = (vnode) => {
    if (vnode.shapeFlag & 6) {
      return getNextHostNode(vnode.component.subTree);
    }
    if (vnode.shapeFlag & 128) {
      return vnode.suspense.next();
    }
    return hostNextSibling(vnode.anchor || vnode.el);
  };
  const render2 = (vnode, container, isSVG) => {
    if (vnode == null) {
      if (container._vnode) {
        unmount2(container._vnode, null, null, true);
      }
    } else {
      patch(container._vnode || null, vnode, container, null, null, null, isSVG);
    }
    flushPostFlushCbs();
    container._vnode = vnode;
  };
  const internals = {
    p: patch,
    um: unmount2,
    m: move,
    r: remove2,
    mt: mountComponent2,
    mc: mountChildren,
    pc: patchChildren,
    pbc: patchBlockChildren,
    n: getNextHostNode,
    o: options
  };
  let hydrate;
  let hydrateNode;
  if (createHydrationFns) {
    [hydrate, hydrateNode] = createHydrationFns(internals);
  }
  return {
    render: render2,
    hydrate,
    createApp: createAppAPI(render2, hydrate)
  };
}
function toggleRecurse({ effect, update }, allowed) {
  effect.allowRecurse = update.allowRecurse = allowed;
}
function traverseStaticChildren(n1, n2, shallow = false) {
  const ch1 = n1.children;
  const ch2 = n2.children;
  if (isArray$1(ch1) && isArray$1(ch2)) {
    for (let i = 0; i < ch1.length; i++) {
      const c1 = ch1[i];
      let c2 = ch2[i];
      if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
        if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
          c2 = ch2[i] = cloneIfMounted(ch2[i]);
          c2.el = c1.el;
        }
        if (!shallow)
          traverseStaticChildren(c1, c2);
      }
      if (process.env.NODE_ENV !== "production" && c2.type === Comment && !c2.el) {
        c2.el = c1.el;
      }
    }
  }
}
function getSequence(arr) {
  const p2 = arr.slice();
  const result = [0];
  let i, j, u, v, c;
  const len = arr.length;
  for (i = 0; i < len; i++) {
    const arrI = arr[i];
    if (arrI !== 0) {
      j = result[result.length - 1];
      if (arr[j] < arrI) {
        p2[i] = j;
        result.push(i);
        continue;
      }
      u = 0;
      v = result.length - 1;
      while (u < v) {
        c = u + v >> 1;
        if (arr[result[c]] < arrI) {
          u = c + 1;
        } else {
          v = c;
        }
      }
      if (arrI < arr[result[u]]) {
        if (u > 0) {
          p2[i] = result[u - 1];
        }
        result[u] = i;
      }
    }
  }
  u = result.length;
  v = result[u - 1];
  while (u-- > 0) {
    result[u] = v;
    v = p2[v];
  }
  return result;
}
const isTeleport = (type) => type.__isTeleport;
const isTeleportDisabled = (props) => props && (props.disabled || props.disabled === "");
const isTargetSVG = (target) => typeof SVGElement !== "undefined" && target instanceof SVGElement;
const resolveTarget = (props, select) => {
  const targetSelector = props && props.to;
  if (isString$1(targetSelector)) {
    if (!select) {
      process.env.NODE_ENV !== "production" && warn(`Current renderer does not support string target for Teleports. (missing querySelector renderer option)`);
      return null;
    } else {
      const target = select(targetSelector);
      if (!target) {
        process.env.NODE_ENV !== "production" && warn(`Failed to locate Teleport target with selector "${targetSelector}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`);
      }
      return target;
    }
  } else {
    if (process.env.NODE_ENV !== "production" && !targetSelector && !isTeleportDisabled(props)) {
      warn(`Invalid Teleport target: ${targetSelector}`);
    }
    return targetSelector;
  }
};
const TeleportImpl = {
  __isTeleport: true,
  process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
    const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
    const disabled = isTeleportDisabled(n2.props);
    let { shapeFlag, children, dynamicChildren } = n2;
    if (process.env.NODE_ENV !== "production" && isHmrUpdating) {
      optimized = false;
      dynamicChildren = null;
    }
    if (n1 == null) {
      const placeholder = n2.el = process.env.NODE_ENV !== "production" ? createComment("teleport start") : createText("");
      const mainAnchor = n2.anchor = process.env.NODE_ENV !== "production" ? createComment("teleport end") : createText("");
      insert(placeholder, container, anchor);
      insert(mainAnchor, container, anchor);
      const target = n2.target = resolveTarget(n2.props, querySelector);
      const targetAnchor = n2.targetAnchor = createText("");
      if (target) {
        insert(targetAnchor, target);
        isSVG = isSVG || isTargetSVG(target);
      } else if (process.env.NODE_ENV !== "production" && !disabled) {
        warn("Invalid Teleport target on mount:", target, `(${typeof target})`);
      }
      const mount = (container2, anchor2) => {
        if (shapeFlag & 16) {
          mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
      };
      if (disabled) {
        mount(container, mainAnchor);
      } else if (target) {
        mount(target, targetAnchor);
      }
    } else {
      n2.el = n1.el;
      const mainAnchor = n2.anchor = n1.anchor;
      const target = n2.target = n1.target;
      const targetAnchor = n2.targetAnchor = n1.targetAnchor;
      const wasDisabled = isTeleportDisabled(n1.props);
      const currentContainer = wasDisabled ? container : target;
      const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
      isSVG = isSVG || isTargetSVG(target);
      if (dynamicChildren) {
        patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
        traverseStaticChildren(n1, n2, true);
      } else if (!optimized) {
        patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
      }
      if (disabled) {
        if (!wasDisabled) {
          moveTeleport(n2, container, mainAnchor, internals, 1);
        }
      } else {
        if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
          const nextTarget = n2.target = resolveTarget(n2.props, querySelector);
          if (nextTarget) {
            moveTeleport(n2, nextTarget, null, internals, 0);
          } else if (process.env.NODE_ENV !== "production") {
            warn("Invalid Teleport target on update:", target, `(${typeof target})`);
          }
        } else if (wasDisabled) {
          moveTeleport(n2, target, targetAnchor, internals, 1);
        }
      }
    }
  },
  remove(vnode, parentComponent, parentSuspense, optimized, { um: unmount2, o: { remove: hostRemove } }, doRemove) {
    const { shapeFlag, children, anchor, targetAnchor, target, props } = vnode;
    if (target) {
      hostRemove(targetAnchor);
    }
    if (doRemove || !isTeleportDisabled(props)) {
      hostRemove(anchor);
      if (shapeFlag & 16) {
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          unmount2(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
        }
      }
    }
  },
  move: moveTeleport,
  hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
  if (moveType === 0) {
    insert(vnode.targetAnchor, container, parentAnchor);
  }
  const { el, anchor, shapeFlag, children, props } = vnode;
  const isReorder = moveType === 2;
  if (isReorder) {
    insert(el, container, parentAnchor);
  }
  if (!isReorder || isTeleportDisabled(props)) {
    if (shapeFlag & 16) {
      for (let i = 0; i < children.length; i++) {
        move(children[i], container, parentAnchor, 2);
      }
    }
  }
  if (isReorder) {
    insert(anchor, container, parentAnchor);
  }
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector } }, hydrateChildren) {
  const target = vnode.target = resolveTarget(vnode.props, querySelector);
  if (target) {
    const targetNode = target._lpa || target.firstChild;
    if (vnode.shapeFlag & 16) {
      if (isTeleportDisabled(vnode.props)) {
        vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
        vnode.targetAnchor = targetNode;
      } else {
        vnode.anchor = nextSibling(node);
        let targetAnchor = targetNode;
        while (targetAnchor) {
          targetAnchor = nextSibling(targetAnchor);
          if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
            vnode.targetAnchor = targetAnchor;
            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
            break;
          }
        }
        hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
      }
    }
  }
  return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
const Fragment = Symbol(process.env.NODE_ENV !== "production" ? "Fragment" : void 0);
const Text = Symbol(process.env.NODE_ENV !== "production" ? "Text" : void 0);
const Comment = Symbol(process.env.NODE_ENV !== "production" ? "Comment" : void 0);
const Static = Symbol(process.env.NODE_ENV !== "production" ? "Static" : void 0);
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
  blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
  blockStack.pop();
  currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value) {
  isBlockTreeEnabled += value;
}
function setupBlock(vnode) {
  vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
  closeBlock();
  if (isBlockTreeEnabled > 0 && currentBlock) {
    currentBlock.push(vnode);
  }
  return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
  return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
  return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
  return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
  if (process.env.NODE_ENV !== "production" && n2.shapeFlag & 6 && hmrDirtyComponents.has(n2.type)) {
    return false;
  }
  return n1.type === n2.type && n1.key === n2.key;
}
const createVNodeWithArgsTransform = (...args) => {
  return _createVNode(...args);
};
const InternalObjectKey = `__vInternal`;
const normalizeKey = ({ key }) => key != null ? key : null;
const normalizeRef = ({ ref: ref2, ref_key, ref_for }) => {
  return ref2 != null ? isString$1(ref2) || isRef(ref2) || isFunction$2(ref2) ? { i: currentRenderingInstance, r: ref2, k: ref_key, f: !!ref_for } : ref2 : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
  const vnode = {
    __v_isVNode: true,
    __v_skip: true,
    type,
    props,
    key: props && normalizeKey(props),
    ref: props && normalizeRef(props),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag,
    patchFlag,
    dynamicProps,
    dynamicChildren: null,
    appContext: null
  };
  if (needFullChildrenNormalization) {
    normalizeChildren(vnode, children);
    if (shapeFlag & 128) {
      type.normalize(vnode);
    }
  } else if (children) {
    vnode.shapeFlag |= isString$1(children) ? 8 : 16;
  }
  if (process.env.NODE_ENV !== "production" && vnode.key !== vnode.key) {
    warn(`VNode created with invalid key (NaN). VNode type:`, vnode.type);
  }
  if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock && (vnode.patchFlag > 0 || shapeFlag & 6) && vnode.patchFlag !== 32) {
    currentBlock.push(vnode);
  }
  return vnode;
}
const createVNode = process.env.NODE_ENV !== "production" ? createVNodeWithArgsTransform : _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
  if (!type || type === NULL_DYNAMIC_COMPONENT) {
    if (process.env.NODE_ENV !== "production" && !type) {
      warn(`Invalid vnode type when creating vnode: ${type}.`);
    }
    type = Comment;
  }
  if (isVNode(type)) {
    const cloned = cloneVNode(type, props, true);
    if (children) {
      normalizeChildren(cloned, children);
    }
    if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
      if (cloned.shapeFlag & 6) {
        currentBlock[currentBlock.indexOf(type)] = cloned;
      } else {
        currentBlock.push(cloned);
      }
    }
    cloned.patchFlag |= -2;
    return cloned;
  }
  if (isClassComponent(type)) {
    type = type.__vccOpts;
  }
  if (props) {
    props = guardReactiveProps(props);
    let { class: klass, style: style2 } = props;
    if (klass && !isString$1(klass)) {
      props.class = normalizeClass(klass);
    }
    if (isObject$2(style2)) {
      if (isProxy(style2) && !isArray$1(style2)) {
        style2 = extend$2({}, style2);
      }
      props.style = normalizeStyle(style2);
    }
  }
  const shapeFlag = isString$1(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject$2(type) ? 4 : isFunction$2(type) ? 2 : 0;
  if (process.env.NODE_ENV !== "production" && shapeFlag & 4 && isProxy(type)) {
    type = toRaw(type);
    warn(`Vue received a Component which was made a reactive object. This can lead to unnecessary performance overhead, and should be avoided by marking the component with \`markRaw\` or using \`shallowRef\` instead of \`ref\`.`, `
Component that was made reactive: `, type);
  }
  return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
  if (!props)
    return null;
  return isProxy(props) || InternalObjectKey in props ? extend$2({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false) {
  const { props, ref: ref2, patchFlag, children } = vnode;
  const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
  const cloned = {
    __v_isVNode: true,
    __v_skip: true,
    type: vnode.type,
    props: mergedProps,
    key: mergedProps && normalizeKey(mergedProps),
    ref: extraProps && extraProps.ref ? mergeRef && ref2 ? isArray$1(ref2) ? ref2.concat(normalizeRef(extraProps)) : [ref2, normalizeRef(extraProps)] : normalizeRef(extraProps) : ref2,
    scopeId: vnode.scopeId,
    slotScopeIds: vnode.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && patchFlag === -1 && isArray$1(children) ? children.map(deepCloneVNode) : children,
    target: vnode.target,
    targetAnchor: vnode.targetAnchor,
    staticCount: vnode.staticCount,
    shapeFlag: vnode.shapeFlag,
    patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
    dynamicProps: vnode.dynamicProps,
    dynamicChildren: vnode.dynamicChildren,
    appContext: vnode.appContext,
    dirs: vnode.dirs,
    transition: vnode.transition,
    component: vnode.component,
    suspense: vnode.suspense,
    ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
    ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
    el: vnode.el,
    anchor: vnode.anchor
  };
  return cloned;
}
function deepCloneVNode(vnode) {
  const cloned = cloneVNode(vnode);
  if (isArray$1(vnode.children)) {
    cloned.children = vnode.children.map(deepCloneVNode);
  }
  return cloned;
}
function createTextVNode(text = " ", flag = 0) {
  return createVNode(Text, null, text, flag);
}
function createCommentVNode(text = "", asBlock = false) {
  return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
  if (child == null || typeof child === "boolean") {
    return createVNode(Comment);
  } else if (isArray$1(child)) {
    return createVNode(
      Fragment,
      null,
      child.slice()
    );
  } else if (typeof child === "object") {
    return cloneIfMounted(child);
  } else {
    return createVNode(Text, null, String(child));
  }
}
function cloneIfMounted(child) {
  return child.el === null || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
  let type = 0;
  const { shapeFlag } = vnode;
  if (children == null) {
    children = null;
  } else if (isArray$1(children)) {
    type = 16;
  } else if (typeof children === "object") {
    if (shapeFlag & (1 | 64)) {
      const slot = children.default;
      if (slot) {
        slot._c && (slot._d = false);
        normalizeChildren(vnode, slot());
        slot._c && (slot._d = true);
      }
      return;
    } else {
      type = 32;
      const slotFlag = children._;
      if (!slotFlag && !(InternalObjectKey in children)) {
        children._ctx = currentRenderingInstance;
      } else if (slotFlag === 3 && currentRenderingInstance) {
        if (currentRenderingInstance.slots._ === 1) {
          children._ = 1;
        } else {
          children._ = 2;
          vnode.patchFlag |= 1024;
        }
      }
    }
  } else if (isFunction$2(children)) {
    children = { default: children, _ctx: currentRenderingInstance };
    type = 32;
  } else {
    children = String(children);
    if (shapeFlag & 64) {
      type = 16;
      children = [createTextVNode(children)];
    } else {
      type = 8;
    }
  }
  vnode.children = children;
  vnode.shapeFlag |= type;
}
function mergeProps(...args) {
  const ret = {};
  for (let i = 0; i < args.length; i++) {
    const toMerge = args[i];
    for (const key in toMerge) {
      if (key === "class") {
        if (ret.class !== toMerge.class) {
          ret.class = normalizeClass([ret.class, toMerge.class]);
        }
      } else if (key === "style") {
        ret.style = normalizeStyle([ret.style, toMerge.style]);
      } else if (isOn(key)) {
        const existing = ret[key];
        const incoming = toMerge[key];
        if (incoming && existing !== incoming && !(isArray$1(existing) && existing.includes(incoming))) {
          ret[key] = existing ? [].concat(existing, incoming) : incoming;
        }
      } else if (key !== "") {
        ret[key] = toMerge[key];
      }
    }
  }
  return ret;
}
function invokeVNodeHook(hook, instance2, vnode, prevVNode = null) {
  callWithAsyncErrorHandling(hook, instance2, 7, [
    vnode,
    prevVNode
  ]);
}
const emptyAppContext = createAppContext();
let uid$1 = 0;
function createComponentInstance(vnode, parent, suspense) {
  const type = vnode.type;
  const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
  const instance2 = {
    uid: uid$1++,
    vnode,
    type,
    parent,
    appContext,
    root: null,
    next: null,
    subTree: null,
    effect: null,
    update: null,
    scope: new EffectScope(true),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: parent ? parent.provides : Object.create(appContext.provides),
    accessCache: null,
    renderCache: [],
    components: null,
    directives: null,
    propsOptions: normalizePropsOptions(type, appContext),
    emitsOptions: normalizeEmitsOptions(type, appContext),
    emit: null,
    emitted: null,
    propsDefaults: EMPTY_OBJ,
    inheritAttrs: type.inheritAttrs,
    ctx: EMPTY_OBJ,
    data: EMPTY_OBJ,
    props: EMPTY_OBJ,
    attrs: EMPTY_OBJ,
    slots: EMPTY_OBJ,
    refs: EMPTY_OBJ,
    setupState: EMPTY_OBJ,
    setupContext: null,
    suspense,
    suspenseId: suspense ? suspense.pendingId : 0,
    asyncDep: null,
    asyncResolved: false,
    isMounted: false,
    isUnmounted: false,
    isDeactivated: false,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  if (process.env.NODE_ENV !== "production") {
    instance2.ctx = createDevRenderContext(instance2);
  } else {
    instance2.ctx = { _: instance2 };
  }
  instance2.root = parent ? parent.root : instance2;
  instance2.emit = emit$1.bind(null, instance2);
  if (vnode.ce) {
    vnode.ce(instance2);
  }
  return instance2;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
const setCurrentInstance = (instance2) => {
  currentInstance = instance2;
  instance2.scope.on();
};
const unsetCurrentInstance = () => {
  currentInstance && currentInstance.scope.off();
  currentInstance = null;
};
const isBuiltInTag = /* @__PURE__ */ makeMap("slot,component");
function validateComponentName(name2, config2) {
  const appIsNativeTag = config2.isNativeTag || NO;
  if (isBuiltInTag(name2) || appIsNativeTag(name2)) {
    warn("Do not use built-in or reserved HTML elements as component id: " + name2);
  }
}
function isStatefulComponent(instance2) {
  return instance2.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance2, isSSR = false) {
  isInSSRComponentSetup = isSSR;
  const { props, children } = instance2.vnode;
  const isStateful = isStatefulComponent(instance2);
  initProps(instance2, props, isStateful, isSSR);
  initSlots(instance2, children);
  const setupResult = isStateful ? setupStatefulComponent(instance2, isSSR) : void 0;
  isInSSRComponentSetup = false;
  return setupResult;
}
function setupStatefulComponent(instance2, isSSR) {
  var _a2;
  const Component = instance2.type;
  if (process.env.NODE_ENV !== "production") {
    if (Component.name) {
      validateComponentName(Component.name, instance2.appContext.config);
    }
    if (Component.components) {
      const names = Object.keys(Component.components);
      for (let i = 0; i < names.length; i++) {
        validateComponentName(names[i], instance2.appContext.config);
      }
    }
    if (Component.directives) {
      const names = Object.keys(Component.directives);
      for (let i = 0; i < names.length; i++) {
        validateDirectiveName(names[i]);
      }
    }
    if (Component.compilerOptions && isRuntimeOnly()) {
      warn(`"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.`);
    }
  }
  instance2.accessCache = /* @__PURE__ */ Object.create(null);
  instance2.proxy = markRaw(new Proxy(instance2.ctx, PublicInstanceProxyHandlers));
  if (process.env.NODE_ENV !== "production") {
    exposePropsOnRenderContext(instance2);
  }
  const { setup } = Component;
  if (setup) {
    const setupContext = instance2.setupContext = setup.length > 1 ? createSetupContext(instance2) : null;
    setCurrentInstance(instance2);
    pauseTracking();
    const setupResult = callWithErrorHandling(setup, instance2, 0, [process.env.NODE_ENV !== "production" ? shallowReadonly(instance2.props) : instance2.props, setupContext]);
    resetTracking();
    unsetCurrentInstance();
    if (isPromise$1(setupResult)) {
      setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
      if (isSSR) {
        return setupResult.then((resolvedResult) => {
          handleSetupResult(instance2, resolvedResult, isSSR);
        }).catch((e) => {
          handleError(e, instance2, 0);
        });
      } else {
        instance2.asyncDep = setupResult;
        if (process.env.NODE_ENV !== "production" && !instance2.suspense) {
          const name2 = (_a2 = Component.name) !== null && _a2 !== void 0 ? _a2 : "Anonymous";
          warn(`Component <${name2}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`);
        }
      }
    } else {
      handleSetupResult(instance2, setupResult, isSSR);
    }
  } else {
    finishComponentSetup(instance2, isSSR);
  }
}
function handleSetupResult(instance2, setupResult, isSSR) {
  if (isFunction$2(setupResult)) {
    if (instance2.type.__ssrInlineRender) {
      instance2.ssrRender = setupResult;
    } else {
      instance2.render = setupResult;
    }
  } else if (isObject$2(setupResult)) {
    if (process.env.NODE_ENV !== "production" && isVNode(setupResult)) {
      warn(`setup() should not return VNodes directly - return a render function instead.`);
    }
    if (process.env.NODE_ENV !== "production" || false) {
      instance2.devtoolsRawSetupState = setupResult;
    }
    instance2.setupState = proxyRefs(setupResult);
    if (process.env.NODE_ENV !== "production") {
      exposeSetupStateOnRenderContext(instance2);
    }
  } else if (process.env.NODE_ENV !== "production" && setupResult !== void 0) {
    warn(`setup() should return an object. Received: ${setupResult === null ? "null" : typeof setupResult}`);
  }
  finishComponentSetup(instance2, isSSR);
}
let compile;
const isRuntimeOnly = () => !compile;
function finishComponentSetup(instance2, isSSR, skipOptions) {
  const Component = instance2.type;
  if (!instance2.render) {
    if (!isSSR && compile && !Component.render) {
      const template = Component.template;
      if (template) {
        if (process.env.NODE_ENV !== "production") {
          startMeasure(instance2, `compile`);
        }
        const { isCustomElement, compilerOptions } = instance2.appContext.config;
        const { delimiters, compilerOptions: componentCompilerOptions } = Component;
        const finalCompilerOptions = extend$2(extend$2({
          isCustomElement,
          delimiters
        }, compilerOptions), componentCompilerOptions);
        Component.render = compile(template, finalCompilerOptions);
        if (process.env.NODE_ENV !== "production") {
          endMeasure(instance2, `compile`);
        }
      }
    }
    instance2.render = Component.render || NOOP;
  }
  {
    setCurrentInstance(instance2);
    pauseTracking();
    applyOptions(instance2);
    resetTracking();
    unsetCurrentInstance();
  }
  if (process.env.NODE_ENV !== "production" && !Component.render && instance2.render === NOOP && !isSSR) {
    if (Component.template) {
      warn(`Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".`);
    } else {
      warn(`Component is missing template or render function.`);
    }
  }
}
function createAttrsProxy(instance2) {
  return new Proxy(instance2.attrs, process.env.NODE_ENV !== "production" ? {
    get(target, key) {
      markAttrsAccessed();
      track(instance2, "get", "$attrs");
      return target[key];
    },
    set() {
      warn(`setupContext.attrs is readonly.`);
      return false;
    },
    deleteProperty() {
      warn(`setupContext.attrs is readonly.`);
      return false;
    }
  } : {
    get(target, key) {
      track(instance2, "get", "$attrs");
      return target[key];
    }
  });
}
function createSetupContext(instance2) {
  const expose = (exposed) => {
    if (process.env.NODE_ENV !== "production" && instance2.exposed) {
      warn(`expose() should be called only once per setup().`);
    }
    instance2.exposed = exposed || {};
  };
  let attrs;
  if (process.env.NODE_ENV !== "production") {
    return Object.freeze({
      get attrs() {
        return attrs || (attrs = createAttrsProxy(instance2));
      },
      get slots() {
        return shallowReadonly(instance2.slots);
      },
      get emit() {
        return (event, ...args) => instance2.emit(event, ...args);
      },
      expose
    });
  } else {
    return {
      get attrs() {
        return attrs || (attrs = createAttrsProxy(instance2));
      },
      slots: instance2.slots,
      emit: instance2.emit,
      expose
    };
  }
}
function getExposeProxy(instance2) {
  if (instance2.exposed) {
    return instance2.exposeProxy || (instance2.exposeProxy = new Proxy(proxyRefs(markRaw(instance2.exposed)), {
      get(target, key) {
        if (key in target) {
          return target[key];
        } else if (key in publicPropertiesMap) {
          return publicPropertiesMap[key](instance2);
        }
      }
    }));
  }
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
  return isFunction$2(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance2, Component, isRoot = false) {
  let name2 = getComponentName(Component);
  if (!name2 && Component.__file) {
    const match = Component.__file.match(/([^/\\]+)\.\w+$/);
    if (match) {
      name2 = match[1];
    }
  }
  if (!name2 && instance2 && instance2.parent) {
    const inferFromRegistry = (registry) => {
      for (const key in registry) {
        if (registry[key] === Component) {
          return key;
        }
      }
    };
    name2 = inferFromRegistry(instance2.components || instance2.parent.type.components) || inferFromRegistry(instance2.appContext.components);
  }
  return name2 ? classify(name2) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
  return isFunction$2(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions) => {
  return computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
};
function h(type, propsOrChildren, children) {
  const l = arguments.length;
  if (l === 2) {
    if (isObject$2(propsOrChildren) && !isArray$1(propsOrChildren)) {
      if (isVNode(propsOrChildren)) {
        return createVNode(type, null, [propsOrChildren]);
      }
      return createVNode(type, propsOrChildren);
    } else {
      return createVNode(type, null, propsOrChildren);
    }
  } else {
    if (l > 3) {
      children = Array.prototype.slice.call(arguments, 2);
    } else if (l === 3 && isVNode(children)) {
      children = [children];
    }
    return createVNode(type, propsOrChildren, children);
  }
}
Symbol(process.env.NODE_ENV !== "production" ? `ssrContext` : ``);
function isShallow(value) {
  return !!(value && value["__v_isShallow"]);
}
function initCustomFormatter() {
  if (!(process.env.NODE_ENV !== "production") || typeof window === "undefined") {
    return;
  }
  const vueStyle = { style: "color:#3ba776" };
  const numberStyle = { style: "color:#0b1bc9" };
  const stringStyle = { style: "color:#b62e24" };
  const keywordStyle = { style: "color:#9d288c" };
  const formatter = {
    header(obj) {
      if (!isObject$2(obj)) {
        return null;
      }
      if (obj.__isVue) {
        return ["div", vueStyle, `VueInstance`];
      } else if (isRef(obj)) {
        return [
          "div",
          {},
          ["span", vueStyle, genRefFlag(obj)],
          "<",
          formatValue(obj.value),
          `>`
        ];
      } else if (isReactive(obj)) {
        return [
          "div",
          {},
          ["span", vueStyle, isShallow(obj) ? "ShallowReactive" : "Reactive"],
          "<",
          formatValue(obj),
          `>${isReadonly(obj) ? ` (readonly)` : ``}`
        ];
      } else if (isReadonly(obj)) {
        return [
          "div",
          {},
          ["span", vueStyle, isShallow(obj) ? "ShallowReadonly" : "Readonly"],
          "<",
          formatValue(obj),
          ">"
        ];
      }
      return null;
    },
    hasBody(obj) {
      return obj && obj.__isVue;
    },
    body(obj) {
      if (obj && obj.__isVue) {
        return [
          "div",
          {},
          ...formatInstance(obj.$)
        ];
      }
    }
  };
  function formatInstance(instance2) {
    const blocks = [];
    if (instance2.type.props && instance2.props) {
      blocks.push(createInstanceBlock("props", toRaw(instance2.props)));
    }
    if (instance2.setupState !== EMPTY_OBJ) {
      blocks.push(createInstanceBlock("setup", instance2.setupState));
    }
    if (instance2.data !== EMPTY_OBJ) {
      blocks.push(createInstanceBlock("data", toRaw(instance2.data)));
    }
    const computed2 = extractKeys(instance2, "computed");
    if (computed2) {
      blocks.push(createInstanceBlock("computed", computed2));
    }
    const injected = extractKeys(instance2, "inject");
    if (injected) {
      blocks.push(createInstanceBlock("injected", injected));
    }
    blocks.push([
      "div",
      {},
      [
        "span",
        {
          style: keywordStyle.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: instance2 }]
    ]);
    return blocks;
  }
  function createInstanceBlock(type, target) {
    target = extend$2({}, target);
    if (!Object.keys(target).length) {
      return ["span", {}];
    }
    return [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        type
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(target).map((key) => {
          return [
            "div",
            {},
            ["span", keywordStyle, key + ": "],
            formatValue(target[key], false)
          ];
        })
      ]
    ];
  }
  function formatValue(v, asRaw = true) {
    if (typeof v === "number") {
      return ["span", numberStyle, v];
    } else if (typeof v === "string") {
      return ["span", stringStyle, JSON.stringify(v)];
    } else if (typeof v === "boolean") {
      return ["span", keywordStyle, v];
    } else if (isObject$2(v)) {
      return ["object", { object: asRaw ? toRaw(v) : v }];
    } else {
      return ["span", stringStyle, String(v)];
    }
  }
  function extractKeys(instance2, type) {
    const Comp = instance2.type;
    if (isFunction$2(Comp)) {
      return;
    }
    const extracted = {};
    for (const key in instance2.ctx) {
      if (isKeyOfType(Comp, key, type)) {
        extracted[key] = instance2.ctx[key];
      }
    }
    return extracted;
  }
  function isKeyOfType(Comp, key, type) {
    const opts = Comp[type];
    if (isArray$1(opts) && opts.includes(key) || isObject$2(opts) && key in opts) {
      return true;
    }
    if (Comp.extends && isKeyOfType(Comp.extends, key, type)) {
      return true;
    }
    if (Comp.mixins && Comp.mixins.some((m) => isKeyOfType(m, key, type))) {
      return true;
    }
  }
  function genRefFlag(v) {
    if (isShallow(v)) {
      return `ShallowRef`;
    }
    if (v.effect) {
      return `ComputedRef`;
    }
    return `Ref`;
  }
  if (window.devtoolsFormatters) {
    window.devtoolsFormatters.push(formatter);
  } else {
    window.devtoolsFormatters = [formatter];
  }
}
const version = "3.2.37";
const svgNS = "http://www.w3.org/2000/svg";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
  insert: (child, parent, anchor) => {
    parent.insertBefore(child, anchor || null);
  },
  remove: (child) => {
    const parent = child.parentNode;
    if (parent) {
      parent.removeChild(child);
    }
  },
  createElement: (tag, isSVG, is, props) => {
    const el = isSVG ? doc.createElementNS(svgNS, tag) : doc.createElement(tag, is ? { is } : void 0);
    if (tag === "select" && props && props.multiple != null) {
      el.setAttribute("multiple", props.multiple);
    }
    return el;
  },
  createText: (text) => doc.createTextNode(text),
  createComment: (text) => doc.createComment(text),
  setText: (node, text) => {
    node.nodeValue = text;
  },
  setElementText: (el, text) => {
    el.textContent = text;
  },
  parentNode: (node) => node.parentNode,
  nextSibling: (node) => node.nextSibling,
  querySelector: (selector) => doc.querySelector(selector),
  setScopeId(el, id) {
    el.setAttribute(id, "");
  },
  cloneNode(el) {
    const cloned = el.cloneNode(true);
    if (`_value` in el) {
      cloned._value = el._value;
    }
    return cloned;
  },
  insertStaticContent(content, parent, anchor, isSVG, start, end) {
    const before = anchor ? anchor.previousSibling : parent.lastChild;
    if (start && (start === end || start.nextSibling)) {
      while (true) {
        parent.insertBefore(start.cloneNode(true), anchor);
        if (start === end || !(start = start.nextSibling))
          break;
      }
    } else {
      templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
      const template = templateContainer.content;
      if (isSVG) {
        const wrapper = template.firstChild;
        while (wrapper.firstChild) {
          template.appendChild(wrapper.firstChild);
        }
        template.removeChild(wrapper);
      }
      parent.insertBefore(template, anchor);
    }
    return [
      before ? before.nextSibling : parent.firstChild,
      anchor ? anchor.previousSibling : parent.lastChild
    ];
  }
};
function patchClass(el, value, isSVG) {
  const transitionClasses = el._vtc;
  if (transitionClasses) {
    value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
  }
  if (value == null) {
    el.removeAttribute("class");
  } else if (isSVG) {
    el.setAttribute("class", value);
  } else {
    el.className = value;
  }
}
function patchStyle(el, prev, next) {
  const style2 = el.style;
  const isCssString = isString$1(next);
  if (next && !isCssString) {
    for (const key in next) {
      setStyle(style2, key, next[key]);
    }
    if (prev && !isString$1(prev)) {
      for (const key in prev) {
        if (next[key] == null) {
          setStyle(style2, key, "");
        }
      }
    }
  } else {
    const currentDisplay = style2.display;
    if (isCssString) {
      if (prev !== next) {
        style2.cssText = next;
      }
    } else if (prev) {
      el.removeAttribute("style");
    }
    if ("_vod" in el) {
      style2.display = currentDisplay;
    }
  }
}
const importantRE = /\s*!important$/;
function setStyle(style2, name2, val) {
  if (isArray$1(val)) {
    val.forEach((v) => setStyle(style2, name2, v));
  } else {
    if (val == null)
      val = "";
    if (name2.startsWith("--")) {
      style2.setProperty(name2, val);
    } else {
      const prefixed = autoPrefix(style2, name2);
      if (importantRE.test(val)) {
        style2.setProperty(hyphenate(prefixed), val.replace(importantRE, ""), "important");
      } else {
        style2[prefixed] = val;
      }
    }
  }
}
const prefixes = ["Webkit", "Moz", "ms"];
const prefixCache = {};
function autoPrefix(style2, rawName) {
  const cached = prefixCache[rawName];
  if (cached) {
    return cached;
  }
  let name2 = camelize$1(rawName);
  if (name2 !== "filter" && name2 in style2) {
    return prefixCache[rawName] = name2;
  }
  name2 = capitalize(name2);
  for (let i = 0; i < prefixes.length; i++) {
    const prefixed = prefixes[i] + name2;
    if (prefixed in style2) {
      return prefixCache[rawName] = prefixed;
    }
  }
  return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance2) {
  if (isSVG && key.startsWith("xlink:")) {
    if (value == null) {
      el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    const isBoolean2 = isSpecialBooleanAttr(key);
    if (value == null || isBoolean2 && !includeBooleanAttr(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, isBoolean2 ? "" : value);
    }
  }
}
function patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
  if (key === "innerHTML" || key === "textContent") {
    if (prevChildren) {
      unmountChildren(prevChildren, parentComponent, parentSuspense);
    }
    el[key] = value == null ? "" : value;
    return;
  }
  if (key === "value" && el.tagName !== "PROGRESS" && !el.tagName.includes("-")) {
    el._value = value;
    const newValue = value == null ? "" : value;
    if (el.value !== newValue || el.tagName === "OPTION") {
      el.value = newValue;
    }
    if (value == null) {
      el.removeAttribute(key);
    }
    return;
  }
  let needRemove = false;
  if (value === "" || value == null) {
    const type = typeof el[key];
    if (type === "boolean") {
      value = includeBooleanAttr(value);
    } else if (value == null && type === "string") {
      value = "";
      needRemove = true;
    } else if (type === "number") {
      value = 0;
      needRemove = true;
    }
  }
  try {
    el[key] = value;
  } catch (e) {
    if (process.env.NODE_ENV !== "production") {
      warn(`Failed setting prop "${key}" on <${el.tagName.toLowerCase()}>: value ${value} is invalid.`, e);
    }
  }
  needRemove && el.removeAttribute(key);
}
const [_getNow, skipTimestampCheck] = /* @__PURE__ */ (() => {
  let _getNow2 = Date.now;
  let skipTimestampCheck2 = false;
  if (typeof window !== "undefined") {
    if (Date.now() > document.createEvent("Event").timeStamp) {
      _getNow2 = performance.now.bind(performance);
    }
    const ffMatch = navigator.userAgent.match(/firefox\/(\d+)/i);
    skipTimestampCheck2 = !!(ffMatch && Number(ffMatch[1]) <= 53);
  }
  return [_getNow2, skipTimestampCheck2];
})();
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const reset = () => {
  cachedNow = 0;
};
const getNow = () => cachedNow || (p.then(reset), cachedNow = _getNow());
function addEventListener(el, event, handler, options) {
  el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
  el.removeEventListener(event, handler, options);
}
function patchEvent(el, rawName, prevValue, nextValue, instance2 = null) {
  const invokers = el._vei || (el._vei = {});
  const existingInvoker = invokers[rawName];
  if (nextValue && existingInvoker) {
    existingInvoker.value = nextValue;
  } else {
    const [name2, options] = parseName(rawName);
    if (nextValue) {
      const invoker = invokers[rawName] = createInvoker(nextValue, instance2);
      addEventListener(el, name2, invoker, options);
    } else if (existingInvoker) {
      removeEventListener(el, name2, existingInvoker, options);
      invokers[rawName] = void 0;
    }
  }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name2) {
  let options;
  if (optionsModifierRE.test(name2)) {
    options = {};
    let m;
    while (m = name2.match(optionsModifierRE)) {
      name2 = name2.slice(0, name2.length - m[0].length);
      options[m[0].toLowerCase()] = true;
    }
  }
  return [hyphenate(name2.slice(2)), options];
}
function createInvoker(initialValue, instance2) {
  const invoker = (e) => {
    const timeStamp = e.timeStamp || _getNow();
    if (skipTimestampCheck || timeStamp >= invoker.attached - 1) {
      callWithAsyncErrorHandling(patchStopImmediatePropagation(e, invoker.value), instance2, 5, [e]);
    }
  };
  invoker.value = initialValue;
  invoker.attached = getNow();
  return invoker;
}
function patchStopImmediatePropagation(e, value) {
  if (isArray$1(value)) {
    const originalStop = e.stopImmediatePropagation;
    e.stopImmediatePropagation = () => {
      originalStop.call(e);
      e._stopped = true;
    };
    return value.map((fn) => (e2) => !e2._stopped && fn && fn(e2));
  } else {
    return value;
  }
}
const nativeOnRE = /^on[a-z]/;
const patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren) => {
  if (key === "class") {
    patchClass(el, nextValue, isSVG);
  } else if (key === "style") {
    patchStyle(el, prevValue, nextValue);
  } else if (isOn(key)) {
    if (!isModelListener(key)) {
      patchEvent(el, key, prevValue, nextValue, parentComponent);
    }
  } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
    patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
  } else {
    if (key === "true-value") {
      el._trueValue = nextValue;
    } else if (key === "false-value") {
      el._falseValue = nextValue;
    }
    patchAttr(el, key, nextValue, isSVG);
  }
};
function shouldSetAsProp(el, key, value, isSVG) {
  if (isSVG) {
    if (key === "innerHTML" || key === "textContent") {
      return true;
    }
    if (key in el && nativeOnRE.test(key) && isFunction$2(value)) {
      return true;
    }
    return false;
  }
  if (key === "spellcheck" || key === "draggable" || key === "translate") {
    return false;
  }
  if (key === "form") {
    return false;
  }
  if (key === "list" && el.tagName === "INPUT") {
    return false;
  }
  if (key === "type" && el.tagName === "TEXTAREA") {
    return false;
  }
  if (nativeOnRE.test(key) && isString$1(value)) {
    return false;
  }
  return key in el;
}
const TRANSITION = "transition";
const ANIMATION = "animation";
const Transition = (props, { slots }) => h(BaseTransition, resolveTransitionProps(props), slots);
Transition.displayName = "Transition";
const DOMTransitionPropsValidators = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: true
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
};
Transition.props = /* @__PURE__ */ extend$2({}, BaseTransition.props, DOMTransitionPropsValidators);
const callHook = (hook, args = []) => {
  if (isArray$1(hook)) {
    hook.forEach((h2) => h2(...args));
  } else if (hook) {
    hook(...args);
  }
};
const hasExplicitCallback = (hook) => {
  return hook ? isArray$1(hook) ? hook.some((h2) => h2.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
  const baseProps = {};
  for (const key in rawProps) {
    if (!(key in DOMTransitionPropsValidators)) {
      baseProps[key] = rawProps[key];
    }
  }
  if (rawProps.css === false) {
    return baseProps;
  }
  const { name: name2 = "v", type, duration, enterFromClass = `${name2}-enter-from`, enterActiveClass = `${name2}-enter-active`, enterToClass = `${name2}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name2}-leave-from`, leaveActiveClass = `${name2}-leave-active`, leaveToClass = `${name2}-leave-to` } = rawProps;
  const durations = normalizeDuration(duration);
  const enterDuration = durations && durations[0];
  const leaveDuration = durations && durations[1];
  const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
  const finishEnter = (el, isAppear, done) => {
    removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
    removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
    done && done();
  };
  const finishLeave = (el, done) => {
    el._isLeaving = false;
    removeTransitionClass(el, leaveFromClass);
    removeTransitionClass(el, leaveToClass);
    removeTransitionClass(el, leaveActiveClass);
    done && done();
  };
  const makeEnterHook = (isAppear) => {
    return (el, done) => {
      const hook = isAppear ? onAppear : onEnter;
      const resolve2 = () => finishEnter(el, isAppear, done);
      callHook(hook, [el, resolve2]);
      nextFrame(() => {
        removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
        addTransitionClass(el, isAppear ? appearToClass : enterToClass);
        if (!hasExplicitCallback(hook)) {
          whenTransitionEnds(el, type, enterDuration, resolve2);
        }
      });
    };
  };
  return extend$2(baseProps, {
    onBeforeEnter(el) {
      callHook(onBeforeEnter, [el]);
      addTransitionClass(el, enterFromClass);
      addTransitionClass(el, enterActiveClass);
    },
    onBeforeAppear(el) {
      callHook(onBeforeAppear, [el]);
      addTransitionClass(el, appearFromClass);
      addTransitionClass(el, appearActiveClass);
    },
    onEnter: makeEnterHook(false),
    onAppear: makeEnterHook(true),
    onLeave(el, done) {
      el._isLeaving = true;
      const resolve2 = () => finishLeave(el, done);
      addTransitionClass(el, leaveFromClass);
      forceReflow();
      addTransitionClass(el, leaveActiveClass);
      nextFrame(() => {
        if (!el._isLeaving) {
          return;
        }
        removeTransitionClass(el, leaveFromClass);
        addTransitionClass(el, leaveToClass);
        if (!hasExplicitCallback(onLeave)) {
          whenTransitionEnds(el, type, leaveDuration, resolve2);
        }
      });
      callHook(onLeave, [el, resolve2]);
    },
    onEnterCancelled(el) {
      finishEnter(el, false);
      callHook(onEnterCancelled, [el]);
    },
    onAppearCancelled(el) {
      finishEnter(el, true);
      callHook(onAppearCancelled, [el]);
    },
    onLeaveCancelled(el) {
      finishLeave(el);
      callHook(onLeaveCancelled, [el]);
    }
  });
}
function normalizeDuration(duration) {
  if (duration == null) {
    return null;
  } else if (isObject$2(duration)) {
    return [NumberOf(duration.enter), NumberOf(duration.leave)];
  } else {
    const n = NumberOf(duration);
    return [n, n];
  }
}
function NumberOf(val) {
  const res = toNumber(val);
  if (process.env.NODE_ENV !== "production")
    validateDuration(res);
  return res;
}
function validateDuration(val) {
  if (typeof val !== "number") {
    warn(`<transition> explicit duration is not a valid number - got ${JSON.stringify(val)}.`);
  } else if (isNaN(val)) {
    warn(`<transition> explicit duration is NaN - the duration expression might be incorrect.`);
  }
}
function addTransitionClass(el, cls) {
  cls.split(/\s+/).forEach((c) => c && el.classList.add(c));
  (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
  cls.split(/\s+/).forEach((c) => c && el.classList.remove(c));
  const { _vtc } = el;
  if (_vtc) {
    _vtc.delete(cls);
    if (!_vtc.size) {
      el._vtc = void 0;
    }
  }
}
function nextFrame(cb) {
  requestAnimationFrame(() => {
    requestAnimationFrame(cb);
  });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve2) {
  const id = el._endId = ++endId;
  const resolveIfNotStale = () => {
    if (id === el._endId) {
      resolve2();
    }
  };
  if (explicitTimeout) {
    return setTimeout(resolveIfNotStale, explicitTimeout);
  }
  const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
  if (!type) {
    return resolve2();
  }
  const endEvent = type + "end";
  let ended = 0;
  const end = () => {
    el.removeEventListener(endEvent, onEnd);
    resolveIfNotStale();
  };
  const onEnd = (e) => {
    if (e.target === el && ++ended >= propCount) {
      end();
    }
  };
  setTimeout(() => {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
  const styles = window.getComputedStyle(el);
  const getStyleProperties = (key) => (styles[key] || "").split(", ");
  const transitionDelays = getStyleProperties(TRANSITION + "Delay");
  const transitionDurations = getStyleProperties(TRANSITION + "Duration");
  const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  const animationDelays = getStyleProperties(ANIMATION + "Delay");
  const animationDurations = getStyleProperties(ANIMATION + "Duration");
  const animationTimeout = getTimeout(animationDelays, animationDurations);
  let type = null;
  let timeout = 0;
  let propCount = 0;
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
    propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
  }
  const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(styles[TRANSITION + "Property"]);
  return {
    type,
    timeout,
    propCount,
    hasTransform
  };
}
function getTimeout(delays, durations) {
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }
  return Math.max(...durations.map((d, i) => toMs(d) + toMs(delays[i])));
}
function toMs(s) {
  return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
  return document.body.offsetHeight;
}
const getModelAssigner = (vnode) => {
  const fn = vnode.props["onUpdate:modelValue"] || false;
  return isArray$1(fn) ? (value) => invokeArrayFns(fn, value) : fn;
};
function onCompositionStart(e) {
  e.target.composing = true;
}
function onCompositionEnd(e) {
  const target = e.target;
  if (target.composing) {
    target.composing = false;
    target.dispatchEvent(new Event("input"));
  }
}
const vModelText = {
  created(el, { modifiers: { lazy, trim: trim2, number } }, vnode) {
    el._assign = getModelAssigner(vnode);
    const castToNumber = number || vnode.props && vnode.props.type === "number";
    addEventListener(el, lazy ? "change" : "input", (e) => {
      if (e.target.composing)
        return;
      let domValue = el.value;
      if (trim2) {
        domValue = domValue.trim();
      }
      if (castToNumber) {
        domValue = toNumber(domValue);
      }
      el._assign(domValue);
    });
    if (trim2) {
      addEventListener(el, "change", () => {
        el.value = el.value.trim();
      });
    }
    if (!lazy) {
      addEventListener(el, "compositionstart", onCompositionStart);
      addEventListener(el, "compositionend", onCompositionEnd);
      addEventListener(el, "change", onCompositionEnd);
    }
  },
  mounted(el, { value }) {
    el.value = value == null ? "" : value;
  },
  beforeUpdate(el, { value, modifiers: { lazy, trim: trim2, number } }, vnode) {
    el._assign = getModelAssigner(vnode);
    if (el.composing)
      return;
    if (document.activeElement === el && el.type !== "range") {
      if (lazy) {
        return;
      }
      if (trim2 && el.value.trim() === value) {
        return;
      }
      if ((number || el.type === "number") && toNumber(el.value) === value) {
        return;
      }
    }
    const newValue = value == null ? "" : value;
    if (el.value !== newValue) {
      el.value = newValue;
    }
  }
};
const keyNames = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
};
const withKeys = (fn, modifiers) => {
  return (event) => {
    if (!("key" in event)) {
      return;
    }
    const eventKey = hyphenate(event.key);
    if (modifiers.some((k) => k === eventKey || keyNames[k] === eventKey)) {
      return fn(event);
    }
  };
};
const vShow = {
  beforeMount(el, { value }, { transition }) {
    el._vod = el.style.display === "none" ? "" : el.style.display;
    if (transition && value) {
      transition.beforeEnter(el);
    } else {
      setDisplay(el, value);
    }
  },
  mounted(el, { value }, { transition }) {
    if (transition && value) {
      transition.enter(el);
    }
  },
  updated(el, { value, oldValue }, { transition }) {
    if (!value === !oldValue)
      return;
    if (transition) {
      if (value) {
        transition.beforeEnter(el);
        setDisplay(el, true);
        transition.enter(el);
      } else {
        transition.leave(el, () => {
          setDisplay(el, false);
        });
      }
    } else {
      setDisplay(el, value);
    }
  },
  beforeUnmount(el, { value }) {
    setDisplay(el, value);
  }
};
function setDisplay(el, value) {
  el.style.display = value ? el._vod : "none";
}
const rendererOptions = /* @__PURE__ */ extend$2({ patchProp }, nodeOps);
let renderer;
function ensureRenderer() {
  return renderer || (renderer = createRenderer(rendererOptions));
}
const createApp = (...args) => {
  const app = ensureRenderer().createApp(...args);
  if (process.env.NODE_ENV !== "production") {
    injectNativeTagCheck(app);
    injectCompilerOptionsCheck(app);
  }
  const { mount } = app;
  app.mount = (containerOrSelector) => {
    const container = normalizeContainer(containerOrSelector);
    if (!container)
      return;
    const component = app._component;
    if (!isFunction$2(component) && !component.render && !component.template) {
      component.template = container.innerHTML;
    }
    container.innerHTML = "";
    const proxy = mount(container, false, container instanceof SVGElement);
    if (container instanceof Element) {
      container.removeAttribute("v-cloak");
      container.setAttribute("data-v-app", "");
    }
    return proxy;
  };
  return app;
};
function injectNativeTagCheck(app) {
  Object.defineProperty(app.config, "isNativeTag", {
    value: (tag) => isHTMLTag(tag) || isSVGTag(tag),
    writable: false
  });
}
function injectCompilerOptionsCheck(app) {
  {
    const isCustomElement = app.config.isCustomElement;
    Object.defineProperty(app.config, "isCustomElement", {
      get() {
        return isCustomElement;
      },
      set() {
        warn(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
      }
    });
    const compilerOptions = app.config.compilerOptions;
    const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-dom`;
    Object.defineProperty(app.config, "compilerOptions", {
      get() {
        warn(msg);
        return compilerOptions;
      },
      set() {
        warn(msg);
      }
    });
  }
}
function normalizeContainer(container) {
  if (isString$1(container)) {
    const res = document.querySelector(container);
    if (process.env.NODE_ENV !== "production" && !res) {
      warn(`Failed to mount app: mount target selector "${container}" returned null.`);
    }
    return res;
  }
  if (process.env.NODE_ENV !== "production" && window.ShadowRoot && container instanceof window.ShadowRoot && container.mode === "closed") {
    warn(`mounting on a ShadowRoot with \`{mode: "closed"}\` may lead to unpredictable bugs`);
  }
  return container;
}
function initDev() {
  {
    initCustomFormatter();
  }
}
if (process.env.NODE_ENV !== "production") {
  initDev();
}
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function sleep$1(time) {
  return new Promise((resolve2) => {
    setTimeout(resolve2, time);
  });
}
function setViewPort(scalable = false, options) {
  const viewport = document.head.querySelector("meta[name='viewport']");
  const oldContent = viewport.content;
  const remainContentArr = oldContent.split(",").filter((t2) => !/width|scal/.test(t2));
  const remainContent = remainContentArr.length ? "," + remainContentArr.join(",") : "";
  if (scalable) {
    const { initial = 1, maximum, minimum = 1 } = options;
    viewport.content = `user-scalable=yes,width=device-width,initial-scale=${initial},maximum-scale=${maximum},minimum-scale=${minimum}` + remainContent;
  } else {
    const scale = options || 1;
    viewport.content = `user-scalable=yes,width=device-width,initial-scale=${scale},maximum-scale=${scale},minimum-scale=${scale}` + remainContent;
  }
  onBeforeUnmount(() => {
    viewport.content = oldContent;
  });
}
const _hoisted_1$8 = { class: "cp-relative cp-flex cp-justify-center cp-items-center" };
const _hoisted_2$6 = { class: "cp-absolute cp-left-1/2 cp-top-1/2 cp-transform cp--translate-x-1/2 cp--translate-y-1/2 cp-text-2xl" };
const _hoisted_3$4 = {
  id: "svg",
  width: "200",
  height: "200",
  viewPort: "0 0 100 100",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_4$3 = /* @__PURE__ */ createBaseVNode("circle", {
  r: "90",
  cx: "100",
  cy: "100",
  fill: "transparent",
  "stroke-dasharray": "565.48",
  "stroke-dashoffset": "0"
}, null, -1);
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  props: {
    modelValue: null
  },
  setup(__props) {
    const props = __props;
    const round = Math.PI * 180;
    const strokeDashoffset = ref(round);
    function render2() {
      const val = props.modelValue;
      if (val === void 0)
        return;
      let progressVal;
      if (val < 0) {
        progressVal = 0;
      } else if (val > 1) {
        progressVal = 1;
      } else {
        progressVal = val;
      }
      strokeDashoffset.value = (1 - progressVal) / 1 * round;
    }
    const option = {
      style: "percent",
      maximumFractionDigits: 2
    };
    const formatter = new Intl.NumberFormat(void 0, option);
    const percent = computed(() => props.modelValue ? formatter.format(Math.min(props.modelValue, 1)) : "0%");
    onMounted(() => {
      watch(() => props.modelValue, render2, { immediate: true });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$8, [
        createBaseVNode("div", _hoisted_2$6, toDisplayString(unref(percent)), 1),
        (openBlock(), createElementBlock("svg", _hoisted_3$4, [
          _hoisted_4$3,
          createBaseVNode("circle", {
            id: "bar",
            style: normalizeStyle({ strokeDashoffset: strokeDashoffset.value }),
            r: "90",
            cx: "100",
            cy: "100",
            fill: "transparent",
            "stroke-dasharray": "565.48"
          }, null, 4)
        ]))
      ]);
    };
  }
});
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf = { exports: {} };
var __viteBrowserExternal = {};
var __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  "default": __viteBrowserExternal
});
var require$$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    return (() => {
      var __webpack_modules__ = [
        ,
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.addLinkAttributes = addLinkAttributes;
          exports2.deprecated = deprecated;
          exports2.getFilenameFromUrl = getFilenameFromUrl;
          exports2.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
          exports2.isDataScheme = isDataScheme;
          exports2.isFetchSupported = isFetchSupported;
          exports2.isPdfFile = isPdfFile;
          exports2.isValidFetchUrl = isValidFetchUrl;
          exports2.loadScript = loadScript;
          exports2.StatTimer = exports2.RenderingCancelledException = exports2.PDFDateString = exports2.PageViewport = exports2.LinkTarget = exports2.DOMSVGFactory = exports2.DOMCMapReaderFactory = exports2.DOMCanvasFactory = exports2.DEFAULT_LINK_REL = exports2.BaseCMapReaderFactory = exports2.BaseCanvasFactory = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          const DEFAULT_LINK_REL = "noopener noreferrer nofollow";
          exports2.DEFAULT_LINK_REL = DEFAULT_LINK_REL;
          const SVG_NS = "http://www.w3.org/2000/svg";
          class BaseCanvasFactory {
            constructor() {
              if (this.constructor === BaseCanvasFactory) {
                (0, _util2.unreachable)("Cannot initialize BaseCanvasFactory.");
              }
            }
            create(width2, height2) {
              (0, _util2.unreachable)("Abstract method `create` called.");
            }
            reset(canvasAndContext, width2, height2) {
              if (!canvasAndContext.canvas) {
                throw new Error("Canvas is not specified");
              }
              if (width2 <= 0 || height2 <= 0) {
                throw new Error("Invalid canvas size");
              }
              canvasAndContext.canvas.width = width2;
              canvasAndContext.canvas.height = height2;
            }
            destroy(canvasAndContext) {
              if (!canvasAndContext.canvas) {
                throw new Error("Canvas is not specified");
              }
              canvasAndContext.canvas.width = 0;
              canvasAndContext.canvas.height = 0;
              canvasAndContext.canvas = null;
              canvasAndContext.context = null;
            }
          }
          exports2.BaseCanvasFactory = BaseCanvasFactory;
          class DOMCanvasFactory extends BaseCanvasFactory {
            constructor({
              ownerDocument = globalThis.document
            } = {}) {
              super();
              this._document = ownerDocument;
            }
            create(width2, height2) {
              if (width2 <= 0 || height2 <= 0) {
                throw new Error("Invalid canvas size");
              }
              const canvas = this._document.createElement("canvas");
              const context = canvas.getContext("2d");
              canvas.width = width2;
              canvas.height = height2;
              return {
                canvas,
                context
              };
            }
          }
          exports2.DOMCanvasFactory = DOMCanvasFactory;
          class BaseCMapReaderFactory {
            constructor({
              baseUrl = null,
              isCompressed = false
            }) {
              if (this.constructor === BaseCMapReaderFactory) {
                (0, _util2.unreachable)("Cannot initialize BaseCMapReaderFactory.");
              }
              this.baseUrl = baseUrl;
              this.isCompressed = isCompressed;
            }
            async fetch({
              name: name2
            }) {
              if (!this.baseUrl) {
                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
              }
              if (!name2) {
                throw new Error("CMap name must be specified.");
              }
              const url = this.baseUrl + name2 + (this.isCompressed ? ".bcmap" : "");
              const compressionType = this.isCompressed ? _util2.CMapCompressionType.BINARY : _util2.CMapCompressionType.NONE;
              return this._fetchData(url, compressionType).catch((reason) => {
                throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
              });
            }
            _fetchData(url, compressionType) {
              (0, _util2.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          exports2.BaseCMapReaderFactory = BaseCMapReaderFactory;
          class DOMCMapReaderFactory extends BaseCMapReaderFactory {
            _fetchData(url, compressionType) {
              if (isFetchSupported() && isValidFetchUrl(url, document.baseURI)) {
                return fetch(url).then(async (response) => {
                  if (!response.ok) {
                    throw new Error(response.statusText);
                  }
                  let cMapData;
                  if (this.isCompressed) {
                    cMapData = new Uint8Array(await response.arrayBuffer());
                  } else {
                    cMapData = (0, _util2.stringToBytes)(await response.text());
                  }
                  return {
                    cMapData,
                    compressionType
                  };
                });
              }
              return new Promise((resolve2, reject) => {
                const request22 = new XMLHttpRequest();
                request22.open("GET", url, true);
                if (this.isCompressed) {
                  request22.responseType = "arraybuffer";
                }
                request22.onreadystatechange = () => {
                  if (request22.readyState !== XMLHttpRequest.DONE) {
                    return;
                  }
                  if (request22.status === 200 || request22.status === 0) {
                    let cMapData;
                    if (this.isCompressed && request22.response) {
                      cMapData = new Uint8Array(request22.response);
                    } else if (!this.isCompressed && request22.responseText) {
                      cMapData = (0, _util2.stringToBytes)(request22.responseText);
                    }
                    if (cMapData) {
                      resolve2({
                        cMapData,
                        compressionType
                      });
                      return;
                    }
                  }
                  reject(new Error(request22.statusText));
                };
                request22.send(null);
              });
            }
          }
          exports2.DOMCMapReaderFactory = DOMCMapReaderFactory;
          class DOMSVGFactory {
            create(width2, height2) {
              (0, _util2.assert)(width2 > 0 && height2 > 0, "Invalid SVG dimensions");
              const svg = document.createElementNS(SVG_NS, "svg:svg");
              svg.setAttribute("version", "1.1");
              svg.setAttribute("width", width2 + "px");
              svg.setAttribute("height", height2 + "px");
              svg.setAttribute("preserveAspectRatio", "none");
              svg.setAttribute("viewBox", "0 0 " + width2 + " " + height2);
              return svg;
            }
            createElement(type) {
              (0, _util2.assert)(typeof type === "string", "Invalid SVG element type");
              return document.createElementNS(SVG_NS, type);
            }
          }
          exports2.DOMSVGFactory = DOMSVGFactory;
          class PageViewport {
            constructor({
              viewBox,
              scale,
              rotation,
              offsetX = 0,
              offsetY = 0,
              dontFlip = false
            }) {
              this.viewBox = viewBox;
              this.scale = scale;
              this.rotation = rotation;
              this.offsetX = offsetX;
              this.offsetY = offsetY;
              const centerX = (viewBox[2] + viewBox[0]) / 2;
              const centerY = (viewBox[3] + viewBox[1]) / 2;
              let rotateA, rotateB, rotateC, rotateD;
              rotation %= 360;
              if (rotation < 0) {
                rotation += 360;
              }
              switch (rotation) {
                case 180:
                  rotateA = -1;
                  rotateB = 0;
                  rotateC = 0;
                  rotateD = 1;
                  break;
                case 90:
                  rotateA = 0;
                  rotateB = 1;
                  rotateC = 1;
                  rotateD = 0;
                  break;
                case 270:
                  rotateA = 0;
                  rotateB = -1;
                  rotateC = -1;
                  rotateD = 0;
                  break;
                case 0:
                  rotateA = 1;
                  rotateB = 0;
                  rotateC = 0;
                  rotateD = -1;
                  break;
                default:
                  throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
              }
              if (dontFlip) {
                rotateC = -rotateC;
                rotateD = -rotateD;
              }
              let offsetCanvasX, offsetCanvasY;
              let width2, height2;
              if (rotateA === 0) {
                offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                width2 = Math.abs(viewBox[3] - viewBox[1]) * scale;
                height2 = Math.abs(viewBox[2] - viewBox[0]) * scale;
              } else {
                offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                width2 = Math.abs(viewBox[2] - viewBox[0]) * scale;
                height2 = Math.abs(viewBox[3] - viewBox[1]) * scale;
              }
              this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
              this.width = width2;
              this.height = height2;
            }
            clone({
              scale = this.scale,
              rotation = this.rotation,
              offsetX = this.offsetX,
              offsetY = this.offsetY,
              dontFlip = false
            } = {}) {
              return new PageViewport({
                viewBox: this.viewBox.slice(),
                scale,
                rotation,
                offsetX,
                offsetY,
                dontFlip
              });
            }
            convertToViewportPoint(x, y) {
              return _util2.Util.applyTransform([x, y], this.transform);
            }
            convertToViewportRectangle(rect) {
              const topLeft = _util2.Util.applyTransform([rect[0], rect[1]], this.transform);
              const bottomRight = _util2.Util.applyTransform([rect[2], rect[3]], this.transform);
              return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
            }
            convertToPdfPoint(x, y) {
              return _util2.Util.applyInverseTransform([x, y], this.transform);
            }
          }
          exports2.PageViewport = PageViewport;
          class RenderingCancelledException extends _util2.BaseException {
            constructor(msg, type) {
              super(msg);
              this.type = type;
            }
          }
          exports2.RenderingCancelledException = RenderingCancelledException;
          const LinkTarget = {
            NONE: 0,
            SELF: 1,
            BLANK: 2,
            PARENT: 3,
            TOP: 4
          };
          exports2.LinkTarget = LinkTarget;
          function addLinkAttributes(link, {
            url,
            target,
            rel,
            enabled = true
          } = {}) {
            (0, _util2.assert)(url && typeof url === "string", 'addLinkAttributes: A valid "url" parameter must provided.');
            const urlNullRemoved = (0, _util2.removeNullCharacters)(url);
            if (enabled) {
              link.href = link.title = urlNullRemoved;
            } else {
              link.href = "";
              link.title = `Disabled: ${urlNullRemoved}`;
              link.onclick = () => {
                return false;
              };
            }
            let targetStr = "";
            switch (target) {
              case LinkTarget.NONE:
                break;
              case LinkTarget.SELF:
                targetStr = "_self";
                break;
              case LinkTarget.BLANK:
                targetStr = "_blank";
                break;
              case LinkTarget.PARENT:
                targetStr = "_parent";
                break;
              case LinkTarget.TOP:
                targetStr = "_top";
                break;
            }
            link.target = targetStr;
            link.rel = typeof rel === "string" ? rel : DEFAULT_LINK_REL;
          }
          function isDataScheme(url) {
            const ii = url.length;
            let i = 0;
            while (i < ii && url[i].trim() === "") {
              i++;
            }
            return url.substring(i, i + 5).toLowerCase() === "data:";
          }
          function isPdfFile(filename) {
            return typeof filename === "string" && /\.pdf$/i.test(filename);
          }
          function getFilenameFromUrl(url) {
            const anchor = url.indexOf("#");
            const query = url.indexOf("?");
            const end = Math.min(anchor > 0 ? anchor : url.length, query > 0 ? query : url.length);
            return url.substring(url.lastIndexOf("/", end) + 1, end);
          }
          function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
            if (typeof url !== "string") {
              return defaultFilename;
            }
            if (isDataScheme(url)) {
              (0, _util2.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
              return defaultFilename;
            }
            const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
            const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
            const splitURI = reURI.exec(url);
            let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
            if (suggestedFilename) {
              suggestedFilename = suggestedFilename[0];
              if (suggestedFilename.includes("%")) {
                try {
                  suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                } catch (ex) {
                }
              }
            }
            return suggestedFilename || defaultFilename;
          }
          class StatTimer {
            constructor() {
              this.started = /* @__PURE__ */ Object.create(null);
              this.times = [];
            }
            time(name2) {
              if (name2 in this.started) {
                (0, _util2.warn)(`Timer is already running for ${name2}`);
              }
              this.started[name2] = Date.now();
            }
            timeEnd(name2) {
              if (!(name2 in this.started)) {
                (0, _util2.warn)(`Timer has not been started for ${name2}`);
              }
              this.times.push({
                name: name2,
                start: this.started[name2],
                end: Date.now()
              });
              delete this.started[name2];
            }
            toString() {
              const outBuf = [];
              let longest = 0;
              for (const time of this.times) {
                const name2 = time.name;
                if (name2.length > longest) {
                  longest = name2.length;
                }
              }
              for (const time of this.times) {
                const duration = time.end - time.start;
                outBuf.push(`${time.name.padEnd(longest)} ${duration}ms
`);
              }
              return outBuf.join("");
            }
          }
          exports2.StatTimer = StatTimer;
          function isFetchSupported() {
            return typeof fetch !== "undefined" && typeof Response !== "undefined" && "body" in Response.prototype && typeof ReadableStream !== "undefined";
          }
          function isValidFetchUrl(url, baseUrl) {
            try {
              const {
                protocol
              } = baseUrl ? new URL(url, baseUrl) : new URL(url);
              return protocol === "http:" || protocol === "https:";
            } catch (ex) {
              return false;
            }
          }
          function loadScript(src, removeScriptElement = false) {
            return new Promise((resolve2, reject) => {
              const script = document.createElement("script");
              script.src = src;
              script.onload = function(evt) {
                if (removeScriptElement) {
                  script.remove();
                }
                resolve2(evt);
              };
              script.onerror = function() {
                reject(new Error(`Cannot load script at: ${script.src}`));
              };
              (document.head || document.documentElement).appendChild(script);
            });
          }
          function deprecated(details) {
            console.log("Deprecated API usage: " + details);
          }
          let pdfDateStringRegex;
          class PDFDateString {
            static toDateObject(input) {
              if (!input || !(0, _util2.isString)(input)) {
                return null;
              }
              if (!pdfDateStringRegex) {
                pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
              }
              const matches = pdfDateStringRegex.exec(input);
              if (!matches) {
                return null;
              }
              const year = parseInt(matches[1], 10);
              let month = parseInt(matches[2], 10);
              month = month >= 1 && month <= 12 ? month - 1 : 0;
              let day = parseInt(matches[3], 10);
              day = day >= 1 && day <= 31 ? day : 1;
              let hour = parseInt(matches[4], 10);
              hour = hour >= 0 && hour <= 23 ? hour : 0;
              let minute = parseInt(matches[5], 10);
              minute = minute >= 0 && minute <= 59 ? minute : 0;
              let second = parseInt(matches[6], 10);
              second = second >= 0 && second <= 59 ? second : 0;
              const universalTimeRelation = matches[7] || "Z";
              let offsetHour = parseInt(matches[8], 10);
              offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
              let offsetMinute = parseInt(matches[9], 10) || 0;
              offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
              if (universalTimeRelation === "-") {
                hour += offsetHour;
                minute += offsetMinute;
              } else if (universalTimeRelation === "+") {
                hour -= offsetHour;
                minute -= offsetMinute;
              }
              return new Date(Date.UTC(year, month, day, hour, minute, second));
            }
          }
          exports2.PDFDateString = PDFDateString;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.arrayByteLength = arrayByteLength;
          exports2.arraysToBytes = arraysToBytes;
          exports2.assert = assert;
          exports2.bytesToString = bytesToString;
          exports2.createObjectURL = createObjectURL;
          exports2.createPromiseCapability = createPromiseCapability;
          exports2.createValidAbsoluteUrl = createValidAbsoluteUrl;
          exports2.escapeString = escapeString;
          exports2.getModificationDate = getModificationDate;
          exports2.getVerbosityLevel = getVerbosityLevel;
          exports2.info = info;
          exports2.isArrayBuffer = isArrayBuffer2;
          exports2.isArrayEqual = isArrayEqual;
          exports2.isAscii = isAscii;
          exports2.isBool = isBool;
          exports2.isNum = isNum;
          exports2.isSameOrigin = isSameOrigin;
          exports2.isString = isString2;
          exports2.objectFromMap = objectFromMap;
          exports2.objectSize = objectSize;
          exports2.removeNullCharacters = removeNullCharacters;
          exports2.setVerbosityLevel = setVerbosityLevel;
          exports2.shadow = shadow;
          exports2.string32 = string32;
          exports2.stringToBytes = stringToBytes;
          exports2.stringToPDFString = stringToPDFString;
          exports2.stringToUTF16BEString = stringToUTF16BEString;
          exports2.stringToUTF8String = stringToUTF8String;
          exports2.unreachable = unreachable;
          exports2.utf8StringToString = utf8StringToString;
          exports2.warn = warn2;
          exports2.VerbosityLevel = exports2.Util = exports2.UNSUPPORTED_FEATURES = exports2.UnknownErrorException = exports2.UnexpectedResponseException = exports2.TextRenderingMode = exports2.StreamType = exports2.PermissionFlag = exports2.PasswordResponses = exports2.PasswordException = exports2.PageActionEventType = exports2.OPS = exports2.MissingPDFException = exports2.IsLittleEndianCached = exports2.IsEvalSupportedCached = exports2.InvalidPDFException = exports2.ImageKind = exports2.IDENTITY_MATRIX = exports2.FormatError = exports2.FontType = exports2.FONT_IDENTITY_MATRIX = exports2.DocumentActionEventType = exports2.CMapCompressionType = exports2.BaseException = exports2.AnnotationType = exports2.AnnotationStateModelType = exports2.AnnotationReviewState = exports2.AnnotationReplyType = exports2.AnnotationMarkedState = exports2.AnnotationFlag = exports2.AnnotationFieldFlag = exports2.AnnotationBorderStyleType = exports2.AnnotationActionEventType = exports2.AbortException = void 0;
          __w_pdfjs_require__2(3);
          const IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
          exports2.IDENTITY_MATRIX = IDENTITY_MATRIX;
          const FONT_IDENTITY_MATRIX = [1e-3, 0, 0, 1e-3, 0, 0];
          exports2.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
          const PermissionFlag = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          exports2.PermissionFlag = PermissionFlag;
          const TextRenderingMode = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          exports2.TextRenderingMode = TextRenderingMode;
          const ImageKind = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          exports2.ImageKind = ImageKind;
          const AnnotationType = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          exports2.AnnotationType = AnnotationType;
          const AnnotationStateModelType = {
            MARKED: "Marked",
            REVIEW: "Review"
          };
          exports2.AnnotationStateModelType = AnnotationStateModelType;
          const AnnotationMarkedState = {
            MARKED: "Marked",
            UNMARKED: "Unmarked"
          };
          exports2.AnnotationMarkedState = AnnotationMarkedState;
          const AnnotationReviewState = {
            ACCEPTED: "Accepted",
            REJECTED: "Rejected",
            CANCELLED: "Cancelled",
            COMPLETED: "Completed",
            NONE: "None"
          };
          exports2.AnnotationReviewState = AnnotationReviewState;
          const AnnotationReplyType = {
            GROUP: "Group",
            REPLY: "R"
          };
          exports2.AnnotationReplyType = AnnotationReplyType;
          const AnnotationFlag = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          exports2.AnnotationFlag = AnnotationFlag;
          const AnnotationFieldFlag = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          exports2.AnnotationFieldFlag = AnnotationFieldFlag;
          const AnnotationBorderStyleType = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          exports2.AnnotationBorderStyleType = AnnotationBorderStyleType;
          const AnnotationActionEventType = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          exports2.AnnotationActionEventType = AnnotationActionEventType;
          const DocumentActionEventType = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          exports2.DocumentActionEventType = DocumentActionEventType;
          const PageActionEventType = {
            O: "PageOpen",
            C: "PageClose"
          };
          exports2.PageActionEventType = PageActionEventType;
          const StreamType = {
            UNKNOWN: "UNKNOWN",
            FLATE: "FLATE",
            LZW: "LZW",
            DCT: "DCT",
            JPX: "JPX",
            JBIG: "JBIG",
            A85: "A85",
            AHX: "AHX",
            CCF: "CCF",
            RLX: "RLX"
          };
          exports2.StreamType = StreamType;
          const FontType = {
            UNKNOWN: "UNKNOWN",
            TYPE1: "TYPE1",
            TYPE1C: "TYPE1C",
            CIDFONTTYPE0: "CIDFONTTYPE0",
            CIDFONTTYPE0C: "CIDFONTTYPE0C",
            TRUETYPE: "TRUETYPE",
            CIDFONTTYPE2: "CIDFONTTYPE2",
            TYPE3: "TYPE3",
            OPENTYPE: "OPENTYPE",
            TYPE0: "TYPE0",
            MMTYPE1: "MMTYPE1"
          };
          exports2.FontType = FontType;
          const VerbosityLevel = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          exports2.VerbosityLevel = VerbosityLevel;
          const CMapCompressionType = {
            NONE: 0,
            BINARY: 1,
            STREAM: 2
          };
          exports2.CMapCompressionType = CMapCompressionType;
          const OPS = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotations: 78,
            endAnnotations: 79,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintJpegXObject: 82,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          exports2.OPS = OPS;
          const UNSUPPORTED_FEATURES = {
            unknown: "unknown",
            forms: "forms",
            javaScript: "javaScript",
            smask: "smask",
            shadingPattern: "shadingPattern",
            font: "font",
            errorTilingPattern: "errorTilingPattern",
            errorExtGState: "errorExtGState",
            errorXObject: "errorXObject",
            errorFontLoadType3: "errorFontLoadType3",
            errorFontState: "errorFontState",
            errorFontMissing: "errorFontMissing",
            errorFontTranslate: "errorFontTranslate",
            errorColorSpace: "errorColorSpace",
            errorOperatorList: "errorOperatorList",
            errorFontToUnicode: "errorFontToUnicode",
            errorFontLoadNative: "errorFontLoadNative",
            errorFontGetPath: "errorFontGetPath",
            errorMarkedContent: "errorMarkedContent"
          };
          exports2.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
          const PasswordResponses = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          exports2.PasswordResponses = PasswordResponses;
          let verbosity = VerbosityLevel.WARNINGS;
          function setVerbosityLevel(level) {
            if (Number.isInteger(level)) {
              verbosity = level;
            }
          }
          function getVerbosityLevel() {
            return verbosity;
          }
          function info(msg) {
            if (verbosity >= VerbosityLevel.INFOS) {
              console.log(`Info: ${msg}`);
            }
          }
          function warn2(msg) {
            if (verbosity >= VerbosityLevel.WARNINGS) {
              console.log(`Warning: ${msg}`);
            }
          }
          function unreachable(msg) {
            throw new Error(msg);
          }
          function assert(cond, msg) {
            if (!cond) {
              unreachable(msg);
            }
          }
          function isSameOrigin(baseUrl, otherUrl) {
            let base2;
            try {
              base2 = new URL(baseUrl);
              if (!base2.origin || base2.origin === "null") {
                return false;
              }
            } catch (e) {
              return false;
            }
            const other = new URL(otherUrl, base2);
            return base2.origin === other.origin;
          }
          function _isValidProtocol(url) {
            if (!url) {
              return false;
            }
            switch (url.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return true;
              default:
                return false;
            }
          }
          function createValidAbsoluteUrl(url, baseUrl) {
            if (!url) {
              return null;
            }
            try {
              const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
              if (_isValidProtocol(absoluteUrl)) {
                return absoluteUrl;
              }
            } catch (ex) {
            }
            return null;
          }
          function shadow(obj, prop, value) {
            Object.defineProperty(obj, prop, {
              value,
              enumerable: true,
              configurable: true,
              writable: false
            });
            return value;
          }
          const BaseException = function BaseExceptionClosure() {
            function BaseException2(message) {
              if (this.constructor === BaseException2) {
                unreachable("Cannot initialize BaseException.");
              }
              this.message = message;
              this.name = this.constructor.name;
            }
            BaseException2.prototype = new Error();
            BaseException2.constructor = BaseException2;
            return BaseException2;
          }();
          exports2.BaseException = BaseException;
          class PasswordException extends BaseException {
            constructor(msg, code) {
              super(msg);
              this.code = code;
            }
          }
          exports2.PasswordException = PasswordException;
          class UnknownErrorException extends BaseException {
            constructor(msg, details) {
              super(msg);
              this.details = details;
            }
          }
          exports2.UnknownErrorException = UnknownErrorException;
          class InvalidPDFException extends BaseException {
          }
          exports2.InvalidPDFException = InvalidPDFException;
          class MissingPDFException extends BaseException {
          }
          exports2.MissingPDFException = MissingPDFException;
          class UnexpectedResponseException extends BaseException {
            constructor(msg, status) {
              super(msg);
              this.status = status;
            }
          }
          exports2.UnexpectedResponseException = UnexpectedResponseException;
          class FormatError extends BaseException {
          }
          exports2.FormatError = FormatError;
          class AbortException extends BaseException {
          }
          exports2.AbortException = AbortException;
          const NullCharactersRegExp = /\x00/g;
          function removeNullCharacters(str) {
            if (typeof str !== "string") {
              warn2("The argument for removeNullCharacters must be a string.");
              return str;
            }
            return str.replace(NullCharactersRegExp, "");
          }
          function bytesToString(bytes) {
            assert(bytes !== null && typeof bytes === "object" && bytes.length !== void 0, "Invalid argument for bytesToString");
            const length = bytes.length;
            const MAX_ARGUMENT_COUNT = 8192;
            if (length < MAX_ARGUMENT_COUNT) {
              return String.fromCharCode.apply(null, bytes);
            }
            const strBuf = [];
            for (let i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
              const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
              const chunk = bytes.subarray(i, chunkEnd);
              strBuf.push(String.fromCharCode.apply(null, chunk));
            }
            return strBuf.join("");
          }
          function stringToBytes(str) {
            assert(typeof str === "string", "Invalid argument for stringToBytes");
            const length = str.length;
            const bytes = new Uint8Array(length);
            for (let i = 0; i < length; ++i) {
              bytes[i] = str.charCodeAt(i) & 255;
            }
            return bytes;
          }
          function arrayByteLength(arr) {
            if (arr.length !== void 0) {
              return arr.length;
            }
            assert(arr.byteLength !== void 0, "arrayByteLength - invalid argument.");
            return arr.byteLength;
          }
          function arraysToBytes(arr) {
            const length = arr.length;
            if (length === 1 && arr[0] instanceof Uint8Array) {
              return arr[0];
            }
            let resultLength = 0;
            for (let i = 0; i < length; i++) {
              resultLength += arrayByteLength(arr[i]);
            }
            let pos = 0;
            const data2 = new Uint8Array(resultLength);
            for (let i = 0; i < length; i++) {
              let item = arr[i];
              if (!(item instanceof Uint8Array)) {
                if (typeof item === "string") {
                  item = stringToBytes(item);
                } else {
                  item = new Uint8Array(item);
                }
              }
              const itemLength = item.byteLength;
              data2.set(item, pos);
              pos += itemLength;
            }
            return data2;
          }
          function string32(value) {
            return String.fromCharCode(value >> 24 & 255, value >> 16 & 255, value >> 8 & 255, value & 255);
          }
          function objectSize(obj) {
            return Object.keys(obj).length;
          }
          function objectFromMap(map2) {
            const obj = /* @__PURE__ */ Object.create(null);
            for (const [key, value] of map2) {
              obj[key] = value;
            }
            return obj;
          }
          function isLittleEndian() {
            const buffer8 = new Uint8Array(4);
            buffer8[0] = 1;
            const view32 = new Uint32Array(buffer8.buffer, 0, 1);
            return view32[0] === 1;
          }
          const IsLittleEndianCached = {
            get value() {
              return shadow(this, "value", isLittleEndian());
            }
          };
          exports2.IsLittleEndianCached = IsLittleEndianCached;
          function isEvalSupported() {
            try {
              new Function("");
              return true;
            } catch (e) {
              return false;
            }
          }
          const IsEvalSupportedCached = {
            get value() {
              return shadow(this, "value", isEvalSupported());
            }
          };
          exports2.IsEvalSupportedCached = IsEvalSupportedCached;
          const hexNumbers = [...Array(256).keys()].map((n) => n.toString(16).padStart(2, "0"));
          class Util {
            static makeHexColor(r, g, b) {
              return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
            }
            static transform(m1, m2) {
              return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
            }
            static applyTransform(p2, m) {
              const xt = p2[0] * m[0] + p2[1] * m[2] + m[4];
              const yt = p2[0] * m[1] + p2[1] * m[3] + m[5];
              return [xt, yt];
            }
            static applyInverseTransform(p2, m) {
              const d = m[0] * m[3] - m[1] * m[2];
              const xt = (p2[0] * m[3] - p2[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
              const yt = (-p2[0] * m[1] + p2[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
              return [xt, yt];
            }
            static getAxialAlignedBoundingBox(r, m) {
              const p1 = Util.applyTransform(r, m);
              const p2 = Util.applyTransform(r.slice(2, 4), m);
              const p3 = Util.applyTransform([r[0], r[3]], m);
              const p4 = Util.applyTransform([r[2], r[1]], m);
              return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
            }
            static inverseTransform(m) {
              const d = m[0] * m[3] - m[1] * m[2];
              return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
            }
            static apply3dTransform(m, v) {
              return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
            }
            static singularValueDecompose2dScale(m) {
              const transpose = [m[0], m[2], m[1], m[3]];
              const a = m[0] * transpose[0] + m[1] * transpose[2];
              const b = m[0] * transpose[1] + m[1] * transpose[3];
              const c = m[2] * transpose[0] + m[3] * transpose[2];
              const d = m[2] * transpose[1] + m[3] * transpose[3];
              const first = (a + d) / 2;
              const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
              const sx = first + second || 1;
              const sy = first - second || 1;
              return [Math.sqrt(sx), Math.sqrt(sy)];
            }
            static normalizeRect(rect) {
              const r = rect.slice(0);
              if (rect[0] > rect[2]) {
                r[0] = rect[2];
                r[2] = rect[0];
              }
              if (rect[1] > rect[3]) {
                r[1] = rect[3];
                r[3] = rect[1];
              }
              return r;
            }
            static intersect(rect1, rect2) {
              function compare(a, b) {
                return a - b;
              }
              const orderedX = [rect1[0], rect1[2], rect2[0], rect2[2]].sort(compare);
              const orderedY = [rect1[1], rect1[3], rect2[1], rect2[3]].sort(compare);
              const result = [];
              rect1 = Util.normalizeRect(rect1);
              rect2 = Util.normalizeRect(rect2);
              if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
                result[0] = orderedX[1];
                result[2] = orderedX[2];
              } else {
                return null;
              }
              if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
                result[1] = orderedY[1];
                result[3] = orderedY[2];
              } else {
                return null;
              }
              return result;
            }
          }
          exports2.Util = Util;
          const PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function stringToPDFString(str) {
            const length = str.length, strBuf = [];
            if (str[0] === "\xFE" && str[1] === "\xFF") {
              for (let i = 2; i < length; i += 2) {
                strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
              }
            } else if (str[0] === "\xFF" && str[1] === "\xFE") {
              for (let i = 2; i < length; i += 2) {
                strBuf.push(String.fromCharCode(str.charCodeAt(i + 1) << 8 | str.charCodeAt(i)));
              }
            } else {
              for (let i = 0; i < length; ++i) {
                const code = PDFStringTranslateTable[str.charCodeAt(i)];
                strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
              }
            }
            return strBuf.join("");
          }
          function escapeString(str) {
            return str.replace(/([()\\\n\r])/g, (match) => {
              if (match === "\n") {
                return "\\n";
              } else if (match === "\r") {
                return "\\r";
              }
              return `\\${match}`;
            });
          }
          function isAscii(str) {
            return /^[\x00-\x7F]*$/.test(str);
          }
          function stringToUTF16BEString(str) {
            const buf = ["\xFE\xFF"];
            for (let i = 0, ii = str.length; i < ii; i++) {
              const char = str.charCodeAt(i);
              buf.push(String.fromCharCode(char >> 8 & 255));
              buf.push(String.fromCharCode(char & 255));
            }
            return buf.join("");
          }
          function stringToUTF8String(str) {
            return decodeURIComponent(escape(str));
          }
          function utf8StringToString(str) {
            return unescape(encodeURIComponent(str));
          }
          function isBool(v) {
            return typeof v === "boolean";
          }
          function isNum(v) {
            return typeof v === "number";
          }
          function isString2(v) {
            return typeof v === "string";
          }
          function isArrayBuffer2(v) {
            return typeof v === "object" && v !== null && v.byteLength !== void 0;
          }
          function isArrayEqual(arr1, arr2) {
            if (arr1.length !== arr2.length) {
              return false;
            }
            for (let i = 0, ii = arr1.length; i < ii; i++) {
              if (arr1[i] !== arr2[i]) {
                return false;
              }
            }
            return true;
          }
          function getModificationDate(date = new Date()) {
            const buffer2 = [date.getUTCFullYear().toString(), (date.getUTCMonth() + 1).toString().padStart(2, "0"), date.getUTCDate().toString().padStart(2, "0"), date.getUTCHours().toString().padStart(2, "0"), date.getUTCMinutes().toString().padStart(2, "0"), date.getUTCSeconds().toString().padStart(2, "0")];
            return buffer2.join("");
          }
          function createPromiseCapability() {
            const capability = /* @__PURE__ */ Object.create(null);
            let isSettled = false;
            Object.defineProperty(capability, "settled", {
              get() {
                return isSettled;
              }
            });
            capability.promise = new Promise(function(resolve2, reject) {
              capability.resolve = function(data2) {
                isSettled = true;
                resolve2(data2);
              };
              capability.reject = function(reason) {
                isSettled = true;
                reject(reason);
              };
            });
            return capability;
          }
          function createObjectURL(data2, contentType = "", forceDataSchema = false) {
            if (URL.createObjectURL && !forceDataSchema) {
              return URL.createObjectURL(new Blob([data2], {
                type: contentType
              }));
            }
            const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            let buffer2 = `data:${contentType};base64,`;
            for (let i = 0, ii = data2.length; i < ii; i += 3) {
              const b1 = data2[i] & 255;
              const b2 = data2[i + 1] & 255;
              const b3 = data2[i + 2] & 255;
              const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
              const d3 = i + 1 < ii ? (b2 & 15) << 2 | b3 >> 6 : 64;
              const d4 = i + 2 < ii ? b3 & 63 : 64;
              buffer2 += digits[d1] + digits[d2] + digits[d3] + digits[d4];
            }
            return buffer2;
          }
        },
        (__unused_webpack_module2, __unused_webpack_exports, __w_pdfjs_require__2) => {
          __w_pdfjs_require__2(4);
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.isNodeJS = void 0;
          const isNodeJS = typeof process === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          exports2.isNodeJS = isNodeJS;
        },
        (__unused_webpack_module, exports, __w_pdfjs_require__) => {
          Object.defineProperty(exports, "__esModule", {
            value: true
          });
          exports.getDocument = getDocument;
          exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
          exports.version = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultCMapReaderFactory = exports.DefaultCanvasFactory = exports.build = void 0;
          var _util = __w_pdfjs_require__(2);
          var _display_utils = __w_pdfjs_require__(1);
          var _font_loader = __w_pdfjs_require__(6);
          var _node_utils = __w_pdfjs_require__(7);
          var _annotation_storage = __w_pdfjs_require__(8);
          var _api_compatibility = __w_pdfjs_require__(9);
          var _canvas = __w_pdfjs_require__(10);
          var _worker_options = __w_pdfjs_require__(12);
          var _is_node = __w_pdfjs_require__(4);
          var _message_handler = __w_pdfjs_require__(13);
          var _metadata = __w_pdfjs_require__(14);
          var _optional_content_config = __w_pdfjs_require__(15);
          var _transport_stream = __w_pdfjs_require__(16);
          var _webgl = __w_pdfjs_require__(17);
          const DEFAULT_RANGE_CHUNK_SIZE = 65536;
          const RENDERING_CANCELLED_TIMEOUT = 100;
          const DefaultCanvasFactory = _is_node.isNodeJS ? _node_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
          exports.DefaultCanvasFactory = DefaultCanvasFactory;
          const DefaultCMapReaderFactory = _is_node.isNodeJS ? _node_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
          exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
          let createPDFNetworkStream;
          function setPDFNetworkStreamFactory(pdfNetworkStreamFactory) {
            createPDFNetworkStream = pdfNetworkStreamFactory;
          }
          function getDocument(src) {
            const task = new PDFDocumentLoadingTask();
            let source;
            if (typeof src === "string" || src instanceof URL) {
              source = {
                url: src
              };
            } else if ((0, _util.isArrayBuffer)(src)) {
              source = {
                data: src
              };
            } else if (src instanceof PDFDataRangeTransport) {
              source = {
                range: src
              };
            } else {
              if (typeof src !== "object") {
                throw new Error("Invalid parameter in getDocument, need either string, URL, Uint8Array, or parameter object.");
              }
              if (!src.url && !src.data && !src.range) {
                throw new Error("Invalid parameter object: need either .data, .range or .url");
              }
              source = src;
            }
            const params = /* @__PURE__ */ Object.create(null);
            let rangeTransport = null, worker2 = null;
            for (const key in source) {
              const value = source[key];
              switch (key) {
                case "url":
                  if (typeof window !== "undefined") {
                    try {
                      params[key] = new URL(value, window.location).href;
                      continue;
                    } catch (ex) {
                      (0, _util.warn)(`Cannot create valid URL: "${ex}".`);
                    }
                  } else if (typeof value === "string" || value instanceof URL) {
                    params[key] = value.toString();
                    continue;
                  }
                  throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                case "range":
                  rangeTransport = value;
                  continue;
                case "worker":
                  worker2 = value;
                  continue;
                case "data":
                  if (_is_node.isNodeJS && typeof Buffer !== "undefined" && value instanceof Buffer) {
                    params[key] = new Uint8Array(value);
                  } else if (value instanceof Uint8Array) {
                    break;
                  } else if (typeof value === "string") {
                    params[key] = (0, _util.stringToBytes)(value);
                  } else if (typeof value === "object" && value !== null && !isNaN(value.length)) {
                    params[key] = new Uint8Array(value);
                  } else if ((0, _util.isArrayBuffer)(value)) {
                    params[key] = new Uint8Array(value);
                  } else {
                    throw new Error("Invalid PDF binary data: either typed array, string, or array-like object is expected in the data property.");
                  }
                  continue;
              }
              params[key] = value;
            }
            params.rangeChunkSize = params.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
            params.CMapReaderFactory = params.CMapReaderFactory || DefaultCMapReaderFactory;
            params.ignoreErrors = params.stopAtErrors !== true;
            params.fontExtraProperties = params.fontExtraProperties === true;
            params.pdfBug = params.pdfBug === true;
            params.enableXfa = params.enableXfa === true;
            if (typeof params.docBaseUrl !== "string" || (0, _display_utils.isDataScheme)(params.docBaseUrl)) {
              params.docBaseUrl = null;
            }
            if (!Number.isInteger(params.maxImageSize)) {
              params.maxImageSize = -1;
            }
            if (typeof params.isEvalSupported !== "boolean") {
              params.isEvalSupported = true;
            }
            if (typeof params.disableFontFace !== "boolean") {
              params.disableFontFace = _api_compatibility.apiCompatibilityParams.disableFontFace || false;
            }
            if (typeof params.ownerDocument === "undefined") {
              params.ownerDocument = globalThis.document;
            }
            if (typeof params.disableRange !== "boolean") {
              params.disableRange = false;
            }
            if (typeof params.disableStream !== "boolean") {
              params.disableStream = false;
            }
            if (typeof params.disableAutoFetch !== "boolean") {
              params.disableAutoFetch = false;
            }
            (0, _util.setVerbosityLevel)(params.verbosity);
            if (!worker2) {
              const workerParams = {
                verbosity: params.verbosity,
                port: _worker_options.GlobalWorkerOptions.workerPort
              };
              worker2 = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
              task._worker = worker2;
            }
            const docId = task.docId;
            worker2.promise.then(function() {
              if (task.destroyed) {
                throw new Error("Loading aborted");
              }
              const workerIdPromise = _fetchDocument(worker2, params, rangeTransport, docId);
              const networkStreamPromise = new Promise(function(resolve2) {
                let networkStream;
                if (rangeTransport) {
                  networkStream = new _transport_stream.PDFDataTransportStream({
                    length: params.length,
                    initialData: params.initialData,
                    progressiveDone: params.progressiveDone,
                    contentDispositionFilename: params.contentDispositionFilename,
                    disableRange: params.disableRange,
                    disableStream: params.disableStream
                  }, rangeTransport);
                } else if (!params.data) {
                  networkStream = createPDFNetworkStream({
                    url: params.url,
                    length: params.length,
                    httpHeaders: params.httpHeaders,
                    withCredentials: params.withCredentials,
                    rangeChunkSize: params.rangeChunkSize,
                    disableRange: params.disableRange,
                    disableStream: params.disableStream
                  });
                }
                resolve2(networkStream);
              });
              return Promise.all([workerIdPromise, networkStreamPromise]).then(function([workerId, networkStream]) {
                if (task.destroyed) {
                  throw new Error("Loading aborted");
                }
                const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker2.port);
                messageHandler.postMessageTransfers = worker2.postMessageTransfers;
                const transport = new WorkerTransport(messageHandler, task, networkStream, params);
                task._transport = transport;
                messageHandler.send("Ready", null);
              });
            }).catch(task._capability.reject);
            return task;
          }
          function _fetchDocument(worker2, source, pdfDataRangeTransport, docId) {
            if (worker2.destroyed) {
              return Promise.reject(new Error("Worker was destroyed"));
            }
            if (pdfDataRangeTransport) {
              source.length = pdfDataRangeTransport.length;
              source.initialData = pdfDataRangeTransport.initialData;
              source.progressiveDone = pdfDataRangeTransport.progressiveDone;
              source.contentDispositionFilename = pdfDataRangeTransport.contentDispositionFilename;
            }
            return worker2.messageHandler.sendWithPromise("GetDocRequest", {
              docId,
              apiVersion: "2.8.335",
              source: {
                data: source.data,
                url: source.url,
                password: source.password,
                disableAutoFetch: source.disableAutoFetch,
                rangeChunkSize: source.rangeChunkSize,
                length: source.length
              },
              maxImageSize: source.maxImageSize,
              disableFontFace: source.disableFontFace,
              postMessageTransfers: worker2.postMessageTransfers,
              docBaseUrl: source.docBaseUrl,
              ignoreErrors: source.ignoreErrors,
              isEvalSupported: source.isEvalSupported,
              fontExtraProperties: source.fontExtraProperties,
              enableXfa: source.enableXfa
            }).then(function(workerId) {
              if (worker2.destroyed) {
                throw new Error("Worker was destroyed");
              }
              return workerId;
            });
          }
          const PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure() {
            let nextDocumentId = 0;
            class PDFDocumentLoadingTask2 {
              constructor() {
                this._capability = (0, _util.createPromiseCapability)();
                this._transport = null;
                this._worker = null;
                this.docId = "d" + nextDocumentId++;
                this.destroyed = false;
                this.onPassword = null;
                this.onProgress = null;
                this.onUnsupportedFeature = null;
              }
              get promise() {
                return this._capability.promise;
              }
              destroy() {
                this.destroyed = true;
                const transportDestroyed = !this._transport ? Promise.resolve() : this._transport.destroy();
                return transportDestroyed.then(() => {
                  this._transport = null;
                  if (this._worker) {
                    this._worker.destroy();
                    this._worker = null;
                  }
                });
              }
            }
            return PDFDocumentLoadingTask2;
          }();
          class PDFDataRangeTransport {
            constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null) {
              this.length = length;
              this.initialData = initialData;
              this.progressiveDone = progressiveDone;
              this.contentDispositionFilename = contentDispositionFilename;
              this._rangeListeners = [];
              this._progressListeners = [];
              this._progressiveReadListeners = [];
              this._progressiveDoneListeners = [];
              this._readyCapability = (0, _util.createPromiseCapability)();
            }
            addRangeListener(listener) {
              this._rangeListeners.push(listener);
            }
            addProgressListener(listener) {
              this._progressListeners.push(listener);
            }
            addProgressiveReadListener(listener) {
              this._progressiveReadListeners.push(listener);
            }
            addProgressiveDoneListener(listener) {
              this._progressiveDoneListeners.push(listener);
            }
            onDataRange(begin, chunk) {
              for (const listener of this._rangeListeners) {
                listener(begin, chunk);
              }
            }
            onDataProgress(loaded, total) {
              this._readyCapability.promise.then(() => {
                for (const listener of this._progressListeners) {
                  listener(loaded, total);
                }
              });
            }
            onDataProgressiveRead(chunk) {
              this._readyCapability.promise.then(() => {
                for (const listener of this._progressiveReadListeners) {
                  listener(chunk);
                }
              });
            }
            onDataProgressiveDone() {
              this._readyCapability.promise.then(() => {
                for (const listener of this._progressiveDoneListeners) {
                  listener();
                }
              });
            }
            transportReady() {
              this._readyCapability.resolve();
            }
            requestDataRange(begin, end) {
              (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
            }
            abort() {
            }
          }
          exports.PDFDataRangeTransport = PDFDataRangeTransport;
          class PDFDocumentProxy {
            constructor(pdfInfo, transport) {
              this._pdfInfo = pdfInfo;
              this._transport = transport;
            }
            get annotationStorage() {
              return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
            }
            get numPages() {
              return this._pdfInfo.numPages;
            }
            get fingerprint() {
              return this._pdfInfo.fingerprint;
            }
            get isPureXfa() {
              return this._pdfInfo.isPureXfa;
            }
            getPage(pageNumber) {
              return this._transport.getPage(pageNumber);
            }
            getPageIndex(ref2) {
              return this._transport.getPageIndex(ref2);
            }
            getDestinations() {
              return this._transport.getDestinations();
            }
            getDestination(id) {
              return this._transport.getDestination(id);
            }
            getPageLabels() {
              return this._transport.getPageLabels();
            }
            getPageLayout() {
              return this._transport.getPageLayout();
            }
            getPageMode() {
              return this._transport.getPageMode();
            }
            getViewerPreferences() {
              return this._transport.getViewerPreferences();
            }
            getOpenAction() {
              return this._transport.getOpenAction();
            }
            getAttachments() {
              return this._transport.getAttachments();
            }
            getJavaScript() {
              return this._transport.getJavaScript();
            }
            getJSActions() {
              return this._transport.getDocJSActions();
            }
            getOutline() {
              return this._transport.getOutline();
            }
            getOptionalContentConfig() {
              return this._transport.getOptionalContentConfig();
            }
            getPermissions() {
              return this._transport.getPermissions();
            }
            getMetadata() {
              return this._transport.getMetadata();
            }
            getMarkInfo() {
              return this._transport.getMarkInfo();
            }
            getData() {
              return this._transport.getData();
            }
            getDownloadInfo() {
              return this._transport.downloadInfoCapability.promise;
            }
            getStats() {
              return this._transport.getStats();
            }
            cleanup(keepLoadedFonts = false) {
              return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
            }
            destroy() {
              return this.loadingTask.destroy();
            }
            get loadingParams() {
              return this._transport.loadingParams;
            }
            get loadingTask() {
              return this._transport.loadingTask;
            }
            saveDocument(annotationStorage) {
              return this._transport.saveDocument(annotationStorage);
            }
            getFieldObjects() {
              return this._transport.getFieldObjects();
            }
            hasJSActions() {
              return this._transport.hasJSActions();
            }
            getCalculationOrderIds() {
              return this._transport.getCalculationOrderIds();
            }
          }
          exports.PDFDocumentProxy = PDFDocumentProxy;
          class PDFPageProxy {
            constructor(pageIndex, pageInfo, transport, ownerDocument, pdfBug = false) {
              this._pageIndex = pageIndex;
              this._pageInfo = pageInfo;
              this._ownerDocument = ownerDocument;
              this._transport = transport;
              this._stats = pdfBug ? new _display_utils.StatTimer() : null;
              this._pdfBug = pdfBug;
              this.commonObjs = transport.commonObjs;
              this.objs = new PDFObjects();
              this.cleanupAfterRender = false;
              this.pendingCleanup = false;
              this._intentStates = /* @__PURE__ */ new Map();
              this.destroyed = false;
            }
            get pageNumber() {
              return this._pageIndex + 1;
            }
            get rotate() {
              return this._pageInfo.rotate;
            }
            get ref() {
              return this._pageInfo.ref;
            }
            get userUnit() {
              return this._pageInfo.userUnit;
            }
            get view() {
              return this._pageInfo.view;
            }
            getViewport({
              scale,
              rotation = this.rotate,
              offsetX = 0,
              offsetY = 0,
              dontFlip = false
            } = {}) {
              return new _display_utils.PageViewport({
                viewBox: this.view,
                scale,
                rotation,
                offsetX,
                offsetY,
                dontFlip
              });
            }
            getAnnotations({
              intent = null
            } = {}) {
              if (!this._annotationsPromise || this._annotationsIntent !== intent) {
                this._annotationsPromise = this._transport.getAnnotations(this._pageIndex, intent);
                this._annotationsIntent = intent;
              }
              return this._annotationsPromise;
            }
            getJSActions() {
              return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
            }
            getXfa() {
              return this._xfaPromise || (this._xfaPromise = this._transport.getPageXfa(this._pageIndex));
            }
            render({
              canvasContext,
              viewport,
              intent = "display",
              enableWebGL = false,
              renderInteractiveForms = false,
              transform = null,
              imageLayer = null,
              canvasFactory = null,
              background = null,
              annotationStorage = null,
              optionalContentConfigPromise = null
            }) {
              var _intentState;
              if (this._stats) {
                this._stats.time("Overall");
              }
              const renderingIntent = intent === "print" ? "print" : "display";
              this.pendingCleanup = false;
              if (!optionalContentConfigPromise) {
                optionalContentConfigPromise = this._transport.getOptionalContentConfig();
              }
              let intentState = this._intentStates.get(renderingIntent);
              if (!intentState) {
                intentState = /* @__PURE__ */ Object.create(null);
                this._intentStates.set(renderingIntent, intentState);
              }
              if (intentState.streamReaderCancelTimeout) {
                clearTimeout(intentState.streamReaderCancelTimeout);
                intentState.streamReaderCancelTimeout = null;
              }
              const canvasFactoryInstance = canvasFactory || new DefaultCanvasFactory({
                ownerDocument: this._ownerDocument
              });
              const webGLContext = new _webgl.WebGLContext({
                enable: enableWebGL
              });
              if (!intentState.displayReadyCapability) {
                intentState.displayReadyCapability = (0, _util.createPromiseCapability)();
                intentState.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: false
                };
                if (this._stats) {
                  this._stats.time("Page Request");
                }
                this._pumpOperatorList({
                  pageIndex: this._pageIndex,
                  intent: renderingIntent,
                  renderInteractiveForms: renderInteractiveForms === true,
                  annotationStorage: (annotationStorage == null ? void 0 : annotationStorage.serializable) || null
                });
              }
              const complete = (error) => {
                intentState.renderTasks.delete(internalRenderTask);
                if (this.cleanupAfterRender || renderingIntent === "print") {
                  this.pendingCleanup = true;
                }
                this._tryCleanup();
                if (error) {
                  internalRenderTask.capability.reject(error);
                  this._abortOperatorList({
                    intentState,
                    reason: error
                  });
                } else {
                  internalRenderTask.capability.resolve();
                }
                if (this._stats) {
                  this._stats.timeEnd("Rendering");
                  this._stats.timeEnd("Overall");
                }
              };
              const internalRenderTask = new InternalRenderTask({
                callback: complete,
                params: {
                  canvasContext,
                  viewport,
                  transform,
                  imageLayer,
                  background
                },
                objs: this.objs,
                commonObjs: this.commonObjs,
                operatorList: intentState.operatorList,
                pageIndex: this._pageIndex,
                canvasFactory: canvasFactoryInstance,
                webGLContext,
                useRequestAnimationFrame: renderingIntent !== "print",
                pdfBug: this._pdfBug
              });
              ((_intentState = intentState).renderTasks || (_intentState.renderTasks = /* @__PURE__ */ new Set())).add(internalRenderTask);
              const renderTask = internalRenderTask.task;
              Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(([transparency, optionalContentConfig]) => {
                if (this.pendingCleanup) {
                  complete();
                  return;
                }
                if (this._stats) {
                  this._stats.time("Rendering");
                }
                internalRenderTask.initializeGraphics({
                  transparency,
                  optionalContentConfig
                });
                internalRenderTask.operatorListChanged();
              }).catch(complete);
              return renderTask;
            }
            getOperatorList() {
              function operatorListChanged() {
                if (intentState.operatorList.lastChunk) {
                  intentState.opListReadCapability.resolve(intentState.operatorList);
                  intentState.renderTasks.delete(opListTask);
                }
              }
              const renderingIntent = "oplist";
              let intentState = this._intentStates.get(renderingIntent);
              if (!intentState) {
                intentState = /* @__PURE__ */ Object.create(null);
                this._intentStates.set(renderingIntent, intentState);
              }
              let opListTask;
              if (!intentState.opListReadCapability) {
                var _intentState2;
                opListTask = /* @__PURE__ */ Object.create(null);
                opListTask.operatorListChanged = operatorListChanged;
                intentState.opListReadCapability = (0, _util.createPromiseCapability)();
                ((_intentState2 = intentState).renderTasks || (_intentState2.renderTasks = /* @__PURE__ */ new Set())).add(opListTask);
                intentState.operatorList = {
                  fnArray: [],
                  argsArray: [],
                  lastChunk: false
                };
                if (this._stats) {
                  this._stats.time("Page Request");
                }
                this._pumpOperatorList({
                  pageIndex: this._pageIndex,
                  intent: renderingIntent
                });
              }
              return intentState.opListReadCapability.promise;
            }
            streamTextContent({
              normalizeWhitespace = false,
              disableCombineTextItems = false
            } = {}) {
              const TEXT_CONTENT_CHUNK_SIZE = 100;
              return this._transport.messageHandler.sendWithStream("GetTextContent", {
                pageIndex: this._pageIndex,
                normalizeWhitespace: normalizeWhitespace === true,
                combineTextItems: disableCombineTextItems !== true
              }, {
                highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                size(textContent) {
                  return textContent.items.length;
                }
              });
            }
            getTextContent(params = {}) {
              const readableStream = this.streamTextContent(params);
              return new Promise(function(resolve2, reject) {
                function pump() {
                  reader.read().then(function({
                    value,
                    done
                  }) {
                    if (done) {
                      resolve2(textContent);
                      return;
                    }
                    Object.assign(textContent.styles, value.styles);
                    textContent.items.push(...value.items);
                    pump();
                  }, reject);
                }
                const reader = readableStream.getReader();
                const textContent = {
                  items: [],
                  styles: /* @__PURE__ */ Object.create(null)
                };
                pump();
              });
            }
            _destroy() {
              this.destroyed = true;
              this._transport.pageCache[this._pageIndex] = null;
              const waitOn = [];
              for (const [intent, intentState] of this._intentStates) {
                this._abortOperatorList({
                  intentState,
                  reason: new Error("Page was destroyed."),
                  force: true
                });
                if (intent === "oplist") {
                  continue;
                }
                for (const internalRenderTask of intentState.renderTasks) {
                  waitOn.push(internalRenderTask.completed);
                  internalRenderTask.cancel();
                }
              }
              this.objs.clear();
              this._annotationsPromise = null;
              this._jsActionsPromise = null;
              this._xfaPromise = null;
              this.pendingCleanup = false;
              return Promise.all(waitOn);
            }
            cleanup(resetStats = false) {
              this.pendingCleanup = true;
              return this._tryCleanup(resetStats);
            }
            _tryCleanup(resetStats = false) {
              if (!this.pendingCleanup) {
                return false;
              }
              for (const {
                renderTasks,
                operatorList
              } of this._intentStates.values()) {
                if (renderTasks.size > 0 || !operatorList.lastChunk) {
                  return false;
                }
              }
              this._intentStates.clear();
              this.objs.clear();
              this._annotationsPromise = null;
              this._jsActionsPromise = null;
              this._xfaPromise = null;
              if (resetStats && this._stats) {
                this._stats = new _display_utils.StatTimer();
              }
              this.pendingCleanup = false;
              return true;
            }
            _startRenderPage(transparency, intent) {
              const intentState = this._intentStates.get(intent);
              if (!intentState) {
                return;
              }
              if (this._stats) {
                this._stats.timeEnd("Page Request");
              }
              if (intentState.displayReadyCapability) {
                intentState.displayReadyCapability.resolve(transparency);
              }
            }
            _renderPageChunk(operatorListChunk, intentState) {
              for (let i = 0, ii = operatorListChunk.length; i < ii; i++) {
                intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
              }
              intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
              for (const internalRenderTask of intentState.renderTasks) {
                internalRenderTask.operatorListChanged();
              }
              if (operatorListChunk.lastChunk) {
                this._tryCleanup();
              }
            }
            _pumpOperatorList(args) {
              (0, _util.assert)(args.intent, 'PDFPageProxy._pumpOperatorList: Expected "intent" argument.');
              const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", args);
              const reader = readableStream.getReader();
              const intentState = this._intentStates.get(args.intent);
              intentState.streamReader = reader;
              const pump = () => {
                reader.read().then(({
                  value,
                  done
                }) => {
                  if (done) {
                    intentState.streamReader = null;
                    return;
                  }
                  if (this._transport.destroyed) {
                    return;
                  }
                  this._renderPageChunk(value, intentState);
                  pump();
                }, (reason) => {
                  intentState.streamReader = null;
                  if (this._transport.destroyed) {
                    return;
                  }
                  if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    for (const internalRenderTask of intentState.renderTasks) {
                      internalRenderTask.operatorListChanged();
                    }
                    this._tryCleanup();
                  }
                  if (intentState.displayReadyCapability) {
                    intentState.displayReadyCapability.reject(reason);
                  } else if (intentState.opListReadCapability) {
                    intentState.opListReadCapability.reject(reason);
                  } else {
                    throw reason;
                  }
                });
              };
              pump();
            }
            _abortOperatorList({
              intentState,
              reason,
              force = false
            }) {
              (0, _util.assert)(reason instanceof Error || typeof reason === "object" && reason !== null, 'PDFPageProxy._abortOperatorList: Expected "reason" argument.');
              if (!intentState.streamReader) {
                return;
              }
              if (!force) {
                if (intentState.renderTasks.size > 0) {
                  return;
                }
                if (reason instanceof _display_utils.RenderingCancelledException) {
                  intentState.streamReaderCancelTimeout = setTimeout(() => {
                    this._abortOperatorList({
                      intentState,
                      reason,
                      force: true
                    });
                    intentState.streamReaderCancelTimeout = null;
                  }, RENDERING_CANCELLED_TIMEOUT);
                  return;
                }
              }
              intentState.streamReader.cancel(new _util.AbortException(reason == null ? void 0 : reason.message));
              intentState.streamReader = null;
              if (this._transport.destroyed) {
                return;
              }
              for (const [intent, curIntentState] of this._intentStates) {
                if (curIntentState === intentState) {
                  this._intentStates.delete(intent);
                  break;
                }
              }
              this.cleanup();
            }
            get stats() {
              return this._stats;
            }
          }
          exports.PDFPageProxy = PDFPageProxy;
          class LoopbackPort {
            constructor() {
              this._listeners = [];
              this._deferred = Promise.resolve(void 0);
            }
            postMessage(obj, transfers) {
              function cloneValue(value) {
                var _a2;
                if (typeof value !== "object" || value === null) {
                  return value;
                }
                if (cloned.has(value)) {
                  return cloned.get(value);
                }
                let buffer2, result;
                if ((buffer2 = value.buffer) && (0, _util.isArrayBuffer)(buffer2)) {
                  if (transfers == null ? void 0 : transfers.includes(buffer2)) {
                    result = new value.constructor(buffer2, value.byteOffset, value.byteLength);
                  } else {
                    result = new value.constructor(value);
                  }
                  cloned.set(value, result);
                  return result;
                }
                if (value instanceof Map) {
                  result = /* @__PURE__ */ new Map();
                  cloned.set(value, result);
                  for (const [key, val] of value) {
                    result.set(key, cloneValue(val));
                  }
                  return result;
                }
                if (value instanceof Set) {
                  result = /* @__PURE__ */ new Set();
                  cloned.set(value, result);
                  for (const val of value) {
                    result.add(cloneValue(val));
                  }
                  return result;
                }
                result = Array.isArray(value) ? [] : {};
                cloned.set(value, result);
                for (const i in value) {
                  let desc, p2 = value;
                  while (!(desc = Object.getOwnPropertyDescriptor(p2, i))) {
                    p2 = Object.getPrototypeOf(p2);
                  }
                  if (typeof desc.value === "undefined") {
                    continue;
                  }
                  if (typeof desc.value === "function") {
                    if ((_a2 = value.hasOwnProperty) == null ? void 0 : _a2.call(value, i)) {
                      throw new Error(`LoopbackPort.postMessage - cannot clone: ${value[i]}`);
                    }
                    continue;
                  }
                  result[i] = cloneValue(desc.value);
                }
                return result;
              }
              const cloned = /* @__PURE__ */ new WeakMap();
              const event = {
                data: cloneValue(obj)
              };
              this._deferred.then(() => {
                for (const listener of this._listeners) {
                  listener.call(this, event);
                }
              });
            }
            addEventListener(name2, listener) {
              this._listeners.push(listener);
            }
            removeEventListener(name2, listener) {
              const i = this._listeners.indexOf(listener);
              this._listeners.splice(i, 1);
            }
            terminate() {
              this._listeners.length = 0;
            }
          }
          exports.LoopbackPort = LoopbackPort;
          const PDFWorker = function PDFWorkerClosure() {
            var _a;
            const pdfWorkerPorts = /* @__PURE__ */ new WeakMap();
            let isWorkerDisabled = false;
            let fallbackWorkerSrc;
            let nextFakeWorkerId = 0;
            let fakeWorkerCapability;
            if (_is_node.isNodeJS && typeof commonjsRequire === "function") {
              isWorkerDisabled = true;
              fallbackWorkerSrc = "./pdf.worker.js";
            } else if (typeof document === "object" && "currentScript" in document) {
              const pdfjsFilePath = (_a = document.currentScript) == null ? void 0 : _a.src;
              if (pdfjsFilePath) {
                fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
              }
            }
            function getWorkerSrc() {
              if (_worker_options.GlobalWorkerOptions.workerSrc) {
                return _worker_options.GlobalWorkerOptions.workerSrc;
              }
              if (typeof fallbackWorkerSrc !== "undefined") {
                if (!_is_node.isNodeJS) {
                  (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                }
                return fallbackWorkerSrc;
              }
              throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
            }
            function getMainThreadWorkerMessageHandler() {
              var _a2;
              let mainWorkerMessageHandler2;
              try {
                mainWorkerMessageHandler2 = (_a2 = globalThis.pdfjsWorker) == null ? void 0 : _a2.WorkerMessageHandler;
              } catch (ex) {
              }
              return mainWorkerMessageHandler2 || null;
            }
            function setupFakeWorkerGlobal() {
              if (fakeWorkerCapability) {
                return fakeWorkerCapability.promise;
              }
              fakeWorkerCapability = (0, _util.createPromiseCapability)();
              const loader = async function() {
                const mainWorkerMessageHandler = getMainThreadWorkerMessageHandler();
                if (mainWorkerMessageHandler) {
                  return mainWorkerMessageHandler;
                }
                if (_is_node.isNodeJS && typeof commonjsRequire === "function") {
                  const worker = eval("require")(getWorkerSrc());
                  return worker.WorkerMessageHandler;
                }
                await (0, _display_utils.loadScript)(getWorkerSrc());
                return window.pdfjsWorker.WorkerMessageHandler;
              };
              loader().then(fakeWorkerCapability.resolve, fakeWorkerCapability.reject);
              return fakeWorkerCapability.promise;
            }
            function createCDNWrapper(url) {
              const wrapper = "importScripts('" + url + "');";
              return URL.createObjectURL(new Blob([wrapper]));
            }
            class PDFWorker {
              constructor({
                name: name2 = null,
                port = null,
                verbosity = (0, _util.getVerbosityLevel)()
              } = {}) {
                if (port && pdfWorkerPorts.has(port)) {
                  throw new Error("Cannot use more than one PDFWorker per port");
                }
                this.name = name2;
                this.destroyed = false;
                this.postMessageTransfers = true;
                this.verbosity = verbosity;
                this._readyCapability = (0, _util.createPromiseCapability)();
                this._port = null;
                this._webWorker = null;
                this._messageHandler = null;
                if (port) {
                  pdfWorkerPorts.set(port, this);
                  this._initializeFromPort(port);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(port) {
                this._port = port;
                this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                this._messageHandler.on("ready", function() {
                });
                this._readyCapability.resolve();
              }
              _initialize() {
                if (typeof Worker !== "undefined" && !isWorkerDisabled && !getMainThreadWorkerMessageHandler()) {
                  let workerSrc = getWorkerSrc();
                  try {
                    if (!(0, _util.isSameOrigin)(window.location.href, workerSrc)) {
                      workerSrc = createCDNWrapper(new URL(workerSrc, window.location).href);
                    }
                    const worker2 = new Worker(workerSrc);
                    const messageHandler = new _message_handler.MessageHandler("main", "worker", worker2);
                    const terminateEarly = () => {
                      worker2.removeEventListener("error", onWorkerError);
                      messageHandler.destroy();
                      worker2.terminate();
                      if (this.destroyed) {
                        this._readyCapability.reject(new Error("Worker was destroyed"));
                      } else {
                        this._setupFakeWorker();
                      }
                    };
                    const onWorkerError = () => {
                      if (!this._webWorker) {
                        terminateEarly();
                      }
                    };
                    worker2.addEventListener("error", onWorkerError);
                    messageHandler.on("test", (data2) => {
                      worker2.removeEventListener("error", onWorkerError);
                      if (this.destroyed) {
                        terminateEarly();
                        return;
                      }
                      if (data2) {
                        this._messageHandler = messageHandler;
                        this._port = worker2;
                        this._webWorker = worker2;
                        if (!data2.supportTransfers) {
                          this.postMessageTransfers = false;
                        }
                        this._readyCapability.resolve();
                        messageHandler.send("configure", {
                          verbosity: this.verbosity
                        });
                      } else {
                        this._setupFakeWorker();
                        messageHandler.destroy();
                        worker2.terminate();
                      }
                    });
                    messageHandler.on("ready", (data2) => {
                      worker2.removeEventListener("error", onWorkerError);
                      if (this.destroyed) {
                        terminateEarly();
                        return;
                      }
                      try {
                        sendTest();
                      } catch (e) {
                        this._setupFakeWorker();
                      }
                    });
                    const sendTest = () => {
                      const testObj = new Uint8Array([this.postMessageTransfers ? 255 : 0]);
                      try {
                        messageHandler.send("test", testObj, [testObj.buffer]);
                      } catch (ex) {
                        (0, _util.warn)("Cannot use postMessage transfers.");
                        testObj[0] = 0;
                        messageHandler.send("test", testObj);
                      }
                    };
                    sendTest();
                    return;
                  } catch (e) {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                if (!isWorkerDisabled) {
                  (0, _util.warn)("Setting up fake worker.");
                  isWorkerDisabled = true;
                }
                setupFakeWorkerGlobal().then((WorkerMessageHandler) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const port = new LoopbackPort();
                  this._port = port;
                  const id = "fake" + nextFakeWorkerId++;
                  const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                  WorkerMessageHandler.setup(workerHandler, port);
                  const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                  this._messageHandler = messageHandler;
                  this._readyCapability.resolve();
                  messageHandler.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((reason) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                });
              }
              destroy() {
                this.destroyed = true;
                if (this._webWorker) {
                  this._webWorker.terminate();
                  this._webWorker = null;
                }
                pdfWorkerPorts.delete(this._port);
                this._port = null;
                if (this._messageHandler) {
                  this._messageHandler.destroy();
                  this._messageHandler = null;
                }
              }
              static fromPort(params) {
                if (!params || !params.port) {
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                }
                if (pdfWorkerPorts.has(params.port)) {
                  return pdfWorkerPorts.get(params.port);
                }
                return new PDFWorker(params);
              }
              static getWorkerSrc() {
                return getWorkerSrc();
              }
            }
            return PDFWorker;
          }();
          exports.PDFWorker = PDFWorker;
          class WorkerTransport {
            constructor(messageHandler, loadingTask, networkStream, params) {
              this.messageHandler = messageHandler;
              this.loadingTask = loadingTask;
              this.commonObjs = new PDFObjects();
              this.fontLoader = new _font_loader.FontLoader({
                docId: loadingTask.docId,
                onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                ownerDocument: params.ownerDocument
              });
              this._params = params;
              this.CMapReaderFactory = new params.CMapReaderFactory({
                baseUrl: params.cMapUrl,
                isCompressed: params.cMapPacked
              });
              this.destroyed = false;
              this.destroyCapability = null;
              this._passwordCapability = null;
              this._networkStream = networkStream;
              this._fullReader = null;
              this._lastProgress = null;
              this.pageCache = [];
              this.pagePromises = [];
              this.downloadInfoCapability = (0, _util.createPromiseCapability)();
              this.setupMessageHandler();
            }
            get loadingTaskSettled() {
              return this.loadingTask._capability.settled;
            }
            destroy() {
              if (this.destroyCapability) {
                return this.destroyCapability.promise;
              }
              this.destroyed = true;
              this.destroyCapability = (0, _util.createPromiseCapability)();
              if (this._passwordCapability) {
                this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
              }
              const waitOn = [];
              this.pageCache.forEach(function(page) {
                if (page) {
                  waitOn.push(page._destroy());
                }
              });
              this.pageCache.length = 0;
              this.pagePromises.length = 0;
              const terminated = this.messageHandler.sendWithPromise("Terminate", null);
              waitOn.push(terminated);
              if (this.loadingTaskSettled) {
                const annotationStorageResetModified = this.loadingTask.promise.then((pdfDocument) => {
                  if (pdfDocument.hasOwnProperty("annotationStorage")) {
                    pdfDocument.annotationStorage.resetModified();
                  }
                }).catch(() => {
                });
                waitOn.push(annotationStorageResetModified);
              }
              Promise.all(waitOn).then(() => {
                this.commonObjs.clear();
                this.fontLoader.clear();
                this._hasJSActionsPromise = null;
                if (this._networkStream) {
                  this._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                }
                if (this.messageHandler) {
                  this.messageHandler.destroy();
                  this.messageHandler = null;
                }
                this.destroyCapability.resolve();
              }, this.destroyCapability.reject);
              return this.destroyCapability.promise;
            }
            setupMessageHandler() {
              const {
                messageHandler,
                loadingTask
              } = this;
              messageHandler.on("GetReader", (data2, sink) => {
                (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                this._fullReader = this._networkStream.getFullReader();
                this._fullReader.onProgress = (evt) => {
                  this._lastProgress = {
                    loaded: evt.loaded,
                    total: evt.total
                  };
                };
                sink.onPull = () => {
                  this._fullReader.read().then(function({
                    value,
                    done
                  }) {
                    if (done) {
                      sink.close();
                      return;
                    }
                    (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [value]);
                  }).catch((reason) => {
                    sink.error(reason);
                  });
                };
                sink.onCancel = (reason) => {
                  this._fullReader.cancel(reason);
                  sink.ready.catch((readyReason) => {
                    if (this.destroyed) {
                      return;
                    }
                    throw readyReason;
                  });
                };
              });
              messageHandler.on("ReaderHeadersReady", (data2) => {
                const headersCapability = (0, _util.createPromiseCapability)();
                const fullReader = this._fullReader;
                fullReader.headersReady.then(() => {
                  if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                    if (this._lastProgress && loadingTask.onProgress) {
                      loadingTask.onProgress(this._lastProgress);
                    }
                    fullReader.onProgress = (evt) => {
                      if (loadingTask.onProgress) {
                        loadingTask.onProgress({
                          loaded: evt.loaded,
                          total: evt.total
                        });
                      }
                    };
                  }
                  headersCapability.resolve({
                    isStreamingSupported: fullReader.isStreamingSupported,
                    isRangeSupported: fullReader.isRangeSupported,
                    contentLength: fullReader.contentLength
                  });
                }, headersCapability.reject);
                return headersCapability.promise;
              });
              messageHandler.on("GetRangeReader", (data2, sink) => {
                (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                const rangeReader = this._networkStream.getRangeReader(data2.begin, data2.end);
                if (!rangeReader) {
                  sink.close();
                  return;
                }
                sink.onPull = () => {
                  rangeReader.read().then(function({
                    value,
                    done
                  }) {
                    if (done) {
                      sink.close();
                      return;
                    }
                    (0, _util.assert)((0, _util.isArrayBuffer)(value), "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [value]);
                  }).catch((reason) => {
                    sink.error(reason);
                  });
                };
                sink.onCancel = (reason) => {
                  rangeReader.cancel(reason);
                  sink.ready.catch((readyReason) => {
                    if (this.destroyed) {
                      return;
                    }
                    throw readyReason;
                  });
                };
              });
              messageHandler.on("GetDoc", ({
                pdfInfo
              }) => {
                this._numPages = pdfInfo.numPages;
                loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
              });
              messageHandler.on("DocException", function(ex) {
                let reason;
                switch (ex.name) {
                  case "PasswordException":
                    reason = new _util.PasswordException(ex.message, ex.code);
                    break;
                  case "InvalidPDFException":
                    reason = new _util.InvalidPDFException(ex.message);
                    break;
                  case "MissingPDFException":
                    reason = new _util.MissingPDFException(ex.message);
                    break;
                  case "UnexpectedResponseException":
                    reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                    break;
                  case "UnknownErrorException":
                    reason = new _util.UnknownErrorException(ex.message, ex.details);
                    break;
                }
                if (!(reason instanceof Error)) {
                  const msg = "DocException - expected a valid Error.";
                  (0, _util.warn)(msg);
                }
                loadingTask._capability.reject(reason);
              });
              messageHandler.on("PasswordRequest", (exception) => {
                this._passwordCapability = (0, _util.createPromiseCapability)();
                if (loadingTask.onPassword) {
                  const updatePassword = (password) => {
                    this._passwordCapability.resolve({
                      password
                    });
                  };
                  try {
                    loadingTask.onPassword(updatePassword, exception.code);
                  } catch (ex) {
                    this._passwordCapability.reject(ex);
                  }
                } else {
                  this._passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
                }
                return this._passwordCapability.promise;
              });
              messageHandler.on("DataLoaded", (data2) => {
                if (loadingTask.onProgress) {
                  loadingTask.onProgress({
                    loaded: data2.length,
                    total: data2.length
                  });
                }
                this.downloadInfoCapability.resolve(data2);
              });
              messageHandler.on("StartRenderPage", (data2) => {
                if (this.destroyed) {
                  return;
                }
                const page = this.pageCache[data2.pageIndex];
                page._startRenderPage(data2.transparency, data2.intent);
              });
              messageHandler.on("commonobj", (data2) => {
                var _a2;
                if (this.destroyed) {
                  return;
                }
                const [id, type, exportedData] = data2;
                if (this.commonObjs.has(id)) {
                  return;
                }
                switch (type) {
                  case "Font":
                    const params = this._params;
                    if ("error" in exportedData) {
                      const exportedError = exportedData.error;
                      (0, _util.warn)(`Error during font loading: ${exportedError}`);
                      this.commonObjs.resolve(id, exportedError);
                      break;
                    }
                    let fontRegistry = null;
                    if (params.pdfBug && ((_a2 = globalThis.FontInspector) == null ? void 0 : _a2.enabled)) {
                      fontRegistry = {
                        registerFont(font2, url) {
                          globalThis.FontInspector.fontAdded(font2, url);
                        }
                      };
                    }
                    const font = new _font_loader.FontFaceObject(exportedData, {
                      isEvalSupported: params.isEvalSupported,
                      disableFontFace: params.disableFontFace,
                      ignoreErrors: params.ignoreErrors,
                      onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                      fontRegistry
                    });
                    this.fontLoader.bind(font).catch((reason) => {
                      return messageHandler.sendWithPromise("FontFallback", {
                        id
                      });
                    }).finally(() => {
                      if (!params.fontExtraProperties && font.data) {
                        font.data = null;
                      }
                      this.commonObjs.resolve(id, font);
                    });
                    break;
                  case "FontPath":
                  case "Image":
                    this.commonObjs.resolve(id, exportedData);
                    break;
                  default:
                    throw new Error(`Got unknown common object type ${type}`);
                }
              });
              messageHandler.on("obj", (data2) => {
                var _a2;
                if (this.destroyed) {
                  return void 0;
                }
                const [id, pageIndex, type, imageData] = data2;
                const pageProxy = this.pageCache[pageIndex];
                if (pageProxy.objs.has(id)) {
                  return void 0;
                }
                switch (type) {
                  case "Image":
                    pageProxy.objs.resolve(id, imageData);
                    const MAX_IMAGE_SIZE_TO_STORE = 8e6;
                    if (((_a2 = imageData == null ? void 0 : imageData.data) == null ? void 0 : _a2.length) > MAX_IMAGE_SIZE_TO_STORE) {
                      pageProxy.cleanupAfterRender = true;
                    }
                    break;
                  default:
                    throw new Error(`Got unknown object type ${type}`);
                }
                return void 0;
              });
              messageHandler.on("DocProgress", (data2) => {
                if (this.destroyed) {
                  return;
                }
                if (loadingTask.onProgress) {
                  loadingTask.onProgress({
                    loaded: data2.loaded,
                    total: data2.total
                  });
                }
              });
              messageHandler.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
              messageHandler.on("FetchBuiltInCMap", (data2, sink) => {
                if (this.destroyed) {
                  sink.error(new Error("Worker was destroyed"));
                  return;
                }
                let fetched = false;
                sink.onPull = () => {
                  if (fetched) {
                    sink.close();
                    return;
                  }
                  fetched = true;
                  this.CMapReaderFactory.fetch(data2).then(function(builtInCMap) {
                    sink.enqueue(builtInCMap, 1, [builtInCMap.cMapData.buffer]);
                  }).catch(function(reason) {
                    sink.error(reason);
                  });
                };
              });
            }
            _onUnsupportedFeature({
              featureId
            }) {
              if (this.destroyed) {
                return;
              }
              if (this.loadingTask.onUnsupportedFeature) {
                this.loadingTask.onUnsupportedFeature(featureId);
              }
            }
            getData() {
              return this.messageHandler.sendWithPromise("GetData", null);
            }
            getPage(pageNumber) {
              if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
                return Promise.reject(new Error("Invalid page request"));
              }
              const pageIndex = pageNumber - 1;
              if (pageIndex in this.pagePromises) {
                return this.pagePromises[pageIndex];
              }
              const promise = this.messageHandler.sendWithPromise("GetPage", {
                pageIndex
              }).then((pageInfo) => {
                if (this.destroyed) {
                  throw new Error("Transport destroyed");
                }
                const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.ownerDocument, this._params.pdfBug);
                this.pageCache[pageIndex] = page;
                return page;
              });
              this.pagePromises[pageIndex] = promise;
              return promise;
            }
            getPageIndex(ref2) {
              return this.messageHandler.sendWithPromise("GetPageIndex", {
                ref: ref2
              }).catch(function(reason) {
                return Promise.reject(new Error(reason));
              });
            }
            getAnnotations(pageIndex, intent) {
              return this.messageHandler.sendWithPromise("GetAnnotations", {
                pageIndex,
                intent
              });
            }
            saveDocument(annotationStorage) {
              var _a2, _b;
              return this.messageHandler.sendWithPromise("SaveDocument", {
                numPages: this._numPages,
                annotationStorage: (annotationStorage == null ? void 0 : annotationStorage.serializable) || null,
                filename: (_b = (_a2 = this._fullReader) == null ? void 0 : _a2.filename) != null ? _b : null
              }).finally(() => {
                if (annotationStorage) {
                  annotationStorage.resetModified();
                }
              });
            }
            getFieldObjects() {
              return this.messageHandler.sendWithPromise("GetFieldObjects", null);
            }
            hasJSActions() {
              return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
            }
            getCalculationOrderIds() {
              return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
            }
            getDestinations() {
              return this.messageHandler.sendWithPromise("GetDestinations", null);
            }
            getDestination(id) {
              if (typeof id !== "string") {
                return Promise.reject(new Error("Invalid destination request."));
              }
              return this.messageHandler.sendWithPromise("GetDestination", {
                id
              });
            }
            getPageLabels() {
              return this.messageHandler.sendWithPromise("GetPageLabels", null);
            }
            getPageLayout() {
              return this.messageHandler.sendWithPromise("GetPageLayout", null);
            }
            getPageMode() {
              return this.messageHandler.sendWithPromise("GetPageMode", null);
            }
            getViewerPreferences() {
              return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
            }
            getOpenAction() {
              return this.messageHandler.sendWithPromise("GetOpenAction", null);
            }
            getAttachments() {
              return this.messageHandler.sendWithPromise("GetAttachments", null);
            }
            getJavaScript() {
              return this.messageHandler.sendWithPromise("GetJavaScript", null);
            }
            getDocJSActions() {
              return this.messageHandler.sendWithPromise("GetDocJSActions", null);
            }
            getPageJSActions(pageIndex) {
              return this.messageHandler.sendWithPromise("GetPageJSActions", {
                pageIndex
              });
            }
            getPageXfa(pageIndex) {
              return this.messageHandler.sendWithPromise("GetPageXfa", {
                pageIndex
              });
            }
            getOutline() {
              return this.messageHandler.sendWithPromise("GetOutline", null);
            }
            getOptionalContentConfig() {
              return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results) => {
                return new _optional_content_config.OptionalContentConfig(results);
              });
            }
            getPermissions() {
              return this.messageHandler.sendWithPromise("GetPermissions", null);
            }
            getMetadata() {
              return this.messageHandler.sendWithPromise("GetMetadata", null).then((results) => {
                var _a2, _b, _c, _d;
                return {
                  info: results[0],
                  metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                  contentDispositionFilename: (_b = (_a2 = this._fullReader) == null ? void 0 : _a2.filename) != null ? _b : null,
                  contentLength: (_d = (_c = this._fullReader) == null ? void 0 : _c.contentLength) != null ? _d : null
                };
              });
            }
            getMarkInfo() {
              return this.messageHandler.sendWithPromise("GetMarkInfo", null);
            }
            getStats() {
              return this.messageHandler.sendWithPromise("GetStats", null);
            }
            async startCleanup(keepLoadedFonts = false) {
              await this.messageHandler.sendWithPromise("Cleanup", null);
              if (this.destroyed) {
                return;
              }
              for (let i = 0, ii = this.pageCache.length; i < ii; i++) {
                const page = this.pageCache[i];
                if (!page) {
                  continue;
                }
                const cleanupSuccessful = page.cleanup();
                if (!cleanupSuccessful) {
                  throw new Error(`startCleanup: Page ${i + 1} is currently rendering.`);
                }
              }
              this.commonObjs.clear();
              if (!keepLoadedFonts) {
                this.fontLoader.clear();
              }
              this._hasJSActionsPromise = null;
            }
            get loadingParams() {
              const params = this._params;
              return (0, _util.shadow)(this, "loadingParams", {
                disableAutoFetch: params.disableAutoFetch,
                disableFontFace: params.disableFontFace
              });
            }
          }
          class PDFObjects {
            constructor() {
              this._objs = /* @__PURE__ */ Object.create(null);
            }
            _ensureObj(objId) {
              if (this._objs[objId]) {
                return this._objs[objId];
              }
              return this._objs[objId] = {
                capability: (0, _util.createPromiseCapability)(),
                data: null,
                resolved: false
              };
            }
            get(objId, callback = null) {
              if (callback) {
                this._ensureObj(objId).capability.promise.then(callback);
                return null;
              }
              const obj = this._objs[objId];
              if (!obj || !obj.resolved) {
                throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
              }
              return obj.data;
            }
            has(objId) {
              const obj = this._objs[objId];
              return (obj == null ? void 0 : obj.resolved) || false;
            }
            resolve(objId, data2) {
              const obj = this._ensureObj(objId);
              obj.resolved = true;
              obj.data = data2;
              obj.capability.resolve(data2);
            }
            clear() {
              this._objs = /* @__PURE__ */ Object.create(null);
            }
          }
          class RenderTask {
            constructor(internalRenderTask) {
              this._internalRenderTask = internalRenderTask;
              this.onContinue = null;
            }
            get promise() {
              return this._internalRenderTask.capability.promise;
            }
            cancel() {
              this._internalRenderTask.cancel();
            }
          }
          const InternalRenderTask = function InternalRenderTaskClosure() {
            const canvasInRendering = /* @__PURE__ */ new WeakSet();
            class InternalRenderTask2 {
              constructor({
                callback,
                params,
                objs,
                commonObjs,
                operatorList,
                pageIndex,
                canvasFactory,
                webGLContext,
                useRequestAnimationFrame = false,
                pdfBug = false
              }) {
                this.callback = callback;
                this.params = params;
                this.objs = objs;
                this.commonObjs = commonObjs;
                this.operatorListIdx = null;
                this.operatorList = operatorList;
                this._pageIndex = pageIndex;
                this.canvasFactory = canvasFactory;
                this.webGLContext = webGLContext;
                this._pdfBug = pdfBug;
                this.running = false;
                this.graphicsReadyCallback = null;
                this.graphicsReady = false;
                this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                this.cancelled = false;
                this.capability = (0, _util.createPromiseCapability)();
                this.task = new RenderTask(this);
                this._cancelBound = this.cancel.bind(this);
                this._continueBound = this._continue.bind(this);
                this._scheduleNextBound = this._scheduleNext.bind(this);
                this._nextBound = this._next.bind(this);
                this._canvas = params.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics({
                transparency = false,
                optionalContentConfig
              }) {
                var _a2;
                if (this.cancelled) {
                  return;
                }
                if (this._canvas) {
                  if (canvasInRendering.has(this._canvas)) {
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  }
                  canvasInRendering.add(this._canvas);
                }
                if (this._pdfBug && ((_a2 = globalThis.StepperManager) == null ? void 0 : _a2.enabled)) {
                  this.stepper = globalThis.StepperManager.create(this._pageIndex);
                  this.stepper.init(this.operatorList);
                  this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                }
                const {
                  canvasContext,
                  viewport,
                  transform,
                  imageLayer,
                  background
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext, imageLayer, optionalContentConfig);
                this.gfx.beginDrawing({
                  transform,
                  viewport,
                  transparency,
                  background
                });
                this.operatorListIdx = 0;
                this.graphicsReady = true;
                if (this.graphicsReadyCallback) {
                  this.graphicsReadyCallback();
                }
              }
              cancel(error = null) {
                this.running = false;
                this.cancelled = true;
                if (this.gfx) {
                  this.gfx.endDrawing();
                }
                if (this._canvas) {
                  canvasInRendering.delete(this._canvas);
                }
                this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, "canvas"));
              }
              operatorListChanged() {
                if (!this.graphicsReady) {
                  if (!this.graphicsReadyCallback) {
                    this.graphicsReadyCallback = this._continueBound;
                  }
                  return;
                }
                if (this.stepper) {
                  this.stepper.updateOperatorList(this.operatorList);
                }
                if (this.running) {
                  return;
                }
                this._continue();
              }
              _continue() {
                this.running = true;
                if (this.cancelled) {
                  return;
                }
                if (this.task.onContinue) {
                  this.task.onContinue(this._scheduleNextBound);
                } else {
                  this._scheduleNext();
                }
              }
              _scheduleNext() {
                if (this._useRequestAnimationFrame) {
                  window.requestAnimationFrame(() => {
                    this._nextBound().catch(this._cancelBound);
                  });
                } else {
                  Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                }
              }
              async _next() {
                if (this.cancelled) {
                  return;
                }
                this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                if (this.operatorListIdx === this.operatorList.argsArray.length) {
                  this.running = false;
                  if (this.operatorList.lastChunk) {
                    this.gfx.endDrawing();
                    if (this._canvas) {
                      canvasInRendering.delete(this._canvas);
                    }
                    this.callback();
                  }
                }
              }
            }
            return InternalRenderTask2;
          }();
          const version = "2.8.335";
          exports.version = version;
          const build = "228adbf67";
          exports.build = build;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.FontLoader = exports2.FontFaceObject = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          class BaseFontLoader {
            constructor({
              docId,
              onUnsupportedFeature,
              ownerDocument = globalThis.document
            }) {
              if (this.constructor === BaseFontLoader) {
                (0, _util2.unreachable)("Cannot initialize BaseFontLoader.");
              }
              this.docId = docId;
              this._onUnsupportedFeature = onUnsupportedFeature;
              this._document = ownerDocument;
              this.nativeFontFaces = [];
              this.styleElement = null;
            }
            addNativeFontFace(nativeFontFace) {
              this.nativeFontFaces.push(nativeFontFace);
              this._document.fonts.add(nativeFontFace);
            }
            insertRule(rule) {
              let styleElement = this.styleElement;
              if (!styleElement) {
                styleElement = this.styleElement = this._document.createElement("style");
                styleElement.id = `PDFJS_FONT_STYLE_TAG_${this.docId}`;
                this._document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement);
              }
              const styleSheet = styleElement.sheet;
              styleSheet.insertRule(rule, styleSheet.cssRules.length);
            }
            clear() {
              this.nativeFontFaces.forEach((nativeFontFace) => {
                this._document.fonts.delete(nativeFontFace);
              });
              this.nativeFontFaces.length = 0;
              if (this.styleElement) {
                this.styleElement.remove();
                this.styleElement = null;
              }
            }
            async bind(font) {
              if (font.attached || font.missingFile) {
                return;
              }
              font.attached = true;
              if (this.isFontLoadingAPISupported) {
                const nativeFontFace = font.createNativeFontFace();
                if (nativeFontFace) {
                  this.addNativeFontFace(nativeFontFace);
                  try {
                    await nativeFontFace.loaded;
                  } catch (ex) {
                    this._onUnsupportedFeature({
                      featureId: _util2.UNSUPPORTED_FEATURES.errorFontLoadNative
                    });
                    (0, _util2.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                    font.disableFontFace = true;
                    throw ex;
                  }
                }
                return;
              }
              const rule = font.createFontFaceRule();
              if (rule) {
                this.insertRule(rule);
                if (this.isSyncFontLoadingSupported) {
                  return;
                }
                await new Promise((resolve2) => {
                  const request22 = this._queueLoadingCallback(resolve2);
                  this._prepareFontLoadEvent([rule], [font], request22);
                });
              }
            }
            _queueLoadingCallback(callback) {
              (0, _util2.unreachable)("Abstract method `_queueLoadingCallback`.");
            }
            get isFontLoadingAPISupported() {
              var _a2;
              return (0, _util2.shadow)(this, "isFontLoadingAPISupported", !!((_a2 = this._document) == null ? void 0 : _a2.fonts));
            }
            get isSyncFontLoadingSupported() {
              (0, _util2.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
            }
            get _loadTestFont() {
              (0, _util2.unreachable)("Abstract method `_loadTestFont`.");
            }
            _prepareFontLoadEvent(rules, fontsToLoad, request22) {
              (0, _util2.unreachable)("Abstract method `_prepareFontLoadEvent`.");
            }
          }
          let FontLoader;
          exports2.FontLoader = FontLoader;
          {
            exports2.FontLoader = FontLoader = class GenericFontLoader extends BaseFontLoader {
              constructor(params) {
                super(params);
                this.loadingContext = {
                  requests: [],
                  nextRequestId: 0
                };
                this.loadTestFontId = 0;
              }
              get isSyncFontLoadingSupported() {
                let supported2 = false;
                if (typeof navigator === "undefined") {
                  supported2 = true;
                } else {
                  const m = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
                  if ((m == null ? void 0 : m[1]) >= 14) {
                    supported2 = true;
                  }
                }
                return (0, _util2.shadow)(this, "isSyncFontLoadingSupported", supported2);
              }
              _queueLoadingCallback(callback) {
                function completeRequest() {
                  (0, _util2.assert)(!request22.done, "completeRequest() cannot be called twice.");
                  request22.done = true;
                  while (context.requests.length > 0 && context.requests[0].done) {
                    const otherRequest = context.requests.shift();
                    setTimeout(otherRequest.callback, 0);
                  }
                }
                const context = this.loadingContext;
                const request22 = {
                  id: `pdfjs-font-loading-${context.nextRequestId++}`,
                  done: false,
                  complete: completeRequest,
                  callback
                };
                context.requests.push(request22);
                return request22;
              }
              get _loadTestFont() {
                const getLoadTestFont = function() {
                  return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                };
                return (0, _util2.shadow)(this, "_loadTestFont", getLoadTestFont());
              }
              _prepareFontLoadEvent(rules, fonts, request22) {
                function int32(data22, offset) {
                  return data22.charCodeAt(offset) << 24 | data22.charCodeAt(offset + 1) << 16 | data22.charCodeAt(offset + 2) << 8 | data22.charCodeAt(offset + 3) & 255;
                }
                function spliceString(s, offset, remove2, insert) {
                  const chunk1 = s.substring(0, offset);
                  const chunk2 = s.substring(offset + remove2);
                  return chunk1 + insert + chunk2;
                }
                let i, ii;
                const canvas = this._document.createElement("canvas");
                canvas.width = 1;
                canvas.height = 1;
                const ctx = canvas.getContext("2d");
                let called = 0;
                function isFontReady(name2, callback) {
                  called++;
                  if (called > 30) {
                    (0, _util2.warn)("Load test font never loaded.");
                    callback();
                    return;
                  }
                  ctx.font = "30px " + name2;
                  ctx.fillText(".", 0, 20);
                  const imageData = ctx.getImageData(0, 0, 1, 1);
                  if (imageData.data[3] > 0) {
                    callback();
                    return;
                  }
                  setTimeout(isFontReady.bind(null, name2, callback));
                }
                const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                let data2 = this._loadTestFont;
                const COMMENT_OFFSET = 976;
                data2 = spliceString(data2, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                const CFF_CHECKSUM_OFFSET = 16;
                const XXXX_VALUE = 1482184792;
                let checksum = int32(data2, CFF_CHECKSUM_OFFSET);
                for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
                  checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                }
                if (i < loadTestFontId.length) {
                  checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                }
                data2 = spliceString(data2, CFF_CHECKSUM_OFFSET, 4, (0, _util2.string32)(checksum));
                const url = `url(data:font/opentype;base64,${btoa(data2)});`;
                const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
                this.insertRule(rule);
                const names = [];
                for (i = 0, ii = fonts.length; i < ii; i++) {
                  names.push(fonts[i].loadedName);
                }
                names.push(loadTestFontId);
                const div = this._document.createElement("div");
                div.style.visibility = "hidden";
                div.style.width = div.style.height = "10px";
                div.style.position = "absolute";
                div.style.top = div.style.left = "0px";
                for (i = 0, ii = names.length; i < ii; ++i) {
                  const span = this._document.createElement("span");
                  span.textContent = "Hi";
                  span.style.fontFamily = names[i];
                  div.appendChild(span);
                }
                this._document.body.appendChild(div);
                isFontReady(loadTestFontId, () => {
                  this._document.body.removeChild(div);
                  request22.complete();
                });
              }
            };
          }
          class FontFaceObject {
            constructor(translatedData, {
              isEvalSupported = true,
              disableFontFace = false,
              ignoreErrors = false,
              onUnsupportedFeature,
              fontRegistry = null
            }) {
              this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
              for (const i in translatedData) {
                this[i] = translatedData[i];
              }
              this.isEvalSupported = isEvalSupported !== false;
              this.disableFontFace = disableFontFace === true;
              this.ignoreErrors = ignoreErrors === true;
              this._onUnsupportedFeature = onUnsupportedFeature;
              this.fontRegistry = fontRegistry;
            }
            createNativeFontFace() {
              if (!this.data || this.disableFontFace) {
                return null;
              }
              const nativeFontFace = new FontFace(this.loadedName, this.data, {});
              if (this.fontRegistry) {
                this.fontRegistry.registerFont(this);
              }
              return nativeFontFace;
            }
            createFontFaceRule() {
              if (!this.data || this.disableFontFace) {
                return null;
              }
              const data2 = (0, _util2.bytesToString)(new Uint8Array(this.data));
              const url = `url(data:${this.mimetype};base64,${btoa(data2)});`;
              const rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
              if (this.fontRegistry) {
                this.fontRegistry.registerFont(this, url);
              }
              return rule;
            }
            getPathGenerator(objs, character) {
              if (this.compiledGlyphs[character] !== void 0) {
                return this.compiledGlyphs[character];
              }
              let cmds, current;
              try {
                cmds = objs.get(this.loadedName + "_path_" + character);
              } catch (ex) {
                if (!this.ignoreErrors) {
                  throw ex;
                }
                this._onUnsupportedFeature({
                  featureId: _util2.UNSUPPORTED_FEATURES.errorFontGetPath
                });
                (0, _util2.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                return this.compiledGlyphs[character] = function(c, size2) {
                };
              }
              if (this.isEvalSupported && _util2.IsEvalSupportedCached.value) {
                let args, js = "";
                for (let i = 0, ii = cmds.length; i < ii; i++) {
                  current = cmds[i];
                  if (current.args !== void 0) {
                    args = current.args.join(",");
                  } else {
                    args = "";
                  }
                  js += "c." + current.cmd + "(" + args + ");\n";
                }
                return this.compiledGlyphs[character] = new Function("c", "size", js);
              }
              return this.compiledGlyphs[character] = function(c, size2) {
                for (let i = 0, ii = cmds.length; i < ii; i++) {
                  current = cmds[i];
                  if (current.cmd === "scale") {
                    current.args = [size2, -size2];
                  }
                  c[current.cmd].apply(c, current.args);
                }
              };
            }
          }
          exports2.FontFaceObject = FontFaceObject;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.NodeCMapReaderFactory = exports2.NodeCanvasFactory = void 0;
          var _display_utils2 = __w_pdfjs_require__2(1);
          var _is_node2 = __w_pdfjs_require__2(4);
          var _util2 = __w_pdfjs_require__2(2);
          let NodeCanvasFactory = class {
            constructor() {
              (0, _util2.unreachable)("Not implemented: NodeCanvasFactory");
            }
          };
          exports2.NodeCanvasFactory = NodeCanvasFactory;
          let NodeCMapReaderFactory = class {
            constructor() {
              (0, _util2.unreachable)("Not implemented: NodeCMapReaderFactory");
            }
          };
          exports2.NodeCMapReaderFactory = NodeCMapReaderFactory;
          if (_is_node2.isNodeJS) {
            exports2.NodeCanvasFactory = NodeCanvasFactory = class extends _display_utils2.BaseCanvasFactory {
              create(width2, height2) {
                if (width2 <= 0 || height2 <= 0) {
                  throw new Error("Invalid canvas size");
                }
                const Canvas = require$$5;
                const canvas = Canvas.createCanvas(width2, height2);
                return {
                  canvas,
                  context: canvas.getContext("2d")
                };
              }
            };
            exports2.NodeCMapReaderFactory = NodeCMapReaderFactory = class extends _display_utils2.BaseCMapReaderFactory {
              _fetchData(url, compressionType) {
                return new Promise((resolve2, reject) => {
                  const fs = require$$5;
                  fs.readFile(url, (error, data2) => {
                    if (error || !data2) {
                      reject(new Error(error));
                      return;
                    }
                    resolve2({
                      cMapData: new Uint8Array(data2),
                      compressionType
                    });
                  });
                });
              }
            };
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.AnnotationStorage = void 0;
          var _display_utils2 = __w_pdfjs_require__2(1);
          var _util2 = __w_pdfjs_require__2(2);
          class AnnotationStorage {
            constructor() {
              this._storage = /* @__PURE__ */ new Map();
              this._modified = false;
              this.onSetModified = null;
              this.onResetModified = null;
            }
            getValue(key, defaultValue) {
              const obj = this._storage.get(key);
              return obj !== void 0 ? obj : defaultValue;
            }
            getOrCreateValue(key, defaultValue) {
              (0, _display_utils2.deprecated)("Use getValue instead.");
              if (this._storage.has(key)) {
                return this._storage.get(key);
              }
              this._storage.set(key, defaultValue);
              return defaultValue;
            }
            setValue(key, value) {
              const obj = this._storage.get(key);
              let modified = false;
              if (obj !== void 0) {
                for (const [entry, val] of Object.entries(value)) {
                  if (obj[entry] !== val) {
                    modified = true;
                    obj[entry] = val;
                  }
                }
              } else {
                this._storage.set(key, value);
                modified = true;
              }
              if (modified) {
                this._setModified();
              }
            }
            getAll() {
              return this._storage.size > 0 ? (0, _util2.objectFromMap)(this._storage) : null;
            }
            get size() {
              return this._storage.size;
            }
            _setModified() {
              if (!this._modified) {
                this._modified = true;
                if (typeof this.onSetModified === "function") {
                  this.onSetModified();
                }
              }
            }
            resetModified() {
              if (this._modified) {
                this._modified = false;
                if (typeof this.onResetModified === "function") {
                  this.onResetModified();
                }
              }
            }
            get serializable() {
              return this._storage.size > 0 ? this._storage : null;
            }
          }
          exports2.AnnotationStorage = AnnotationStorage;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.apiCompatibilityParams = void 0;
          var _is_node2 = __w_pdfjs_require__2(4);
          const compatibilityParams = /* @__PURE__ */ Object.create(null);
          {
            (function checkFontFace() {
              if (_is_node2.isNodeJS) {
                compatibilityParams.disableFontFace = true;
              }
            })();
          }
          const apiCompatibilityParams = Object.freeze(compatibilityParams);
          exports2.apiCompatibilityParams = apiCompatibilityParams;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.CanvasGraphics = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          var _pattern_helper = __w_pdfjs_require__2(11);
          const MIN_FONT_SIZE = 16;
          const MAX_FONT_SIZE = 100;
          const MAX_GROUP_SIZE = 4096;
          const MAX_SIZE_TO_COMPILE = 1e3;
          const FULL_CHUNK_HEIGHT = 16;
          const LINEWIDTH_SCALE_FACTOR = 1.000001;
          function addContextCurrentTransform(ctx) {
            if (!ctx.mozCurrentTransform) {
              ctx._originalSave = ctx.save;
              ctx._originalRestore = ctx.restore;
              ctx._originalRotate = ctx.rotate;
              ctx._originalScale = ctx.scale;
              ctx._originalTranslate = ctx.translate;
              ctx._originalTransform = ctx.transform;
              ctx._originalSetTransform = ctx.setTransform;
              ctx._originalResetTransform = ctx.resetTransform;
              ctx._transformMatrix = ctx._transformMatrix || [1, 0, 0, 1, 0, 0];
              ctx._transformStack = [];
              try {
                const desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(ctx), "lineWidth");
                ctx._setLineWidth = desc.set;
                ctx._getLineWidth = desc.get;
                Object.defineProperty(ctx, "lineWidth", {
                  set: function setLineWidth(width2) {
                    this._setLineWidth(width2 * LINEWIDTH_SCALE_FACTOR);
                  },
                  get: function getLineWidth() {
                    return this._getLineWidth();
                  }
                });
              } catch (_) {
              }
              Object.defineProperty(ctx, "mozCurrentTransform", {
                get: function getCurrentTransform() {
                  return this._transformMatrix;
                }
              });
              Object.defineProperty(ctx, "mozCurrentTransformInverse", {
                get: function getCurrentTransformInverse() {
                  const m = this._transformMatrix;
                  const a = m[0], b = m[1], c = m[2], d = m[3], e = m[4], f = m[5];
                  const ad_bc = a * d - b * c;
                  const bc_ad = b * c - a * d;
                  return [d / ad_bc, b / bc_ad, c / bc_ad, a / ad_bc, (d * e - c * f) / bc_ad, (b * e - a * f) / ad_bc];
                }
              });
              ctx.save = function ctxSave() {
                const old = this._transformMatrix;
                this._transformStack.push(old);
                this._transformMatrix = old.slice(0, 6);
                this._originalSave();
              };
              ctx.restore = function ctxRestore() {
                const prev = this._transformStack.pop();
                if (prev) {
                  this._transformMatrix = prev;
                  this._originalRestore();
                }
              };
              ctx.translate = function ctxTranslate(x, y) {
                const m = this._transformMatrix;
                m[4] = m[0] * x + m[2] * y + m[4];
                m[5] = m[1] * x + m[3] * y + m[5];
                this._originalTranslate(x, y);
              };
              ctx.scale = function ctxScale(x, y) {
                const m = this._transformMatrix;
                m[0] = m[0] * x;
                m[1] = m[1] * x;
                m[2] = m[2] * y;
                m[3] = m[3] * y;
                this._originalScale(x, y);
              };
              ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                const m = this._transformMatrix;
                this._transformMatrix = [m[0] * a + m[2] * b, m[1] * a + m[3] * b, m[0] * c + m[2] * d, m[1] * c + m[3] * d, m[0] * e + m[2] * f + m[4], m[1] * e + m[3] * f + m[5]];
                ctx._originalTransform(a, b, c, d, e, f);
              };
              ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                this._transformMatrix = [a, b, c, d, e, f];
                ctx._originalSetTransform(a, b, c, d, e, f);
              };
              ctx.resetTransform = function ctxResetTransform() {
                this._transformMatrix = [1, 0, 0, 1, 0, 0];
                ctx._originalResetTransform();
              };
              ctx.rotate = function ctxRotate(angle) {
                const cosValue = Math.cos(angle);
                const sinValue = Math.sin(angle);
                const m = this._transformMatrix;
                this._transformMatrix = [m[0] * cosValue + m[2] * sinValue, m[1] * cosValue + m[3] * sinValue, m[0] * -sinValue + m[2] * cosValue, m[1] * -sinValue + m[3] * cosValue, m[4], m[5]];
                this._originalRotate(angle);
              };
            }
          }
          const CachedCanvases = function CachedCanvasesClosure() {
            function CachedCanvases2(canvasFactory) {
              this.canvasFactory = canvasFactory;
              this.cache = /* @__PURE__ */ Object.create(null);
            }
            CachedCanvases2.prototype = {
              getCanvas: function CachedCanvases_getCanvas(id, width2, height2, trackTransform) {
                let canvasEntry;
                if (this.cache[id] !== void 0) {
                  canvasEntry = this.cache[id];
                  this.canvasFactory.reset(canvasEntry, width2, height2);
                  canvasEntry.context.setTransform(1, 0, 0, 1, 0, 0);
                } else {
                  canvasEntry = this.canvasFactory.create(width2, height2);
                  this.cache[id] = canvasEntry;
                }
                if (trackTransform) {
                  addContextCurrentTransform(canvasEntry.context);
                }
                return canvasEntry;
              },
              clear() {
                for (const id in this.cache) {
                  const canvasEntry = this.cache[id];
                  this.canvasFactory.destroy(canvasEntry);
                  delete this.cache[id];
                }
              }
            };
            return CachedCanvases2;
          }();
          function compileType3Glyph(imgData) {
            const POINT_TO_PROCESS_LIMIT = 1e3;
            const width2 = imgData.width, height2 = imgData.height, width1 = width2 + 1;
            let i, ii, j, j0;
            const points = new Uint8Array(width1 * (height2 + 1));
            const POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
            const lineSize = width2 + 7 & ~7, data0 = imgData.data;
            const data2 = new Uint8Array(lineSize * height2);
            let pos = 0;
            for (i = 0, ii = data0.length; i < ii; i++) {
              const elem = data0[i];
              let mask = 128;
              while (mask > 0) {
                data2[pos++] = elem & mask ? 0 : 255;
                mask >>= 1;
              }
            }
            let count = 0;
            pos = 0;
            if (data2[pos] !== 0) {
              points[0] = 1;
              ++count;
            }
            for (j = 1; j < width2; j++) {
              if (data2[pos] !== data2[pos + 1]) {
                points[j] = data2[pos] ? 2 : 1;
                ++count;
              }
              pos++;
            }
            if (data2[pos] !== 0) {
              points[j] = 2;
              ++count;
            }
            for (i = 1; i < height2; i++) {
              pos = i * lineSize;
              j0 = i * width1;
              if (data2[pos - lineSize] !== data2[pos]) {
                points[j0] = data2[pos] ? 1 : 8;
                ++count;
              }
              let sum = (data2[pos] ? 4 : 0) + (data2[pos - lineSize] ? 8 : 0);
              for (j = 1; j < width2; j++) {
                sum = (sum >> 2) + (data2[pos + 1] ? 4 : 0) + (data2[pos - lineSize + 1] ? 8 : 0);
                if (POINT_TYPES[sum]) {
                  points[j0 + j] = POINT_TYPES[sum];
                  ++count;
                }
                pos++;
              }
              if (data2[pos - lineSize] !== data2[pos]) {
                points[j0 + j] = data2[pos] ? 2 : 4;
                ++count;
              }
              if (count > POINT_TO_PROCESS_LIMIT) {
                return null;
              }
            }
            pos = lineSize * (height2 - 1);
            j0 = i * width1;
            if (data2[pos] !== 0) {
              points[j0] = 8;
              ++count;
            }
            for (j = 1; j < width2; j++) {
              if (data2[pos] !== data2[pos + 1]) {
                points[j0 + j] = data2[pos] ? 4 : 8;
                ++count;
              }
              pos++;
            }
            if (data2[pos] !== 0) {
              points[j0 + j] = 4;
              ++count;
            }
            if (count > POINT_TO_PROCESS_LIMIT) {
              return null;
            }
            const steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
            const outlines = [];
            for (i = 0; count && i <= height2; i++) {
              let p2 = i * width1;
              const end = p2 + width2;
              while (p2 < end && !points[p2]) {
                p2++;
              }
              if (p2 === end) {
                continue;
              }
              const coords = [p2 % width1, i];
              const p0 = p2;
              let type = points[p2];
              do {
                const step = steps[type];
                do {
                  p2 += step;
                } while (!points[p2]);
                const pp = points[p2];
                if (pp !== 5 && pp !== 10) {
                  type = pp;
                  points[p2] = 0;
                } else {
                  type = pp & 51 * type >> 4;
                  points[p2] &= type >> 2 | type << 2;
                }
                coords.push(p2 % width1);
                coords.push(p2 / width1 | 0);
                if (!points[p2]) {
                  --count;
                }
              } while (p0 !== p2);
              outlines.push(coords);
              --i;
            }
            const drawOutline = function(c) {
              c.save();
              c.scale(1 / width2, -1 / height2);
              c.translate(0, -height2);
              c.beginPath();
              for (let k = 0, kk = outlines.length; k < kk; k++) {
                const o = outlines[k];
                c.moveTo(o[0], o[1]);
                for (let l = 2, ll = o.length; l < ll; l += 2) {
                  c.lineTo(o[l], o[l + 1]);
                }
              }
              c.fill();
              c.beginPath();
              c.restore();
            };
            return drawOutline;
          }
          const CanvasExtraState = function CanvasExtraStateClosure() {
            function CanvasExtraState2() {
              this.alphaIsShape = false;
              this.fontSize = 0;
              this.fontSizeScale = 1;
              this.textMatrix = _util2.IDENTITY_MATRIX;
              this.textMatrixScale = 1;
              this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
              this.leading = 0;
              this.x = 0;
              this.y = 0;
              this.lineX = 0;
              this.lineY = 0;
              this.charSpacing = 0;
              this.wordSpacing = 0;
              this.textHScale = 1;
              this.textRenderingMode = _util2.TextRenderingMode.FILL;
              this.textRise = 0;
              this.fillColor = "#000000";
              this.strokeColor = "#000000";
              this.patternFill = false;
              this.fillAlpha = 1;
              this.strokeAlpha = 1;
              this.lineWidth = 1;
              this.activeSMask = null;
              this.resumeSMaskCtx = null;
              this.transferMaps = null;
            }
            CanvasExtraState2.prototype = {
              clone: function CanvasExtraState_clone() {
                return Object.create(this);
              },
              setCurrentPoint: function CanvasExtraState_setCurrentPoint(x, y) {
                this.x = x;
                this.y = y;
              }
            };
            return CanvasExtraState2;
          }();
          const CanvasGraphics = function CanvasGraphicsClosure() {
            const EXECUTION_TIME = 15;
            const EXECUTION_STEPS = 10;
            function CanvasGraphics2(canvasCtx, commonObjs, objs, canvasFactory, webGLContext, imageLayer, optionalContentConfig) {
              this.ctx = canvasCtx;
              this.current = new CanvasExtraState();
              this.stateStack = [];
              this.pendingClip = null;
              this.pendingEOFill = false;
              this.res = null;
              this.xobjs = null;
              this.commonObjs = commonObjs;
              this.objs = objs;
              this.canvasFactory = canvasFactory;
              this.webGLContext = webGLContext;
              this.imageLayer = imageLayer;
              this.groupStack = [];
              this.processingType3 = null;
              this.baseTransform = null;
              this.baseTransformStack = [];
              this.groupLevel = 0;
              this.smaskStack = [];
              this.smaskCounter = 0;
              this.tempSMask = null;
              this.contentVisible = true;
              this.markedContentStack = [];
              this.optionalContentConfig = optionalContentConfig;
              this.cachedCanvases = new CachedCanvases(this.canvasFactory);
              if (canvasCtx) {
                addContextCurrentTransform(canvasCtx);
              }
              this._cachedGetSinglePixelWidth = null;
            }
            function putBinaryImageData(ctx, imgData, transferMaps = null) {
              if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                ctx.putImageData(imgData, 0, 0);
                return;
              }
              const height2 = imgData.height, width2 = imgData.width;
              const partialChunkHeight = height2 % FULL_CHUNK_HEIGHT;
              const fullChunks = (height2 - partialChunkHeight) / FULL_CHUNK_HEIGHT;
              const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
              const chunkImgData = ctx.createImageData(width2, FULL_CHUNK_HEIGHT);
              let srcPos = 0, destPos;
              const src = imgData.data;
              const dest = chunkImgData.data;
              let i, j, thisChunkHeight, elemsInThisChunk;
              let transferMapRed, transferMapGreen, transferMapBlue, transferMapGray;
              if (transferMaps) {
                switch (transferMaps.length) {
                  case 1:
                    transferMapRed = transferMaps[0];
                    transferMapGreen = transferMaps[0];
                    transferMapBlue = transferMaps[0];
                    transferMapGray = transferMaps[0];
                    break;
                  case 4:
                    transferMapRed = transferMaps[0];
                    transferMapGreen = transferMaps[1];
                    transferMapBlue = transferMaps[2];
                    transferMapGray = transferMaps[3];
                    break;
                }
              }
              if (imgData.kind === _util2.ImageKind.GRAYSCALE_1BPP) {
                const srcLength = src.byteLength;
                const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                const dest32DataLength = dest32.length;
                const fullSrcDiff = width2 + 7 >> 3;
                let white = 4294967295;
                let black = _util2.IsLittleEndianCached.value ? 4278190080 : 255;
                if (transferMapGray) {
                  if (transferMapGray[0] === 255 && transferMapGray[255] === 0) {
                    [white, black] = [black, white];
                  }
                }
                for (i = 0; i < totalChunks; i++) {
                  thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                  destPos = 0;
                  for (j = 0; j < thisChunkHeight; j++) {
                    const srcDiff = srcLength - srcPos;
                    let k = 0;
                    const kEnd = srcDiff > fullSrcDiff ? width2 : srcDiff * 8 - 7;
                    const kEndUnrolled = kEnd & ~7;
                    let mask = 0;
                    let srcByte = 0;
                    for (; k < kEndUnrolled; k += 8) {
                      srcByte = src[srcPos++];
                      dest32[destPos++] = srcByte & 128 ? white : black;
                      dest32[destPos++] = srcByte & 64 ? white : black;
                      dest32[destPos++] = srcByte & 32 ? white : black;
                      dest32[destPos++] = srcByte & 16 ? white : black;
                      dest32[destPos++] = srcByte & 8 ? white : black;
                      dest32[destPos++] = srcByte & 4 ? white : black;
                      dest32[destPos++] = srcByte & 2 ? white : black;
                      dest32[destPos++] = srcByte & 1 ? white : black;
                    }
                    for (; k < kEnd; k++) {
                      if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                      }
                      dest32[destPos++] = srcByte & mask ? white : black;
                      mask >>= 1;
                    }
                  }
                  while (destPos < dest32DataLength) {
                    dest32[destPos++] = 0;
                  }
                  ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                }
              } else if (imgData.kind === _util2.ImageKind.RGBA_32BPP) {
                const hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
                j = 0;
                elemsInThisChunk = width2 * FULL_CHUNK_HEIGHT * 4;
                for (i = 0; i < fullChunks; i++) {
                  dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                  srcPos += elemsInThisChunk;
                  if (hasTransferMaps) {
                    for (let k = 0; k < elemsInThisChunk; k += 4) {
                      if (transferMapRed) {
                        dest[k + 0] = transferMapRed[dest[k + 0]];
                      }
                      if (transferMapGreen) {
                        dest[k + 1] = transferMapGreen[dest[k + 1]];
                      }
                      if (transferMapBlue) {
                        dest[k + 2] = transferMapBlue[dest[k + 2]];
                      }
                    }
                  }
                  ctx.putImageData(chunkImgData, 0, j);
                  j += FULL_CHUNK_HEIGHT;
                }
                if (i < totalChunks) {
                  elemsInThisChunk = width2 * partialChunkHeight * 4;
                  dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                  if (hasTransferMaps) {
                    for (let k = 0; k < elemsInThisChunk; k += 4) {
                      if (transferMapRed) {
                        dest[k + 0] = transferMapRed[dest[k + 0]];
                      }
                      if (transferMapGreen) {
                        dest[k + 1] = transferMapGreen[dest[k + 1]];
                      }
                      if (transferMapBlue) {
                        dest[k + 2] = transferMapBlue[dest[k + 2]];
                      }
                    }
                  }
                  ctx.putImageData(chunkImgData, 0, j);
                }
              } else if (imgData.kind === _util2.ImageKind.RGB_24BPP) {
                const hasTransferMaps = !!(transferMapRed || transferMapGreen || transferMapBlue);
                thisChunkHeight = FULL_CHUNK_HEIGHT;
                elemsInThisChunk = width2 * thisChunkHeight;
                for (i = 0; i < totalChunks; i++) {
                  if (i >= fullChunks) {
                    thisChunkHeight = partialChunkHeight;
                    elemsInThisChunk = width2 * thisChunkHeight;
                  }
                  destPos = 0;
                  for (j = elemsInThisChunk; j--; ) {
                    dest[destPos++] = src[srcPos++];
                    dest[destPos++] = src[srcPos++];
                    dest[destPos++] = src[srcPos++];
                    dest[destPos++] = 255;
                  }
                  if (hasTransferMaps) {
                    for (let k = 0; k < destPos; k += 4) {
                      if (transferMapRed) {
                        dest[k + 0] = transferMapRed[dest[k + 0]];
                      }
                      if (transferMapGreen) {
                        dest[k + 1] = transferMapGreen[dest[k + 1]];
                      }
                      if (transferMapBlue) {
                        dest[k + 2] = transferMapBlue[dest[k + 2]];
                      }
                    }
                  }
                  ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                }
              } else {
                throw new Error(`bad image kind: ${imgData.kind}`);
              }
            }
            function putBinaryImageMask(ctx, imgData) {
              const height2 = imgData.height, width2 = imgData.width;
              const partialChunkHeight = height2 % FULL_CHUNK_HEIGHT;
              const fullChunks = (height2 - partialChunkHeight) / FULL_CHUNK_HEIGHT;
              const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
              const chunkImgData = ctx.createImageData(width2, FULL_CHUNK_HEIGHT);
              let srcPos = 0;
              const src = imgData.data;
              const dest = chunkImgData.data;
              for (let i = 0; i < totalChunks; i++) {
                const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                let destPos = 3;
                for (let j = 0; j < thisChunkHeight; j++) {
                  let elem, mask = 0;
                  for (let k = 0; k < width2; k++) {
                    if (!mask) {
                      elem = src[srcPos++];
                      mask = 128;
                    }
                    dest[destPos] = elem & mask ? 0 : 255;
                    destPos += 4;
                    mask >>= 1;
                  }
                }
                ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
              }
            }
            function copyCtxState(sourceCtx, destCtx) {
              const properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"];
              for (let i = 0, ii = properties.length; i < ii; i++) {
                const property = properties[i];
                if (sourceCtx[property] !== void 0) {
                  destCtx[property] = sourceCtx[property];
                }
              }
              if (sourceCtx.setLineDash !== void 0) {
                destCtx.setLineDash(sourceCtx.getLineDash());
                destCtx.lineDashOffset = sourceCtx.lineDashOffset;
              }
            }
            function resetCtxToDefault(ctx) {
              ctx.strokeStyle = "#000000";
              ctx.fillStyle = "#000000";
              ctx.fillRule = "nonzero";
              ctx.globalAlpha = 1;
              ctx.lineWidth = 1;
              ctx.lineCap = "butt";
              ctx.lineJoin = "miter";
              ctx.miterLimit = 10;
              ctx.globalCompositeOperation = "source-over";
              ctx.font = "10px sans-serif";
              if (ctx.setLineDash !== void 0) {
                ctx.setLineDash([]);
                ctx.lineDashOffset = 0;
              }
            }
            function composeSMaskBackdrop(bytes, r0, g0, b0) {
              const length = bytes.length;
              for (let i = 3; i < length; i += 4) {
                const alpha = bytes[i];
                if (alpha === 0) {
                  bytes[i - 3] = r0;
                  bytes[i - 2] = g0;
                  bytes[i - 1] = b0;
                } else if (alpha < 255) {
                  const alpha_ = 255 - alpha;
                  bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                  bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                  bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                }
              }
            }
            function composeSMaskAlpha(maskData, layerData, transferMap) {
              const length = maskData.length;
              const scale = 1 / 255;
              for (let i = 3; i < length; i += 4) {
                const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                layerData[i] = layerData[i] * alpha * scale | 0;
              }
            }
            function composeSMaskLuminosity(maskData, layerData, transferMap) {
              const length = maskData.length;
              for (let i = 3; i < length; i += 4) {
                const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
              }
            }
            function genericComposeSMask(maskCtx, layerCtx, width2, height2, subtype, backdrop, transferMap) {
              const hasBackdrop = !!backdrop;
              const r0 = hasBackdrop ? backdrop[0] : 0;
              const g0 = hasBackdrop ? backdrop[1] : 0;
              const b0 = hasBackdrop ? backdrop[2] : 0;
              let composeFn;
              if (subtype === "Luminosity") {
                composeFn = composeSMaskLuminosity;
              } else {
                composeFn = composeSMaskAlpha;
              }
              const PIXELS_TO_PROCESS = 1048576;
              const chunkSize = Math.min(height2, Math.ceil(PIXELS_TO_PROCESS / width2));
              for (let row = 0; row < height2; row += chunkSize) {
                const chunkHeight = Math.min(chunkSize, height2 - row);
                const maskData = maskCtx.getImageData(0, row, width2, chunkHeight);
                const layerData = layerCtx.getImageData(0, row, width2, chunkHeight);
                if (hasBackdrop) {
                  composeSMaskBackdrop(maskData.data, r0, g0, b0);
                }
                composeFn(maskData.data, layerData.data, transferMap);
                maskCtx.putImageData(layerData, 0, row);
              }
            }
            function composeSMask(ctx, smask, layerCtx, webGLContext) {
              const mask = smask.canvas;
              const maskCtx = smask.context;
              ctx.setTransform(smask.scaleX, 0, 0, smask.scaleY, smask.offsetX, smask.offsetY);
              const backdrop = smask.backdrop || null;
              if (!smask.transferMap && webGLContext.isEnabled) {
                const composed = webGLContext.composeSMask({
                  layer: layerCtx.canvas,
                  mask,
                  properties: {
                    subtype: smask.subtype,
                    backdrop
                  }
                });
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.drawImage(composed, smask.offsetX, smask.offsetY);
                return;
              }
              genericComposeSMask(maskCtx, layerCtx, mask.width, mask.height, smask.subtype, backdrop, smask.transferMap);
              ctx.drawImage(mask, 0, 0);
            }
            const LINE_CAP_STYLES = ["butt", "round", "square"];
            const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
            const NORMAL_CLIP = {};
            const EO_CLIP = {};
            CanvasGraphics2.prototype = {
              beginDrawing({
                transform,
                viewport,
                transparency = false,
                background = null
              }) {
                const width2 = this.ctx.canvas.width;
                const height2 = this.ctx.canvas.height;
                this.ctx.save();
                this.ctx.fillStyle = background || "rgb(255, 255, 255)";
                this.ctx.fillRect(0, 0, width2, height2);
                this.ctx.restore();
                if (transparency) {
                  const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width2, height2, true);
                  this.compositeCtx = this.ctx;
                  this.transparentCanvas = transparentCanvas.canvas;
                  this.ctx = transparentCanvas.context;
                  this.ctx.save();
                  this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                }
                this.ctx.save();
                resetCtxToDefault(this.ctx);
                if (transform) {
                  this.ctx.transform.apply(this.ctx, transform);
                }
                this.ctx.transform.apply(this.ctx, viewport.transform);
                this.baseTransform = this.ctx.mozCurrentTransform.slice();
                this._combinedScaleFactor = Math.hypot(this.baseTransform[0], this.baseTransform[2]);
                if (this.imageLayer) {
                  this.imageLayer.beginLayout();
                }
              },
              executeOperatorList: function CanvasGraphics_executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                const argsArray = operatorList.argsArray;
                const fnArray = operatorList.fnArray;
                let i = executionStartIdx || 0;
                const argsArrayLen = argsArray.length;
                if (argsArrayLen === i) {
                  return i;
                }
                const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                let steps = 0;
                const commonObjs = this.commonObjs;
                const objs = this.objs;
                let fnId;
                while (true) {
                  if (stepper !== void 0 && i === stepper.nextBreakPoint) {
                    stepper.breakIt(i, continueCallback);
                    return i;
                  }
                  fnId = fnArray[i];
                  if (fnId !== _util2.OPS.dependency) {
                    this[fnId].apply(this, argsArray[i]);
                  } else {
                    for (const depObjId of argsArray[i]) {
                      const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                      if (!objsPool.has(depObjId)) {
                        objsPool.get(depObjId, continueCallback);
                        return i;
                      }
                    }
                  }
                  i++;
                  if (i === argsArrayLen) {
                    return i;
                  }
                  if (chunkOperations && ++steps > EXECUTION_STEPS) {
                    if (Date.now() > endTime) {
                      continueCallback();
                      return i;
                    }
                    steps = 0;
                  }
                }
              },
              endDrawing: function CanvasGraphics_endDrawing() {
                while (this.stateStack.length || this.current.activeSMask !== null) {
                  this.restore();
                }
                this.ctx.restore();
                if (this.transparentCanvas) {
                  this.ctx = this.compositeCtx;
                  this.ctx.save();
                  this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                  this.ctx.drawImage(this.transparentCanvas, 0, 0);
                  this.ctx.restore();
                  this.transparentCanvas = null;
                }
                this.cachedCanvases.clear();
                this.webGLContext.clear();
                if (this.imageLayer) {
                  this.imageLayer.endLayout();
                }
              },
              setLineWidth: function CanvasGraphics_setLineWidth(width2) {
                this.current.lineWidth = width2;
                this.ctx.lineWidth = width2;
              },
              setLineCap: function CanvasGraphics_setLineCap(style2) {
                this.ctx.lineCap = LINE_CAP_STYLES[style2];
              },
              setLineJoin: function CanvasGraphics_setLineJoin(style2) {
                this.ctx.lineJoin = LINE_JOIN_STYLES[style2];
              },
              setMiterLimit: function CanvasGraphics_setMiterLimit(limit) {
                this.ctx.miterLimit = limit;
              },
              setDash: function CanvasGraphics_setDash(dashArray, dashPhase) {
                const ctx = this.ctx;
                if (ctx.setLineDash !== void 0) {
                  ctx.setLineDash(dashArray);
                  ctx.lineDashOffset = dashPhase;
                }
              },
              setRenderingIntent(intent) {
              },
              setFlatness(flatness) {
              },
              setGState: function CanvasGraphics_setGState(states) {
                for (let i = 0, ii = states.length; i < ii; i++) {
                  const state2 = states[i];
                  const key = state2[0];
                  const value = state2[1];
                  switch (key) {
                    case "LW":
                      this.setLineWidth(value);
                      break;
                    case "LC":
                      this.setLineCap(value);
                      break;
                    case "LJ":
                      this.setLineJoin(value);
                      break;
                    case "ML":
                      this.setMiterLimit(value);
                      break;
                    case "D":
                      this.setDash(value[0], value[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(value);
                      break;
                    case "FL":
                      this.setFlatness(value);
                      break;
                    case "Font":
                      this.setFont(value[0], value[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = state2[1];
                      break;
                    case "ca":
                      this.current.fillAlpha = state2[1];
                      this.ctx.globalAlpha = state2[1];
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = value;
                      break;
                    case "SMask":
                      if (this.current.activeSMask) {
                        if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) {
                          this.suspendSMaskGroup();
                        } else {
                          this.endSMaskGroup();
                        }
                      }
                      this.current.activeSMask = value ? this.tempSMask : null;
                      if (this.current.activeSMask) {
                        this.beginSMaskGroup();
                      }
                      this.tempSMask = null;
                      break;
                    case "TR":
                      this.current.transferMaps = value;
                  }
                }
              },
              beginSMaskGroup: function CanvasGraphics_beginSMaskGroup() {
                const activeSMask = this.current.activeSMask;
                const drawnWidth = activeSMask.canvas.width;
                const drawnHeight = activeSMask.canvas.height;
                const cacheId = "smaskGroupAt" + this.groupLevel;
                const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                const currentCtx = this.ctx;
                const currentTransform = currentCtx.mozCurrentTransform;
                this.ctx.save();
                const groupCtx = scratchCanvas.context;
                groupCtx.scale(1 / activeSMask.scaleX, 1 / activeSMask.scaleY);
                groupCtx.translate(-activeSMask.offsetX, -activeSMask.offsetY);
                groupCtx.transform.apply(groupCtx, currentTransform);
                activeSMask.startTransformInverse = groupCtx.mozCurrentTransformInverse;
                copyCtxState(currentCtx, groupCtx);
                this.ctx = groupCtx;
                this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
                this.groupStack.push(currentCtx);
                this.groupLevel++;
              },
              suspendSMaskGroup: function CanvasGraphics_endSMaskGroup() {
                const groupCtx = this.ctx;
                this.groupLevel--;
                this.ctx = this.groupStack.pop();
                composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
                this.ctx.restore();
                this.ctx.save();
                copyCtxState(groupCtx, this.ctx);
                this.current.resumeSMaskCtx = groupCtx;
                const deltaTransform = _util2.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
                this.ctx.transform.apply(this.ctx, deltaTransform);
                groupCtx.save();
                groupCtx.setTransform(1, 0, 0, 1, 0, 0);
                groupCtx.clearRect(0, 0, groupCtx.canvas.width, groupCtx.canvas.height);
                groupCtx.restore();
              },
              resumeSMaskGroup: function CanvasGraphics_resumeSMaskGroup() {
                const groupCtx = this.current.resumeSMaskCtx;
                const currentCtx = this.ctx;
                this.ctx = groupCtx;
                this.groupStack.push(currentCtx);
                this.groupLevel++;
              },
              endSMaskGroup: function CanvasGraphics_endSMaskGroup() {
                const groupCtx = this.ctx;
                this.groupLevel--;
                this.ctx = this.groupStack.pop();
                composeSMask(this.ctx, this.current.activeSMask, groupCtx, this.webGLContext);
                this.ctx.restore();
                copyCtxState(groupCtx, this.ctx);
                const deltaTransform = _util2.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx.mozCurrentTransform);
                this.ctx.transform.apply(this.ctx, deltaTransform);
              },
              save: function CanvasGraphics_save() {
                this.ctx.save();
                const old = this.current;
                this.stateStack.push(old);
                this.current = old.clone();
                this.current.resumeSMaskCtx = null;
              },
              restore: function CanvasGraphics_restore() {
                if (this.current.resumeSMaskCtx) {
                  this.resumeSMaskGroup();
                }
                if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) {
                  this.endSMaskGroup();
                }
                if (this.stateStack.length !== 0) {
                  this.current = this.stateStack.pop();
                  this.ctx.restore();
                  this.pendingClip = null;
                  this._cachedGetSinglePixelWidth = null;
                } else {
                  this.current.activeSMask = null;
                }
              },
              transform: function CanvasGraphics_transform(a, b, c, d, e, f) {
                this.ctx.transform(a, b, c, d, e, f);
                this._cachedGetSinglePixelWidth = null;
              },
              constructPath: function CanvasGraphics_constructPath(ops, args) {
                const ctx = this.ctx;
                const current = this.current;
                let x = current.x, y = current.y;
                for (let i = 0, j = 0, ii = ops.length; i < ii; i++) {
                  switch (ops[i] | 0) {
                    case _util2.OPS.rectangle:
                      x = args[j++];
                      y = args[j++];
                      const width2 = args[j++];
                      const height2 = args[j++];
                      const xw = x + width2;
                      const yh = y + height2;
                      ctx.moveTo(x, y);
                      if (width2 === 0 || height2 === 0) {
                        ctx.lineTo(xw, yh);
                      } else {
                        ctx.lineTo(xw, y);
                        ctx.lineTo(xw, yh);
                        ctx.lineTo(x, yh);
                      }
                      ctx.closePath();
                      break;
                    case _util2.OPS.moveTo:
                      x = args[j++];
                      y = args[j++];
                      ctx.moveTo(x, y);
                      break;
                    case _util2.OPS.lineTo:
                      x = args[j++];
                      y = args[j++];
                      ctx.lineTo(x, y);
                      break;
                    case _util2.OPS.curveTo:
                      x = args[j + 4];
                      y = args[j + 5];
                      ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                      j += 6;
                      break;
                    case _util2.OPS.curveTo2:
                      ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                      x = args[j + 2];
                      y = args[j + 3];
                      j += 4;
                      break;
                    case _util2.OPS.curveTo3:
                      x = args[j + 2];
                      y = args[j + 3];
                      ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                      j += 4;
                      break;
                    case _util2.OPS.closePath:
                      ctx.closePath();
                      break;
                  }
                }
                current.setCurrentPoint(x, y);
              },
              closePath: function CanvasGraphics_closePath() {
                this.ctx.closePath();
              },
              stroke: function CanvasGraphics_stroke(consumePath) {
                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                const ctx = this.ctx;
                const strokeColor = this.current.strokeColor;
                ctx.globalAlpha = this.current.strokeAlpha;
                if (this.contentVisible) {
                  if (typeof strokeColor === "object" && (strokeColor == null ? void 0 : strokeColor.getPattern)) {
                    ctx.save();
                    const transform = ctx.mozCurrentTransform;
                    const scale = _util2.Util.singularValueDecompose2dScale(transform)[0];
                    ctx.strokeStyle = strokeColor.getPattern(ctx, this);
                    const lineWidth = this.getSinglePixelWidth();
                    const scaledLineWidth = this.current.lineWidth * scale;
                    if (lineWidth < 0 && -lineWidth >= scaledLineWidth) {
                      ctx.resetTransform();
                      ctx.lineWidth = Math.round(this._combinedScaleFactor);
                    } else {
                      ctx.lineWidth = Math.max(lineWidth, scaledLineWidth);
                    }
                    ctx.stroke();
                    ctx.restore();
                  } else {
                    const lineWidth = this.getSinglePixelWidth();
                    if (lineWidth < 0 && -lineWidth >= this.current.lineWidth) {
                      ctx.save();
                      ctx.resetTransform();
                      ctx.lineWidth = Math.round(this._combinedScaleFactor);
                      ctx.stroke();
                      ctx.restore();
                    } else {
                      ctx.lineWidth = Math.max(lineWidth, this.current.lineWidth);
                      ctx.stroke();
                    }
                  }
                }
                if (consumePath) {
                  this.consumePath();
                }
                ctx.globalAlpha = this.current.fillAlpha;
              },
              closeStroke: function CanvasGraphics_closeStroke() {
                this.closePath();
                this.stroke();
              },
              fill: function CanvasGraphics_fill(consumePath) {
                consumePath = typeof consumePath !== "undefined" ? consumePath : true;
                const ctx = this.ctx;
                const fillColor = this.current.fillColor;
                const isPatternFill = this.current.patternFill;
                let needRestore = false;
                if (isPatternFill) {
                  ctx.save();
                  if (this.baseTransform) {
                    ctx.setTransform.apply(ctx, this.baseTransform);
                  }
                  ctx.fillStyle = fillColor.getPattern(ctx, this);
                  needRestore = true;
                }
                if (this.contentVisible) {
                  if (this.pendingEOFill) {
                    ctx.fill("evenodd");
                    this.pendingEOFill = false;
                  } else {
                    ctx.fill();
                  }
                }
                if (needRestore) {
                  ctx.restore();
                }
                if (consumePath) {
                  this.consumePath();
                }
              },
              eoFill: function CanvasGraphics_eoFill() {
                this.pendingEOFill = true;
                this.fill();
              },
              fillStroke: function CanvasGraphics_fillStroke() {
                this.fill(false);
                this.stroke(false);
                this.consumePath();
              },
              eoFillStroke: function CanvasGraphics_eoFillStroke() {
                this.pendingEOFill = true;
                this.fillStroke();
              },
              closeFillStroke: function CanvasGraphics_closeFillStroke() {
                this.closePath();
                this.fillStroke();
              },
              closeEOFillStroke: function CanvasGraphics_closeEOFillStroke() {
                this.pendingEOFill = true;
                this.closePath();
                this.fillStroke();
              },
              endPath: function CanvasGraphics_endPath() {
                this.consumePath();
              },
              clip: function CanvasGraphics_clip() {
                this.pendingClip = NORMAL_CLIP;
              },
              eoClip: function CanvasGraphics_eoClip() {
                this.pendingClip = EO_CLIP;
              },
              beginText: function CanvasGraphics_beginText() {
                this.current.textMatrix = _util2.IDENTITY_MATRIX;
                this.current.textMatrixScale = 1;
                this.current.x = this.current.lineX = 0;
                this.current.y = this.current.lineY = 0;
              },
              endText: function CanvasGraphics_endText() {
                const paths = this.pendingTextPaths;
                const ctx = this.ctx;
                if (paths === void 0) {
                  ctx.beginPath();
                  return;
                }
                ctx.save();
                ctx.beginPath();
                for (let i = 0; i < paths.length; i++) {
                  const path = paths[i];
                  ctx.setTransform.apply(ctx, path.transform);
                  ctx.translate(path.x, path.y);
                  path.addToPath(ctx, path.fontSize);
                }
                ctx.restore();
                ctx.clip();
                ctx.beginPath();
                delete this.pendingTextPaths;
              },
              setCharSpacing: function CanvasGraphics_setCharSpacing(spacing) {
                this.current.charSpacing = spacing;
              },
              setWordSpacing: function CanvasGraphics_setWordSpacing(spacing) {
                this.current.wordSpacing = spacing;
              },
              setHScale: function CanvasGraphics_setHScale(scale) {
                this.current.textHScale = scale / 100;
              },
              setLeading: function CanvasGraphics_setLeading(leading) {
                this.current.leading = -leading;
              },
              setFont: function CanvasGraphics_setFont(fontRefName, size2) {
                const fontObj = this.commonObjs.get(fontRefName);
                const current = this.current;
                if (!fontObj) {
                  throw new Error(`Can't find font for ${fontRefName}`);
                }
                current.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
                  (0, _util2.warn)("Invalid font matrix for font " + fontRefName);
                }
                if (size2 < 0) {
                  size2 = -size2;
                  current.fontDirection = -1;
                } else {
                  current.fontDirection = 1;
                }
                this.current.font = fontObj;
                this.current.fontSize = size2;
                if (fontObj.isType3Font) {
                  return;
                }
                const name2 = fontObj.loadedName || "sans-serif";
                let bold = "normal";
                if (fontObj.black) {
                  bold = "900";
                } else if (fontObj.bold) {
                  bold = "bold";
                }
                const italic = fontObj.italic ? "italic" : "normal";
                const typeface = `"${name2}", ${fontObj.fallbackName}`;
                let browserFontSize = size2;
                if (size2 < MIN_FONT_SIZE) {
                  browserFontSize = MIN_FONT_SIZE;
                } else if (size2 > MAX_FONT_SIZE) {
                  browserFontSize = MAX_FONT_SIZE;
                }
                this.current.fontSizeScale = size2 / browserFontSize;
                this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
              },
              setTextRenderingMode: function CanvasGraphics_setTextRenderingMode(mode) {
                this.current.textRenderingMode = mode;
              },
              setTextRise: function CanvasGraphics_setTextRise(rise) {
                this.current.textRise = rise;
              },
              moveText: function CanvasGraphics_moveText(x, y) {
                this.current.x = this.current.lineX += x;
                this.current.y = this.current.lineY += y;
              },
              setLeadingMoveText: function CanvasGraphics_setLeadingMoveText(x, y) {
                this.setLeading(-y);
                this.moveText(x, y);
              },
              setTextMatrix: function CanvasGraphics_setTextMatrix(a, b, c, d, e, f) {
                this.current.textMatrix = [a, b, c, d, e, f];
                this.current.textMatrixScale = Math.hypot(a, b);
                this.current.x = this.current.lineX = 0;
                this.current.y = this.current.lineY = 0;
              },
              nextLine: function CanvasGraphics_nextLine() {
                this.moveText(0, this.current.leading);
              },
              paintChar(character, x, y, patternTransform, resetLineWidthToOne) {
                const ctx = this.ctx;
                const current = this.current;
                const font = current.font;
                const textRenderingMode = current.textRenderingMode;
                const fontSize = current.fontSize / current.fontSizeScale;
                const fillStrokeMode = textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                const isAddToPathSet = !!(textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG);
                const patternFill = current.patternFill && !font.missingFile;
                let addToPath;
                if (font.disableFontFace || isAddToPathSet || patternFill) {
                  addToPath = font.getPathGenerator(this.commonObjs, character);
                }
                if (font.disableFontFace || patternFill) {
                  ctx.save();
                  ctx.translate(x, y);
                  ctx.beginPath();
                  addToPath(ctx, fontSize);
                  if (patternTransform) {
                    ctx.setTransform.apply(ctx, patternTransform);
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx.fill();
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    if (resetLineWidthToOne) {
                      ctx.resetTransform();
                      ctx.lineWidth = Math.round(this._combinedScaleFactor);
                    }
                    ctx.stroke();
                  }
                  ctx.restore();
                } else {
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx.fillText(character, x, y);
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    if (resetLineWidthToOne) {
                      ctx.save();
                      ctx.moveTo(x, y);
                      ctx.resetTransform();
                      ctx.lineWidth = Math.round(this._combinedScaleFactor);
                      ctx.strokeText(character, 0, 0);
                      ctx.restore();
                    } else {
                      ctx.strokeText(character, x, y);
                    }
                  }
                }
                if (isAddToPathSet) {
                  const paths = this.pendingTextPaths || (this.pendingTextPaths = []);
                  paths.push({
                    transform: ctx.mozCurrentTransform,
                    x,
                    y,
                    fontSize,
                    addToPath
                  });
                }
              },
              get isFontSubpixelAAEnabled() {
                const {
                  context: ctx
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                ctx.scale(1.5, 1);
                ctx.fillText("I", 0, 10);
                const data2 = ctx.getImageData(0, 0, 10, 10).data;
                let enabled = false;
                for (let i = 3; i < data2.length; i += 4) {
                  if (data2[i] > 0 && data2[i] < 255) {
                    enabled = true;
                    break;
                  }
                }
                return (0, _util2.shadow)(this, "isFontSubpixelAAEnabled", enabled);
              },
              showText: function CanvasGraphics_showText(glyphs) {
                const current = this.current;
                const font = current.font;
                if (font.isType3Font) {
                  return this.showType3Text(glyphs);
                }
                const fontSize = current.fontSize;
                if (fontSize === 0) {
                  return void 0;
                }
                const ctx = this.ctx;
                const fontSizeScale = current.fontSizeScale;
                const charSpacing = current.charSpacing;
                const wordSpacing = current.wordSpacing;
                const fontDirection = current.fontDirection;
                const textHScale = current.textHScale * fontDirection;
                const glyphsLength = glyphs.length;
                const vertical = font.vertical;
                const spacingDir = vertical ? 1 : -1;
                const defaultVMetrics = font.defaultVMetrics;
                const widthAdvanceScale = fontSize * current.fontMatrix[0];
                const simpleFillText = current.textRenderingMode === _util2.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                ctx.save();
                let patternTransform;
                if (current.patternFill) {
                  ctx.save();
                  const pattern = current.fillColor.getPattern(ctx, this);
                  patternTransform = ctx.mozCurrentTransform;
                  ctx.restore();
                  ctx.fillStyle = pattern;
                }
                ctx.transform.apply(ctx, current.textMatrix);
                ctx.translate(current.x, current.y + current.textRise);
                if (fontDirection > 0) {
                  ctx.scale(textHScale, -1);
                } else {
                  ctx.scale(textHScale, 1);
                }
                let lineWidth = current.lineWidth;
                let resetLineWidthToOne = false;
                const scale = current.textMatrixScale;
                if (scale === 0 || lineWidth === 0) {
                  const fillStrokeMode = current.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    this._cachedGetSinglePixelWidth = null;
                    lineWidth = this.getSinglePixelWidth();
                    resetLineWidthToOne = lineWidth < 0;
                  }
                } else {
                  lineWidth /= scale;
                }
                if (fontSizeScale !== 1) {
                  ctx.scale(fontSizeScale, fontSizeScale);
                  lineWidth /= fontSizeScale;
                }
                ctx.lineWidth = lineWidth;
                let x = 0, i;
                for (i = 0; i < glyphsLength; ++i) {
                  const glyph = glyphs[i];
                  if ((0, _util2.isNum)(glyph)) {
                    x += spacingDir * glyph * fontSize / 1e3;
                    continue;
                  }
                  let restoreNeeded = false;
                  const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  const character = glyph.fontChar;
                  const accent = glyph.accent;
                  let scaledX, scaledY;
                  let width2 = glyph.width;
                  if (vertical) {
                    const vmetric = glyph.vmetric || defaultVMetrics;
                    const vx = -(glyph.vmetric ? vmetric[1] : width2 * 0.5) * widthAdvanceScale;
                    const vy = vmetric[2] * widthAdvanceScale;
                    width2 = vmetric ? -vmetric[0] : width2;
                    scaledX = vx / fontSizeScale;
                    scaledY = (x + vy) / fontSizeScale;
                  } else {
                    scaledX = x / fontSizeScale;
                    scaledY = 0;
                  }
                  if (font.remeasure && width2 > 0) {
                    const measuredWidth = ctx.measureText(character).width * 1e3 / fontSize * fontSizeScale;
                    if (width2 < measuredWidth && this.isFontSubpixelAAEnabled) {
                      const characterScaleX = width2 / measuredWidth;
                      restoreNeeded = true;
                      ctx.save();
                      ctx.scale(characterScaleX, 1);
                      scaledX /= characterScaleX;
                    } else if (width2 !== measuredWidth) {
                      scaledX += (width2 - measuredWidth) / 2e3 * fontSize / fontSizeScale;
                    }
                  }
                  if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                    if (simpleFillText && !accent) {
                      ctx.fillText(character, scaledX, scaledY);
                    } else {
                      this.paintChar(character, scaledX, scaledY, patternTransform, resetLineWidthToOne);
                      if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform, resetLineWidthToOne);
                      }
                    }
                  }
                  let charWidth;
                  if (vertical) {
                    charWidth = width2 * widthAdvanceScale - spacing * fontDirection;
                  } else {
                    charWidth = width2 * widthAdvanceScale + spacing * fontDirection;
                  }
                  x += charWidth;
                  if (restoreNeeded) {
                    ctx.restore();
                  }
                }
                if (vertical) {
                  current.y -= x;
                } else {
                  current.x += x * textHScale;
                }
                ctx.restore();
              },
              showType3Text: function CanvasGraphics_showType3Text(glyphs) {
                const ctx = this.ctx;
                const current = this.current;
                const font = current.font;
                const fontSize = current.fontSize;
                const fontDirection = current.fontDirection;
                const spacingDir = font.vertical ? 1 : -1;
                const charSpacing = current.charSpacing;
                const wordSpacing = current.wordSpacing;
                const textHScale = current.textHScale * fontDirection;
                const fontMatrix = current.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                const glyphsLength = glyphs.length;
                const isTextInvisible = current.textRenderingMode === _util2.TextRenderingMode.INVISIBLE;
                let i, glyph, width2, spacingLength;
                if (isTextInvisible || fontSize === 0) {
                  return;
                }
                this._cachedGetSinglePixelWidth = null;
                ctx.save();
                ctx.transform.apply(ctx, current.textMatrix);
                ctx.translate(current.x, current.y);
                ctx.scale(textHScale, fontDirection);
                for (i = 0; i < glyphsLength; ++i) {
                  glyph = glyphs[i];
                  if ((0, _util2.isNum)(glyph)) {
                    spacingLength = spacingDir * glyph * fontSize / 1e3;
                    this.ctx.translate(spacingLength, 0);
                    current.x += spacingLength * textHScale;
                    continue;
                  }
                  const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  const operatorList = font.charProcOperatorList[glyph.operatorListId];
                  if (!operatorList) {
                    (0, _util2.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                    continue;
                  }
                  if (this.contentVisible) {
                    this.processingType3 = glyph;
                    this.save();
                    ctx.scale(fontSize, fontSize);
                    ctx.transform.apply(ctx, fontMatrix);
                    this.executeOperatorList(operatorList);
                    this.restore();
                  }
                  const transformed = _util2.Util.applyTransform([glyph.width, 0], fontMatrix);
                  width2 = transformed[0] * fontSize + spacing;
                  ctx.translate(width2, 0);
                  current.x += width2 * textHScale;
                }
                ctx.restore();
                this.processingType3 = null;
              },
              setCharWidth: function CanvasGraphics_setCharWidth(xWidth, yWidth) {
              },
              setCharWidthAndBounds: function CanvasGraphics_setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                this.ctx.rect(llx, lly, urx - llx, ury - lly);
                this.clip();
                this.endPath();
              },
              getColorN_Pattern: function CanvasGraphics_getColorN_Pattern(IR) {
                let pattern;
                if (IR[0] === "TilingPattern") {
                  const color = IR[1];
                  const baseTransform = this.baseTransform || this.ctx.mozCurrentTransform.slice();
                  const canvasGraphicsFactory = {
                    createCanvasGraphics: (ctx) => {
                      return new CanvasGraphics2(ctx, this.commonObjs, this.objs, this.canvasFactory, this.webGLContext);
                    }
                  };
                  pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                } else {
                  pattern = (0, _pattern_helper.getShadingPatternFromIR)(IR);
                }
                return pattern;
              },
              setStrokeColorN: function CanvasGraphics_setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              },
              setFillColorN: function CanvasGraphics_setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments);
                this.current.patternFill = true;
              },
              setStrokeRGBColor: function CanvasGraphics_setStrokeRGBColor(r, g, b) {
                const color = _util2.Util.makeHexColor(r, g, b);
                this.ctx.strokeStyle = color;
                this.current.strokeColor = color;
              },
              setFillRGBColor: function CanvasGraphics_setFillRGBColor(r, g, b) {
                const color = _util2.Util.makeHexColor(r, g, b);
                this.ctx.fillStyle = color;
                this.current.fillColor = color;
                this.current.patternFill = false;
              },
              shadingFill: function CanvasGraphics_shadingFill(patternIR) {
                if (!this.contentVisible) {
                  return;
                }
                const ctx = this.ctx;
                this.save();
                const pattern = (0, _pattern_helper.getShadingPatternFromIR)(patternIR);
                ctx.fillStyle = pattern.getPattern(ctx, this, true);
                const inv = ctx.mozCurrentTransformInverse;
                if (inv) {
                  const canvas = ctx.canvas;
                  const width2 = canvas.width;
                  const height2 = canvas.height;
                  const bl = _util2.Util.applyTransform([0, 0], inv);
                  const br = _util2.Util.applyTransform([0, height2], inv);
                  const ul = _util2.Util.applyTransform([width2, 0], inv);
                  const ur = _util2.Util.applyTransform([width2, height2], inv);
                  const x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                  const y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                  const x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                  const y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                  this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                } else {
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                }
                this.restore();
              },
              beginInlineImage: function CanvasGraphics_beginInlineImage() {
                (0, _util2.unreachable)("Should not call beginInlineImage");
              },
              beginImageData: function CanvasGraphics_beginImageData() {
                (0, _util2.unreachable)("Should not call beginImageData");
              },
              paintFormXObjectBegin: function CanvasGraphics_paintFormXObjectBegin(matrix, bbox) {
                if (!this.contentVisible) {
                  return;
                }
                this.save();
                this.baseTransformStack.push(this.baseTransform);
                if (Array.isArray(matrix) && matrix.length === 6) {
                  this.transform.apply(this, matrix);
                }
                this.baseTransform = this.ctx.mozCurrentTransform;
                if (bbox) {
                  const width2 = bbox[2] - bbox[0];
                  const height2 = bbox[3] - bbox[1];
                  this.ctx.rect(bbox[0], bbox[1], width2, height2);
                  this.clip();
                  this.endPath();
                }
              },
              paintFormXObjectEnd: function CanvasGraphics_paintFormXObjectEnd() {
                if (!this.contentVisible) {
                  return;
                }
                this.restore();
                this.baseTransform = this.baseTransformStack.pop();
              },
              beginGroup: function CanvasGraphics_beginGroup(group) {
                if (!this.contentVisible) {
                  return;
                }
                this.save();
                const currentCtx = this.ctx;
                if (!group.isolated) {
                  (0, _util2.info)("TODO: Support non-isolated groups.");
                }
                if (group.knockout) {
                  (0, _util2.warn)("Knockout groups not supported.");
                }
                const currentTransform = currentCtx.mozCurrentTransform;
                if (group.matrix) {
                  currentCtx.transform.apply(currentCtx, group.matrix);
                }
                if (!group.bbox) {
                  throw new Error("Bounding box is required.");
                }
                let bounds = _util2.Util.getAxialAlignedBoundingBox(group.bbox, currentCtx.mozCurrentTransform);
                const canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
                bounds = _util2.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
                const offsetX = Math.floor(bounds[0]);
                const offsetY = Math.floor(bounds[1]);
                let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                let scaleX = 1, scaleY = 1;
                if (drawnWidth > MAX_GROUP_SIZE) {
                  scaleX = drawnWidth / MAX_GROUP_SIZE;
                  drawnWidth = MAX_GROUP_SIZE;
                }
                if (drawnHeight > MAX_GROUP_SIZE) {
                  scaleY = drawnHeight / MAX_GROUP_SIZE;
                  drawnHeight = MAX_GROUP_SIZE;
                }
                let cacheId = "groupAt" + this.groupLevel;
                if (group.smask) {
                  cacheId += "_smask_" + this.smaskCounter++ % 2;
                }
                const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight, true);
                const groupCtx = scratchCanvas.context;
                groupCtx.scale(1 / scaleX, 1 / scaleY);
                groupCtx.translate(-offsetX, -offsetY);
                groupCtx.transform.apply(groupCtx, currentTransform);
                if (group.smask) {
                  this.smaskStack.push({
                    canvas: scratchCanvas.canvas,
                    context: groupCtx,
                    offsetX,
                    offsetY,
                    scaleX,
                    scaleY,
                    subtype: group.smask.subtype,
                    backdrop: group.smask.backdrop,
                    transferMap: group.smask.transferMap || null,
                    startTransformInverse: null
                  });
                } else {
                  currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                  currentCtx.translate(offsetX, offsetY);
                  currentCtx.scale(scaleX, scaleY);
                }
                copyCtxState(currentCtx, groupCtx);
                this.ctx = groupCtx;
                this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
                this.groupStack.push(currentCtx);
                this.groupLevel++;
                this.current.activeSMask = null;
              },
              endGroup: function CanvasGraphics_endGroup(group) {
                if (!this.contentVisible) {
                  return;
                }
                this.groupLevel--;
                const groupCtx = this.ctx;
                this.ctx = this.groupStack.pop();
                if (this.ctx.imageSmoothingEnabled !== void 0) {
                  this.ctx.imageSmoothingEnabled = false;
                } else {
                  this.ctx.mozImageSmoothingEnabled = false;
                }
                if (group.smask) {
                  this.tempSMask = this.smaskStack.pop();
                } else {
                  this.ctx.drawImage(groupCtx.canvas, 0, 0);
                }
                this.restore();
              },
              beginAnnotations: function CanvasGraphics_beginAnnotations() {
                this.save();
                if (this.baseTransform) {
                  this.ctx.setTransform.apply(this.ctx, this.baseTransform);
                }
              },
              endAnnotations: function CanvasGraphics_endAnnotations() {
                this.restore();
              },
              beginAnnotation: function CanvasGraphics_beginAnnotation(rect, transform, matrix) {
                this.save();
                resetCtxToDefault(this.ctx);
                this.current = new CanvasExtraState();
                if (Array.isArray(rect) && rect.length === 4) {
                  const width2 = rect[2] - rect[0];
                  const height2 = rect[3] - rect[1];
                  this.ctx.rect(rect[0], rect[1], width2, height2);
                  this.clip();
                  this.endPath();
                }
                this.transform.apply(this, transform);
                this.transform.apply(this, matrix);
              },
              endAnnotation: function CanvasGraphics_endAnnotation() {
                this.restore();
              },
              paintImageMaskXObject: function CanvasGraphics_paintImageMaskXObject(img2) {
                if (!this.contentVisible) {
                  return;
                }
                const ctx = this.ctx;
                const width2 = img2.width, height2 = img2.height;
                const fillColor = this.current.fillColor;
                const isPatternFill = this.current.patternFill;
                const glyph = this.processingType3;
                if (glyph && glyph.compiled === void 0) {
                  if (width2 <= MAX_SIZE_TO_COMPILE && height2 <= MAX_SIZE_TO_COMPILE) {
                    glyph.compiled = compileType3Glyph({
                      data: img2.data,
                      width: width2,
                      height: height2
                    });
                  } else {
                    glyph.compiled = null;
                  }
                }
                if (glyph == null ? void 0 : glyph.compiled) {
                  glyph.compiled(ctx);
                  return;
                }
                const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width2, height2);
                const maskCtx = maskCanvas.context;
                maskCtx.save();
                putBinaryImageMask(maskCtx, img2);
                maskCtx.globalCompositeOperation = "source-in";
                maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
                maskCtx.fillRect(0, 0, width2, height2);
                maskCtx.restore();
                this.paintInlineImageXObject(maskCanvas.canvas);
              },
              paintImageMaskXObjectRepeat(imgData, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                if (!this.contentVisible) {
                  return;
                }
                const width2 = imgData.width;
                const height2 = imgData.height;
                const fillColor = this.current.fillColor;
                const isPatternFill = this.current.patternFill;
                const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width2, height2);
                const maskCtx = maskCanvas.context;
                maskCtx.save();
                putBinaryImageMask(maskCtx, imgData);
                maskCtx.globalCompositeOperation = "source-in";
                maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
                maskCtx.fillRect(0, 0, width2, height2);
                maskCtx.restore();
                const ctx = this.ctx;
                for (let i = 0, ii = positions.length; i < ii; i += 2) {
                  ctx.save();
                  ctx.transform(scaleX, skewX, skewY, scaleY, positions[i], positions[i + 1]);
                  ctx.scale(1, -1);
                  ctx.drawImage(maskCanvas.canvas, 0, 0, width2, height2, 0, -1, 1, 1);
                  ctx.restore();
                }
              },
              paintImageMaskXObjectGroup: function CanvasGraphics_paintImageMaskXObjectGroup(images) {
                if (!this.contentVisible) {
                  return;
                }
                const ctx = this.ctx;
                const fillColor = this.current.fillColor;
                const isPatternFill = this.current.patternFill;
                for (let i = 0, ii = images.length; i < ii; i++) {
                  const image = images[i];
                  const width2 = image.width, height2 = image.height;
                  const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width2, height2);
                  const maskCtx = maskCanvas.context;
                  maskCtx.save();
                  putBinaryImageMask(maskCtx, image);
                  maskCtx.globalCompositeOperation = "source-in";
                  maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this) : fillColor;
                  maskCtx.fillRect(0, 0, width2, height2);
                  maskCtx.restore();
                  ctx.save();
                  ctx.transform.apply(ctx, image.transform);
                  ctx.scale(1, -1);
                  ctx.drawImage(maskCanvas.canvas, 0, 0, width2, height2, 0, -1, 1, 1);
                  ctx.restore();
                }
              },
              paintImageXObject: function CanvasGraphics_paintImageXObject(objId) {
                if (!this.contentVisible) {
                  return;
                }
                const imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                if (!imgData) {
                  (0, _util2.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(imgData);
              },
              paintImageXObjectRepeat: function CanvasGraphics_paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                if (!this.contentVisible) {
                  return;
                }
                const imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                if (!imgData) {
                  (0, _util2.warn)("Dependent image isn't ready yet");
                  return;
                }
                const width2 = imgData.width;
                const height2 = imgData.height;
                const map2 = [];
                for (let i = 0, ii = positions.length; i < ii; i += 2) {
                  map2.push({
                    transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
                    x: 0,
                    y: 0,
                    w: width2,
                    h: height2
                  });
                }
                this.paintInlineImageXObjectGroup(imgData, map2);
              },
              paintInlineImageXObject: function CanvasGraphics_paintInlineImageXObject(imgData) {
                if (!this.contentVisible) {
                  return;
                }
                const width2 = imgData.width;
                const height2 = imgData.height;
                const ctx = this.ctx;
                this.save();
                ctx.scale(1 / width2, -1 / height2);
                const currentTransform = ctx.mozCurrentTransformInverse;
                let widthScale = Math.max(Math.hypot(currentTransform[0], currentTransform[1]), 1);
                let heightScale = Math.max(Math.hypot(currentTransform[2], currentTransform[3]), 1);
                let imgToPaint, tmpCanvas, tmpCtx;
                if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
                  imgToPaint = imgData;
                } else {
                  tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width2, height2);
                  tmpCtx = tmpCanvas.context;
                  putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                  imgToPaint = tmpCanvas.canvas;
                }
                let paintWidth = width2, paintHeight = height2;
                let tmpCanvasId = "prescale1";
                while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
                  let newWidth = paintWidth, newHeight = paintHeight;
                  if (widthScale > 2 && paintWidth > 1) {
                    newWidth = Math.ceil(paintWidth / 2);
                    widthScale /= paintWidth / newWidth;
                  }
                  if (heightScale > 2 && paintHeight > 1) {
                    newHeight = Math.ceil(paintHeight / 2);
                    heightScale /= paintHeight / newHeight;
                  }
                  tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                  tmpCtx = tmpCanvas.context;
                  tmpCtx.clearRect(0, 0, newWidth, newHeight);
                  tmpCtx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                  imgToPaint = tmpCanvas.canvas;
                  paintWidth = newWidth;
                  paintHeight = newHeight;
                  tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                }
                ctx.drawImage(imgToPaint, 0, 0, paintWidth, paintHeight, 0, -height2, width2, height2);
                if (this.imageLayer) {
                  const position = this.getCanvasPosition(0, -height2);
                  this.imageLayer.appendImage({
                    imgData,
                    left: position[0],
                    top: position[1],
                    width: width2 / currentTransform[0],
                    height: height2 / currentTransform[3]
                  });
                }
                this.restore();
              },
              paintInlineImageXObjectGroup: function CanvasGraphics_paintInlineImageXObjectGroup(imgData, map2) {
                if (!this.contentVisible) {
                  return;
                }
                const ctx = this.ctx;
                const w = imgData.width;
                const h2 = imgData.height;
                const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h2);
                const tmpCtx = tmpCanvas.context;
                putBinaryImageData(tmpCtx, imgData, this.current.transferMaps);
                for (let i = 0, ii = map2.length; i < ii; i++) {
                  const entry = map2[i];
                  ctx.save();
                  ctx.transform.apply(ctx, entry.transform);
                  ctx.scale(1, -1);
                  ctx.drawImage(tmpCanvas.canvas, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                  if (this.imageLayer) {
                    const position = this.getCanvasPosition(entry.x, entry.y);
                    this.imageLayer.appendImage({
                      imgData,
                      left: position[0],
                      top: position[1],
                      width: w,
                      height: h2
                    });
                  }
                  ctx.restore();
                }
              },
              paintSolidColorImageMask: function CanvasGraphics_paintSolidColorImageMask() {
                if (!this.contentVisible) {
                  return;
                }
                this.ctx.fillRect(0, 0, 1, 1);
              },
              markPoint: function CanvasGraphics_markPoint(tag) {
              },
              markPointProps: function CanvasGraphics_markPointProps(tag, properties) {
              },
              beginMarkedContent: function CanvasGraphics_beginMarkedContent(tag) {
                this.markedContentStack.push({
                  visible: true
                });
              },
              beginMarkedContentProps: function CanvasGraphics_beginMarkedContentProps(tag, properties) {
                if (tag === "OC") {
                  this.markedContentStack.push({
                    visible: this.optionalContentConfig.isVisible(properties)
                  });
                } else {
                  this.markedContentStack.push({
                    visible: true
                  });
                }
                this.contentVisible = this.isContentVisible();
              },
              endMarkedContent: function CanvasGraphics_endMarkedContent() {
                this.markedContentStack.pop();
                this.contentVisible = this.isContentVisible();
              },
              beginCompat: function CanvasGraphics_beginCompat() {
              },
              endCompat: function CanvasGraphics_endCompat() {
              },
              consumePath: function CanvasGraphics_consumePath() {
                const ctx = this.ctx;
                if (this.pendingClip) {
                  if (this.pendingClip === EO_CLIP) {
                    ctx.clip("evenodd");
                  } else {
                    ctx.clip();
                  }
                  this.pendingClip = null;
                }
                ctx.beginPath();
              },
              getSinglePixelWidth() {
                if (this._cachedGetSinglePixelWidth === null) {
                  const m = this.ctx.mozCurrentTransform;
                  const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                  const sqNorm1 = m[0] ** 2 + m[2] ** 2;
                  const sqNorm2 = m[1] ** 2 + m[3] ** 2;
                  const pixelHeight = Math.sqrt(Math.max(sqNorm1, sqNorm2)) / absDet;
                  if (sqNorm1 !== sqNorm2 && this._combinedScaleFactor * pixelHeight > 1) {
                    this._cachedGetSinglePixelWidth = -(this._combinedScaleFactor * pixelHeight);
                  } else if (absDet > Number.EPSILON) {
                    this._cachedGetSinglePixelWidth = pixelHeight;
                  } else {
                    this._cachedGetSinglePixelWidth = 1;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              },
              getCanvasPosition: function CanvasGraphics_getCanvasPosition(x, y) {
                const transform = this.ctx.mozCurrentTransform;
                return [transform[0] * x + transform[2] * y + transform[4], transform[1] * x + transform[3] * y + transform[5]];
              },
              isContentVisible: function CanvasGraphics_isContentVisible() {
                for (let i = this.markedContentStack.length - 1; i >= 0; i--) {
                  if (!this.markedContentStack[i].visible) {
                    return false;
                  }
                }
                return true;
              }
            };
            for (const op in _util2.OPS) {
              CanvasGraphics2.prototype[_util2.OPS[op]] = CanvasGraphics2.prototype[op];
            }
            return CanvasGraphics2;
          }();
          exports2.CanvasGraphics = CanvasGraphics;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getShadingPatternFromIR = getShadingPatternFromIR;
          exports2.TilingPattern = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          const ShadingIRs = {};
          function applyBoundingBox(ctx, bbox) {
            if (!bbox || typeof Path2D === "undefined") {
              return;
            }
            const width2 = bbox[2] - bbox[0];
            const height2 = bbox[3] - bbox[1];
            const region = new Path2D();
            region.rect(bbox[0], bbox[1], width2, height2);
            ctx.clip(region);
          }
          ShadingIRs.RadialAxial = {
            fromIR: function RadialAxial_fromIR(raw) {
              const type = raw[1];
              const bbox = raw[2];
              const colorStops = raw[3];
              const p0 = raw[4];
              const p1 = raw[5];
              const r0 = raw[6];
              const r1 = raw[7];
              return {
                getPattern: function RadialAxial_getPattern(ctx) {
                  applyBoundingBox(ctx, bbox);
                  let grad;
                  if (type === "axial") {
                    grad = ctx.createLinearGradient(p0[0], p0[1], p1[0], p1[1]);
                  } else if (type === "radial") {
                    grad = ctx.createRadialGradient(p0[0], p0[1], r0, p1[0], p1[1], r1);
                  }
                  for (let i = 0, ii = colorStops.length; i < ii; ++i) {
                    const c = colorStops[i];
                    grad.addColorStop(c[0], c[1]);
                  }
                  return grad;
                }
              };
            }
          };
          const createMeshCanvas = function createMeshCanvasClosure() {
            function drawTriangle(data2, context, p1, p2, p3, c1, c2, c3) {
              const coords = context.coords, colors = context.colors;
              const bytes = data2.data, rowSize = data2.width * 4;
              let tmp;
              if (coords[p1 + 1] > coords[p2 + 1]) {
                tmp = p1;
                p1 = p2;
                p2 = tmp;
                tmp = c1;
                c1 = c2;
                c2 = tmp;
              }
              if (coords[p2 + 1] > coords[p3 + 1]) {
                tmp = p2;
                p2 = p3;
                p3 = tmp;
                tmp = c2;
                c2 = c3;
                c3 = tmp;
              }
              if (coords[p1 + 1] > coords[p2 + 1]) {
                tmp = p1;
                p1 = p2;
                p2 = tmp;
                tmp = c1;
                c1 = c2;
                c2 = tmp;
              }
              const x1 = (coords[p1] + context.offsetX) * context.scaleX;
              const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
              const x2 = (coords[p2] + context.offsetX) * context.scaleX;
              const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
              const x3 = (coords[p3] + context.offsetX) * context.scaleX;
              const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
              if (y1 >= y3) {
                return;
              }
              const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
              const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
              const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
              const minY = Math.round(y1), maxY = Math.round(y3);
              let xa, car, cag, cab;
              let xb, cbr, cbg, cbb;
              for (let y = minY; y <= maxY; y++) {
                if (y < y2) {
                  let k2;
                  if (y < y1) {
                    k2 = 0;
                  } else if (y1 === y2) {
                    k2 = 1;
                  } else {
                    k2 = (y1 - y) / (y1 - y2);
                  }
                  xa = x1 - (x1 - x2) * k2;
                  car = c1r - (c1r - c2r) * k2;
                  cag = c1g - (c1g - c2g) * k2;
                  cab = c1b - (c1b - c2b) * k2;
                } else {
                  let k2;
                  if (y > y3) {
                    k2 = 1;
                  } else if (y2 === y3) {
                    k2 = 0;
                  } else {
                    k2 = (y2 - y) / (y2 - y3);
                  }
                  xa = x2 - (x2 - x3) * k2;
                  car = c2r - (c2r - c3r) * k2;
                  cag = c2g - (c2g - c3g) * k2;
                  cab = c2b - (c2b - c3b) * k2;
                }
                let k;
                if (y < y1) {
                  k = 0;
                } else if (y > y3) {
                  k = 1;
                } else {
                  k = (y1 - y) / (y1 - y3);
                }
                xb = x1 - (x1 - x3) * k;
                cbr = c1r - (c1r - c3r) * k;
                cbg = c1g - (c1g - c3g) * k;
                cbb = c1b - (c1b - c3b) * k;
                const x1_ = Math.round(Math.min(xa, xb));
                const x2_ = Math.round(Math.max(xa, xb));
                let j = rowSize * y + x1_ * 4;
                for (let x = x1_; x <= x2_; x++) {
                  k = (xa - x) / (xa - xb);
                  if (k < 0) {
                    k = 0;
                  } else if (k > 1) {
                    k = 1;
                  }
                  bytes[j++] = car - (car - cbr) * k | 0;
                  bytes[j++] = cag - (cag - cbg) * k | 0;
                  bytes[j++] = cab - (cab - cbb) * k | 0;
                  bytes[j++] = 255;
                }
              }
            }
            function drawFigure(data2, figure, context) {
              const ps = figure.coords;
              const cs = figure.colors;
              let i, ii;
              switch (figure.type) {
                case "lattice":
                  const verticesPerRow = figure.verticesPerRow;
                  const rows = Math.floor(ps.length / verticesPerRow) - 1;
                  const cols = verticesPerRow - 1;
                  for (i = 0; i < rows; i++) {
                    let q = i * verticesPerRow;
                    for (let j = 0; j < cols; j++, q++) {
                      drawTriangle(data2, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                      drawTriangle(data2, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                    }
                  }
                  break;
                case "triangles":
                  for (i = 0, ii = ps.length; i < ii; i += 3) {
                    drawTriangle(data2, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                  }
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            function createMeshCanvas2(bounds, combinesScale, coords, colors, figures, backgroundColor, cachedCanvases, webGLContext) {
              const EXPECTED_SCALE = 1.1;
              const MAX_PATTERN_SIZE = 3e3;
              const BORDER_SIZE = 2;
              const offsetX = Math.floor(bounds[0]);
              const offsetY = Math.floor(bounds[1]);
              const boundsWidth = Math.ceil(bounds[2]) - offsetX;
              const boundsHeight = Math.ceil(bounds[3]) - offsetY;
              const width2 = Math.min(Math.ceil(Math.abs(boundsWidth * combinesScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
              const height2 = Math.min(Math.ceil(Math.abs(boundsHeight * combinesScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
              const scaleX = boundsWidth / width2;
              const scaleY = boundsHeight / height2;
              const context = {
                coords,
                colors,
                offsetX: -offsetX,
                offsetY: -offsetY,
                scaleX: 1 / scaleX,
                scaleY: 1 / scaleY
              };
              const paddedWidth = width2 + BORDER_SIZE * 2;
              const paddedHeight = height2 + BORDER_SIZE * 2;
              let canvas, tmpCanvas, i, ii;
              if (webGLContext.isEnabled) {
                canvas = webGLContext.drawFigures({
                  width: width2,
                  height: height2,
                  backgroundColor,
                  figures,
                  context
                });
                tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                tmpCanvas.context.drawImage(canvas, BORDER_SIZE, BORDER_SIZE);
                canvas = tmpCanvas.canvas;
              } else {
                tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                const tmpCtx = tmpCanvas.context;
                const data2 = tmpCtx.createImageData(width2, height2);
                if (backgroundColor) {
                  const bytes = data2.data;
                  for (i = 0, ii = bytes.length; i < ii; i += 4) {
                    bytes[i] = backgroundColor[0];
                    bytes[i + 1] = backgroundColor[1];
                    bytes[i + 2] = backgroundColor[2];
                    bytes[i + 3] = 255;
                  }
                }
                for (i = 0; i < figures.length; i++) {
                  drawFigure(data2, figures[i], context);
                }
                tmpCtx.putImageData(data2, BORDER_SIZE, BORDER_SIZE);
                canvas = tmpCanvas.canvas;
              }
              return {
                canvas,
                offsetX: offsetX - BORDER_SIZE * scaleX,
                offsetY: offsetY - BORDER_SIZE * scaleY,
                scaleX,
                scaleY
              };
            }
            return createMeshCanvas2;
          }();
          ShadingIRs.Mesh = {
            fromIR: function Mesh_fromIR(raw) {
              const coords = raw[2];
              const colors = raw[3];
              const figures = raw[4];
              const bounds = raw[5];
              const matrix = raw[6];
              const bbox = raw[7];
              const background = raw[8];
              return {
                getPattern: function Mesh_getPattern(ctx, owner, shadingFill) {
                  applyBoundingBox(ctx, bbox);
                  let scale;
                  if (shadingFill) {
                    scale = _util2.Util.singularValueDecompose2dScale(ctx.mozCurrentTransform);
                  } else {
                    scale = _util2.Util.singularValueDecompose2dScale(owner.baseTransform);
                    if (matrix) {
                      const matrixScale = _util2.Util.singularValueDecompose2dScale(matrix);
                      scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
                    }
                  }
                  const temporaryPatternCanvas = createMeshCanvas(bounds, scale, coords, colors, figures, shadingFill ? null : background, owner.cachedCanvases, owner.webGLContext);
                  if (!shadingFill) {
                    ctx.setTransform.apply(ctx, owner.baseTransform);
                    if (matrix) {
                      ctx.transform.apply(ctx, matrix);
                    }
                  }
                  ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                  ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                  return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                }
              };
            }
          };
          ShadingIRs.Dummy = {
            fromIR: function Dummy_fromIR() {
              return {
                getPattern: function Dummy_fromIR_getPattern() {
                  return "hotpink";
                }
              };
            }
          };
          function getShadingPatternFromIR(raw) {
            const shadingIR = ShadingIRs[raw[0]];
            if (!shadingIR) {
              throw new Error(`Unknown IR type: ${raw[0]}`);
            }
            return shadingIR.fromIR(raw);
          }
          const TilingPattern = function TilingPatternClosure() {
            const PaintType = {
              COLORED: 1,
              UNCOLORED: 2
            };
            const MAX_PATTERN_SIZE = 3e3;
            function TilingPattern2(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
              this.operatorList = IR[2];
              this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
              this.bbox = IR[4];
              this.xstep = IR[5];
              this.ystep = IR[6];
              this.paintType = IR[7];
              this.tilingType = IR[8];
              this.color = color;
              this.canvasGraphicsFactory = canvasGraphicsFactory;
              this.baseTransform = baseTransform;
              this.ctx = ctx;
            }
            TilingPattern2.prototype = {
              createPatternCanvas: function TilinPattern_createPatternCanvas(owner) {
                const operatorList = this.operatorList;
                const bbox = this.bbox;
                const xstep = this.xstep;
                const ystep = this.ystep;
                const paintType = this.paintType;
                const tilingType = this.tilingType;
                const color = this.color;
                const canvasGraphicsFactory = this.canvasGraphicsFactory;
                (0, _util2.info)("TilingType: " + tilingType);
                const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                const matrixScale = _util2.Util.singularValueDecompose2dScale(this.matrix);
                const curMatrixScale = _util2.Util.singularValueDecompose2dScale(this.baseTransform);
                const combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
                const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                const tmpCtx = tmpCanvas.context;
                const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                graphics.groupLevel = owner.groupLevel;
                this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                graphics.transform(1, 0, 0, 1, -x0, -y0);
                this.clipBbox(graphics, bbox, x0, y0, x1, y1);
                graphics.executeOperatorList(operatorList);
                this.ctx.transform(1, 0, 0, 1, x0, y0);
                this.ctx.scale(1 / dimx.scale, 1 / dimy.scale);
                return tmpCanvas.canvas;
              },
              getSizeAndScale: function TilingPattern_getSizeAndScale(step, realOutputSize, scale) {
                step = Math.abs(step);
                const maxSize = Math.max(MAX_PATTERN_SIZE, realOutputSize);
                let size2 = Math.ceil(step * scale);
                if (size2 >= maxSize) {
                  size2 = maxSize;
                } else {
                  scale = size2 / step;
                }
                return {
                  scale,
                  size: size2
                };
              },
              clipBbox: function clipBbox(graphics, bbox, x0, y0, x1, y1) {
                if (Array.isArray(bbox) && bbox.length === 4) {
                  const bboxWidth = x1 - x0;
                  const bboxHeight = y1 - y0;
                  graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                  graphics.clip();
                  graphics.endPath();
                }
              },
              setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(graphics, paintType, color) {
                const context = graphics.ctx, current = graphics.current;
                switch (paintType) {
                  case PaintType.COLORED:
                    const ctx = this.ctx;
                    context.fillStyle = ctx.fillStyle;
                    context.strokeStyle = ctx.strokeStyle;
                    current.fillColor = ctx.fillStyle;
                    current.strokeColor = ctx.strokeStyle;
                    break;
                  case PaintType.UNCOLORED:
                    const cssColor = _util2.Util.makeHexColor(color[0], color[1], color[2]);
                    context.fillStyle = cssColor;
                    context.strokeStyle = cssColor;
                    current.fillColor = cssColor;
                    current.strokeColor = cssColor;
                    break;
                  default:
                    throw new _util2.FormatError(`Unsupported paint type: ${paintType}`);
                }
              },
              getPattern: function TilingPattern_getPattern(ctx, owner) {
                ctx = this.ctx;
                ctx.setTransform.apply(ctx, this.baseTransform);
                ctx.transform.apply(ctx, this.matrix);
                const temporaryPatternCanvas = this.createPatternCanvas(owner);
                return ctx.createPattern(temporaryPatternCanvas, "repeat");
              }
            };
            return TilingPattern2;
          }();
          exports2.TilingPattern = TilingPattern;
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.GlobalWorkerOptions = void 0;
          const GlobalWorkerOptions = /* @__PURE__ */ Object.create(null);
          exports2.GlobalWorkerOptions = GlobalWorkerOptions;
          GlobalWorkerOptions.workerPort = GlobalWorkerOptions.workerPort === void 0 ? null : GlobalWorkerOptions.workerPort;
          GlobalWorkerOptions.workerSrc = GlobalWorkerOptions.workerSrc === void 0 ? "" : GlobalWorkerOptions.workerSrc;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.MessageHandler = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          const CallbackKind = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          };
          const StreamKind = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function wrapReason(reason) {
            if (typeof reason !== "object" || reason === null) {
              return reason;
            }
            switch (reason.name) {
              case "AbortException":
                return new _util2.AbortException(reason.message);
              case "MissingPDFException":
                return new _util2.MissingPDFException(reason.message);
              case "UnexpectedResponseException":
                return new _util2.UnexpectedResponseException(reason.message, reason.status);
              case "UnknownErrorException":
                return new _util2.UnknownErrorException(reason.message, reason.details);
              default:
                return new _util2.UnknownErrorException(reason.message, reason.toString());
            }
          }
          class MessageHandler {
            constructor(sourceName, targetName, comObj) {
              this.sourceName = sourceName;
              this.targetName = targetName;
              this.comObj = comObj;
              this.callbackId = 1;
              this.streamId = 1;
              this.postMessageTransfers = true;
              this.streamSinks = /* @__PURE__ */ Object.create(null);
              this.streamControllers = /* @__PURE__ */ Object.create(null);
              this.callbackCapabilities = /* @__PURE__ */ Object.create(null);
              this.actionHandler = /* @__PURE__ */ Object.create(null);
              this._onComObjOnMessage = (event) => {
                const data2 = event.data;
                if (data2.targetName !== this.sourceName) {
                  return;
                }
                if (data2.stream) {
                  this._processStreamMessage(data2);
                  return;
                }
                if (data2.callback) {
                  const callbackId = data2.callbackId;
                  const capability = this.callbackCapabilities[callbackId];
                  if (!capability) {
                    throw new Error(`Cannot resolve callback ${callbackId}`);
                  }
                  delete this.callbackCapabilities[callbackId];
                  if (data2.callback === CallbackKind.DATA) {
                    capability.resolve(data2.data);
                  } else if (data2.callback === CallbackKind.ERROR) {
                    capability.reject(wrapReason(data2.reason));
                  } else {
                    throw new Error("Unexpected callback case");
                  }
                  return;
                }
                const action = this.actionHandler[data2.action];
                if (!action) {
                  throw new Error(`Unknown action from worker: ${data2.action}`);
                }
                if (data2.callbackId) {
                  const cbSourceName = this.sourceName;
                  const cbTargetName = data2.sourceName;
                  new Promise(function(resolve2) {
                    resolve2(action(data2.data));
                  }).then(function(result) {
                    comObj.postMessage({
                      sourceName: cbSourceName,
                      targetName: cbTargetName,
                      callback: CallbackKind.DATA,
                      callbackId: data2.callbackId,
                      data: result
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName: cbSourceName,
                      targetName: cbTargetName,
                      callback: CallbackKind.ERROR,
                      callbackId: data2.callbackId,
                      reason: wrapReason(reason)
                    });
                  });
                  return;
                }
                if (data2.streamId) {
                  this._createStreamSink(data2);
                  return;
                }
                action(data2.data);
              };
              comObj.addEventListener("message", this._onComObjOnMessage);
            }
            on(actionName, handler) {
              const ah = this.actionHandler;
              if (ah[actionName]) {
                throw new Error(`There is already an actionName called "${actionName}"`);
              }
              ah[actionName] = handler;
            }
            send(actionName, data2, transfers) {
              this._postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                data: data2
              }, transfers);
            }
            sendWithPromise(actionName, data2, transfers) {
              const callbackId = this.callbackId++;
              const capability = (0, _util2.createPromiseCapability)();
              this.callbackCapabilities[callbackId] = capability;
              try {
                this._postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: actionName,
                  callbackId,
                  data: data2
                }, transfers);
              } catch (ex) {
                capability.reject(ex);
              }
              return capability.promise;
            }
            sendWithStream(actionName, data2, queueingStrategy, transfers) {
              const streamId = this.streamId++;
              const sourceName = this.sourceName;
              const targetName = this.targetName;
              const comObj = this.comObj;
              return new ReadableStream({
                start: (controller) => {
                  const startCapability = (0, _util2.createPromiseCapability)();
                  this.streamControllers[streamId] = {
                    controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                  };
                  this._postMessage({
                    sourceName,
                    targetName,
                    action: actionName,
                    streamId,
                    data: data2,
                    desiredSize: controller.desiredSize
                  }, transfers);
                  return startCapability.promise;
                },
                pull: (controller) => {
                  const pullCapability = (0, _util2.createPromiseCapability)();
                  this.streamControllers[streamId].pullCall = pullCapability;
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.PULL,
                    streamId,
                    desiredSize: controller.desiredSize
                  });
                  return pullCapability.promise;
                },
                cancel: (reason) => {
                  (0, _util2.assert)(reason instanceof Error, "cancel must have a valid reason");
                  const cancelCapability = (0, _util2.createPromiseCapability)();
                  this.streamControllers[streamId].cancelCall = cancelCapability;
                  this.streamControllers[streamId].isClosed = true;
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.CANCEL,
                    streamId,
                    reason: wrapReason(reason)
                  });
                  return cancelCapability.promise;
                }
              }, queueingStrategy);
            }
            _createStreamSink(data2) {
              const self2 = this;
              const action = this.actionHandler[data2.action];
              const streamId = data2.streamId;
              const sourceName = this.sourceName;
              const targetName = data2.sourceName;
              const comObj = this.comObj;
              const streamSink = {
                enqueue(chunk, size2 = 1, transfers) {
                  if (this.isCancelled) {
                    return;
                  }
                  const lastDesiredSize = this.desiredSize;
                  this.desiredSize -= size2;
                  if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = (0, _util2.createPromiseCapability)();
                    this.ready = this.sinkCapability.promise;
                  }
                  self2._postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.ENQUEUE,
                    streamId,
                    chunk
                  }, transfers);
                },
                close() {
                  if (this.isCancelled) {
                    return;
                  }
                  this.isCancelled = true;
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.CLOSE,
                    streamId
                  });
                  delete self2.streamSinks[streamId];
                },
                error(reason) {
                  (0, _util2.assert)(reason instanceof Error, "error must have a valid reason");
                  if (this.isCancelled) {
                    return;
                  }
                  this.isCancelled = true;
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.ERROR,
                    streamId,
                    reason: wrapReason(reason)
                  });
                },
                sinkCapability: (0, _util2.createPromiseCapability)(),
                onPull: null,
                onCancel: null,
                isCancelled: false,
                desiredSize: data2.desiredSize,
                ready: null
              };
              streamSink.sinkCapability.resolve();
              streamSink.ready = streamSink.sinkCapability.promise;
              this.streamSinks[streamId] = streamSink;
              new Promise(function(resolve2) {
                resolve2(action(data2.data, streamSink));
              }).then(function() {
                comObj.postMessage({
                  sourceName,
                  targetName,
                  stream: StreamKind.START_COMPLETE,
                  streamId,
                  success: true
                });
              }, function(reason) {
                comObj.postMessage({
                  sourceName,
                  targetName,
                  stream: StreamKind.START_COMPLETE,
                  streamId,
                  reason: wrapReason(reason)
                });
              });
            }
            _processStreamMessage(data2) {
              const streamId = data2.streamId;
              const sourceName = this.sourceName;
              const targetName = data2.sourceName;
              const comObj = this.comObj;
              switch (data2.stream) {
                case StreamKind.START_COMPLETE:
                  if (data2.success) {
                    this.streamControllers[streamId].startCall.resolve();
                  } else {
                    this.streamControllers[streamId].startCall.reject(wrapReason(data2.reason));
                  }
                  break;
                case StreamKind.PULL_COMPLETE:
                  if (data2.success) {
                    this.streamControllers[streamId].pullCall.resolve();
                  } else {
                    this.streamControllers[streamId].pullCall.reject(wrapReason(data2.reason));
                  }
                  break;
                case StreamKind.PULL:
                  if (!this.streamSinks[streamId]) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL_COMPLETE,
                      streamId,
                      success: true
                    });
                    break;
                  }
                  if (this.streamSinks[streamId].desiredSize <= 0 && data2.desiredSize > 0) {
                    this.streamSinks[streamId].sinkCapability.resolve();
                  }
                  this.streamSinks[streamId].desiredSize = data2.desiredSize;
                  const {
                    onPull
                  } = this.streamSinks[data2.streamId];
                  new Promise(function(resolve2) {
                    resolve2(onPull && onPull());
                  }).then(function() {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL_COMPLETE,
                      streamId,
                      success: true
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL_COMPLETE,
                      streamId,
                      reason: wrapReason(reason)
                    });
                  });
                  break;
                case StreamKind.ENQUEUE:
                  (0, _util2.assert)(this.streamControllers[streamId], "enqueue should have stream controller");
                  if (this.streamControllers[streamId].isClosed) {
                    break;
                  }
                  this.streamControllers[streamId].controller.enqueue(data2.chunk);
                  break;
                case StreamKind.CLOSE:
                  (0, _util2.assert)(this.streamControllers[streamId], "close should have stream controller");
                  if (this.streamControllers[streamId].isClosed) {
                    break;
                  }
                  this.streamControllers[streamId].isClosed = true;
                  this.streamControllers[streamId].controller.close();
                  this._deleteStreamController(streamId);
                  break;
                case StreamKind.ERROR:
                  (0, _util2.assert)(this.streamControllers[streamId], "error should have stream controller");
                  this.streamControllers[streamId].controller.error(wrapReason(data2.reason));
                  this._deleteStreamController(streamId);
                  break;
                case StreamKind.CANCEL_COMPLETE:
                  if (data2.success) {
                    this.streamControllers[streamId].cancelCall.resolve();
                  } else {
                    this.streamControllers[streamId].cancelCall.reject(wrapReason(data2.reason));
                  }
                  this._deleteStreamController(streamId);
                  break;
                case StreamKind.CANCEL:
                  if (!this.streamSinks[streamId]) {
                    break;
                  }
                  const {
                    onCancel
                  } = this.streamSinks[data2.streamId];
                  new Promise(function(resolve2) {
                    resolve2(onCancel && onCancel(wrapReason(data2.reason)));
                  }).then(function() {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.CANCEL_COMPLETE,
                      streamId,
                      success: true
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.CANCEL_COMPLETE,
                      streamId,
                      reason: wrapReason(reason)
                    });
                  });
                  this.streamSinks[streamId].sinkCapability.reject(wrapReason(data2.reason));
                  this.streamSinks[streamId].isCancelled = true;
                  delete this.streamSinks[streamId];
                  break;
                default:
                  throw new Error("Unexpected stream case");
              }
            }
            async _deleteStreamController(streamId) {
              await Promise.allSettled([this.streamControllers[streamId].startCall, this.streamControllers[streamId].pullCall, this.streamControllers[streamId].cancelCall].map(function(capability) {
                return capability && capability.promise;
              }));
              delete this.streamControllers[streamId];
            }
            _postMessage(message, transfers) {
              if (transfers && this.postMessageTransfers) {
                this.comObj.postMessage(message, transfers);
              } else {
                this.comObj.postMessage(message);
              }
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          exports2.MessageHandler = MessageHandler;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.Metadata = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          class Metadata {
            constructor({
              parsedData,
              rawData
            }) {
              this._metadataMap = parsedData;
              this._data = rawData;
            }
            getRaw() {
              return this._data;
            }
            get(name2) {
              var _a2;
              return (_a2 = this._metadataMap.get(name2)) != null ? _a2 : null;
            }
            getAll() {
              return (0, _util2.objectFromMap)(this._metadataMap);
            }
            has(name2) {
              return this._metadataMap.has(name2);
            }
          }
          exports2.Metadata = Metadata;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.OptionalContentConfig = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          class OptionalContentGroup {
            constructor(name2, intent) {
              this.visible = true;
              this.name = name2;
              this.intent = intent;
            }
          }
          class OptionalContentConfig {
            constructor(data2) {
              this.name = null;
              this.creator = null;
              this._order = null;
              this._groups = /* @__PURE__ */ new Map();
              if (data2 === null) {
                return;
              }
              this.name = data2.name;
              this.creator = data2.creator;
              this._order = data2.order;
              for (const group of data2.groups) {
                this._groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
              }
              if (data2.baseState === "OFF") {
                for (const group of this._groups) {
                  group.visible = false;
                }
              }
              for (const on of data2.on) {
                this._groups.get(on).visible = true;
              }
              for (const off of data2.off) {
                this._groups.get(off).visible = false;
              }
            }
            isVisible(group) {
              if (group.type === "OCG") {
                if (!this._groups.has(group.id)) {
                  (0, _util2.warn)(`Optional content group not found: ${group.id}`);
                  return true;
                }
                return this._groups.get(group.id).visible;
              } else if (group.type === "OCMD") {
                if (group.expression) {
                  (0, _util2.warn)("Visibility expression not supported yet.");
                }
                if (!group.policy || group.policy === "AnyOn") {
                  for (const id of group.ids) {
                    if (!this._groups.has(id)) {
                      (0, _util2.warn)(`Optional content group not found: ${id}`);
                      return true;
                    }
                    if (this._groups.get(id).visible) {
                      return true;
                    }
                  }
                  return false;
                } else if (group.policy === "AllOn") {
                  for (const id of group.ids) {
                    if (!this._groups.has(id)) {
                      (0, _util2.warn)(`Optional content group not found: ${id}`);
                      return true;
                    }
                    if (!this._groups.get(id).visible) {
                      return false;
                    }
                  }
                  return true;
                } else if (group.policy === "AnyOff") {
                  for (const id of group.ids) {
                    if (!this._groups.has(id)) {
                      (0, _util2.warn)(`Optional content group not found: ${id}`);
                      return true;
                    }
                    if (!this._groups.get(id).visible) {
                      return true;
                    }
                  }
                  return false;
                } else if (group.policy === "AllOff") {
                  for (const id of group.ids) {
                    if (!this._groups.has(id)) {
                      (0, _util2.warn)(`Optional content group not found: ${id}`);
                      return true;
                    }
                    if (this._groups.get(id).visible) {
                      return false;
                    }
                  }
                  return true;
                }
                (0, _util2.warn)(`Unknown optional content policy ${group.policy}.`);
                return true;
              }
              (0, _util2.warn)(`Unknown group type ${group.type}.`);
              return true;
            }
            setVisibility(id, visible = true) {
              if (!this._groups.has(id)) {
                (0, _util2.warn)(`Optional content group not found: ${id}`);
                return;
              }
              this._groups.get(id).visible = !!visible;
            }
            getOrder() {
              if (!this._groups.size) {
                return null;
              }
              if (this._order) {
                return this._order.slice();
              }
              return Array.from(this._groups.keys());
            }
            getGroups() {
              return this._groups.size > 0 ? (0, _util2.objectFromMap)(this._groups) : null;
            }
            getGroup(id) {
              return this._groups.get(id) || null;
            }
          }
          exports2.OptionalContentConfig = OptionalContentConfig;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFDataTransportStream = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          var _display_utils2 = __w_pdfjs_require__2(1);
          class PDFDataTransportStream {
            constructor(params, pdfDataRangeTransport) {
              (0, _util2.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
              this._queuedChunks = [];
              this._progressiveDone = params.progressiveDone || false;
              this._contentDispositionFilename = params.contentDispositionFilename || null;
              const initialData = params.initialData;
              if ((initialData == null ? void 0 : initialData.length) > 0) {
                const buffer2 = new Uint8Array(initialData).buffer;
                this._queuedChunks.push(buffer2);
              }
              this._pdfDataRangeTransport = pdfDataRangeTransport;
              this._isStreamingSupported = !params.disableStream;
              this._isRangeSupported = !params.disableRange;
              this._contentLength = params.length;
              this._fullRequestReader = null;
              this._rangeReaders = [];
              this._pdfDataRangeTransport.addRangeListener((begin, chunk) => {
                this._onReceiveData({
                  begin,
                  chunk
                });
              });
              this._pdfDataRangeTransport.addProgressListener((loaded, total) => {
                this._onProgress({
                  loaded,
                  total
                });
              });
              this._pdfDataRangeTransport.addProgressiveReadListener((chunk) => {
                this._onReceiveData({
                  chunk
                });
              });
              this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                this._onProgressiveDone();
              });
              this._pdfDataRangeTransport.transportReady();
            }
            _onReceiveData(args) {
              const buffer2 = new Uint8Array(args.chunk).buffer;
              if (args.begin === void 0) {
                if (this._fullRequestReader) {
                  this._fullRequestReader._enqueue(buffer2);
                } else {
                  this._queuedChunks.push(buffer2);
                }
              } else {
                const found = this._rangeReaders.some(function(rangeReader) {
                  if (rangeReader._begin !== args.begin) {
                    return false;
                  }
                  rangeReader._enqueue(buffer2);
                  return true;
                });
                (0, _util2.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
              }
            }
            get _progressiveDataLength() {
              var _a2, _b;
              return (_b = (_a2 = this._fullRequestReader) == null ? void 0 : _a2._loaded) != null ? _b : 0;
            }
            _onProgress(evt) {
              if (evt.total === void 0) {
                const firstReader = this._rangeReaders[0];
                if (firstReader == null ? void 0 : firstReader.onProgress) {
                  firstReader.onProgress({
                    loaded: evt.loaded
                  });
                }
              } else {
                const fullReader = this._fullRequestReader;
                if (fullReader == null ? void 0 : fullReader.onProgress) {
                  fullReader.onProgress({
                    loaded: evt.loaded,
                    total: evt.total
                  });
                }
              }
            }
            _onProgressiveDone() {
              if (this._fullRequestReader) {
                this._fullRequestReader.progressiveDone();
              }
              this._progressiveDone = true;
            }
            _removeRangeReader(reader) {
              const i = this._rangeReaders.indexOf(reader);
              if (i >= 0) {
                this._rangeReaders.splice(i, 1);
              }
            }
            getFullReader() {
              (0, _util2.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
              const queuedChunks = this._queuedChunks;
              this._queuedChunks = null;
              return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
            }
            getRangeReader(begin, end) {
              if (end <= this._progressiveDataLength) {
                return null;
              }
              const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
              this._pdfDataRangeTransport.requestDataRange(begin, end);
              this._rangeReaders.push(reader);
              return reader;
            }
            cancelAllRequests(reason) {
              if (this._fullRequestReader) {
                this._fullRequestReader.cancel(reason);
              }
              const readers = this._rangeReaders.slice(0);
              readers.forEach(function(rangeReader) {
                rangeReader.cancel(reason);
              });
              this._pdfDataRangeTransport.abort();
            }
          }
          exports2.PDFDataTransportStream = PDFDataTransportStream;
          class PDFDataTransportStreamReader {
            constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null) {
              this._stream = stream;
              this._done = progressiveDone || false;
              this._filename = (0, _display_utils2.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
              this._queuedChunks = queuedChunks || [];
              this._loaded = 0;
              for (const chunk of this._queuedChunks) {
                this._loaded += chunk.byteLength;
              }
              this._requests = [];
              this._headersReady = Promise.resolve();
              stream._fullRequestReader = this;
              this.onProgress = null;
            }
            _enqueue(chunk) {
              if (this._done) {
                return;
              }
              if (this._requests.length > 0) {
                const requestCapability = this._requests.shift();
                requestCapability.resolve({
                  value: chunk,
                  done: false
                });
              } else {
                this._queuedChunks.push(chunk);
              }
              this._loaded += chunk.byteLength;
            }
            get headersReady() {
              return this._headersReady;
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._stream._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._stream._isStreamingSupported;
            }
            get contentLength() {
              return this._stream._contentLength;
            }
            async read() {
              if (this._queuedChunks.length > 0) {
                const chunk = this._queuedChunks.shift();
                return {
                  value: chunk,
                  done: false
                };
              }
              if (this._done) {
                return {
                  value: void 0,
                  done: true
                };
              }
              const requestCapability = (0, _util2.createPromiseCapability)();
              this._requests.push(requestCapability);
              return requestCapability.promise;
            }
            cancel(reason) {
              this._done = true;
              this._requests.forEach(function(requestCapability) {
                requestCapability.resolve({
                  value: void 0,
                  done: true
                });
              });
              this._requests = [];
            }
            progressiveDone() {
              if (this._done) {
                return;
              }
              this._done = true;
            }
          }
          class PDFDataTransportStreamRangeReader {
            constructor(stream, begin, end) {
              this._stream = stream;
              this._begin = begin;
              this._end = end;
              this._queuedChunk = null;
              this._requests = [];
              this._done = false;
              this.onProgress = null;
            }
            _enqueue(chunk) {
              if (this._done) {
                return;
              }
              if (this._requests.length === 0) {
                this._queuedChunk = chunk;
              } else {
                const requestsCapability = this._requests.shift();
                requestsCapability.resolve({
                  value: chunk,
                  done: false
                });
                this._requests.forEach(function(requestCapability) {
                  requestCapability.resolve({
                    value: void 0,
                    done: true
                  });
                });
                this._requests = [];
              }
              this._done = true;
              this._stream._removeRangeReader(this);
            }
            get isStreamingSupported() {
              return false;
            }
            async read() {
              if (this._queuedChunk) {
                const chunk = this._queuedChunk;
                this._queuedChunk = null;
                return {
                  value: chunk,
                  done: false
                };
              }
              if (this._done) {
                return {
                  value: void 0,
                  done: true
                };
              }
              const requestCapability = (0, _util2.createPromiseCapability)();
              this._requests.push(requestCapability);
              return requestCapability.promise;
            }
            cancel(reason) {
              this._done = true;
              this._requests.forEach(function(requestCapability) {
                requestCapability.resolve({
                  value: void 0,
                  done: true
                });
              });
              this._requests = [];
              this._stream._removeRangeReader(this);
            }
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.WebGLContext = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          class WebGLContext {
            constructor({
              enable = false
            }) {
              this._enabled = enable === true;
            }
            get isEnabled() {
              let enabled = this._enabled;
              if (enabled) {
                enabled = WebGLUtils.tryInitGL();
              }
              return (0, _util2.shadow)(this, "isEnabled", enabled);
            }
            composeSMask({
              layer,
              mask,
              properties
            }) {
              return WebGLUtils.composeSMask(layer, mask, properties);
            }
            drawFigures({
              width: width2,
              height: height2,
              backgroundColor,
              figures,
              context
            }) {
              return WebGLUtils.drawFigures(width2, height2, backgroundColor, figures, context);
            }
            clear() {
              WebGLUtils.cleanup();
            }
          }
          exports2.WebGLContext = WebGLContext;
          const WebGLUtils = function WebGLUtilsClosure() {
            function loadShader(gl, code, shaderType) {
              const shader = gl.createShader(shaderType);
              gl.shaderSource(shader, code);
              gl.compileShader(shader);
              const compiled = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
              if (!compiled) {
                const errorMsg = gl.getShaderInfoLog(shader);
                throw new Error("Error during shader compilation: " + errorMsg);
              }
              return shader;
            }
            function createVertexShader(gl, code) {
              return loadShader(gl, code, gl.VERTEX_SHADER);
            }
            function createFragmentShader(gl, code) {
              return loadShader(gl, code, gl.FRAGMENT_SHADER);
            }
            function createProgram(gl, shaders) {
              const program = gl.createProgram();
              for (let i = 0, ii = shaders.length; i < ii; ++i) {
                gl.attachShader(program, shaders[i]);
              }
              gl.linkProgram(program);
              const linked = gl.getProgramParameter(program, gl.LINK_STATUS);
              if (!linked) {
                const errorMsg = gl.getProgramInfoLog(program);
                throw new Error("Error during program linking: " + errorMsg);
              }
              return program;
            }
            function createTexture(gl, image, textureId) {
              gl.activeTexture(textureId);
              const texture = gl.createTexture();
              gl.bindTexture(gl.TEXTURE_2D, texture);
              gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
              gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
              gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
              gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
              gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
              return texture;
            }
            let currentGL, currentCanvas;
            function generateGL() {
              if (currentGL) {
                return;
              }
              currentCanvas = document.createElement("canvas");
              currentGL = currentCanvas.getContext("webgl", {
                premultipliedalpha: false
              });
            }
            const smaskVertexShaderCode = "  attribute vec2 a_position;                                      attribute vec2 a_texCoord;                                                                                                      uniform vec2 u_resolution;                                                                                                      varying vec2 v_texCoord;                                                                                                        void main() {                                                     vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;       gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);                                                                              v_texCoord = a_texCoord;                                      }                                                             ";
            const smaskFragmentShaderCode = "  precision mediump float;                                                                                                        uniform vec4 u_backdrop;                                        uniform int u_subtype;                                          uniform sampler2D u_image;                                      uniform sampler2D u_mask;                                                                                                       varying vec2 v_texCoord;                                                                                                        void main() {                                                     vec4 imageColor = texture2D(u_image, v_texCoord);               vec4 maskColor = texture2D(u_mask, v_texCoord);                 if (u_backdrop.a > 0.0) {                                         maskColor.rgb = maskColor.rgb * maskColor.a +                                   u_backdrop.rgb * (1.0 - maskColor.a);         }                                                               float lum;                                                      if (u_subtype == 0) {                                             lum = maskColor.a;                                            } else {                                                          lum = maskColor.r * 0.3 + maskColor.g * 0.59 +                        maskColor.b * 0.11;                                     }                                                               imageColor.a *= lum;                                            imageColor.rgb *= imageColor.a;                                 gl_FragColor = imageColor;                                    }                                                             ";
            let smaskCache = null;
            function initSmaskGL() {
              generateGL();
              const canvas = currentCanvas;
              currentCanvas = null;
              const gl = currentGL;
              currentGL = null;
              const vertexShader = createVertexShader(gl, smaskVertexShaderCode);
              const fragmentShader = createFragmentShader(gl, smaskFragmentShaderCode);
              const program = createProgram(gl, [vertexShader, fragmentShader]);
              gl.useProgram(program);
              const cache = {};
              cache.gl = gl;
              cache.canvas = canvas;
              cache.resolutionLocation = gl.getUniformLocation(program, "u_resolution");
              cache.positionLocation = gl.getAttribLocation(program, "a_position");
              cache.backdropLocation = gl.getUniformLocation(program, "u_backdrop");
              cache.subtypeLocation = gl.getUniformLocation(program, "u_subtype");
              const texCoordLocation = gl.getAttribLocation(program, "a_texCoord");
              const texLayerLocation = gl.getUniformLocation(program, "u_image");
              const texMaskLocation = gl.getUniformLocation(program, "u_mask");
              const texCoordBuffer = gl.createBuffer();
              gl.bindBuffer(gl.ARRAY_BUFFER, texCoordBuffer);
              gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]), gl.STATIC_DRAW);
              gl.enableVertexAttribArray(texCoordLocation);
              gl.vertexAttribPointer(texCoordLocation, 2, gl.FLOAT, false, 0, 0);
              gl.uniform1i(texLayerLocation, 0);
              gl.uniform1i(texMaskLocation, 1);
              smaskCache = cache;
            }
            function composeSMask(layer, mask, properties) {
              const width2 = layer.width, height2 = layer.height;
              if (!smaskCache) {
                initSmaskGL();
              }
              const cache = smaskCache, canvas = cache.canvas, gl = cache.gl;
              canvas.width = width2;
              canvas.height = height2;
              gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
              gl.uniform2f(cache.resolutionLocation, width2, height2);
              if (properties.backdrop) {
                gl.uniform4f(cache.resolutionLocation, properties.backdrop[0], properties.backdrop[1], properties.backdrop[2], 1);
              } else {
                gl.uniform4f(cache.resolutionLocation, 0, 0, 0, 0);
              }
              gl.uniform1i(cache.subtypeLocation, properties.subtype === "Luminosity" ? 1 : 0);
              const texture = createTexture(gl, layer, gl.TEXTURE0);
              const maskTexture = createTexture(gl, mask, gl.TEXTURE1);
              const buffer2 = gl.createBuffer();
              gl.bindBuffer(gl.ARRAY_BUFFER, buffer2);
              gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, width2, 0, 0, height2, 0, height2, width2, 0, width2, height2]), gl.STATIC_DRAW);
              gl.enableVertexAttribArray(cache.positionLocation);
              gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
              gl.clearColor(0, 0, 0, 0);
              gl.enable(gl.BLEND);
              gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
              gl.clear(gl.COLOR_BUFFER_BIT);
              gl.drawArrays(gl.TRIANGLES, 0, 6);
              gl.flush();
              gl.deleteTexture(texture);
              gl.deleteTexture(maskTexture);
              gl.deleteBuffer(buffer2);
              return canvas;
            }
            const figuresVertexShaderCode = "  attribute vec2 a_position;                                      attribute vec3 a_color;                                                                                                         uniform vec2 u_resolution;                                      uniform vec2 u_scale;                                           uniform vec2 u_offset;                                                                                                          varying vec4 v_color;                                                                                                           void main() {                                                     vec2 position = (a_position + u_offset) * u_scale;              vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;         gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);                                                                              v_color = vec4(a_color / 255.0, 1.0);                         }                                                             ";
            const figuresFragmentShaderCode = "  precision mediump float;                                                                                                        varying vec4 v_color;                                                                                                           void main() {                                                     gl_FragColor = v_color;                                       }                                                             ";
            let figuresCache = null;
            function initFiguresGL() {
              generateGL();
              const canvas = currentCanvas;
              currentCanvas = null;
              const gl = currentGL;
              currentGL = null;
              const vertexShader = createVertexShader(gl, figuresVertexShaderCode);
              const fragmentShader = createFragmentShader(gl, figuresFragmentShaderCode);
              const program = createProgram(gl, [vertexShader, fragmentShader]);
              gl.useProgram(program);
              const cache = {};
              cache.gl = gl;
              cache.canvas = canvas;
              cache.resolutionLocation = gl.getUniformLocation(program, "u_resolution");
              cache.scaleLocation = gl.getUniformLocation(program, "u_scale");
              cache.offsetLocation = gl.getUniformLocation(program, "u_offset");
              cache.positionLocation = gl.getAttribLocation(program, "a_position");
              cache.colorLocation = gl.getAttribLocation(program, "a_color");
              figuresCache = cache;
            }
            function drawFigures(width2, height2, backgroundColor, figures, context) {
              if (!figuresCache) {
                initFiguresGL();
              }
              const cache = figuresCache, canvas = cache.canvas, gl = cache.gl;
              canvas.width = width2;
              canvas.height = height2;
              gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
              gl.uniform2f(cache.resolutionLocation, width2, height2);
              let count = 0;
              for (let i = 0, ii = figures.length; i < ii; i++) {
                switch (figures[i].type) {
                  case "lattice":
                    const rows = figures[i].coords.length / figures[i].verticesPerRow | 0;
                    count += (rows - 1) * (figures[i].verticesPerRow - 1) * 6;
                    break;
                  case "triangles":
                    count += figures[i].coords.length;
                    break;
                }
              }
              const coords = new Float32Array(count * 2);
              const colors = new Uint8Array(count * 3);
              const coordsMap = context.coords, colorsMap = context.colors;
              let pIndex = 0, cIndex = 0;
              for (let i = 0, ii = figures.length; i < ii; i++) {
                const figure = figures[i], ps = figure.coords, cs = figure.colors;
                switch (figure.type) {
                  case "lattice":
                    const cols = figure.verticesPerRow;
                    const rows = ps.length / cols | 0;
                    for (let row = 1; row < rows; row++) {
                      let offset = row * cols + 1;
                      for (let col = 1; col < cols; col++, offset++) {
                        coords[pIndex] = coordsMap[ps[offset - cols - 1]];
                        coords[pIndex + 1] = coordsMap[ps[offset - cols - 1] + 1];
                        coords[pIndex + 2] = coordsMap[ps[offset - cols]];
                        coords[pIndex + 3] = coordsMap[ps[offset - cols] + 1];
                        coords[pIndex + 4] = coordsMap[ps[offset - 1]];
                        coords[pIndex + 5] = coordsMap[ps[offset - 1] + 1];
                        colors[cIndex] = colorsMap[cs[offset - cols - 1]];
                        colors[cIndex + 1] = colorsMap[cs[offset - cols - 1] + 1];
                        colors[cIndex + 2] = colorsMap[cs[offset - cols - 1] + 2];
                        colors[cIndex + 3] = colorsMap[cs[offset - cols]];
                        colors[cIndex + 4] = colorsMap[cs[offset - cols] + 1];
                        colors[cIndex + 5] = colorsMap[cs[offset - cols] + 2];
                        colors[cIndex + 6] = colorsMap[cs[offset - 1]];
                        colors[cIndex + 7] = colorsMap[cs[offset - 1] + 1];
                        colors[cIndex + 8] = colorsMap[cs[offset - 1] + 2];
                        coords[pIndex + 6] = coords[pIndex + 2];
                        coords[pIndex + 7] = coords[pIndex + 3];
                        coords[pIndex + 8] = coords[pIndex + 4];
                        coords[pIndex + 9] = coords[pIndex + 5];
                        coords[pIndex + 10] = coordsMap[ps[offset]];
                        coords[pIndex + 11] = coordsMap[ps[offset] + 1];
                        colors[cIndex + 9] = colors[cIndex + 3];
                        colors[cIndex + 10] = colors[cIndex + 4];
                        colors[cIndex + 11] = colors[cIndex + 5];
                        colors[cIndex + 12] = colors[cIndex + 6];
                        colors[cIndex + 13] = colors[cIndex + 7];
                        colors[cIndex + 14] = colors[cIndex + 8];
                        colors[cIndex + 15] = colorsMap[cs[offset]];
                        colors[cIndex + 16] = colorsMap[cs[offset] + 1];
                        colors[cIndex + 17] = colorsMap[cs[offset] + 2];
                        pIndex += 12;
                        cIndex += 18;
                      }
                    }
                    break;
                  case "triangles":
                    for (let j = 0, jj = ps.length; j < jj; j++) {
                      coords[pIndex] = coordsMap[ps[j]];
                      coords[pIndex + 1] = coordsMap[ps[j] + 1];
                      colors[cIndex] = colorsMap[cs[j]];
                      colors[cIndex + 1] = colorsMap[cs[j] + 1];
                      colors[cIndex + 2] = colorsMap[cs[j] + 2];
                      pIndex += 2;
                      cIndex += 3;
                    }
                    break;
                }
              }
              if (backgroundColor) {
                gl.clearColor(backgroundColor[0] / 255, backgroundColor[1] / 255, backgroundColor[2] / 255, 1);
              } else {
                gl.clearColor(0, 0, 0, 0);
              }
              gl.clear(gl.COLOR_BUFFER_BIT);
              const coordsBuffer = gl.createBuffer();
              gl.bindBuffer(gl.ARRAY_BUFFER, coordsBuffer);
              gl.bufferData(gl.ARRAY_BUFFER, coords, gl.STATIC_DRAW);
              gl.enableVertexAttribArray(cache.positionLocation);
              gl.vertexAttribPointer(cache.positionLocation, 2, gl.FLOAT, false, 0, 0);
              const colorsBuffer = gl.createBuffer();
              gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
              gl.bufferData(gl.ARRAY_BUFFER, colors, gl.STATIC_DRAW);
              gl.enableVertexAttribArray(cache.colorLocation);
              gl.vertexAttribPointer(cache.colorLocation, 3, gl.UNSIGNED_BYTE, false, 0, 0);
              gl.uniform2f(cache.scaleLocation, context.scaleX, context.scaleY);
              gl.uniform2f(cache.offsetLocation, context.offsetX, context.offsetY);
              gl.drawArrays(gl.TRIANGLES, 0, count);
              gl.flush();
              gl.deleteBuffer(coordsBuffer);
              gl.deleteBuffer(colorsBuffer);
              return canvas;
            }
            return {
              tryInitGL() {
                try {
                  generateGL();
                  return !!currentGL;
                } catch (ex) {
                }
                return false;
              },
              composeSMask,
              drawFigures,
              cleanup() {
                if (smaskCache == null ? void 0 : smaskCache.canvas) {
                  smaskCache.canvas.width = 0;
                  smaskCache.canvas.height = 0;
                }
                if (figuresCache == null ? void 0 : figuresCache.canvas) {
                  figuresCache.canvas.width = 0;
                  figuresCache.canvas.height = 0;
                }
                smaskCache = null;
                figuresCache = null;
              }
            };
          }();
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.AnnotationLayer = void 0;
          var _display_utils2 = __w_pdfjs_require__2(1);
          var _util2 = __w_pdfjs_require__2(2);
          var _annotation_storage2 = __w_pdfjs_require__2(8);
          var _scripting_utils = __w_pdfjs_require__2(19);
          class AnnotationElementFactory {
            static create(parameters) {
              const subtype = parameters.data.annotationType;
              switch (subtype) {
                case _util2.AnnotationType.LINK:
                  return new LinkAnnotationElement(parameters);
                case _util2.AnnotationType.TEXT:
                  return new TextAnnotationElement(parameters);
                case _util2.AnnotationType.WIDGET:
                  const fieldType = parameters.data.fieldType;
                  switch (fieldType) {
                    case "Tx":
                      return new TextWidgetAnnotationElement(parameters);
                    case "Btn":
                      if (parameters.data.radioButton) {
                        return new RadioButtonWidgetAnnotationElement(parameters);
                      } else if (parameters.data.checkBox) {
                        return new CheckboxWidgetAnnotationElement(parameters);
                      }
                      return new PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                      return new ChoiceWidgetAnnotationElement(parameters);
                  }
                  return new WidgetAnnotationElement(parameters);
                case _util2.AnnotationType.POPUP:
                  return new PopupAnnotationElement(parameters);
                case _util2.AnnotationType.FREETEXT:
                  return new FreeTextAnnotationElement(parameters);
                case _util2.AnnotationType.LINE:
                  return new LineAnnotationElement(parameters);
                case _util2.AnnotationType.SQUARE:
                  return new SquareAnnotationElement(parameters);
                case _util2.AnnotationType.CIRCLE:
                  return new CircleAnnotationElement(parameters);
                case _util2.AnnotationType.POLYLINE:
                  return new PolylineAnnotationElement(parameters);
                case _util2.AnnotationType.CARET:
                  return new CaretAnnotationElement(parameters);
                case _util2.AnnotationType.INK:
                  return new InkAnnotationElement(parameters);
                case _util2.AnnotationType.POLYGON:
                  return new PolygonAnnotationElement(parameters);
                case _util2.AnnotationType.HIGHLIGHT:
                  return new HighlightAnnotationElement(parameters);
                case _util2.AnnotationType.UNDERLINE:
                  return new UnderlineAnnotationElement(parameters);
                case _util2.AnnotationType.SQUIGGLY:
                  return new SquigglyAnnotationElement(parameters);
                case _util2.AnnotationType.STRIKEOUT:
                  return new StrikeOutAnnotationElement(parameters);
                case _util2.AnnotationType.STAMP:
                  return new StampAnnotationElement(parameters);
                case _util2.AnnotationType.FILEATTACHMENT:
                  return new FileAttachmentAnnotationElement(parameters);
                default:
                  return new AnnotationElement(parameters);
              }
            }
          }
          class AnnotationElement {
            constructor(parameters, {
              isRenderable = false,
              ignoreBorder = false,
              createQuadrilaterals = false
            } = {}) {
              this.isRenderable = isRenderable;
              this.data = parameters.data;
              this.layer = parameters.layer;
              this.page = parameters.page;
              this.viewport = parameters.viewport;
              this.linkService = parameters.linkService;
              this.downloadManager = parameters.downloadManager;
              this.imageResourcesPath = parameters.imageResourcesPath;
              this.renderInteractiveForms = parameters.renderInteractiveForms;
              this.svgFactory = parameters.svgFactory;
              this.annotationStorage = parameters.annotationStorage;
              this.enableScripting = parameters.enableScripting;
              this.hasJSActions = parameters.hasJSActions;
              this._mouseState = parameters.mouseState;
              if (isRenderable) {
                this.container = this._createContainer(ignoreBorder);
              }
              if (createQuadrilaterals) {
                this.quadrilaterals = this._createQuadrilaterals(ignoreBorder);
              }
            }
            _createContainer(ignoreBorder = false) {
              const data2 = this.data, page = this.page, viewport = this.viewport;
              const container = document.createElement("section");
              let width2 = data2.rect[2] - data2.rect[0];
              let height2 = data2.rect[3] - data2.rect[1];
              container.setAttribute("data-annotation-id", data2.id);
              const rect = _util2.Util.normalizeRect([data2.rect[0], page.view[3] - data2.rect[1] + page.view[1], data2.rect[2], page.view[3] - data2.rect[3] + page.view[1]]);
              container.style.transform = `matrix(${viewport.transform.join(",")})`;
              container.style.transformOrigin = `${-rect[0]}px ${-rect[1]}px`;
              if (!ignoreBorder && data2.borderStyle.width > 0) {
                container.style.borderWidth = `${data2.borderStyle.width}px`;
                if (data2.borderStyle.style !== _util2.AnnotationBorderStyleType.UNDERLINE) {
                  width2 = width2 - 2 * data2.borderStyle.width;
                  height2 = height2 - 2 * data2.borderStyle.width;
                }
                const horizontalRadius = data2.borderStyle.horizontalCornerRadius;
                const verticalRadius = data2.borderStyle.verticalCornerRadius;
                if (horizontalRadius > 0 || verticalRadius > 0) {
                  const radius = `${horizontalRadius}px / ${verticalRadius}px`;
                  container.style.borderRadius = radius;
                }
                switch (data2.borderStyle.style) {
                  case _util2.AnnotationBorderStyleType.SOLID:
                    container.style.borderStyle = "solid";
                    break;
                  case _util2.AnnotationBorderStyleType.DASHED:
                    container.style.borderStyle = "dashed";
                    break;
                  case _util2.AnnotationBorderStyleType.BEVELED:
                    (0, _util2.warn)("Unimplemented border style: beveled");
                    break;
                  case _util2.AnnotationBorderStyleType.INSET:
                    (0, _util2.warn)("Unimplemented border style: inset");
                    break;
                  case _util2.AnnotationBorderStyleType.UNDERLINE:
                    container.style.borderBottomStyle = "solid";
                    break;
                }
                if (data2.color) {
                  container.style.borderColor = _util2.Util.makeHexColor(data2.color[0] | 0, data2.color[1] | 0, data2.color[2] | 0);
                } else {
                  container.style.borderWidth = 0;
                }
              }
              container.style.left = `${rect[0]}px`;
              container.style.top = `${rect[1]}px`;
              container.style.width = `${width2}px`;
              container.style.height = `${height2}px`;
              return container;
            }
            _createQuadrilaterals(ignoreBorder = false) {
              if (!this.data.quadPoints) {
                return null;
              }
              const quadrilaterals = [];
              const savedRect = this.data.rect;
              for (const quadPoint of this.data.quadPoints) {
                this.data.rect = [quadPoint[2].x, quadPoint[2].y, quadPoint[1].x, quadPoint[1].y];
                quadrilaterals.push(this._createContainer(ignoreBorder));
              }
              this.data.rect = savedRect;
              return quadrilaterals;
            }
            _createPopup(trigger2, data2) {
              let container = this.container;
              if (this.quadrilaterals) {
                trigger2 = trigger2 || this.quadrilaterals;
                container = this.quadrilaterals[0];
              }
              if (!trigger2) {
                trigger2 = document.createElement("div");
                trigger2.style.height = container.style.height;
                trigger2.style.width = container.style.width;
                container.appendChild(trigger2);
              }
              const popupElement = new PopupElement({
                container,
                trigger: trigger2,
                color: data2.color,
                title: data2.title,
                modificationDate: data2.modificationDate,
                contents: data2.contents,
                hideWrapper: true
              });
              const popup = popupElement.render();
              popup.style.left = container.style.width;
              container.appendChild(popup);
            }
            _renderQuadrilaterals(className) {
              this.quadrilaterals.forEach((quadrilateral) => {
                quadrilateral.className = className;
              });
              return this.quadrilaterals;
            }
            render() {
              (0, _util2.unreachable)("Abstract method `AnnotationElement.render` called");
            }
          }
          class LinkAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.url || parameters.data.dest || parameters.data.action || parameters.data.isTooltipOnly || parameters.data.actions && (parameters.data.actions.Action || parameters.data.actions["Mouse Up"] || parameters.data.actions["Mouse Down"]));
              super(parameters, {
                isRenderable,
                createQuadrilaterals: true
              });
            }
            render() {
              const {
                data: data2,
                linkService
              } = this;
              const link = document.createElement("a");
              if (data2.url) {
                (0, _display_utils2.addLinkAttributes)(link, {
                  url: data2.url,
                  target: data2.newWindow ? _display_utils2.LinkTarget.BLANK : linkService.externalLinkTarget,
                  rel: linkService.externalLinkRel,
                  enabled: linkService.externalLinkEnabled
                });
              } else if (data2.action) {
                this._bindNamedAction(link, data2.action);
              } else if (data2.dest) {
                this._bindLink(link, data2.dest);
              } else if (data2.actions && (data2.actions.Action || data2.actions["Mouse Up"] || data2.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data2);
              } else {
                this._bindLink(link, "");
              }
              if (this.quadrilaterals) {
                return this._renderQuadrilaterals("linkAnnotation").map((quadrilateral, index2) => {
                  const linkElement = index2 === 0 ? link : link.cloneNode();
                  quadrilateral.appendChild(linkElement);
                  return quadrilateral;
                });
              }
              this.container.className = "linkAnnotation";
              this.container.appendChild(link);
              return this.container;
            }
            _bindLink(link, destination) {
              link.href = this.linkService.getDestinationHash(destination);
              link.onclick = () => {
                if (destination) {
                  this.linkService.goToDestination(destination);
                }
                return false;
              };
              if (destination || destination === "") {
                link.className = "internalLink";
              }
            }
            _bindNamedAction(link, action) {
              link.href = this.linkService.getAnchorUrl("");
              link.onclick = () => {
                this.linkService.executeNamedAction(action);
                return false;
              };
              link.className = "internalLink";
            }
            _bindJSAction(link, data2) {
              link.href = this.linkService.getAnchorUrl("");
              const map2 = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
              for (const name2 of Object.keys(data2.actions)) {
                const jsName = map2.get(name2);
                if (!jsName) {
                  continue;
                }
                link[jsName] = () => {
                  var _a2;
                  (_a2 = this.linkService.eventBus) == null ? void 0 : _a2.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: data2.id,
                      name: name2
                    }
                  });
                  return false;
                };
              }
              link.className = "internalLink";
            }
          }
          class TextAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable
              });
            }
            render() {
              this.container.className = "textAnnotation";
              const image = document.createElement("img");
              image.style.height = this.container.style.height;
              image.style.width = this.container.style.width;
              image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
              image.alt = "[{{type}} Annotation]";
              image.dataset.l10nId = "text_annotation_type";
              image.dataset.l10nArgs = JSON.stringify({
                type: this.data.name
              });
              if (!this.data.hasPopup) {
                this._createPopup(image, this.data);
              }
              this.container.appendChild(image);
              return this.container;
            }
          }
          class WidgetAnnotationElement extends AnnotationElement {
            render() {
              if (this.data.alternativeText) {
                this.container.title = this.data.alternativeText;
              }
              return this.container;
            }
            _getKeyModifier(event) {
              return navigator.platform.includes("Win") && event.ctrlKey || navigator.platform.includes("Mac") && event.metaKey;
            }
            _setEventListener(element, baseName, eventName, valueGetter) {
              if (baseName.includes("mouse")) {
                element.addEventListener(baseName, (event) => {
                  var _a2;
                  (_a2 = this.linkService.eventBus) == null ? void 0 : _a2.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: eventName,
                      value: valueGetter(event),
                      shift: event.shiftKey,
                      modifier: this._getKeyModifier(event)
                    }
                  });
                });
              } else {
                element.addEventListener(baseName, (event) => {
                  var _a2;
                  (_a2 = this.linkService.eventBus) == null ? void 0 : _a2.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: this.data.id,
                      name: eventName,
                      value: event.target.checked
                    }
                  });
                });
              }
            }
            _setEventListeners(element, names, getter) {
              var _a2;
              for (const [baseName, eventName] of names) {
                if (eventName === "Action" || ((_a2 = this.data.actions) == null ? void 0 : _a2[eventName])) {
                  this._setEventListener(element, baseName, eventName, getter);
                }
              }
            }
            _setColor(event) {
              const {
                detail,
                target
              } = event;
              const {
                style: style2
              } = target;
              for (const name2 of ["bgColor", "fillColor", "fgColor", "textColor", "borderColor", "strokeColor"]) {
                let color = detail[name2];
                if (!color) {
                  continue;
                }
                color = _scripting_utils.ColorConverters[`${color[0]}_HTML`](color.slice(1));
                switch (name2) {
                  case "bgColor":
                  case "fillColor":
                    style2.backgroundColor = color;
                    break;
                  case "fgColor":
                  case "textColor":
                    style2.color = color;
                    break;
                  case "borderColor":
                  case "strokeColor":
                    style2.borderColor = color;
                    break;
                }
              }
            }
          }
          class TextWidgetAnnotationElement extends WidgetAnnotationElement {
            constructor(parameters) {
              const isRenderable = parameters.renderInteractiveForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
              super(parameters, {
                isRenderable
              });
            }
            render() {
              var _a2;
              const storage = this.annotationStorage;
              const id = this.data.id;
              this.container.className = "textWidgetAnnotation";
              let element = null;
              if (this.renderInteractiveForms) {
                const storedData = storage.getValue(id, {
                  value: this.data.fieldValue,
                  valueAsString: this.data.fieldValue
                });
                const textContent = storedData.valueAsString || storedData.value || "";
                const elementData = {
                  userValue: null,
                  formattedValue: null,
                  beforeInputSelectionRange: null,
                  beforeInputValue: null
                };
                if (this.data.multiLine) {
                  element = document.createElement("textarea");
                  element.textContent = textContent;
                } else {
                  element = document.createElement("input");
                  element.type = "text";
                  element.setAttribute("value", textContent);
                }
                elementData.userValue = textContent;
                element.setAttribute("id", id);
                element.addEventListener("input", function(event) {
                  storage.setValue(id, {
                    value: event.target.value
                  });
                });
                let blurListener = (event) => {
                  if (elementData.formattedValue) {
                    event.target.value = elementData.formattedValue;
                  }
                  event.target.setSelectionRange(0, 0);
                  elementData.beforeInputSelectionRange = null;
                };
                if (this.enableScripting && this.hasJSActions) {
                  element.addEventListener("focus", (event) => {
                    if (elementData.userValue) {
                      event.target.value = elementData.userValue;
                    }
                  });
                  element.addEventListener("updatefromsandbox", (event) => {
                    const {
                      detail
                    } = event;
                    const actions = {
                      value() {
                        elementData.userValue = detail.value || "";
                        storage.setValue(id, {
                          value: elementData.userValue.toString()
                        });
                        if (!elementData.formattedValue) {
                          event.target.value = elementData.userValue;
                        }
                      },
                      valueAsString() {
                        elementData.formattedValue = detail.valueAsString || "";
                        if (event.target !== document.activeElement) {
                          event.target.value = elementData.formattedValue;
                        }
                        storage.setValue(id, {
                          formattedValue: elementData.formattedValue
                        });
                      },
                      focus() {
                        setTimeout(() => event.target.focus({
                          preventScroll: false
                        }), 0);
                      },
                      userName() {
                        event.target.title = detail.userName;
                      },
                      hidden() {
                        event.target.style.visibility = detail.hidden ? "hidden" : "visible";
                        storage.setValue(id, {
                          hidden: detail.hidden
                        });
                      },
                      editable() {
                        event.target.disabled = !detail.editable;
                      },
                      selRange() {
                        const [selStart, selEnd] = detail.selRange;
                        if (selStart >= 0 && selEnd < event.target.value.length) {
                          event.target.setSelectionRange(selStart, selEnd);
                        }
                      }
                    };
                    Object.keys(detail).filter((name2) => name2 in actions).forEach((name2) => actions[name2]());
                    this._setColor(event);
                  });
                  element.addEventListener("keydown", (event) => {
                    var _a22;
                    elementData.beforeInputValue = event.target.value;
                    let commitKey = -1;
                    if (event.key === "Escape") {
                      commitKey = 0;
                    } else if (event.key === "Enter") {
                      commitKey = 2;
                    } else if (event.key === "Tab") {
                      commitKey = 3;
                    }
                    if (commitKey === -1) {
                      return;
                    }
                    elementData.userValue = event.target.value;
                    (_a22 = this.linkService.eventBus) == null ? void 0 : _a22.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id,
                        name: "Keystroke",
                        value: event.target.value,
                        willCommit: true,
                        commitKey,
                        selStart: event.target.selectionStart,
                        selEnd: event.target.selectionEnd
                      }
                    });
                  });
                  const _blurListener = blurListener;
                  blurListener = null;
                  element.addEventListener("blur", (event) => {
                    var _a22;
                    if (this._mouseState.isDown) {
                      elementData.userValue = event.target.value;
                      (_a22 = this.linkService.eventBus) == null ? void 0 : _a22.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id,
                          name: "Keystroke",
                          value: event.target.value,
                          willCommit: true,
                          commitKey: 1,
                          selStart: event.target.selectionStart,
                          selEnd: event.target.selectionEnd
                        }
                      });
                    }
                    _blurListener(event);
                  });
                  element.addEventListener("mousedown", (event) => {
                    elementData.beforeInputValue = event.target.value;
                    elementData.beforeInputSelectionRange = null;
                  });
                  element.addEventListener("keyup", (event) => {
                    if (event.target.selectionStart === event.target.selectionEnd) {
                      elementData.beforeInputSelectionRange = null;
                    }
                  });
                  element.addEventListener("select", (event) => {
                    elementData.beforeInputSelectionRange = [event.target.selectionStart, event.target.selectionEnd];
                  });
                  if ((_a2 = this.data.actions) == null ? void 0 : _a2.Keystroke) {
                    element.addEventListener("input", (event) => {
                      var _a22;
                      let selStart = -1;
                      let selEnd = -1;
                      if (elementData.beforeInputSelectionRange) {
                        [selStart, selEnd] = elementData.beforeInputSelectionRange;
                      }
                      (_a22 = this.linkService.eventBus) == null ? void 0 : _a22.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id,
                          name: "Keystroke",
                          value: elementData.beforeInputValue,
                          change: event.data,
                          willCommit: false,
                          selStart,
                          selEnd
                        }
                      });
                    });
                  }
                  this._setEventListeners(element, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.value);
                }
                if (blurListener) {
                  element.addEventListener("blur", blurListener);
                }
                element.disabled = this.data.readOnly;
                element.name = this.data.fieldName;
                if (this.data.maxLen !== null) {
                  element.maxLength = this.data.maxLen;
                }
                if (this.data.comb) {
                  const fieldWidth = this.data.rect[2] - this.data.rect[0];
                  const combWidth = fieldWidth / this.data.maxLen;
                  element.classList.add("comb");
                  element.style.letterSpacing = `calc(${combWidth}px - 1ch)`;
                }
              } else {
                element = document.createElement("div");
                element.textContent = this.data.fieldValue;
                element.style.verticalAlign = "middle";
                element.style.display = "table-cell";
              }
              this._setTextStyle(element);
              this.container.appendChild(element);
              return this.container;
            }
            _setTextStyle(element) {
              const TEXT_ALIGNMENT = ["left", "center", "right"];
              const {
                fontSize,
                fontColor
              } = this.data.defaultAppearanceData;
              const style2 = element.style;
              if (fontSize) {
                style2.fontSize = `${fontSize}px`;
              }
              style2.color = _util2.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
              if (this.data.textAlignment !== null) {
                style2.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
              }
            }
          }
          class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
            constructor(parameters) {
              super(parameters, {
                isRenderable: parameters.renderInteractiveForms
              });
            }
            render() {
              const storage = this.annotationStorage;
              const data2 = this.data;
              const id = data2.id;
              const value = storage.getValue(id, {
                value: data2.fieldValue && (data2.exportValue && data2.exportValue === data2.fieldValue || !data2.exportValue && data2.fieldValue !== "Off")
              }).value;
              this.container.className = "buttonWidgetAnnotation checkBox";
              const element = document.createElement("input");
              element.disabled = data2.readOnly;
              element.type = "checkbox";
              element.name = this.data.fieldName;
              if (value) {
                element.setAttribute("checked", true);
              }
              element.setAttribute("id", id);
              element.addEventListener("change", function(event) {
                const name2 = event.target.name;
                for (const checkbox of document.getElementsByName(name2)) {
                  if (checkbox !== event.target) {
                    checkbox.checked = false;
                    storage.setValue(checkbox.parentNode.getAttribute("data-annotation-id"), {
                      value: false
                    });
                  }
                }
                storage.setValue(id, {
                  value: event.target.checked
                });
              });
              if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("updatefromsandbox", (event) => {
                  const {
                    detail
                  } = event;
                  const actions = {
                    value() {
                      event.target.checked = detail.value !== "Off";
                      storage.setValue(id, {
                        value: event.target.checked
                      });
                    },
                    focus() {
                      setTimeout(() => event.target.focus({
                        preventScroll: false
                      }), 0);
                    },
                    hidden() {
                      event.target.style.visibility = detail.hidden ? "hidden" : "visible";
                      storage.setValue(id, {
                        hidden: detail.hidden
                      });
                    },
                    editable() {
                      event.target.disabled = !detail.editable;
                    }
                  };
                  Object.keys(detail).filter((name2) => name2 in actions).forEach((name2) => actions[name2]());
                  this._setColor(event);
                });
                this._setEventListeners(element, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.checked);
              }
              this.container.appendChild(element);
              return this.container;
            }
          }
          class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
            constructor(parameters) {
              super(parameters, {
                isRenderable: parameters.renderInteractiveForms
              });
            }
            render() {
              this.container.className = "buttonWidgetAnnotation radioButton";
              const storage = this.annotationStorage;
              const data2 = this.data;
              const id = data2.id;
              const value = storage.getValue(id, {
                value: data2.fieldValue === data2.buttonValue
              }).value;
              const element = document.createElement("input");
              element.disabled = data2.readOnly;
              element.type = "radio";
              element.name = data2.fieldName;
              if (value) {
                element.setAttribute("checked", true);
              }
              element.setAttribute("id", id);
              element.addEventListener("change", function(event) {
                const {
                  target
                } = event;
                for (const radio of document.getElementsByName(target.name)) {
                  if (radio !== target) {
                    storage.setValue(radio.getAttribute("id"), {
                      value: false
                    });
                  }
                }
                storage.setValue(id, {
                  value: target.checked
                });
              });
              if (this.enableScripting && this.hasJSActions) {
                const pdfButtonValue = data2.buttonValue;
                element.addEventListener("updatefromsandbox", (event) => {
                  const {
                    detail
                  } = event;
                  const actions = {
                    value() {
                      const checked = pdfButtonValue === detail.value;
                      for (const radio of document.getElementsByName(event.target.name)) {
                        const radioId = radio.getAttribute("id");
                        radio.checked = radioId === id && checked;
                        storage.setValue(radioId, {
                          value: radio.checked
                        });
                      }
                    },
                    focus() {
                      setTimeout(() => event.target.focus({
                        preventScroll: false
                      }), 0);
                    },
                    hidden() {
                      event.target.style.visibility = detail.hidden ? "hidden" : "visible";
                      storage.setValue(id, {
                        hidden: detail.hidden
                      });
                    },
                    editable() {
                      event.target.disabled = !detail.editable;
                    }
                  };
                  Object.keys(detail).filter((name2) => name2 in actions).forEach((name2) => actions[name2]());
                  this._setColor(event);
                });
                this._setEventListeners(element, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.checked);
              }
              this.container.appendChild(element);
              return this.container;
            }
          }
          class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
            render() {
              const container = super.render();
              container.className = "buttonWidgetAnnotation pushButton";
              if (this.data.alternativeText) {
                container.title = this.data.alternativeText;
              }
              return container;
            }
          }
          class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
            constructor(parameters) {
              super(parameters, {
                isRenderable: parameters.renderInteractiveForms
              });
            }
            render() {
              this.container.className = "choiceWidgetAnnotation";
              const storage = this.annotationStorage;
              const id = this.data.id;
              storage.getValue(id, {
                value: this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : void 0
              });
              const selectElement = document.createElement("select");
              selectElement.disabled = this.data.readOnly;
              selectElement.name = this.data.fieldName;
              selectElement.setAttribute("id", id);
              if (!this.data.combo) {
                selectElement.size = this.data.options.length;
                if (this.data.multiSelect) {
                  selectElement.multiple = true;
                }
              }
              for (const option of this.data.options) {
                const optionElement = document.createElement("option");
                optionElement.textContent = option.displayValue;
                optionElement.value = option.exportValue;
                if (this.data.fieldValue.includes(option.exportValue)) {
                  optionElement.setAttribute("selected", true);
                }
                selectElement.appendChild(optionElement);
              }
              const getValue = (event, isExport) => {
                const name2 = isExport ? "value" : "textContent";
                const options = event.target.options;
                if (!event.target.multiple) {
                  return options.selectedIndex === -1 ? null : options[options.selectedIndex][name2];
                }
                return Array.prototype.filter.call(options, (option) => option.selected).map((option) => option[name2]);
              };
              const getItems = (event) => {
                const options = event.target.options;
                return Array.prototype.map.call(options, (option) => {
                  return {
                    displayValue: option.textContent,
                    exportValue: option.value
                  };
                });
              };
              if (this.enableScripting && this.hasJSActions) {
                selectElement.addEventListener("updatefromsandbox", (event) => {
                  const {
                    detail
                  } = event;
                  const actions = {
                    value() {
                      const options = selectElement.options;
                      const value = detail.value;
                      const values = new Set(Array.isArray(value) ? value : [value]);
                      Array.prototype.forEach.call(options, (option) => {
                        option.selected = values.has(option.value);
                      });
                      storage.setValue(id, {
                        value: getValue(event, true)
                      });
                    },
                    multipleSelection() {
                      selectElement.multiple = true;
                    },
                    remove() {
                      const options = selectElement.options;
                      const index2 = detail.remove;
                      options[index2].selected = false;
                      selectElement.remove(index2);
                      if (options.length > 0) {
                        const i = Array.prototype.findIndex.call(options, (option) => option.selected);
                        if (i === -1) {
                          options[0].selected = true;
                        }
                      }
                      storage.setValue(id, {
                        value: getValue(event, true),
                        items: getItems(event)
                      });
                    },
                    clear() {
                      while (selectElement.length !== 0) {
                        selectElement.remove(0);
                      }
                      storage.setValue(id, {
                        value: null,
                        items: []
                      });
                    },
                    insert() {
                      const {
                        index: index2,
                        displayValue,
                        exportValue
                      } = detail.insert;
                      const optionElement = document.createElement("option");
                      optionElement.textContent = displayValue;
                      optionElement.value = exportValue;
                      selectElement.insertBefore(optionElement, selectElement.children[index2]);
                      storage.setValue(id, {
                        value: getValue(event, true),
                        items: getItems(event)
                      });
                    },
                    items() {
                      const {
                        items
                      } = detail;
                      while (selectElement.length !== 0) {
                        selectElement.remove(0);
                      }
                      for (const item of items) {
                        const {
                          displayValue,
                          exportValue
                        } = item;
                        const optionElement = document.createElement("option");
                        optionElement.textContent = displayValue;
                        optionElement.value = exportValue;
                        selectElement.appendChild(optionElement);
                      }
                      if (selectElement.options.length > 0) {
                        selectElement.options[0].selected = true;
                      }
                      storage.setValue(id, {
                        value: getValue(event, true),
                        items: getItems(event)
                      });
                    },
                    indices() {
                      const indices = new Set(detail.indices);
                      const options = event.target.options;
                      Array.prototype.forEach.call(options, (option, i) => {
                        option.selected = indices.has(i);
                      });
                      storage.setValue(id, {
                        value: getValue(event, true)
                      });
                    },
                    focus() {
                      setTimeout(() => event.target.focus({
                        preventScroll: false
                      }), 0);
                    },
                    hidden() {
                      event.target.style.visibility = detail.hidden ? "hidden" : "visible";
                      storage.setValue(id, {
                        hidden: detail.hidden
                      });
                    },
                    editable() {
                      event.target.disabled = !detail.editable;
                    }
                  };
                  Object.keys(detail).filter((name2) => name2 in actions).forEach((name2) => actions[name2]());
                  this._setColor(event);
                });
                selectElement.addEventListener("input", (event) => {
                  var _a2;
                  const exportValue = getValue(event, true);
                  const value = getValue(event, false);
                  storage.setValue(id, {
                    value: exportValue
                  });
                  (_a2 = this.linkService.eventBus) == null ? void 0 : _a2.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id,
                      name: "Keystroke",
                      value,
                      changeEx: exportValue,
                      willCommit: true,
                      commitKey: 1,
                      keyDown: false
                    }
                  });
                });
                this._setEventListeners(selectElement, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"]], (event) => event.target.checked);
              } else {
                selectElement.addEventListener("input", function(event) {
                  storage.setValue(id, {
                    value: getValue(event)
                  });
                });
              }
              this.container.appendChild(selectElement);
              return this.container;
            }
          }
          class PopupAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable
              });
            }
            render() {
              const IGNORE_TYPES = ["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"];
              this.container.className = "popupAnnotation";
              if (IGNORE_TYPES.includes(this.data.parentType)) {
                return this.container;
              }
              const selector = `[data-annotation-id="${this.data.parentId}"]`;
              const parentElements = this.layer.querySelectorAll(selector);
              if (parentElements.length === 0) {
                return this.container;
              }
              const popup = new PopupElement({
                container: this.container,
                trigger: Array.from(parentElements),
                color: this.data.color,
                title: this.data.title,
                modificationDate: this.data.modificationDate,
                contents: this.data.contents
              });
              const page = this.page;
              const rect = _util2.Util.normalizeRect([this.data.parentRect[0], page.view[3] - this.data.parentRect[1] + page.view[1], this.data.parentRect[2], page.view[3] - this.data.parentRect[3] + page.view[1]]);
              const popupLeft = rect[0] + this.data.parentRect[2] - this.data.parentRect[0];
              const popupTop = rect[1];
              this.container.style.transformOrigin = `${-popupLeft}px ${-popupTop}px`;
              this.container.style.left = `${popupLeft}px`;
              this.container.style.top = `${popupTop}px`;
              this.container.appendChild(popup.render());
              return this.container;
            }
          }
          class PopupElement {
            constructor(parameters) {
              this.container = parameters.container;
              this.trigger = parameters.trigger;
              this.color = parameters.color;
              this.title = parameters.title;
              this.modificationDate = parameters.modificationDate;
              this.contents = parameters.contents;
              this.hideWrapper = parameters.hideWrapper || false;
              this.pinned = false;
            }
            render() {
              const BACKGROUND_ENLIGHT = 0.7;
              const wrapper = document.createElement("div");
              wrapper.className = "popupWrapper";
              this.hideElement = this.hideWrapper ? wrapper : this.container;
              this.hideElement.hidden = true;
              const popup = document.createElement("div");
              popup.className = "popup";
              const color = this.color;
              if (color) {
                const r = BACKGROUND_ENLIGHT * (255 - color[0]) + color[0];
                const g = BACKGROUND_ENLIGHT * (255 - color[1]) + color[1];
                const b = BACKGROUND_ENLIGHT * (255 - color[2]) + color[2];
                popup.style.backgroundColor = _util2.Util.makeHexColor(r | 0, g | 0, b | 0);
              }
              const title = document.createElement("h1");
              title.textContent = this.title;
              popup.appendChild(title);
              const dateObject = _display_utils2.PDFDateString.toDateObject(this.modificationDate);
              if (dateObject) {
                const modificationDate = document.createElement("span");
                modificationDate.textContent = "{{date}}, {{time}}";
                modificationDate.dataset.l10nId = "annotation_date_string";
                modificationDate.dataset.l10nArgs = JSON.stringify({
                  date: dateObject.toLocaleDateString(),
                  time: dateObject.toLocaleTimeString()
                });
                popup.appendChild(modificationDate);
              }
              const contents = this._formatContents(this.contents);
              popup.appendChild(contents);
              if (!Array.isArray(this.trigger)) {
                this.trigger = [this.trigger];
              }
              this.trigger.forEach((element) => {
                element.addEventListener("click", this._toggle.bind(this));
                element.addEventListener("mouseover", this._show.bind(this, false));
                element.addEventListener("mouseout", this._hide.bind(this, false));
              });
              popup.addEventListener("click", this._hide.bind(this, true));
              wrapper.appendChild(popup);
              return wrapper;
            }
            _formatContents(contents) {
              const p2 = document.createElement("p");
              const lines = contents.split(/(?:\r\n?|\n)/);
              for (let i = 0, ii = lines.length; i < ii; ++i) {
                const line = lines[i];
                p2.appendChild(document.createTextNode(line));
                if (i < ii - 1) {
                  p2.appendChild(document.createElement("br"));
                }
              }
              return p2;
            }
            _toggle() {
              if (this.pinned) {
                this._hide(true);
              } else {
                this._show(true);
              }
            }
            _show(pin = false) {
              if (pin) {
                this.pinned = true;
              }
              if (this.hideElement.hidden) {
                this.hideElement.hidden = false;
                this.container.style.zIndex += 1;
              }
            }
            _hide(unpin = true) {
              if (unpin) {
                this.pinned = false;
              }
              if (!this.hideElement.hidden && !this.pinned) {
                this.hideElement.hidden = true;
                this.container.style.zIndex -= 1;
              }
            }
          }
          class FreeTextAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            render() {
              this.container.className = "freeTextAnnotation";
              if (!this.data.hasPopup) {
                this._createPopup(null, this.data);
              }
              return this.container;
            }
          }
          class LineAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            render() {
              this.container.className = "lineAnnotation";
              const data2 = this.data;
              const width2 = data2.rect[2] - data2.rect[0];
              const height2 = data2.rect[3] - data2.rect[1];
              const svg = this.svgFactory.create(width2, height2);
              const line = this.svgFactory.createElement("svg:line");
              line.setAttribute("x1", data2.rect[2] - data2.lineCoordinates[0]);
              line.setAttribute("y1", data2.rect[3] - data2.lineCoordinates[1]);
              line.setAttribute("x2", data2.rect[2] - data2.lineCoordinates[2]);
              line.setAttribute("y2", data2.rect[3] - data2.lineCoordinates[3]);
              line.setAttribute("stroke-width", data2.borderStyle.width || 1);
              line.setAttribute("stroke", "transparent");
              svg.appendChild(line);
              this.container.append(svg);
              this._createPopup(line, data2);
              return this.container;
            }
          }
          class SquareAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            render() {
              this.container.className = "squareAnnotation";
              const data2 = this.data;
              const width2 = data2.rect[2] - data2.rect[0];
              const height2 = data2.rect[3] - data2.rect[1];
              const svg = this.svgFactory.create(width2, height2);
              const borderWidth = data2.borderStyle.width;
              const square = this.svgFactory.createElement("svg:rect");
              square.setAttribute("x", borderWidth / 2);
              square.setAttribute("y", borderWidth / 2);
              square.setAttribute("width", width2 - borderWidth);
              square.setAttribute("height", height2 - borderWidth);
              square.setAttribute("stroke-width", borderWidth || 1);
              square.setAttribute("stroke", "transparent");
              square.setAttribute("fill", "none");
              svg.appendChild(square);
              this.container.append(svg);
              this._createPopup(square, data2);
              return this.container;
            }
          }
          class CircleAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            render() {
              this.container.className = "circleAnnotation";
              const data2 = this.data;
              const width2 = data2.rect[2] - data2.rect[0];
              const height2 = data2.rect[3] - data2.rect[1];
              const svg = this.svgFactory.create(width2, height2);
              const borderWidth = data2.borderStyle.width;
              const circle = this.svgFactory.createElement("svg:ellipse");
              circle.setAttribute("cx", width2 / 2);
              circle.setAttribute("cy", height2 / 2);
              circle.setAttribute("rx", width2 / 2 - borderWidth / 2);
              circle.setAttribute("ry", height2 / 2 - borderWidth / 2);
              circle.setAttribute("stroke-width", borderWidth || 1);
              circle.setAttribute("stroke", "transparent");
              circle.setAttribute("fill", "none");
              svg.appendChild(circle);
              this.container.append(svg);
              this._createPopup(circle, data2);
              return this.container;
            }
          }
          class PolylineAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
              this.containerClassName = "polylineAnnotation";
              this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.className = this.containerClassName;
              const data2 = this.data;
              const width2 = data2.rect[2] - data2.rect[0];
              const height2 = data2.rect[3] - data2.rect[1];
              const svg = this.svgFactory.create(width2, height2);
              let points = [];
              for (const coordinate of data2.vertices) {
                const x = coordinate.x - data2.rect[0];
                const y = data2.rect[3] - coordinate.y;
                points.push(x + "," + y);
              }
              points = points.join(" ");
              const polyline = this.svgFactory.createElement(this.svgElementName);
              polyline.setAttribute("points", points);
              polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
              polyline.setAttribute("stroke", "transparent");
              polyline.setAttribute("fill", "none");
              svg.appendChild(polyline);
              this.container.append(svg);
              this._createPopup(polyline, data2);
              return this.container;
            }
          }
          class PolygonAnnotationElement extends PolylineAnnotationElement {
            constructor(parameters) {
              super(parameters);
              this.containerClassName = "polygonAnnotation";
              this.svgElementName = "svg:polygon";
            }
          }
          class CaretAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            render() {
              this.container.className = "caretAnnotation";
              if (!this.data.hasPopup) {
                this._createPopup(null, this.data);
              }
              return this.container;
            }
          }
          class InkAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
              this.containerClassName = "inkAnnotation";
              this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.className = this.containerClassName;
              const data2 = this.data;
              const width2 = data2.rect[2] - data2.rect[0];
              const height2 = data2.rect[3] - data2.rect[1];
              const svg = this.svgFactory.create(width2, height2);
              for (const inkList of data2.inkLists) {
                let points = [];
                for (const coordinate of inkList) {
                  const x = coordinate.x - data2.rect[0];
                  const y = data2.rect[3] - coordinate.y;
                  points.push(`${x},${y}`);
                }
                points = points.join(" ");
                const polyline = this.svgFactory.createElement(this.svgElementName);
                polyline.setAttribute("points", points);
                polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
                polyline.setAttribute("stroke", "transparent");
                polyline.setAttribute("fill", "none");
                this._createPopup(polyline, data2);
                svg.appendChild(polyline);
              }
              this.container.append(svg);
              return this.container;
            }
          }
          class HighlightAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            render() {
              if (!this.data.hasPopup) {
                this._createPopup(null, this.data);
              }
              if (this.quadrilaterals) {
                return this._renderQuadrilaterals("highlightAnnotation");
              }
              this.container.className = "highlightAnnotation";
              return this.container;
            }
          }
          class UnderlineAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            render() {
              if (!this.data.hasPopup) {
                this._createPopup(null, this.data);
              }
              if (this.quadrilaterals) {
                return this._renderQuadrilaterals("underlineAnnotation");
              }
              this.container.className = "underlineAnnotation";
              return this.container;
            }
          }
          class SquigglyAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            render() {
              if (!this.data.hasPopup) {
                this._createPopup(null, this.data);
              }
              if (this.quadrilaterals) {
                return this._renderQuadrilaterals("squigglyAnnotation");
              }
              this.container.className = "squigglyAnnotation";
              return this.container;
            }
          }
          class StrikeOutAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true,
                createQuadrilaterals: true
              });
            }
            render() {
              if (!this.data.hasPopup) {
                this._createPopup(null, this.data);
              }
              if (this.quadrilaterals) {
                return this._renderQuadrilaterals("strikeoutAnnotation");
              }
              this.container.className = "strikeoutAnnotation";
              return this.container;
            }
          }
          class StampAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              const isRenderable = !!(parameters.data.hasPopup || parameters.data.title || parameters.data.contents);
              super(parameters, {
                isRenderable,
                ignoreBorder: true
              });
            }
            render() {
              this.container.className = "stampAnnotation";
              if (!this.data.hasPopup) {
                this._createPopup(null, this.data);
              }
              return this.container;
            }
          }
          class FileAttachmentAnnotationElement extends AnnotationElement {
            constructor(parameters) {
              super(parameters, {
                isRenderable: true
              });
              var _a2;
              const {
                filename,
                content
              } = this.data.file;
              this.filename = (0, _display_utils2.getFilenameFromUrl)(filename);
              this.content = content;
              (_a2 = this.linkService.eventBus) == null ? void 0 : _a2.dispatch("fileattachmentannotation", {
                source: this,
                id: (0, _util2.stringToPDFString)(filename),
                filename,
                content
              });
            }
            render() {
              this.container.className = "fileAttachmentAnnotation";
              const trigger2 = document.createElement("div");
              trigger2.style.height = this.container.style.height;
              trigger2.style.width = this.container.style.width;
              trigger2.addEventListener("dblclick", this._download.bind(this));
              if (!this.data.hasPopup && (this.data.title || this.data.contents)) {
                this._createPopup(trigger2, this.data);
              }
              this.container.appendChild(trigger2);
              return this.container;
            }
            _download() {
              var _a2;
              (_a2 = this.downloadManager) == null ? void 0 : _a2.openOrDownloadData(this.container, this.content, this.filename);
            }
          }
          class AnnotationLayer {
            static render(parameters) {
              const sortedAnnotations = [], popupAnnotations = [];
              for (const data2 of parameters.annotations) {
                if (!data2) {
                  continue;
                }
                if (data2.annotationType === _util2.AnnotationType.POPUP) {
                  popupAnnotations.push(data2);
                  continue;
                }
                sortedAnnotations.push(data2);
              }
              if (popupAnnotations.length) {
                sortedAnnotations.push(...popupAnnotations);
              }
              for (const data2 of sortedAnnotations) {
                const element = AnnotationElementFactory.create({
                  data: data2,
                  layer: parameters.div,
                  page: parameters.page,
                  viewport: parameters.viewport,
                  linkService: parameters.linkService,
                  downloadManager: parameters.downloadManager,
                  imageResourcesPath: parameters.imageResourcesPath || "",
                  renderInteractiveForms: parameters.renderInteractiveForms !== false,
                  svgFactory: new _display_utils2.DOMSVGFactory(),
                  annotationStorage: parameters.annotationStorage || new _annotation_storage2.AnnotationStorage(),
                  enableScripting: parameters.enableScripting,
                  hasJSActions: parameters.hasJSActions,
                  mouseState: parameters.mouseState || {
                    isDown: false
                  }
                });
                if (element.isRenderable) {
                  const rendered = element.render();
                  if (data2.hidden) {
                    rendered.style.visibility = "hidden";
                  }
                  if (Array.isArray(rendered)) {
                    for (const renderedElement of rendered) {
                      parameters.div.appendChild(renderedElement);
                    }
                  } else {
                    if (element instanceof PopupAnnotationElement) {
                      parameters.div.prepend(rendered);
                    } else {
                      parameters.div.appendChild(rendered);
                    }
                  }
                }
              }
            }
            static update(parameters) {
              const transform = `matrix(${parameters.viewport.transform.join(",")})`;
              for (const data2 of parameters.annotations) {
                const elements = parameters.div.querySelectorAll(`[data-annotation-id="${data2.id}"]`);
                if (elements) {
                  elements.forEach((element) => {
                    element.style.transform = transform;
                  });
                }
              }
              parameters.div.hidden = false;
            }
          }
          exports2.AnnotationLayer = AnnotationLayer;
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.ColorConverters = void 0;
          function makeColorComp(n) {
            return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
          }
          class ColorConverters {
            static CMYK_G([c, y, m, k]) {
              return ["G", 1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)];
            }
            static G_CMYK([g]) {
              return ["CMYK", 0, 0, 0, 1 - g];
            }
            static G_RGB([g]) {
              return ["RGB", g, g, g];
            }
            static G_HTML([g]) {
              const G = makeColorComp(g);
              return `#${G}${G}${G}`;
            }
            static RGB_G([r, g, b]) {
              return ["G", 0.3 * r + 0.59 * g + 0.11 * b];
            }
            static RGB_HTML([r, g, b]) {
              const R = makeColorComp(r);
              const G = makeColorComp(g);
              const B = makeColorComp(b);
              return `#${R}${G}${B}`;
            }
            static T_HTML() {
              return "#00000000";
            }
            static CMYK_RGB([c, y, m, k]) {
              return ["RGB", 1 - Math.min(1, c + k), 1 - Math.min(1, m + k), 1 - Math.min(1, y + k)];
            }
            static CMYK_HTML(components) {
              return this.RGB_HTML(this.CMYK_RGB(components));
            }
            static RGB_CMYK([r, g, b]) {
              const c = 1 - r;
              const m = 1 - g;
              const y = 1 - b;
              const k = Math.min(c, m, y);
              return ["CMYK", c, m, y, k];
            }
          }
          exports2.ColorConverters = ColorConverters;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.renderTextLayer = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          const renderTextLayer = function renderTextLayerClosure() {
            const MAX_TEXT_DIVS_TO_RENDER = 1e5;
            const DEFAULT_FONT_SIZE = 30;
            const DEFAULT_FONT_ASCENT = 0.8;
            const ascentCache = /* @__PURE__ */ new Map();
            const NonWhitespaceRegexp = /\S/;
            function isAllWhitespace(str) {
              return !NonWhitespaceRegexp.test(str);
            }
            function getAscent(fontFamily, ctx) {
              const cachedAscent = ascentCache.get(fontFamily);
              if (cachedAscent) {
                return cachedAscent;
              }
              ctx.save();
              ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
              const metrics = ctx.measureText("");
              let ascent = metrics.fontBoundingBoxAscent;
              let descent = Math.abs(metrics.fontBoundingBoxDescent);
              if (ascent) {
                ctx.restore();
                const ratio = ascent / (ascent + descent);
                ascentCache.set(fontFamily, ratio);
                return ratio;
              }
              ctx.strokeStyle = "red";
              ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
              ctx.strokeText("g", 0, 0);
              let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
              descent = 0;
              for (let i = pixels.length - 1 - 3; i >= 0; i -= 4) {
                if (pixels[i] > 0) {
                  descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                  break;
                }
              }
              ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
              ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
              pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
              ascent = 0;
              for (let i = 0, ii = pixels.length; i < ii; i += 4) {
                if (pixels[i] > 0) {
                  ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
                  break;
                }
              }
              ctx.restore();
              if (ascent) {
                const ratio = ascent / (ascent + descent);
                ascentCache.set(fontFamily, ratio);
                return ratio;
              }
              ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
              return DEFAULT_FONT_ASCENT;
            }
            function appendText(task, geom, styles, ctx) {
              const textDiv = document.createElement("span");
              const textDivProperties = {
                angle: 0,
                canvasWidth: 0,
                isWhitespace: false,
                originalTransform: null,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                paddingTop: 0,
                scale: 1
              };
              task._textDivs.push(textDiv);
              if (isAllWhitespace(geom.str)) {
                textDivProperties.isWhitespace = true;
                task._textDivProperties.set(textDiv, textDivProperties);
                return;
              }
              const tx = _util2.Util.transform(task._viewport.transform, geom.transform);
              let angle = Math.atan2(tx[1], tx[0]);
              const style2 = styles[geom.fontName];
              if (style2.vertical) {
                angle += Math.PI / 2;
              }
              const fontHeight = Math.hypot(tx[2], tx[3]);
              const fontAscent = fontHeight * getAscent(style2.fontFamily, ctx);
              let left, top;
              if (angle === 0) {
                left = tx[4];
                top = tx[5] - fontAscent;
              } else {
                left = tx[4] + fontAscent * Math.sin(angle);
                top = tx[5] - fontAscent * Math.cos(angle);
              }
              textDiv.style.left = `${left}px`;
              textDiv.style.top = `${top}px`;
              textDiv.style.fontSize = `${fontHeight}px`;
              textDiv.style.fontFamily = style2.fontFamily;
              textDiv.textContent = geom.str;
              textDiv.dir = geom.dir;
              if (task._fontInspectorEnabled) {
                textDiv.dataset.fontName = geom.fontName;
              }
              if (angle !== 0) {
                textDivProperties.angle = angle * (180 / Math.PI);
              }
              let shouldScaleText = false;
              if (geom.str.length > 1) {
                shouldScaleText = true;
              } else if (geom.transform[0] !== geom.transform[3]) {
                const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
                  shouldScaleText = true;
                }
              }
              if (shouldScaleText) {
                if (style2.vertical) {
                  textDivProperties.canvasWidth = geom.height * task._viewport.scale;
                } else {
                  textDivProperties.canvasWidth = geom.width * task._viewport.scale;
                }
              }
              task._textDivProperties.set(textDiv, textDivProperties);
              if (task._textContentStream) {
                task._layoutText(textDiv);
              }
              if (task._enhanceTextSelection) {
                let angleCos = 1, angleSin = 0;
                if (angle !== 0) {
                  angleCos = Math.cos(angle);
                  angleSin = Math.sin(angle);
                }
                const divWidth = (style2.vertical ? geom.height : geom.width) * task._viewport.scale;
                const divHeight = fontHeight;
                let m, b;
                if (angle !== 0) {
                  m = [angleCos, angleSin, -angleSin, angleCos, left, top];
                  b = _util2.Util.getAxialAlignedBoundingBox([0, 0, divWidth, divHeight], m);
                } else {
                  b = [left, top, left + divWidth, top + divHeight];
                }
                task._bounds.push({
                  left: b[0],
                  top: b[1],
                  right: b[2],
                  bottom: b[3],
                  div: textDiv,
                  size: [divWidth, divHeight],
                  m
                });
              }
            }
            function render2(task) {
              if (task._canceled) {
                return;
              }
              const textDivs = task._textDivs;
              const capability = task._capability;
              const textDivsLength = textDivs.length;
              if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                task._renderingDone = true;
                capability.resolve();
                return;
              }
              if (!task._textContentStream) {
                for (let i = 0; i < textDivsLength; i++) {
                  task._layoutText(textDivs[i]);
                }
              }
              task._renderingDone = true;
              capability.resolve();
            }
            function findPositiveMin(ts, offset, count) {
              let result = 0;
              for (let i = 0; i < count; i++) {
                const t2 = ts[offset++];
                if (t2 > 0) {
                  result = result ? Math.min(t2, result) : t2;
                }
              }
              return result;
            }
            function expand(task) {
              const bounds = task._bounds;
              const viewport = task._viewport;
              const expanded = expandBounds(viewport.width, viewport.height, bounds);
              for (let i = 0; i < expanded.length; i++) {
                const div = bounds[i].div;
                const divProperties = task._textDivProperties.get(div);
                if (divProperties.angle === 0) {
                  divProperties.paddingLeft = bounds[i].left - expanded[i].left;
                  divProperties.paddingTop = bounds[i].top - expanded[i].top;
                  divProperties.paddingRight = expanded[i].right - bounds[i].right;
                  divProperties.paddingBottom = expanded[i].bottom - bounds[i].bottom;
                  task._textDivProperties.set(div, divProperties);
                  continue;
                }
                const e = expanded[i], b = bounds[i];
                const m = b.m, c = m[0], s = m[1];
                const points = [[0, 0], [0, b.size[1]], [b.size[0], 0], b.size];
                const ts = new Float64Array(64);
                points.forEach(function(p2, j) {
                  const t2 = _util2.Util.applyTransform(p2, m);
                  ts[j + 0] = c && (e.left - t2[0]) / c;
                  ts[j + 4] = s && (e.top - t2[1]) / s;
                  ts[j + 8] = c && (e.right - t2[0]) / c;
                  ts[j + 12] = s && (e.bottom - t2[1]) / s;
                  ts[j + 16] = s && (e.left - t2[0]) / -s;
                  ts[j + 20] = c && (e.top - t2[1]) / c;
                  ts[j + 24] = s && (e.right - t2[0]) / -s;
                  ts[j + 28] = c && (e.bottom - t2[1]) / c;
                  ts[j + 32] = c && (e.left - t2[0]) / -c;
                  ts[j + 36] = s && (e.top - t2[1]) / -s;
                  ts[j + 40] = c && (e.right - t2[0]) / -c;
                  ts[j + 44] = s && (e.bottom - t2[1]) / -s;
                  ts[j + 48] = s && (e.left - t2[0]) / s;
                  ts[j + 52] = c && (e.top - t2[1]) / -c;
                  ts[j + 56] = s && (e.right - t2[0]) / s;
                  ts[j + 60] = c && (e.bottom - t2[1]) / -c;
                });
                const boxScale = 1 + Math.min(Math.abs(c), Math.abs(s));
                divProperties.paddingLeft = findPositiveMin(ts, 32, 16) / boxScale;
                divProperties.paddingTop = findPositiveMin(ts, 48, 16) / boxScale;
                divProperties.paddingRight = findPositiveMin(ts, 0, 16) / boxScale;
                divProperties.paddingBottom = findPositiveMin(ts, 16, 16) / boxScale;
                task._textDivProperties.set(div, divProperties);
              }
            }
            function expandBounds(width2, height2, boxes) {
              const bounds = boxes.map(function(box, i) {
                return {
                  x1: box.left,
                  y1: box.top,
                  x2: box.right,
                  y2: box.bottom,
                  index: i,
                  x1New: void 0,
                  x2New: void 0
                };
              });
              expandBoundsLTR(width2, bounds);
              const expanded = new Array(boxes.length);
              bounds.forEach(function(b) {
                const i = b.index;
                expanded[i] = {
                  left: b.x1New,
                  top: 0,
                  right: b.x2New,
                  bottom: 0
                };
              });
              boxes.map(function(box, i) {
                const e = expanded[i], b = bounds[i];
                b.x1 = box.top;
                b.y1 = width2 - e.right;
                b.x2 = box.bottom;
                b.y2 = width2 - e.left;
                b.index = i;
                b.x1New = void 0;
                b.x2New = void 0;
              });
              expandBoundsLTR(height2, bounds);
              bounds.forEach(function(b) {
                const i = b.index;
                expanded[i].top = b.x1New;
                expanded[i].bottom = b.x2New;
              });
              return expanded;
            }
            function expandBoundsLTR(width2, bounds) {
              bounds.sort(function(a, b) {
                return a.x1 - b.x1 || a.index - b.index;
              });
              const fakeBoundary = {
                x1: -Infinity,
                y1: -Infinity,
                x2: 0,
                y2: Infinity,
                index: -1,
                x1New: 0,
                x2New: 0
              };
              const horizon = [{
                start: -Infinity,
                end: Infinity,
                boundary: fakeBoundary
              }];
              bounds.forEach(function(boundary) {
                let i = 0;
                while (i < horizon.length && horizon[i].end <= boundary.y1) {
                  i++;
                }
                let j = horizon.length - 1;
                while (j >= 0 && horizon[j].start >= boundary.y2) {
                  j--;
                }
                let horizonPart, affectedBoundary;
                let q, k, maxXNew = -Infinity;
                for (q = i; q <= j; q++) {
                  horizonPart = horizon[q];
                  affectedBoundary = horizonPart.boundary;
                  let xNew;
                  if (affectedBoundary.x2 > boundary.x1) {
                    xNew = affectedBoundary.index > boundary.index ? affectedBoundary.x1New : boundary.x1;
                  } else if (affectedBoundary.x2New === void 0) {
                    xNew = (affectedBoundary.x2 + boundary.x1) / 2;
                  } else {
                    xNew = affectedBoundary.x2New;
                  }
                  if (xNew > maxXNew) {
                    maxXNew = xNew;
                  }
                }
                boundary.x1New = maxXNew;
                for (q = i; q <= j; q++) {
                  horizonPart = horizon[q];
                  affectedBoundary = horizonPart.boundary;
                  if (affectedBoundary.x2New === void 0) {
                    if (affectedBoundary.x2 > boundary.x1) {
                      if (affectedBoundary.index > boundary.index) {
                        affectedBoundary.x2New = affectedBoundary.x2;
                      }
                    } else {
                      affectedBoundary.x2New = maxXNew;
                    }
                  } else if (affectedBoundary.x2New > maxXNew) {
                    affectedBoundary.x2New = Math.max(maxXNew, affectedBoundary.x2);
                  }
                }
                const changedHorizon = [];
                let lastBoundary = null;
                for (q = i; q <= j; q++) {
                  horizonPart = horizon[q];
                  affectedBoundary = horizonPart.boundary;
                  const useBoundary = affectedBoundary.x2 > boundary.x2 ? affectedBoundary : boundary;
                  if (lastBoundary === useBoundary) {
                    changedHorizon[changedHorizon.length - 1].end = horizonPart.end;
                  } else {
                    changedHorizon.push({
                      start: horizonPart.start,
                      end: horizonPart.end,
                      boundary: useBoundary
                    });
                    lastBoundary = useBoundary;
                  }
                }
                if (horizon[i].start < boundary.y1) {
                  changedHorizon[0].start = boundary.y1;
                  changedHorizon.unshift({
                    start: horizon[i].start,
                    end: boundary.y1,
                    boundary: horizon[i].boundary
                  });
                }
                if (boundary.y2 < horizon[j].end) {
                  changedHorizon[changedHorizon.length - 1].end = boundary.y2;
                  changedHorizon.push({
                    start: boundary.y2,
                    end: horizon[j].end,
                    boundary: horizon[j].boundary
                  });
                }
                for (q = i; q <= j; q++) {
                  horizonPart = horizon[q];
                  affectedBoundary = horizonPart.boundary;
                  if (affectedBoundary.x2New !== void 0) {
                    continue;
                  }
                  let used = false;
                  for (k = i - 1; !used && k >= 0 && horizon[k].start >= affectedBoundary.y1; k--) {
                    used = horizon[k].boundary === affectedBoundary;
                  }
                  for (k = j + 1; !used && k < horizon.length && horizon[k].end <= affectedBoundary.y2; k++) {
                    used = horizon[k].boundary === affectedBoundary;
                  }
                  for (k = 0; !used && k < changedHorizon.length; k++) {
                    used = changedHorizon[k].boundary === affectedBoundary;
                  }
                  if (!used) {
                    affectedBoundary.x2New = maxXNew;
                  }
                }
                Array.prototype.splice.apply(horizon, [i, j - i + 1].concat(changedHorizon));
              });
              horizon.forEach(function(horizonPart) {
                const affectedBoundary = horizonPart.boundary;
                if (affectedBoundary.x2New === void 0) {
                  affectedBoundary.x2New = Math.max(width2, affectedBoundary.x2);
                }
              });
            }
            function TextLayerRenderTask({
              textContent,
              textContentStream,
              container,
              viewport,
              textDivs,
              textContentItemsStr,
              enhanceTextSelection
            }) {
              var _a2;
              this._textContent = textContent;
              this._textContentStream = textContentStream;
              this._container = container;
              this._document = container.ownerDocument;
              this._viewport = viewport;
              this._textDivs = textDivs || [];
              this._textContentItemsStr = textContentItemsStr || [];
              this._enhanceTextSelection = !!enhanceTextSelection;
              this._fontInspectorEnabled = !!((_a2 = globalThis.FontInspector) == null ? void 0 : _a2.enabled);
              this._reader = null;
              this._layoutTextLastFontSize = null;
              this._layoutTextLastFontFamily = null;
              this._layoutTextCtx = null;
              this._textDivProperties = /* @__PURE__ */ new WeakMap();
              this._renderingDone = false;
              this._canceled = false;
              this._capability = (0, _util2.createPromiseCapability)();
              this._renderTimer = null;
              this._bounds = [];
              this._capability.promise.finally(() => {
                if (this._layoutTextCtx) {
                  this._layoutTextCtx.canvas.width = 0;
                  this._layoutTextCtx.canvas.height = 0;
                  this._layoutTextCtx = null;
                }
              }).catch(() => {
              });
            }
            TextLayerRenderTask.prototype = {
              get promise() {
                return this._capability.promise;
              },
              cancel: function TextLayer_cancel() {
                this._canceled = true;
                if (this._reader) {
                  this._reader.cancel(new _util2.AbortException("TextLayer task cancelled."));
                  this._reader = null;
                }
                if (this._renderTimer !== null) {
                  clearTimeout(this._renderTimer);
                  this._renderTimer = null;
                }
                this._capability.reject(new Error("TextLayer task cancelled."));
              },
              _processItems(items, styleCache) {
                for (let i = 0, len = items.length; i < len; i++) {
                  this._textContentItemsStr.push(items[i].str);
                  appendText(this, items[i], styleCache, this._layoutTextCtx);
                }
              },
              _layoutText(textDiv) {
                const textDivProperties = this._textDivProperties.get(textDiv);
                if (textDivProperties.isWhitespace) {
                  return;
                }
                let transform = "";
                if (textDivProperties.canvasWidth !== 0) {
                  const {
                    fontSize,
                    fontFamily
                  } = textDiv.style;
                  if (fontSize !== this._layoutTextLastFontSize || fontFamily !== this._layoutTextLastFontFamily) {
                    this._layoutTextCtx.font = `${fontSize} ${fontFamily}`;
                    this._layoutTextLastFontSize = fontSize;
                    this._layoutTextLastFontFamily = fontFamily;
                  }
                  const {
                    width: width2
                  } = this._layoutTextCtx.measureText(textDiv.textContent);
                  if (width2 > 0) {
                    textDivProperties.scale = textDivProperties.canvasWidth / width2;
                    transform = `scaleX(${textDivProperties.scale})`;
                  }
                }
                if (textDivProperties.angle !== 0) {
                  transform = `rotate(${textDivProperties.angle}deg) ${transform}`;
                }
                if (transform.length > 0) {
                  if (this._enhanceTextSelection) {
                    textDivProperties.originalTransform = transform;
                  }
                  textDiv.style.transform = transform;
                }
                this._textDivProperties.set(textDiv, textDivProperties);
                this._container.appendChild(textDiv);
              },
              _render: function TextLayer_render(timeout) {
                const capability = (0, _util2.createPromiseCapability)();
                let styleCache = /* @__PURE__ */ Object.create(null);
                const canvas = this._document.createElement("canvas");
                canvas.height = canvas.width = DEFAULT_FONT_SIZE;
                canvas.mozOpaque = true;
                this._layoutTextCtx = canvas.getContext("2d", {
                  alpha: false
                });
                if (this._textContent) {
                  const textItems = this._textContent.items;
                  const textStyles = this._textContent.styles;
                  this._processItems(textItems, textStyles);
                  capability.resolve();
                } else if (this._textContentStream) {
                  const pump = () => {
                    this._reader.read().then(({
                      value,
                      done
                    }) => {
                      if (done) {
                        capability.resolve();
                        return;
                      }
                      Object.assign(styleCache, value.styles);
                      this._processItems(value.items, styleCache);
                      pump();
                    }, capability.reject);
                  };
                  this._reader = this._textContentStream.getReader();
                  pump();
                } else {
                  throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                }
                capability.promise.then(() => {
                  styleCache = null;
                  if (!timeout) {
                    render2(this);
                  } else {
                    this._renderTimer = setTimeout(() => {
                      render2(this);
                      this._renderTimer = null;
                    }, timeout);
                  }
                }, this._capability.reject);
              },
              expandTextDivs: function TextLayer_expandTextDivs(expandDivs) {
                if (!this._enhanceTextSelection || !this._renderingDone) {
                  return;
                }
                if (this._bounds !== null) {
                  expand(this);
                  this._bounds = null;
                }
                const transformBuf = [], paddingBuf = [];
                for (let i = 0, ii = this._textDivs.length; i < ii; i++) {
                  const div = this._textDivs[i];
                  const divProps = this._textDivProperties.get(div);
                  if (divProps.isWhitespace) {
                    continue;
                  }
                  if (expandDivs) {
                    transformBuf.length = 0;
                    paddingBuf.length = 0;
                    if (divProps.originalTransform) {
                      transformBuf.push(divProps.originalTransform);
                    }
                    if (divProps.paddingTop > 0) {
                      paddingBuf.push(`${divProps.paddingTop}px`);
                      transformBuf.push(`translateY(${-divProps.paddingTop}px)`);
                    } else {
                      paddingBuf.push(0);
                    }
                    if (divProps.paddingRight > 0) {
                      paddingBuf.push(`${divProps.paddingRight / divProps.scale}px`);
                    } else {
                      paddingBuf.push(0);
                    }
                    if (divProps.paddingBottom > 0) {
                      paddingBuf.push(`${divProps.paddingBottom}px`);
                    } else {
                      paddingBuf.push(0);
                    }
                    if (divProps.paddingLeft > 0) {
                      paddingBuf.push(`${divProps.paddingLeft / divProps.scale}px`);
                      transformBuf.push(`translateX(${-divProps.paddingLeft / divProps.scale}px)`);
                    } else {
                      paddingBuf.push(0);
                    }
                    div.style.padding = paddingBuf.join(" ");
                    if (transformBuf.length) {
                      div.style.transform = transformBuf.join(" ");
                    }
                  } else {
                    div.style.padding = null;
                    div.style.transform = divProps.originalTransform;
                  }
                }
              }
            };
            function renderTextLayer2(renderParameters) {
              const task = new TextLayerRenderTask({
                textContent: renderParameters.textContent,
                textContentStream: renderParameters.textContentStream,
                container: renderParameters.container,
                viewport: renderParameters.viewport,
                textDivs: renderParameters.textDivs,
                textContentItemsStr: renderParameters.textContentItemsStr,
                enhanceTextSelection: renderParameters.enhanceTextSelection
              });
              task._render(renderParameters.timeout);
              return task;
            }
            return renderTextLayer2;
          }();
          exports2.renderTextLayer = renderTextLayer;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.SVGGraphics = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          var _display_utils2 = __w_pdfjs_require__2(1);
          var _is_node2 = __w_pdfjs_require__2(4);
          let SVGGraphics = function() {
            throw new Error("Not implemented: SVGGraphics");
          };
          exports2.SVGGraphics = SVGGraphics;
          {
            let opListToTree = function(opList) {
              let opTree = [];
              const tmp = [];
              for (const opListElement of opList) {
                if (opListElement.fn === "save") {
                  opTree.push({
                    fnId: 92,
                    fn: "group",
                    items: []
                  });
                  tmp.push(opTree);
                  opTree = opTree[opTree.length - 1].items;
                  continue;
                }
                if (opListElement.fn === "restore") {
                  opTree = tmp.pop();
                } else {
                  opTree.push(opListElement);
                }
              }
              return opTree;
            }, pf = function(value) {
              if (Number.isInteger(value)) {
                return value.toString();
              }
              const s = value.toFixed(10);
              let i = s.length - 1;
              if (s[i] !== "0") {
                return s;
              }
              do {
                i--;
              } while (s[i] === "0");
              return s.substring(0, s[i] === "." ? i : i + 1);
            }, pm = function(m) {
              if (m[4] === 0 && m[5] === 0) {
                if (m[1] === 0 && m[2] === 0) {
                  if (m[0] === 1 && m[3] === 1) {
                    return "";
                  }
                  return `scale(${pf(m[0])} ${pf(m[3])})`;
                }
                if (m[0] === m[3] && m[1] === -m[2]) {
                  const a = Math.acos(m[0]) * 180 / Math.PI;
                  return `rotate(${pf(a)})`;
                }
              } else {
                if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
                  return `translate(${pf(m[4])} ${pf(m[5])})`;
                }
              }
              return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ${pf(m[5])})`;
            };
            const SVG_DEFAULTS = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            };
            const XML_NS = "http://www.w3.org/XML/1998/namespace";
            const XLINK_NS = "http://www.w3.org/1999/xlink";
            const LINE_CAP_STYLES = ["butt", "round", "square"];
            const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
            const convertImgDataToPng = function() {
              const PNG_HEADER = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]);
              const CHUNK_WRAPPER_SIZE = 12;
              const crcTable = new Int32Array(256);
              for (let i = 0; i < 256; i++) {
                let c = i;
                for (let h2 = 0; h2 < 8; h2++) {
                  if (c & 1) {
                    c = 3988292384 ^ c >> 1 & 2147483647;
                  } else {
                    c = c >> 1 & 2147483647;
                  }
                }
                crcTable[i] = c;
              }
              function crc32(data2, start, end) {
                let crc = -1;
                for (let i = start; i < end; i++) {
                  const a = (crc ^ data2[i]) & 255;
                  const b = crcTable[a];
                  crc = crc >>> 8 ^ b;
                }
                return crc ^ -1;
              }
              function writePngChunk(type, body, data2, offset) {
                let p2 = offset;
                const len = body.length;
                data2[p2] = len >> 24 & 255;
                data2[p2 + 1] = len >> 16 & 255;
                data2[p2 + 2] = len >> 8 & 255;
                data2[p2 + 3] = len & 255;
                p2 += 4;
                data2[p2] = type.charCodeAt(0) & 255;
                data2[p2 + 1] = type.charCodeAt(1) & 255;
                data2[p2 + 2] = type.charCodeAt(2) & 255;
                data2[p2 + 3] = type.charCodeAt(3) & 255;
                p2 += 4;
                data2.set(body, p2);
                p2 += body.length;
                const crc = crc32(data2, offset + 4, p2);
                data2[p2] = crc >> 24 & 255;
                data2[p2 + 1] = crc >> 16 & 255;
                data2[p2 + 2] = crc >> 8 & 255;
                data2[p2 + 3] = crc & 255;
              }
              function adler32(data2, start, end) {
                let a = 1;
                let b = 0;
                for (let i = start; i < end; ++i) {
                  a = (a + (data2[i] & 255)) % 65521;
                  b = (b + a) % 65521;
                }
                return b << 16 | a;
              }
              function deflateSync(literals) {
                if (!_is_node2.isNodeJS) {
                  return deflateSyncUncompressed(literals);
                }
                try {
                  let input;
                  if (parseInt(process.versions.node) >= 8) {
                    input = literals;
                  } else {
                    input = Buffer.from(literals);
                  }
                  const output = require$$5.deflateSync(input, {
                    level: 9
                  });
                  return output instanceof Uint8Array ? output : new Uint8Array(output);
                } catch (e) {
                  (0, _util2.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                }
                return deflateSyncUncompressed(literals);
              }
              function deflateSyncUncompressed(literals) {
                let len = literals.length;
                const maxBlockLength = 65535;
                const deflateBlocks = Math.ceil(len / maxBlockLength);
                const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                let pi = 0;
                idat[pi++] = 120;
                idat[pi++] = 156;
                let pos = 0;
                while (len > maxBlockLength) {
                  idat[pi++] = 0;
                  idat[pi++] = 255;
                  idat[pi++] = 255;
                  idat[pi++] = 0;
                  idat[pi++] = 0;
                  idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                  pi += maxBlockLength;
                  pos += maxBlockLength;
                  len -= maxBlockLength;
                }
                idat[pi++] = 1;
                idat[pi++] = len & 255;
                idat[pi++] = len >> 8 & 255;
                idat[pi++] = ~len & 65535 & 255;
                idat[pi++] = (~len & 65535) >> 8 & 255;
                idat.set(literals.subarray(pos), pi);
                pi += literals.length - pos;
                const adler = adler32(literals, 0, literals.length);
                idat[pi++] = adler >> 24 & 255;
                idat[pi++] = adler >> 16 & 255;
                idat[pi++] = adler >> 8 & 255;
                idat[pi++] = adler & 255;
                return idat;
              }
              function encode2(imgData, kind, forceDataSchema, isMask) {
                const width2 = imgData.width;
                const height2 = imgData.height;
                let bitDepth, colorType, lineSize;
                const bytes = imgData.data;
                switch (kind) {
                  case _util2.ImageKind.GRAYSCALE_1BPP:
                    colorType = 0;
                    bitDepth = 1;
                    lineSize = width2 + 7 >> 3;
                    break;
                  case _util2.ImageKind.RGB_24BPP:
                    colorType = 2;
                    bitDepth = 8;
                    lineSize = width2 * 3;
                    break;
                  case _util2.ImageKind.RGBA_32BPP:
                    colorType = 6;
                    bitDepth = 8;
                    lineSize = width2 * 4;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                const literals = new Uint8Array((1 + lineSize) * height2);
                let offsetLiterals = 0, offsetBytes = 0;
                for (let y = 0; y < height2; ++y) {
                  literals[offsetLiterals++] = 0;
                  literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                  offsetBytes += lineSize;
                  offsetLiterals += lineSize;
                }
                if (kind === _util2.ImageKind.GRAYSCALE_1BPP && isMask) {
                  offsetLiterals = 0;
                  for (let y = 0; y < height2; y++) {
                    offsetLiterals++;
                    for (let i = 0; i < lineSize; i++) {
                      literals[offsetLiterals++] ^= 255;
                    }
                  }
                }
                const ihdr = new Uint8Array([width2 >> 24 & 255, width2 >> 16 & 255, width2 >> 8 & 255, width2 & 255, height2 >> 24 & 255, height2 >> 16 & 255, height2 >> 8 & 255, height2 & 255, bitDepth, colorType, 0, 0, 0]);
                const idat = deflateSync(literals);
                const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                const data2 = new Uint8Array(pngLength);
                let offset = 0;
                data2.set(PNG_HEADER, offset);
                offset += PNG_HEADER.length;
                writePngChunk("IHDR", ihdr, data2, offset);
                offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                writePngChunk("IDATA", idat, data2, offset);
                offset += CHUNK_WRAPPER_SIZE + idat.length;
                writePngChunk("IEND", new Uint8Array(0), data2, offset);
                return (0, _util2.createObjectURL)(data2, "image/png", forceDataSchema);
              }
              return function convertImgDataToPng2(imgData, forceDataSchema, isMask) {
                const kind = imgData.kind === void 0 ? _util2.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                return encode2(imgData, kind, forceDataSchema, isMask);
              };
            }();
            class SVGExtraState {
              constructor() {
                this.fontSizeScale = 1;
                this.fontWeight = SVG_DEFAULTS.fontWeight;
                this.fontSize = 0;
                this.textMatrix = _util2.IDENTITY_MATRIX;
                this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
                this.leading = 0;
                this.textRenderingMode = _util2.TextRenderingMode.FILL;
                this.textMatrixScale = 1;
                this.x = 0;
                this.y = 0;
                this.lineX = 0;
                this.lineY = 0;
                this.charSpacing = 0;
                this.wordSpacing = 0;
                this.textHScale = 1;
                this.textRise = 0;
                this.fillColor = SVG_DEFAULTS.fillColor;
                this.strokeColor = "#000000";
                this.fillAlpha = 1;
                this.strokeAlpha = 1;
                this.lineWidth = 1;
                this.lineJoin = "";
                this.lineCap = "";
                this.miterLimit = 0;
                this.dashArray = [];
                this.dashPhase = 0;
                this.dependencies = [];
                this.activeClipUrl = null;
                this.clipGroup = null;
                this.maskId = "";
              }
              clone() {
                return Object.create(this);
              }
              setCurrentPoint(x, y) {
                this.x = x;
                this.y = y;
              }
            }
            let clipCount = 0;
            let maskCount = 0;
            let shadingCount = 0;
            exports2.SVGGraphics = SVGGraphics = class SVGGraphics {
              constructor(commonObjs, objs, forceDataSchema = false) {
                this.svgFactory = new _display_utils2.DOMSVGFactory();
                this.current = new SVGExtraState();
                this.transformMatrix = _util2.IDENTITY_MATRIX;
                this.transformStack = [];
                this.extraStack = [];
                this.commonObjs = commonObjs;
                this.objs = objs;
                this.pendingClip = null;
                this.pendingEOFill = false;
                this.embedFonts = false;
                this.embeddedFonts = /* @__PURE__ */ Object.create(null);
                this.cssStyle = null;
                this.forceDataSchema = !!forceDataSchema;
                this._operatorIdMapping = [];
                for (const op in _util2.OPS) {
                  this._operatorIdMapping[_util2.OPS[op]] = op;
                }
              }
              save() {
                this.transformStack.push(this.transformMatrix);
                const old = this.current;
                this.extraStack.push(old);
                this.current = old.clone();
              }
              restore() {
                this.transformMatrix = this.transformStack.pop();
                this.current = this.extraStack.pop();
                this.pendingClip = null;
                this.tgrp = null;
              }
              group(items) {
                this.save();
                this.executeOpTree(items);
                this.restore();
              }
              loadDependencies(operatorList) {
                const fnArray = operatorList.fnArray;
                const argsArray = operatorList.argsArray;
                for (let i = 0, ii = fnArray.length; i < ii; i++) {
                  if (fnArray[i] !== _util2.OPS.dependency) {
                    continue;
                  }
                  for (const obj of argsArray[i]) {
                    const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                    const promise = new Promise((resolve2) => {
                      objsPool.get(obj, resolve2);
                    });
                    this.current.dependencies.push(promise);
                  }
                }
                return Promise.all(this.current.dependencies);
              }
              transform(a, b, c, d, e, f) {
                const transformMatrix = [a, b, c, d, e, f];
                this.transformMatrix = _util2.Util.transform(this.transformMatrix, transformMatrix);
                this.tgrp = null;
              }
              getSVG(operatorList, viewport) {
                this.viewport = viewport;
                const svgElement = this._initialize(viewport);
                return this.loadDependencies(operatorList).then(() => {
                  this.transformMatrix = _util2.IDENTITY_MATRIX;
                  this.executeOpTree(this.convertOpList(operatorList));
                  return svgElement;
                });
              }
              convertOpList(operatorList) {
                const operatorIdMapping = this._operatorIdMapping;
                const argsArray = operatorList.argsArray;
                const fnArray = operatorList.fnArray;
                const opList = [];
                for (let i = 0, ii = fnArray.length; i < ii; i++) {
                  const fnId = fnArray[i];
                  opList.push({
                    fnId,
                    fn: operatorIdMapping[fnId],
                    args: argsArray[i]
                  });
                }
                return opListToTree(opList);
              }
              executeOpTree(opTree) {
                for (const opTreeElement of opTree) {
                  const fn = opTreeElement.fn;
                  const fnId = opTreeElement.fnId;
                  const args = opTreeElement.args;
                  switch (fnId | 0) {
                    case _util2.OPS.beginText:
                      this.beginText();
                      break;
                    case _util2.OPS.dependency:
                      break;
                    case _util2.OPS.setLeading:
                      this.setLeading(args);
                      break;
                    case _util2.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(args[0], args[1]);
                      break;
                    case _util2.OPS.setFont:
                      this.setFont(args);
                      break;
                    case _util2.OPS.showText:
                      this.showText(args[0]);
                      break;
                    case _util2.OPS.showSpacedText:
                      this.showText(args[0]);
                      break;
                    case _util2.OPS.endText:
                      this.endText();
                      break;
                    case _util2.OPS.moveText:
                      this.moveText(args[0], args[1]);
                      break;
                    case _util2.OPS.setCharSpacing:
                      this.setCharSpacing(args[0]);
                      break;
                    case _util2.OPS.setWordSpacing:
                      this.setWordSpacing(args[0]);
                      break;
                    case _util2.OPS.setHScale:
                      this.setHScale(args[0]);
                      break;
                    case _util2.OPS.setTextMatrix:
                      this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                      break;
                    case _util2.OPS.setTextRise:
                      this.setTextRise(args[0]);
                      break;
                    case _util2.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(args[0]);
                      break;
                    case _util2.OPS.setLineWidth:
                      this.setLineWidth(args[0]);
                      break;
                    case _util2.OPS.setLineJoin:
                      this.setLineJoin(args[0]);
                      break;
                    case _util2.OPS.setLineCap:
                      this.setLineCap(args[0]);
                      break;
                    case _util2.OPS.setMiterLimit:
                      this.setMiterLimit(args[0]);
                      break;
                    case _util2.OPS.setFillRGBColor:
                      this.setFillRGBColor(args[0], args[1], args[2]);
                      break;
                    case _util2.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(args[0], args[1], args[2]);
                      break;
                    case _util2.OPS.setStrokeColorN:
                      this.setStrokeColorN(args);
                      break;
                    case _util2.OPS.setFillColorN:
                      this.setFillColorN(args);
                      break;
                    case _util2.OPS.shadingFill:
                      this.shadingFill(args[0]);
                      break;
                    case _util2.OPS.setDash:
                      this.setDash(args[0], args[1]);
                      break;
                    case _util2.OPS.setRenderingIntent:
                      this.setRenderingIntent(args[0]);
                      break;
                    case _util2.OPS.setFlatness:
                      this.setFlatness(args[0]);
                      break;
                    case _util2.OPS.setGState:
                      this.setGState(args[0]);
                      break;
                    case _util2.OPS.fill:
                      this.fill();
                      break;
                    case _util2.OPS.eoFill:
                      this.eoFill();
                      break;
                    case _util2.OPS.stroke:
                      this.stroke();
                      break;
                    case _util2.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case _util2.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case _util2.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case _util2.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case _util2.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case _util2.OPS.paintImageXObject:
                      this.paintImageXObject(args[0]);
                      break;
                    case _util2.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(args[0]);
                      break;
                    case _util2.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(args[0]);
                      break;
                    case _util2.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(args[0], args[1]);
                      break;
                    case _util2.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case _util2.OPS.closePath:
                      this.closePath();
                      break;
                    case _util2.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case _util2.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case _util2.OPS.closeEOFillStroke:
                      this.closeEOFillStroke();
                      break;
                    case _util2.OPS.nextLine:
                      this.nextLine();
                      break;
                    case _util2.OPS.transform:
                      this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                      break;
                    case _util2.OPS.constructPath:
                      this.constructPath(args[0], args[1]);
                      break;
                    case _util2.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(opTreeElement.items);
                      break;
                    default:
                      (0, _util2.warn)(`Unimplemented operator ${fn}`);
                      break;
                  }
                }
              }
              setWordSpacing(wordSpacing) {
                this.current.wordSpacing = wordSpacing;
              }
              setCharSpacing(charSpacing) {
                this.current.charSpacing = charSpacing;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              setTextMatrix(a, b, c, d, e, f) {
                const current = this.current;
                current.textMatrix = current.lineMatrix = [a, b, c, d, e, f];
                current.textMatrixScale = Math.hypot(a, b);
                current.x = current.lineX = 0;
                current.y = current.lineY = 0;
                current.xcoords = [];
                current.ycoords = [];
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                current.txtElement = this.svgFactory.createElement("svg:text");
                current.txtElement.appendChild(current.tspan);
              }
              beginText() {
                const current = this.current;
                current.x = current.lineX = 0;
                current.y = current.lineY = 0;
                current.textMatrix = _util2.IDENTITY_MATRIX;
                current.lineMatrix = _util2.IDENTITY_MATRIX;
                current.textMatrixScale = 1;
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.txtElement = this.svgFactory.createElement("svg:text");
                current.txtgrp = this.svgFactory.createElement("svg:g");
                current.xcoords = [];
                current.ycoords = [];
              }
              moveText(x, y) {
                const current = this.current;
                current.x = current.lineX += x;
                current.y = current.lineY += y;
                current.xcoords = [];
                current.ycoords = [];
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                current.tspan.setAttributeNS(null, "y", pf(-current.y));
              }
              showText(glyphs) {
                const current = this.current;
                const font = current.font;
                const fontSize = current.fontSize;
                if (fontSize === 0) {
                  return;
                }
                const fontSizeScale = current.fontSizeScale;
                const charSpacing = current.charSpacing;
                const wordSpacing = current.wordSpacing;
                const fontDirection = current.fontDirection;
                const textHScale = current.textHScale * fontDirection;
                const vertical = font.vertical;
                const spacingDir = vertical ? 1 : -1;
                const defaultVMetrics = font.defaultVMetrics;
                const widthAdvanceScale = fontSize * current.fontMatrix[0];
                let x = 0;
                for (const glyph of glyphs) {
                  if (glyph === null) {
                    x += fontDirection * wordSpacing;
                    continue;
                  } else if ((0, _util2.isNum)(glyph)) {
                    x += spacingDir * glyph * fontSize / 1e3;
                    continue;
                  }
                  const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  const character = glyph.fontChar;
                  let scaledX, scaledY;
                  let width2 = glyph.width;
                  if (vertical) {
                    let vx;
                    const vmetric = glyph.vmetric || defaultVMetrics;
                    vx = glyph.vmetric ? vmetric[1] : width2 * 0.5;
                    vx = -vx * widthAdvanceScale;
                    const vy = vmetric[2] * widthAdvanceScale;
                    width2 = vmetric ? -vmetric[0] : width2;
                    scaledX = vx / fontSizeScale;
                    scaledY = (x + vy) / fontSizeScale;
                  } else {
                    scaledX = x / fontSizeScale;
                    scaledY = 0;
                  }
                  if (glyph.isInFont || font.missingFile) {
                    current.xcoords.push(current.x + scaledX);
                    if (vertical) {
                      current.ycoords.push(-current.y + scaledY);
                    }
                    current.tspan.textContent += character;
                  }
                  let charWidth;
                  if (vertical) {
                    charWidth = width2 * widthAdvanceScale - spacing * fontDirection;
                  } else {
                    charWidth = width2 * widthAdvanceScale + spacing * fontDirection;
                  }
                  x += charWidth;
                }
                current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                if (vertical) {
                  current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                } else {
                  current.tspan.setAttributeNS(null, "y", pf(-current.y));
                }
                if (vertical) {
                  current.y -= x;
                } else {
                  current.x += x * textHScale;
                }
                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
                  current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                }
                if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
                  current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                }
                const fillStrokeMode = current.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                  if (current.fillColor !== SVG_DEFAULTS.fillColor) {
                    current.tspan.setAttributeNS(null, "fill", current.fillColor);
                  }
                  if (current.fillAlpha < 1) {
                    current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                  }
                } else if (current.textRenderingMode === _util2.TextRenderingMode.ADD_TO_PATH) {
                  current.tspan.setAttributeNS(null, "fill", "transparent");
                } else {
                  current.tspan.setAttributeNS(null, "fill", "none");
                }
                if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                  const lineWidthScale = 1 / (current.textMatrixScale || 1);
                  this._setStrokeAttributes(current.tspan, lineWidthScale);
                }
                let textMatrix = current.textMatrix;
                if (current.textRise !== 0) {
                  textMatrix = textMatrix.slice();
                  textMatrix[5] += current.textRise;
                }
                current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                current.txtElement.appendChild(current.tspan);
                current.txtgrp.appendChild(current.txtElement);
                this._ensureTransformGroup().appendChild(current.txtElement);
              }
              setLeadingMoveText(x, y) {
                this.setLeading(-y);
                this.moveText(x, y);
              }
              addFontStyle(fontObj) {
                if (!fontObj.data) {
                  throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                }
                if (!this.cssStyle) {
                  this.cssStyle = this.svgFactory.createElement("svg:style");
                  this.cssStyle.setAttributeNS(null, "type", "text/css");
                  this.defs.appendChild(this.cssStyle);
                }
                const url = (0, _util2.createObjectURL)(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}"; src: url(${url}); }
`;
              }
              setFont(details) {
                const current = this.current;
                const fontObj = this.commonObjs.get(details[0]);
                let size2 = details[1];
                current.font = fontObj;
                if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                  this.addFontStyle(fontObj);
                  this.embeddedFonts[fontObj.loadedName] = fontObj;
                }
                current.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                let bold = "normal";
                if (fontObj.black) {
                  bold = "900";
                } else if (fontObj.bold) {
                  bold = "bold";
                }
                const italic = fontObj.italic ? "italic" : "normal";
                if (size2 < 0) {
                  size2 = -size2;
                  current.fontDirection = -1;
                } else {
                  current.fontDirection = 1;
                }
                current.fontSize = size2;
                current.fontFamily = fontObj.loadedName;
                current.fontWeight = bold;
                current.fontStyle = italic;
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                current.xcoords = [];
                current.ycoords = [];
              }
              endText() {
                var _a2;
                const current = this.current;
                if (current.textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG && ((_a2 = current.txtElement) == null ? void 0 : _a2.hasChildNodes())) {
                  current.element = current.txtElement;
                  this.clip("nonzero");
                  this.endPath();
                }
              }
              setLineWidth(width2) {
                if (width2 > 0) {
                  this.current.lineWidth = width2;
                }
              }
              setLineCap(style2) {
                this.current.lineCap = LINE_CAP_STYLES[style2];
              }
              setLineJoin(style2) {
                this.current.lineJoin = LINE_JOIN_STYLES[style2];
              }
              setMiterLimit(limit) {
                this.current.miterLimit = limit;
              }
              setStrokeAlpha(strokeAlpha) {
                this.current.strokeAlpha = strokeAlpha;
              }
              setStrokeRGBColor(r, g, b) {
                this.current.strokeColor = _util2.Util.makeHexColor(r, g, b);
              }
              setFillAlpha(fillAlpha) {
                this.current.fillAlpha = fillAlpha;
              }
              setFillRGBColor(r, g, b) {
                this.current.fillColor = _util2.Util.makeHexColor(r, g, b);
                this.current.tspan = this.svgFactory.createElement("svg:tspan");
                this.current.xcoords = [];
                this.current.ycoords = [];
              }
              setStrokeColorN(args) {
                this.current.strokeColor = this._makeColorN_Pattern(args);
              }
              setFillColorN(args) {
                this.current.fillColor = this._makeColorN_Pattern(args);
              }
              shadingFill(args) {
                const width2 = this.viewport.width;
                const height2 = this.viewport.height;
                const inv = _util2.Util.inverseTransform(this.transformMatrix);
                const bl = _util2.Util.applyTransform([0, 0], inv);
                const br = _util2.Util.applyTransform([0, height2], inv);
                const ul = _util2.Util.applyTransform([width2, 0], inv);
                const ur = _util2.Util.applyTransform([width2, height2], inv);
                const x0 = Math.min(bl[0], br[0], ul[0], ur[0]);
                const y0 = Math.min(bl[1], br[1], ul[1], ur[1]);
                const x1 = Math.max(bl[0], br[0], ul[0], ur[0]);
                const y1 = Math.max(bl[1], br[1], ul[1], ur[1]);
                const rect = this.svgFactory.createElement("svg:rect");
                rect.setAttributeNS(null, "x", x0);
                rect.setAttributeNS(null, "y", y0);
                rect.setAttributeNS(null, "width", x1 - x0);
                rect.setAttributeNS(null, "height", y1 - y0);
                rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                if (this.current.fillAlpha < 1) {
                  rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                }
                this._ensureTransformGroup().appendChild(rect);
              }
              _makeColorN_Pattern(args) {
                if (args[0] === "TilingPattern") {
                  return this._makeTilingPattern(args);
                }
                return this._makeShadingPattern(args);
              }
              _makeTilingPattern(args) {
                const color = args[1];
                const operatorList = args[2];
                const matrix = args[3] || _util2.IDENTITY_MATRIX;
                const [x0, y0, x1, y1] = args[4];
                const xstep = args[5];
                const ystep = args[6];
                const paintType = args[7];
                const tilingId = `shading${shadingCount++}`;
                const [tx0, ty0] = _util2.Util.applyTransform([x0, y0], matrix);
                const [tx1, ty1] = _util2.Util.applyTransform([x1, y1], matrix);
                const [xscale, yscale] = _util2.Util.singularValueDecompose2dScale(matrix);
                const txstep = xstep * xscale;
                const tystep = ystep * yscale;
                const tiling = this.svgFactory.createElement("svg:pattern");
                tiling.setAttributeNS(null, "id", tilingId);
                tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                tiling.setAttributeNS(null, "width", txstep);
                tiling.setAttributeNS(null, "height", tystep);
                tiling.setAttributeNS(null, "x", `${tx0}`);
                tiling.setAttributeNS(null, "y", `${ty0}`);
                const svg = this.svg;
                const transformMatrix = this.transformMatrix;
                const fillColor = this.current.fillColor;
                const strokeColor = this.current.strokeColor;
                const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                this.svg = bbox;
                this.transformMatrix = matrix;
                if (paintType === 2) {
                  const cssColor = _util2.Util.makeHexColor(...color);
                  this.current.fillColor = cssColor;
                  this.current.strokeColor = cssColor;
                }
                this.executeOpTree(this.convertOpList(operatorList));
                this.svg = svg;
                this.transformMatrix = transformMatrix;
                this.current.fillColor = fillColor;
                this.current.strokeColor = strokeColor;
                tiling.appendChild(bbox.childNodes[0]);
                this.defs.appendChild(tiling);
                return `url(#${tilingId})`;
              }
              _makeShadingPattern(args) {
                switch (args[0]) {
                  case "RadialAxial":
                    const shadingId = `shading${shadingCount++}`;
                    const colorStops = args[3];
                    let gradient;
                    switch (args[1]) {
                      case "axial":
                        const point0 = args[4];
                        const point1 = args[5];
                        gradient = this.svgFactory.createElement("svg:linearGradient");
                        gradient.setAttributeNS(null, "id", shadingId);
                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                        gradient.setAttributeNS(null, "x1", point0[0]);
                        gradient.setAttributeNS(null, "y1", point0[1]);
                        gradient.setAttributeNS(null, "x2", point1[0]);
                        gradient.setAttributeNS(null, "y2", point1[1]);
                        break;
                      case "radial":
                        const focalPoint = args[4];
                        const circlePoint = args[5];
                        const focalRadius = args[6];
                        const circleRadius = args[7];
                        gradient = this.svgFactory.createElement("svg:radialGradient");
                        gradient.setAttributeNS(null, "id", shadingId);
                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                        gradient.setAttributeNS(null, "r", circleRadius);
                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                        gradient.setAttributeNS(null, "fr", focalRadius);
                        break;
                      default:
                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                    }
                    for (const colorStop of colorStops) {
                      const stop = this.svgFactory.createElement("svg:stop");
                      stop.setAttributeNS(null, "offset", colorStop[0]);
                      stop.setAttributeNS(null, "stop-color", colorStop[1]);
                      gradient.appendChild(stop);
                    }
                    this.defs.appendChild(gradient);
                    return `url(#${shadingId})`;
                  case "Mesh":
                    (0, _util2.warn)("Unimplemented pattern Mesh");
                    return null;
                  case "Dummy":
                    return "hotpink";
                  default:
                    throw new Error(`Unknown IR type: ${args[0]}`);
                }
              }
              setDash(dashArray, dashPhase) {
                this.current.dashArray = dashArray;
                this.current.dashPhase = dashPhase;
              }
              constructPath(ops, args) {
                const current = this.current;
                let x = current.x, y = current.y;
                let d = [];
                let j = 0;
                for (const op of ops) {
                  switch (op | 0) {
                    case _util2.OPS.rectangle:
                      x = args[j++];
                      y = args[j++];
                      const width2 = args[j++];
                      const height2 = args[j++];
                      const xw = x + width2;
                      const yh = y + height2;
                      d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                      break;
                    case _util2.OPS.moveTo:
                      x = args[j++];
                      y = args[j++];
                      d.push("M", pf(x), pf(y));
                      break;
                    case _util2.OPS.lineTo:
                      x = args[j++];
                      y = args[j++];
                      d.push("L", pf(x), pf(y));
                      break;
                    case _util2.OPS.curveTo:
                      x = args[j + 4];
                      y = args[j + 5];
                      d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                      j += 6;
                      break;
                    case _util2.OPS.curveTo2:
                      d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                      x = args[j + 2];
                      y = args[j + 3];
                      j += 4;
                      break;
                    case _util2.OPS.curveTo3:
                      x = args[j + 2];
                      y = args[j + 3];
                      d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                      j += 4;
                      break;
                    case _util2.OPS.closePath:
                      d.push("Z");
                      break;
                  }
                }
                d = d.join(" ");
                if (current.path && ops.length > 0 && ops[0] !== _util2.OPS.rectangle && ops[0] !== _util2.OPS.moveTo) {
                  d = current.path.getAttributeNS(null, "d") + d;
                } else {
                  current.path = this.svgFactory.createElement("svg:path");
                  this._ensureTransformGroup().appendChild(current.path);
                }
                current.path.setAttributeNS(null, "d", d);
                current.path.setAttributeNS(null, "fill", "none");
                current.element = current.path;
                current.setCurrentPoint(x, y);
              }
              endPath() {
                const current = this.current;
                current.path = null;
                if (!this.pendingClip) {
                  return;
                }
                if (!current.element) {
                  this.pendingClip = null;
                  return;
                }
                const clipId = `clippath${clipCount++}`;
                const clipPath = this.svgFactory.createElement("svg:clipPath");
                clipPath.setAttributeNS(null, "id", clipId);
                clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                const clipElement = current.element.cloneNode(true);
                if (this.pendingClip === "evenodd") {
                  clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                } else {
                  clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                }
                this.pendingClip = null;
                clipPath.appendChild(clipElement);
                this.defs.appendChild(clipPath);
                if (current.activeClipUrl) {
                  current.clipGroup = null;
                  this.extraStack.forEach(function(prev) {
                    prev.clipGroup = null;
                  });
                  clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                }
                current.activeClipUrl = `url(#${clipId})`;
                this.tgrp = null;
              }
              clip(type) {
                this.pendingClip = type;
              }
              closePath() {
                const current = this.current;
                if (current.path) {
                  const d = `${current.path.getAttributeNS(null, "d")}Z`;
                  current.path.setAttributeNS(null, "d", d);
                }
              }
              setLeading(leading) {
                this.current.leading = -leading;
              }
              setTextRise(textRise) {
                this.current.textRise = textRise;
              }
              setTextRenderingMode(textRenderingMode) {
                this.current.textRenderingMode = textRenderingMode;
              }
              setHScale(scale) {
                this.current.textHScale = scale / 100;
              }
              setRenderingIntent(intent) {
              }
              setFlatness(flatness) {
              }
              setGState(states) {
                for (const [key, value] of states) {
                  switch (key) {
                    case "LW":
                      this.setLineWidth(value);
                      break;
                    case "LC":
                      this.setLineCap(value);
                      break;
                    case "LJ":
                      this.setLineJoin(value);
                      break;
                    case "ML":
                      this.setMiterLimit(value);
                      break;
                    case "D":
                      this.setDash(value[0], value[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(value);
                      break;
                    case "FL":
                      this.setFlatness(value);
                      break;
                    case "Font":
                      this.setFont(value);
                      break;
                    case "CA":
                      this.setStrokeAlpha(value);
                      break;
                    case "ca":
                      this.setFillAlpha(value);
                      break;
                    default:
                      (0, _util2.warn)(`Unimplemented graphic state operator ${key}`);
                      break;
                  }
                }
              }
              fill() {
                const current = this.current;
                if (current.element) {
                  current.element.setAttributeNS(null, "fill", current.fillColor);
                  current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                  this.endPath();
                }
              }
              stroke() {
                const current = this.current;
                if (current.element) {
                  this._setStrokeAttributes(current.element);
                  current.element.setAttributeNS(null, "fill", "none");
                  this.endPath();
                }
              }
              _setStrokeAttributes(element, lineWidthScale = 1) {
                const current = this.current;
                let dashArray = current.dashArray;
                if (lineWidthScale !== 1 && dashArray.length > 0) {
                  dashArray = dashArray.map(function(value) {
                    return lineWidthScale * value;
                  });
                }
                element.setAttributeNS(null, "stroke", current.strokeColor);
                element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
              }
              eoFill() {
                if (this.current.element) {
                  this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                }
                this.fill();
              }
              fillStroke() {
                this.stroke();
                this.fill();
              }
              eoFillStroke() {
                if (this.current.element) {
                  this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                }
                this.fillStroke();
              }
              closeStroke() {
                this.closePath();
                this.stroke();
              }
              closeFillStroke() {
                this.closePath();
                this.fillStroke();
              }
              closeEOFillStroke() {
                this.closePath();
                this.eoFillStroke();
              }
              paintSolidColorImageMask() {
                const rect = this.svgFactory.createElement("svg:rect");
                rect.setAttributeNS(null, "x", "0");
                rect.setAttributeNS(null, "y", "0");
                rect.setAttributeNS(null, "width", "1px");
                rect.setAttributeNS(null, "height", "1px");
                rect.setAttributeNS(null, "fill", this.current.fillColor);
                this._ensureTransformGroup().appendChild(rect);
              }
              paintImageXObject(objId) {
                const imgData = objId.startsWith("g_") ? this.commonObjs.get(objId) : this.objs.get(objId);
                if (!imgData) {
                  (0, _util2.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                  return;
                }
                this.paintInlineImageXObject(imgData);
              }
              paintInlineImageXObject(imgData, mask) {
                const width2 = imgData.width;
                const height2 = imgData.height;
                const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                const cliprect = this.svgFactory.createElement("svg:rect");
                cliprect.setAttributeNS(null, "x", "0");
                cliprect.setAttributeNS(null, "y", "0");
                cliprect.setAttributeNS(null, "width", pf(width2));
                cliprect.setAttributeNS(null, "height", pf(height2));
                this.current.element = cliprect;
                this.clip("nonzero");
                const imgEl = this.svgFactory.createElement("svg:image");
                imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                imgEl.setAttributeNS(null, "x", "0");
                imgEl.setAttributeNS(null, "y", pf(-height2));
                imgEl.setAttributeNS(null, "width", pf(width2) + "px");
                imgEl.setAttributeNS(null, "height", pf(height2) + "px");
                imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width2)} ${pf(-1 / height2)})`);
                if (mask) {
                  mask.appendChild(imgEl);
                } else {
                  this._ensureTransformGroup().appendChild(imgEl);
                }
              }
              paintImageMaskXObject(imgData) {
                const current = this.current;
                const width2 = imgData.width;
                const height2 = imgData.height;
                const fillColor = current.fillColor;
                current.maskId = `mask${maskCount++}`;
                const mask = this.svgFactory.createElement("svg:mask");
                mask.setAttributeNS(null, "id", current.maskId);
                const rect = this.svgFactory.createElement("svg:rect");
                rect.setAttributeNS(null, "x", "0");
                rect.setAttributeNS(null, "y", "0");
                rect.setAttributeNS(null, "width", pf(width2));
                rect.setAttributeNS(null, "height", pf(height2));
                rect.setAttributeNS(null, "fill", fillColor);
                rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                this.defs.appendChild(mask);
                this._ensureTransformGroup().appendChild(rect);
                this.paintInlineImageXObject(imgData, mask);
              }
              paintFormXObjectBegin(matrix, bbox) {
                if (Array.isArray(matrix) && matrix.length === 6) {
                  this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                }
                if (bbox) {
                  const width2 = bbox[2] - bbox[0];
                  const height2 = bbox[3] - bbox[1];
                  const cliprect = this.svgFactory.createElement("svg:rect");
                  cliprect.setAttributeNS(null, "x", bbox[0]);
                  cliprect.setAttributeNS(null, "y", bbox[1]);
                  cliprect.setAttributeNS(null, "width", pf(width2));
                  cliprect.setAttributeNS(null, "height", pf(height2));
                  this.current.element = cliprect;
                  this.clip("nonzero");
                  this.endPath();
                }
              }
              paintFormXObjectEnd() {
              }
              _initialize(viewport) {
                const svg = this.svgFactory.create(viewport.width, viewport.height);
                const definitions = this.svgFactory.createElement("svg:defs");
                svg.appendChild(definitions);
                this.defs = definitions;
                const rootGroup = this.svgFactory.createElement("svg:g");
                rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                svg.appendChild(rootGroup);
                this.svg = rootGroup;
                return svg;
              }
              _ensureClipGroup() {
                if (!this.current.clipGroup) {
                  const clipGroup = this.svgFactory.createElement("svg:g");
                  clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                  this.svg.appendChild(clipGroup);
                  this.current.clipGroup = clipGroup;
                }
                return this.current.clipGroup;
              }
              _ensureTransformGroup() {
                if (!this.tgrp) {
                  this.tgrp = this.svgFactory.createElement("svg:g");
                  this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                  if (this.current.activeClipUrl) {
                    this._ensureClipGroup().appendChild(this.tgrp);
                  } else {
                    this.svg.appendChild(this.tgrp);
                  }
                }
                return this.tgrp;
              }
            };
          }
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.XfaLayer = void 0;
          class XfaLayer {
            static setAttributes(html, attrs) {
              for (const [key, value] of Object.entries(attrs)) {
                if (value === null || value === void 0) {
                  continue;
                }
                if (key !== "style") {
                  html.setAttribute(key, value);
                } else {
                  Object.assign(html.style, value);
                }
              }
            }
            static render(parameters) {
              const root = parameters.xfa;
              const rootHtml = document.createElement(root.name);
              if (root.attributes) {
                XfaLayer.setAttributes(rootHtml, root.attributes);
              }
              const stack2 = [[root, -1, rootHtml]];
              const rootDiv = parameters.div;
              rootDiv.appendChild(rootHtml);
              const coeffs = parameters.viewport.transform.join(",");
              rootDiv.style.transform = `matrix(${coeffs})`;
              rootDiv.setAttribute("class", "xfaLayer xfaFont");
              while (stack2.length > 0) {
                const [parent, i, html] = stack2[stack2.length - 1];
                if (i + 1 === parent.children.length) {
                  stack2.pop();
                  continue;
                }
                const child = parent.children[++stack2[stack2.length - 1][1]];
                if (child === null) {
                  continue;
                }
                const {
                  name: name2
                } = child;
                if (name2 === "#text") {
                  html.appendChild(document.createTextNode(child.value));
                  continue;
                }
                const childHtml = document.createElement(name2);
                html.appendChild(childHtml);
                if (child.attributes) {
                  XfaLayer.setAttributes(childHtml, child.attributes);
                }
                if (child.children && child.children.length > 0) {
                  stack2.push([child, -1, childHtml]);
                } else if (child.value) {
                  childHtml.appendChild(document.createTextNode(child.value));
                }
              }
            }
            static update(parameters) {
              const transform = `matrix(${parameters.viewport.transform.join(",")})`;
              parameters.div.style.transform = transform;
              parameters.div.hidden = false;
            }
          }
          exports2.XfaLayer = XfaLayer;
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFNodeStream = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          var _network_utils = __w_pdfjs_require__2(24);
          const fs = require$$5;
          const http = require$$5;
          const https = require$$5;
          const url = require$$5;
          const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
          function parseUrl(sourceUrl) {
            const parsedUrl = url.parse(sourceUrl);
            if (parsedUrl.protocol === "file:" || parsedUrl.host) {
              return parsedUrl;
            }
            if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
              return url.parse(`file:///${sourceUrl}`);
            }
            if (!parsedUrl.host) {
              parsedUrl.protocol = "file:";
            }
            return parsedUrl;
          }
          class PDFNodeStream {
            constructor(source) {
              this.source = source;
              this.url = parseUrl(source.url);
              this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
              this.isFsUrl = this.url.protocol === "file:";
              this.httpHeaders = this.isHttp && source.httpHeaders || {};
              this._fullRequestReader = null;
              this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var _a2, _b;
              return (_b = (_a2 = this._fullRequestReader) == null ? void 0 : _a2._loaded) != null ? _b : 0;
            }
            getFullReader() {
              (0, _util2.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
              this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
              return this._fullRequestReader;
            }
            getRangeReader(start, end) {
              if (end <= this._progressiveDataLength) {
                return null;
              }
              const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
              this._rangeRequestReaders.push(rangeReader);
              return rangeReader;
            }
            cancelAllRequests(reason) {
              if (this._fullRequestReader) {
                this._fullRequestReader.cancel(reason);
              }
              const readers = this._rangeRequestReaders.slice(0);
              readers.forEach(function(reader) {
                reader.cancel(reason);
              });
            }
          }
          exports2.PDFNodeStream = PDFNodeStream;
          class BaseFullReader {
            constructor(stream) {
              this._url = stream.url;
              this._done = false;
              this._storedError = null;
              this.onProgress = null;
              const source = stream.source;
              this._contentLength = source.length;
              this._loaded = 0;
              this._filename = null;
              this._disableRange = source.disableRange || false;
              this._rangeChunkSize = source.rangeChunkSize;
              if (!this._rangeChunkSize && !this._disableRange) {
                this._disableRange = true;
              }
              this._isStreamingSupported = !source.disableStream;
              this._isRangeSupported = !source.disableRange;
              this._readableStream = null;
              this._readCapability = (0, _util2.createPromiseCapability)();
              this._headersCapability = (0, _util2.createPromiseCapability)();
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              await this._readCapability.promise;
              if (this._done) {
                return {
                  value: void 0,
                  done: true
                };
              }
              if (this._storedError) {
                throw this._storedError;
              }
              const chunk = this._readableStream.read();
              if (chunk === null) {
                this._readCapability = (0, _util2.createPromiseCapability)();
                return this.read();
              }
              this._loaded += chunk.length;
              if (this.onProgress) {
                this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                });
              }
              const buffer2 = new Uint8Array(chunk).buffer;
              return {
                value: buffer2,
                done: false
              };
            }
            cancel(reason) {
              if (!this._readableStream) {
                this._error(reason);
                return;
              }
              this._readableStream.destroy(reason);
            }
            _error(reason) {
              this._storedError = reason;
              this._readCapability.resolve();
            }
            _setReadableStream(readableStream) {
              this._readableStream = readableStream;
              readableStream.on("readable", () => {
                this._readCapability.resolve();
              });
              readableStream.on("end", () => {
                readableStream.destroy();
                this._done = true;
                this._readCapability.resolve();
              });
              readableStream.on("error", (reason) => {
                this._error(reason);
              });
              if (!this._isStreamingSupported && this._isRangeSupported) {
                this._error(new _util2.AbortException("streaming is disabled"));
              }
              if (this._storedError) {
                this._readableStream.destroy(this._storedError);
              }
            }
          }
          class BaseRangeReader {
            constructor(stream) {
              this._url = stream.url;
              this._done = false;
              this._storedError = null;
              this.onProgress = null;
              this._loaded = 0;
              this._readableStream = null;
              this._readCapability = (0, _util2.createPromiseCapability)();
              const source = stream.source;
              this._isStreamingSupported = !source.disableStream;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              await this._readCapability.promise;
              if (this._done) {
                return {
                  value: void 0,
                  done: true
                };
              }
              if (this._storedError) {
                throw this._storedError;
              }
              const chunk = this._readableStream.read();
              if (chunk === null) {
                this._readCapability = (0, _util2.createPromiseCapability)();
                return this.read();
              }
              this._loaded += chunk.length;
              if (this.onProgress) {
                this.onProgress({
                  loaded: this._loaded
                });
              }
              const buffer2 = new Uint8Array(chunk).buffer;
              return {
                value: buffer2,
                done: false
              };
            }
            cancel(reason) {
              if (!this._readableStream) {
                this._error(reason);
                return;
              }
              this._readableStream.destroy(reason);
            }
            _error(reason) {
              this._storedError = reason;
              this._readCapability.resolve();
            }
            _setReadableStream(readableStream) {
              this._readableStream = readableStream;
              readableStream.on("readable", () => {
                this._readCapability.resolve();
              });
              readableStream.on("end", () => {
                readableStream.destroy();
                this._done = true;
                this._readCapability.resolve();
              });
              readableStream.on("error", (reason) => {
                this._error(reason);
              });
              if (this._storedError) {
                this._readableStream.destroy(this._storedError);
              }
            }
          }
          function createRequestOptions(parsedUrl, headers) {
            return {
              protocol: parsedUrl.protocol,
              auth: parsedUrl.auth,
              host: parsedUrl.hostname,
              port: parsedUrl.port,
              path: parsedUrl.path,
              method: "GET",
              headers
            };
          }
          class PDFNodeStreamFullReader extends BaseFullReader {
            constructor(stream) {
              super(stream);
              const handleResponse = (response) => {
                if (response.statusCode === 404) {
                  const error = new _util2.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = error;
                  this._headersCapability.reject(error);
                  return;
                }
                this._headersCapability.resolve();
                this._setReadableStream(response);
                const getResponseHeader = (name2) => {
                  return this._readableStream.headers[name2.toLowerCase()];
                };
                const {
                  allowRangeRequests,
                  suggestedLength
                } = (0, _network_utils.validateRangeRequestCapabilities)({
                  getResponseHeader,
                  isHttp: stream.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = allowRangeRequests;
                this._contentLength = suggestedLength || this._contentLength;
                this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
              };
              this._request = null;
              if (this._url.protocol === "http:") {
                this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
              } else {
                this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
              }
              this._request.on("error", (reason) => {
                this._storedError = reason;
                this._headersCapability.reject(reason);
              });
              this._request.end();
            }
          }
          class PDFNodeStreamRangeReader extends BaseRangeReader {
            constructor(stream, start, end) {
              super(stream);
              this._httpHeaders = {};
              for (const property in stream.httpHeaders) {
                const value = stream.httpHeaders[property];
                if (typeof value === "undefined") {
                  continue;
                }
                this._httpHeaders[property] = value;
              }
              this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
              const handleResponse = (response) => {
                if (response.statusCode === 404) {
                  const error = new _util2.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = error;
                  return;
                }
                this._setReadableStream(response);
              };
              this._request = null;
              if (this._url.protocol === "http:") {
                this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
              } else {
                this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
              }
              this._request.on("error", (reason) => {
                this._storedError = reason;
              });
              this._request.end();
            }
          }
          class PDFNodeStreamFsFullReader extends BaseFullReader {
            constructor(stream) {
              super(stream);
              let path = decodeURIComponent(this._url.path);
              if (fileUriRegex.test(this._url.href)) {
                path = path.replace(/^\//, "");
              }
              fs.lstat(path, (error, stat) => {
                if (error) {
                  if (error.code === "ENOENT") {
                    error = new _util2.MissingPDFException(`Missing PDF "${path}".`);
                  }
                  this._storedError = error;
                  this._headersCapability.reject(error);
                  return;
                }
                this._contentLength = stat.size;
                this._setReadableStream(fs.createReadStream(path));
                this._headersCapability.resolve();
              });
            }
          }
          class PDFNodeStreamFsRangeReader extends BaseRangeReader {
            constructor(stream, start, end) {
              super(stream);
              let path = decodeURIComponent(this._url.path);
              if (fileUriRegex.test(this._url.href)) {
                path = path.replace(/^\//, "");
              }
              this._setReadableStream(fs.createReadStream(path, {
                start,
                end: end - 1
              }));
            }
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.createResponseStatusError = createResponseStatusError;
          exports2.extractFilenameFromHeader = extractFilenameFromHeader;
          exports2.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
          exports2.validateResponseStatus = validateResponseStatus;
          var _util2 = __w_pdfjs_require__2(2);
          var _content_disposition = __w_pdfjs_require__2(25);
          var _display_utils2 = __w_pdfjs_require__2(1);
          function validateRangeRequestCapabilities({
            getResponseHeader,
            isHttp,
            rangeChunkSize,
            disableRange
          }) {
            (0, _util2.assert)(rangeChunkSize > 0, "Range chunk size must be larger than zero");
            const returnValues = {
              allowRangeRequests: false,
              suggestedLength: void 0
            };
            const length = parseInt(getResponseHeader("Content-Length"), 10);
            if (!Number.isInteger(length)) {
              return returnValues;
            }
            returnValues.suggestedLength = length;
            if (length <= 2 * rangeChunkSize) {
              return returnValues;
            }
            if (disableRange || !isHttp) {
              return returnValues;
            }
            if (getResponseHeader("Accept-Ranges") !== "bytes") {
              return returnValues;
            }
            const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
            if (contentEncoding !== "identity") {
              return returnValues;
            }
            returnValues.allowRangeRequests = true;
            return returnValues;
          }
          function extractFilenameFromHeader(getResponseHeader) {
            const contentDisposition = getResponseHeader("Content-Disposition");
            if (contentDisposition) {
              let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
              if (filename.includes("%")) {
                try {
                  filename = decodeURIComponent(filename);
                } catch (ex) {
                }
              }
              if ((0, _display_utils2.isPdfFile)(filename)) {
                return filename;
              }
            }
            return null;
          }
          function createResponseStatusError(status, url) {
            if (status === 404 || status === 0 && url.startsWith("file:")) {
              return new _util2.MissingPDFException('Missing PDF "' + url + '".');
            }
            return new _util2.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
          }
          function validateResponseStatus(status) {
            return status === 200 || status === 206;
          }
        },
        (__unused_webpack_module2, exports2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
          function getFilenameFromContentDispositionHeader(contentDisposition) {
            let needsEncodingFixup = true;
            let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
            if (tmp) {
              tmp = tmp[1];
              let filename = rfc2616unquote(tmp);
              filename = unescape(filename);
              filename = rfc5987decode(filename);
              filename = rfc2047decode(filename);
              return fixupEncoding(filename);
            }
            tmp = rfc2231getparam(contentDisposition);
            if (tmp) {
              const filename = rfc2047decode(tmp);
              return fixupEncoding(filename);
            }
            tmp = toParamRegExp("filename", "i").exec(contentDisposition);
            if (tmp) {
              tmp = tmp[1];
              let filename = rfc2616unquote(tmp);
              filename = rfc2047decode(filename);
              return fixupEncoding(filename);
            }
            function toParamRegExp(attributePattern, flags) {
              return new RegExp("(?:^|;)\\s*" + attributePattern + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', flags);
            }
            function textdecode(encoding, value) {
              if (encoding) {
                if (!/^[\x00-\xFF]+$/.test(value)) {
                  return value;
                }
                try {
                  const decoder = new TextDecoder(encoding, {
                    fatal: true
                  });
                  const bytes = Array.from(value, function(ch) {
                    return ch.charCodeAt(0) & 255;
                  });
                  value = decoder.decode(new Uint8Array(bytes));
                  needsEncodingFixup = false;
                } catch (e) {
                  if (/^utf-?8$/i.test(encoding)) {
                    try {
                      value = decodeURIComponent(escape(value));
                      needsEncodingFixup = false;
                    } catch (err) {
                    }
                  }
                }
              }
              return value;
            }
            function fixupEncoding(value) {
              if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                value = textdecode("utf-8", value);
                if (needsEncodingFixup) {
                  value = textdecode("iso-8859-1", value);
                }
              }
              return value;
            }
            function rfc2231getparam(contentDispositionStr) {
              const matches = [];
              let match;
              const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
              while ((match = iter.exec(contentDispositionStr)) !== null) {
                let [, n, quot, part] = match;
                n = parseInt(n, 10);
                if (n in matches) {
                  if (n === 0) {
                    break;
                  }
                  continue;
                }
                matches[n] = [quot, part];
              }
              const parts = [];
              for (let n = 0; n < matches.length; ++n) {
                if (!(n in matches)) {
                  break;
                }
                let [quot, part] = matches[n];
                part = rfc2616unquote(part);
                if (quot) {
                  part = unescape(part);
                  if (n === 0) {
                    part = rfc5987decode(part);
                  }
                }
                parts.push(part);
              }
              return parts.join("");
            }
            function rfc2616unquote(value) {
              if (value.startsWith('"')) {
                const parts = value.slice(1).split('\\"');
                for (let i = 0; i < parts.length; ++i) {
                  const quotindex = parts[i].indexOf('"');
                  if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                  }
                  parts[i] = parts[i].replace(/\\(.)/g, "$1");
                }
                value = parts.join('"');
              }
              return value;
            }
            function rfc5987decode(extvalue) {
              const encodingend = extvalue.indexOf("'");
              if (encodingend === -1) {
                return extvalue;
              }
              const encoding = extvalue.slice(0, encodingend);
              const langvalue = extvalue.slice(encodingend + 1);
              const value = langvalue.replace(/^[^']*'/, "");
              return textdecode(encoding, value);
            }
            function rfc2047decode(value) {
              if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
                return value;
              }
              return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                if (encoding === "q" || encoding === "Q") {
                  text = text.replace(/_/g, " ");
                  text = text.replace(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                  });
                  return textdecode(charset, text);
                }
                try {
                  text = atob(text);
                } catch (e) {
                }
                return textdecode(charset, text);
              });
            }
            return "";
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFNetworkStream = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          var _network_utils = __w_pdfjs_require__2(24);
          const OK_RESPONSE = 200;
          const PARTIAL_CONTENT_RESPONSE = 206;
          function getArrayBuffer(xhr2) {
            const data2 = xhr2.response;
            if (typeof data2 !== "string") {
              return data2;
            }
            const array = (0, _util2.stringToBytes)(data2);
            return array.buffer;
          }
          class NetworkManager {
            constructor(url, args) {
              this.url = url;
              args = args || {};
              this.isHttp = /^https?:/i.test(url);
              this.httpHeaders = this.isHttp && args.httpHeaders || {};
              this.withCredentials = args.withCredentials || false;
              this.getXhr = args.getXhr || function NetworkManager_getXhr() {
                return new XMLHttpRequest();
              };
              this.currXhrId = 0;
              this.pendingRequests = /* @__PURE__ */ Object.create(null);
            }
            requestRange(begin, end, listeners) {
              const args = {
                begin,
                end
              };
              for (const prop in listeners) {
                args[prop] = listeners[prop];
              }
              return this.request(args);
            }
            requestFull(listeners) {
              return this.request(listeners);
            }
            request(args) {
              const xhr2 = this.getXhr();
              const xhrId = this.currXhrId++;
              const pendingRequest = this.pendingRequests[xhrId] = {
                xhr: xhr2
              };
              xhr2.open("GET", this.url);
              xhr2.withCredentials = this.withCredentials;
              for (const property in this.httpHeaders) {
                const value = this.httpHeaders[property];
                if (typeof value === "undefined") {
                  continue;
                }
                xhr2.setRequestHeader(property, value);
              }
              if (this.isHttp && "begin" in args && "end" in args) {
                xhr2.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
              } else {
                pendingRequest.expectedStatus = OK_RESPONSE;
              }
              xhr2.responseType = "arraybuffer";
              if (args.onError) {
                xhr2.onerror = function(evt) {
                  args.onError(xhr2.status);
                };
              }
              xhr2.onreadystatechange = this.onStateChange.bind(this, xhrId);
              xhr2.onprogress = this.onProgress.bind(this, xhrId);
              pendingRequest.onHeadersReceived = args.onHeadersReceived;
              pendingRequest.onDone = args.onDone;
              pendingRequest.onError = args.onError;
              pendingRequest.onProgress = args.onProgress;
              xhr2.send(null);
              return xhrId;
            }
            onProgress(xhrId, evt) {
              const pendingRequest = this.pendingRequests[xhrId];
              if (!pendingRequest) {
                return;
              }
              if (pendingRequest.onProgress) {
                pendingRequest.onProgress(evt);
              }
            }
            onStateChange(xhrId, evt) {
              const pendingRequest = this.pendingRequests[xhrId];
              if (!pendingRequest) {
                return;
              }
              const xhr2 = pendingRequest.xhr;
              if (xhr2.readyState >= 2 && pendingRequest.onHeadersReceived) {
                pendingRequest.onHeadersReceived();
                delete pendingRequest.onHeadersReceived;
              }
              if (xhr2.readyState !== 4) {
                return;
              }
              if (!(xhrId in this.pendingRequests)) {
                return;
              }
              delete this.pendingRequests[xhrId];
              if (xhr2.status === 0 && this.isHttp) {
                if (pendingRequest.onError) {
                  pendingRequest.onError(xhr2.status);
                }
                return;
              }
              const xhrStatus = xhr2.status || OK_RESPONSE;
              const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
              if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                if (pendingRequest.onError) {
                  pendingRequest.onError(xhr2.status);
                }
                return;
              }
              const chunk = getArrayBuffer(xhr2);
              if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                const rangeHeader = xhr2.getResponseHeader("Content-Range");
                const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                pendingRequest.onDone({
                  begin: parseInt(matches[1], 10),
                  chunk
                });
              } else if (chunk) {
                pendingRequest.onDone({
                  begin: 0,
                  chunk
                });
              } else if (pendingRequest.onError) {
                pendingRequest.onError(xhr2.status);
              }
            }
            getRequestXhr(xhrId) {
              return this.pendingRequests[xhrId].xhr;
            }
            isPendingRequest(xhrId) {
              return xhrId in this.pendingRequests;
            }
            abortRequest(xhrId) {
              const xhr2 = this.pendingRequests[xhrId].xhr;
              delete this.pendingRequests[xhrId];
              xhr2.abort();
            }
          }
          class PDFNetworkStream {
            constructor(source) {
              this._source = source;
              this._manager = new NetworkManager(source.url, {
                httpHeaders: source.httpHeaders,
                withCredentials: source.withCredentials
              });
              this._rangeChunkSize = source.rangeChunkSize;
              this._fullRequestReader = null;
              this._rangeRequestReaders = [];
            }
            _onRangeRequestReaderClosed(reader) {
              const i = this._rangeRequestReaders.indexOf(reader);
              if (i >= 0) {
                this._rangeRequestReaders.splice(i, 1);
              }
            }
            getFullReader() {
              (0, _util2.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
              this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
              return this._fullRequestReader;
            }
            getRangeReader(begin, end) {
              const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
              reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
              this._rangeRequestReaders.push(reader);
              return reader;
            }
            cancelAllRequests(reason) {
              if (this._fullRequestReader) {
                this._fullRequestReader.cancel(reason);
              }
              const readers = this._rangeRequestReaders.slice(0);
              readers.forEach(function(reader) {
                reader.cancel(reason);
              });
            }
          }
          exports2.PDFNetworkStream = PDFNetworkStream;
          class PDFNetworkStreamFullRequestReader {
            constructor(manager, source) {
              this._manager = manager;
              const args = {
                onHeadersReceived: this._onHeadersReceived.bind(this),
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = source.url;
              this._fullRequestId = manager.requestFull(args);
              this._headersReceivedCapability = (0, _util2.createPromiseCapability)();
              this._disableRange = source.disableRange || false;
              this._contentLength = source.length;
              this._rangeChunkSize = source.rangeChunkSize;
              if (!this._rangeChunkSize && !this._disableRange) {
                this._disableRange = true;
              }
              this._isStreamingSupported = false;
              this._isRangeSupported = false;
              this._cachedChunks = [];
              this._requests = [];
              this._done = false;
              this._storedError = void 0;
              this._filename = null;
              this.onProgress = null;
            }
            _onHeadersReceived() {
              const fullRequestXhrId = this._fullRequestId;
              const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
              const getResponseHeader = (name2) => {
                return fullRequestXhr.getResponseHeader(name2);
              };
              const {
                allowRangeRequests,
                suggestedLength
              } = (0, _network_utils.validateRangeRequestCapabilities)({
                getResponseHeader,
                isHttp: this._manager.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
              });
              if (allowRangeRequests) {
                this._isRangeSupported = true;
              }
              this._contentLength = suggestedLength || this._contentLength;
              this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
              if (this._isRangeSupported) {
                this._manager.abortRequest(fullRequestXhrId);
              }
              this._headersReceivedCapability.resolve();
            }
            _onDone(args) {
              if (args) {
                if (this._requests.length > 0) {
                  const requestCapability = this._requests.shift();
                  requestCapability.resolve({
                    value: args.chunk,
                    done: false
                  });
                } else {
                  this._cachedChunks.push(args.chunk);
                }
              }
              this._done = true;
              if (this._cachedChunks.length > 0) {
                return;
              }
              this._requests.forEach(function(requestCapability) {
                requestCapability.resolve({
                  value: void 0,
                  done: true
                });
              });
              this._requests = [];
            }
            _onError(status) {
              const url = this._url;
              const exception = (0, _network_utils.createResponseStatusError)(status, url);
              this._storedError = exception;
              this._headersReceivedCapability.reject(exception);
              this._requests.forEach(function(requestCapability) {
                requestCapability.reject(exception);
              });
              this._requests = [];
              this._cachedChunks = [];
            }
            _onProgress(data2) {
              if (this.onProgress) {
                this.onProgress({
                  loaded: data2.loaded,
                  total: data2.lengthComputable ? data2.total : this._contentLength
                });
              }
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get contentLength() {
              return this._contentLength;
            }
            get headersReady() {
              return this._headersReceivedCapability.promise;
            }
            async read() {
              if (this._storedError) {
                throw this._storedError;
              }
              if (this._cachedChunks.length > 0) {
                const chunk = this._cachedChunks.shift();
                return {
                  value: chunk,
                  done: false
                };
              }
              if (this._done) {
                return {
                  value: void 0,
                  done: true
                };
              }
              const requestCapability = (0, _util2.createPromiseCapability)();
              this._requests.push(requestCapability);
              return requestCapability.promise;
            }
            cancel(reason) {
              this._done = true;
              this._headersReceivedCapability.reject(reason);
              this._requests.forEach(function(requestCapability) {
                requestCapability.resolve({
                  value: void 0,
                  done: true
                });
              });
              this._requests = [];
              if (this._manager.isPendingRequest(this._fullRequestId)) {
                this._manager.abortRequest(this._fullRequestId);
              }
              this._fullRequestReader = null;
            }
          }
          class PDFNetworkStreamRangeRequestReader {
            constructor(manager, begin, end) {
              this._manager = manager;
              const args = {
                onDone: this._onDone.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._requestId = manager.requestRange(begin, end, args);
              this._requests = [];
              this._queuedChunk = null;
              this._done = false;
              this.onProgress = null;
              this.onClosed = null;
            }
            _close() {
              if (this.onClosed) {
                this.onClosed(this);
              }
            }
            _onDone(data2) {
              const chunk = data2.chunk;
              if (this._requests.length > 0) {
                const requestCapability = this._requests.shift();
                requestCapability.resolve({
                  value: chunk,
                  done: false
                });
              } else {
                this._queuedChunk = chunk;
              }
              this._done = true;
              this._requests.forEach(function(requestCapability) {
                requestCapability.resolve({
                  value: void 0,
                  done: true
                });
              });
              this._requests = [];
              this._close();
            }
            _onProgress(evt) {
              if (!this.isStreamingSupported && this.onProgress) {
                this.onProgress({
                  loaded: evt.loaded
                });
              }
            }
            get isStreamingSupported() {
              return false;
            }
            async read() {
              if (this._queuedChunk !== null) {
                const chunk = this._queuedChunk;
                this._queuedChunk = null;
                return {
                  value: chunk,
                  done: false
                };
              }
              if (this._done) {
                return {
                  value: void 0,
                  done: true
                };
              }
              const requestCapability = (0, _util2.createPromiseCapability)();
              this._requests.push(requestCapability);
              return requestCapability.promise;
            }
            cancel(reason) {
              this._done = true;
              this._requests.forEach(function(requestCapability) {
                requestCapability.resolve({
                  value: void 0,
                  done: true
                });
              });
              this._requests = [];
              if (this._manager.isPendingRequest(this._requestId)) {
                this._manager.abortRequest(this._requestId);
              }
              this._close();
            }
          }
        },
        (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.PDFFetchStream = void 0;
          var _util2 = __w_pdfjs_require__2(2);
          var _network_utils = __w_pdfjs_require__2(24);
          function createFetchOptions(headers, withCredentials, abortController) {
            return {
              method: "GET",
              headers,
              signal: abortController == null ? void 0 : abortController.signal,
              mode: "cors",
              credentials: withCredentials ? "include" : "same-origin",
              redirect: "follow"
            };
          }
          function createHeaders(httpHeaders) {
            const headers = new Headers();
            for (const property in httpHeaders) {
              const value = httpHeaders[property];
              if (typeof value === "undefined") {
                continue;
              }
              headers.append(property, value);
            }
            return headers;
          }
          class PDFFetchStream {
            constructor(source) {
              this.source = source;
              this.isHttp = /^https?:/i.test(source.url);
              this.httpHeaders = this.isHttp && source.httpHeaders || {};
              this._fullRequestReader = null;
              this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var _a2, _b;
              return (_b = (_a2 = this._fullRequestReader) == null ? void 0 : _a2._loaded) != null ? _b : 0;
            }
            getFullReader() {
              (0, _util2.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
              this._fullRequestReader = new PDFFetchStreamReader(this);
              return this._fullRequestReader;
            }
            getRangeReader(begin, end) {
              if (end <= this._progressiveDataLength) {
                return null;
              }
              const reader = new PDFFetchStreamRangeReader(this, begin, end);
              this._rangeRequestReaders.push(reader);
              return reader;
            }
            cancelAllRequests(reason) {
              if (this._fullRequestReader) {
                this._fullRequestReader.cancel(reason);
              }
              const readers = this._rangeRequestReaders.slice(0);
              readers.forEach(function(reader) {
                reader.cancel(reason);
              });
            }
          }
          exports2.PDFFetchStream = PDFFetchStream;
          class PDFFetchStreamReader {
            constructor(stream) {
              this._stream = stream;
              this._reader = null;
              this._loaded = 0;
              this._filename = null;
              const source = stream.source;
              this._withCredentials = source.withCredentials || false;
              this._contentLength = source.length;
              this._headersCapability = (0, _util2.createPromiseCapability)();
              this._disableRange = source.disableRange || false;
              this._rangeChunkSize = source.rangeChunkSize;
              if (!this._rangeChunkSize && !this._disableRange) {
                this._disableRange = true;
              }
              if (typeof AbortController !== "undefined") {
                this._abortController = new AbortController();
              }
              this._isStreamingSupported = !source.disableStream;
              this._isRangeSupported = !source.disableRange;
              this._headers = createHeaders(this._stream.httpHeaders);
              const url = source.url;
              fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response) => {
                if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                  throw (0, _network_utils.createResponseStatusError)(response.status, url);
                }
                this._reader = response.body.getReader();
                this._headersCapability.resolve();
                const getResponseHeader = (name2) => {
                  return response.headers.get(name2);
                };
                const {
                  allowRangeRequests,
                  suggestedLength
                } = (0, _network_utils.validateRangeRequestCapabilities)({
                  getResponseHeader,
                  isHttp: this._stream.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = allowRangeRequests;
                this._contentLength = suggestedLength || this._contentLength;
                this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                if (!this._isStreamingSupported && this._isRangeSupported) {
                  this.cancel(new _util2.AbortException("Streaming is disabled."));
                }
              }).catch(this._headersCapability.reject);
              this.onProgress = null;
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              await this._headersCapability.promise;
              const {
                value,
                done
              } = await this._reader.read();
              if (done) {
                return {
                  value,
                  done
                };
              }
              this._loaded += value.byteLength;
              if (this.onProgress) {
                this.onProgress({
                  loaded: this._loaded,
                  total: this._contentLength
                });
              }
              const buffer2 = new Uint8Array(value).buffer;
              return {
                value: buffer2,
                done: false
              };
            }
            cancel(reason) {
              if (this._reader) {
                this._reader.cancel(reason);
              }
              if (this._abortController) {
                this._abortController.abort();
              }
            }
          }
          class PDFFetchStreamRangeReader {
            constructor(stream, begin, end) {
              this._stream = stream;
              this._reader = null;
              this._loaded = 0;
              const source = stream.source;
              this._withCredentials = source.withCredentials || false;
              this._readCapability = (0, _util2.createPromiseCapability)();
              this._isStreamingSupported = !source.disableStream;
              if (typeof AbortController !== "undefined") {
                this._abortController = new AbortController();
              }
              this._headers = createHeaders(this._stream.httpHeaders);
              this._headers.append("Range", `bytes=${begin}-${end - 1}`);
              const url = source.url;
              fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response) => {
                if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                  throw (0, _network_utils.createResponseStatusError)(response.status, url);
                }
                this._readCapability.resolve();
                this._reader = response.body.getReader();
              }).catch((reason) => {
                if ((reason == null ? void 0 : reason.name) === "AbortError") {
                  return;
                }
                throw reason;
              });
              this.onProgress = null;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              await this._readCapability.promise;
              const {
                value,
                done
              } = await this._reader.read();
              if (done) {
                return {
                  value,
                  done
                };
              }
              this._loaded += value.byteLength;
              if (this.onProgress) {
                this.onProgress({
                  loaded: this._loaded
                });
              }
              const buffer2 = new Uint8Array(value).buffer;
              return {
                value: buffer2,
                done: false
              };
            }
            cancel(reason) {
              if (this._reader) {
                this._reader.cancel(reason);
              }
              if (this._abortController) {
                this._abortController.abort();
              }
            }
          }
        }
      ];
      var __webpack_module_cache__ = {};
      function __w_pdfjs_require__(moduleId) {
        var cachedModule = __webpack_module_cache__[moduleId];
        if (cachedModule !== void 0) {
          return cachedModule.exports;
        }
        var module2 = __webpack_module_cache__[moduleId] = {
          exports: {}
        };
        __webpack_modules__[moduleId](module2, module2.exports, __w_pdfjs_require__);
        return module2.exports;
      }
      var __webpack_exports__ = {};
      (() => {
        var exports2 = __webpack_exports__;
        Object.defineProperty(exports2, "__esModule", {
          value: true
        });
        Object.defineProperty(exports2, "addLinkAttributes", {
          enumerable: true,
          get: function() {
            return _display_utils2.addLinkAttributes;
          }
        });
        Object.defineProperty(exports2, "getFilenameFromUrl", {
          enumerable: true,
          get: function() {
            return _display_utils2.getFilenameFromUrl;
          }
        });
        Object.defineProperty(exports2, "getPdfFilenameFromUrl", {
          enumerable: true,
          get: function() {
            return _display_utils2.getPdfFilenameFromUrl;
          }
        });
        Object.defineProperty(exports2, "isPdfFile", {
          enumerable: true,
          get: function() {
            return _display_utils2.isPdfFile;
          }
        });
        Object.defineProperty(exports2, "LinkTarget", {
          enumerable: true,
          get: function() {
            return _display_utils2.LinkTarget;
          }
        });
        Object.defineProperty(exports2, "loadScript", {
          enumerable: true,
          get: function() {
            return _display_utils2.loadScript;
          }
        });
        Object.defineProperty(exports2, "PDFDateString", {
          enumerable: true,
          get: function() {
            return _display_utils2.PDFDateString;
          }
        });
        Object.defineProperty(exports2, "RenderingCancelledException", {
          enumerable: true,
          get: function() {
            return _display_utils2.RenderingCancelledException;
          }
        });
        Object.defineProperty(exports2, "build", {
          enumerable: true,
          get: function() {
            return _api.build;
          }
        });
        Object.defineProperty(exports2, "getDocument", {
          enumerable: true,
          get: function() {
            return _api.getDocument;
          }
        });
        Object.defineProperty(exports2, "LoopbackPort", {
          enumerable: true,
          get: function() {
            return _api.LoopbackPort;
          }
        });
        Object.defineProperty(exports2, "PDFDataRangeTransport", {
          enumerable: true,
          get: function() {
            return _api.PDFDataRangeTransport;
          }
        });
        Object.defineProperty(exports2, "PDFWorker", {
          enumerable: true,
          get: function() {
            return _api.PDFWorker;
          }
        });
        Object.defineProperty(exports2, "version", {
          enumerable: true,
          get: function() {
            return _api.version;
          }
        });
        Object.defineProperty(exports2, "CMapCompressionType", {
          enumerable: true,
          get: function() {
            return _util2.CMapCompressionType;
          }
        });
        Object.defineProperty(exports2, "createObjectURL", {
          enumerable: true,
          get: function() {
            return _util2.createObjectURL;
          }
        });
        Object.defineProperty(exports2, "createPromiseCapability", {
          enumerable: true,
          get: function() {
            return _util2.createPromiseCapability;
          }
        });
        Object.defineProperty(exports2, "createValidAbsoluteUrl", {
          enumerable: true,
          get: function() {
            return _util2.createValidAbsoluteUrl;
          }
        });
        Object.defineProperty(exports2, "InvalidPDFException", {
          enumerable: true,
          get: function() {
            return _util2.InvalidPDFException;
          }
        });
        Object.defineProperty(exports2, "MissingPDFException", {
          enumerable: true,
          get: function() {
            return _util2.MissingPDFException;
          }
        });
        Object.defineProperty(exports2, "OPS", {
          enumerable: true,
          get: function() {
            return _util2.OPS;
          }
        });
        Object.defineProperty(exports2, "PasswordResponses", {
          enumerable: true,
          get: function() {
            return _util2.PasswordResponses;
          }
        });
        Object.defineProperty(exports2, "PermissionFlag", {
          enumerable: true,
          get: function() {
            return _util2.PermissionFlag;
          }
        });
        Object.defineProperty(exports2, "removeNullCharacters", {
          enumerable: true,
          get: function() {
            return _util2.removeNullCharacters;
          }
        });
        Object.defineProperty(exports2, "shadow", {
          enumerable: true,
          get: function() {
            return _util2.shadow;
          }
        });
        Object.defineProperty(exports2, "UnexpectedResponseException", {
          enumerable: true,
          get: function() {
            return _util2.UnexpectedResponseException;
          }
        });
        Object.defineProperty(exports2, "UNSUPPORTED_FEATURES", {
          enumerable: true,
          get: function() {
            return _util2.UNSUPPORTED_FEATURES;
          }
        });
        Object.defineProperty(exports2, "Util", {
          enumerable: true,
          get: function() {
            return _util2.Util;
          }
        });
        Object.defineProperty(exports2, "VerbosityLevel", {
          enumerable: true,
          get: function() {
            return _util2.VerbosityLevel;
          }
        });
        Object.defineProperty(exports2, "AnnotationLayer", {
          enumerable: true,
          get: function() {
            return _annotation_layer.AnnotationLayer;
          }
        });
        Object.defineProperty(exports2, "apiCompatibilityParams", {
          enumerable: true,
          get: function() {
            return _api_compatibility2.apiCompatibilityParams;
          }
        });
        Object.defineProperty(exports2, "GlobalWorkerOptions", {
          enumerable: true,
          get: function() {
            return _worker_options2.GlobalWorkerOptions;
          }
        });
        Object.defineProperty(exports2, "renderTextLayer", {
          enumerable: true,
          get: function() {
            return _text_layer.renderTextLayer;
          }
        });
        Object.defineProperty(exports2, "SVGGraphics", {
          enumerable: true,
          get: function() {
            return _svg.SVGGraphics;
          }
        });
        Object.defineProperty(exports2, "XfaLayer", {
          enumerable: true,
          get: function() {
            return _xfa_layer.XfaLayer;
          }
        });
        var _display_utils2 = __w_pdfjs_require__(1);
        var _api = __w_pdfjs_require__(5);
        var _util2 = __w_pdfjs_require__(2);
        var _annotation_layer = __w_pdfjs_require__(18);
        var _api_compatibility2 = __w_pdfjs_require__(9);
        var _worker_options2 = __w_pdfjs_require__(12);
        var _text_layer = __w_pdfjs_require__(20);
        var _svg = __w_pdfjs_require__(21);
        var _xfa_layer = __w_pdfjs_require__(22);
        {
          const {
            isNodeJS
          } = __w_pdfjs_require__(4);
          if (isNodeJS) {
            const PDFNodeStream = __w_pdfjs_require__(23).PDFNodeStream;
            (0, _api.setPDFNetworkStreamFactory)((params) => {
              return new PDFNodeStream(params);
            });
          } else {
            const PDFNetworkStream = __w_pdfjs_require__(26).PDFNetworkStream;
            let PDFFetchStream;
            if ((0, _display_utils2.isFetchSupported)()) {
              PDFFetchStream = __w_pdfjs_require__(27).PDFFetchStream;
            }
            (0, _api.setPDFNetworkStreamFactory)((params) => {
              if (PDFFetchStream && (0, _display_utils2.isValidFetchUrl)(params.url)) {
                return new PDFFetchStream(params);
              }
              return new PDFNetworkStream(params);
            });
          }
        }
      })();
      return __webpack_exports__;
    })();
  });
})(pdf);
function isWeixin$1() {
  return /MicroMessenger/.test(window.navigator.userAgent);
}
function isMobile() {
  return /(iPhone|iPad|iPod|iOS|Android)/i.test(window.navigator.userAgent);
}
const MAX_SCALE_RATE = 2;
const _hoisted_1$7 = { class: "cp-absolute cp-top-1/2 cp-left-1/2 cp-transform cp--translate-x-1/2 cp--translate-y-1/2 cp-w-full cp-px-lg cp-text-center" };
const _hoisted_2$5 = { class: "cp-break-words" };
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  props: {
    text: null
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$7, [
        createBaseVNode("span", _hoisted_2$5, "ERROR: " + toDisplayString(__props.text), 1)
      ]);
    };
  }
});
const _hoisted_1$6 = ["page"];
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  props: {
    pdf: null,
    page: null,
    type: { default: "canvas" },
    options: null
  },
  emits: ["change"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const root = ref(), options = Object.assign({ ratio: Math.round(window.devicePixelRatio || 1) }, props.options);
    const errorMsg = ref("");
    async function renderPage() {
      if (!(root.value && props.page > 0))
        return;
      const pdf2 = await props.pdf;
      updateLoadStatus(true);
      const page = await pdf2.getPage(props.page);
      try {
        if (props.type === "canvas") {
          await renderInCanvas(page);
        } else {
          await renderInSvg(page);
        }
      } catch (error) {
        errorMsg.value = error.message;
      }
      updateLoadStatus(false);
    }
    const pdfRender = ref();
    async function renderInCanvas(page) {
      const canvas = pdfRender.value;
      const context = canvas.getContext("2d");
      const scale = getCalScale(page.getViewport({ scale: 1 }).width);
      const viewport = page.getViewport({ scale });
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      const renderContext = {
        canvasContext: context,
        viewport
      };
      const renderTask = page.render(renderContext);
      await renderTask.promise;
    }
    const isMobileDevice = isMobile();
    function getCalScale(baseScale) {
      const { ratio } = options;
      const t2 = rootSize.width / baseScale;
      return t2 * ratio * (isMobileDevice ? MAX_SCALE_RATE : 1.5);
    }
    async function renderInSvg(page) {
      const wrapper = root.value;
      const scale = rootSize.width / page.getViewport({ scale: 1 }).width;
      const viewport = page.getViewport({ scale });
      const opList = await page.getOperatorList();
      const svgGfx = new pdf.exports.SVGGraphics(page.commonObjs, page.objs);
      const svg = await svgGfx.getSVG(opList, viewport);
      wrapper.appendChild(svg);
    }
    function updateLoadStatus(loading) {
      emit2("change", {
        page: props.page,
        loading,
        element: root.value
      });
    }
    let rootSize = { width: 0, height: 0 };
    function calRefSize(ele) {
      const { offsetWidth: width2, offsetHeight: height2 } = ele.value;
      rootSize = { width: width2, height: height2 };
    }
    onMounted(() => {
      calRefSize(root);
      watch(() => props.page, renderPage, { immediate: true });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "root",
        ref: root,
        page: __props.page,
        class: "cp-w-full shadow-book"
      }, [
        __props.type === "canvas" ? (openBlock(), createElementBlock("canvas", {
          key: 0,
          ref_key: "pdfRender",
          ref: pdfRender,
          class: "cp-w-full"
        }, "canvas is not supported", 512)) : createCommentVNode("", true),
        errorMsg.value ? (openBlock(), createBlock(_sfc_main$7, {
          key: 1,
          text: errorMsg.value
        }, null, 8, ["text"])) : createCommentVNode("", true)
      ], 8, _hoisted_1$6);
    };
  }
});
var useLoadList = ({ whenLoaded } = {}, emit2) => {
  const loadingList = reactive([false]);
  function loadChange({ page, loading, element }) {
    loadingList[page] = loading;
    if (!loading) {
      emit2("loaded", page);
      whenLoaded && whenLoaded(page, element);
    }
  }
  const sizeArr = reactive([]);
  let loadedAmount = 0;
  function onImgLoad(page, range, element) {
    loadingList[page] = false;
    if (sizeArr[page])
      return;
    sizeArr[page] = { width: element.offsetWidth, height: element.offsetHeight };
    emit2("loaded", page);
    whenLoaded && whenLoaded(page, element);
    loadedAmount++;
    emit2("progress", loadedAmount / range);
  }
  function isPageLoaded(page) {
    return !!loadingList[page];
  }
  function getLoadingPageAmount() {
    return loadingList.filter((t2) => t2).length;
  }
  return {
    isPageLoaded,
    getLoadingPageAmount,
    loadChange,
    onImgLoad,
    sizeArr,
    loadingList
  };
};
var request = async (url) => {
  const rsp = await fetch(url);
  if (!(rsp.ok && rsp.status === 200))
    throw Error("server error");
  const type = rsp.headers.get("content-type");
  if (!type)
    throw Error("content-type is empty");
  if (type.includes("json")) {
    return rsp.json();
  } else {
    return rsp.text();
  }
};
async function getPdfImgs(url) {
  const { pdfInfo } = await request(`${url}?view=3`);
  return pdfInfo;
}
async function getPdfSource(url) {
  return request(`${url}?view=2`);
}
pdf.exports.GlobalWorkerOptions.workerSrc = "https://custouch-cloud.oss-cn-hangzhou.aliyuncs.com/modules/pdf/build/2.8.335/pdf.worker.min.js";
var usePdfTask = (emit2, pdfUrl, { pages, maxPage }) => {
  const pdfPromise = ref(), numPages = ref(0);
  let pdfLoadingTask;
  async function createLoadingTask(url) {
    if (!url)
      throw Error("empty source");
    if (pdfLoadingTask) {
      await close();
    }
    pdfLoadingTask = pdf.exports.getDocument({
      url,
      cMapUrl: "https://oss.cloud.custouch.com/static/cloud/font/cmaps/",
      cMapPacked: true
    });
    pdfLoadingTask.onProgress = (progressData) => {
      emit2("progress", Math.min(1, progressData.loaded / progressData.total));
    };
    return pdfLoadingTask.promise;
  }
  function close() {
    if (!pdfLoadingTask) {
      return Promise.resolve();
    }
    const promise = pdfLoadingTask.destroy();
    pdfLoadingTask = null;
    return promise;
  }
  const calMaxPage = computed(() => maxPage.value ? Math.min(numPages.value, maxPage.value) : numPages.value);
  const isLimit = computed(() => calMaxPage.value < numPages.value);
  const errorMsg = ref(""), imgPages = ref();
  async function createPdfTask() {
    let source = pdfUrl;
    try {
      if (pages.length) {
        numPages.value = pages.length;
        imgPages.value = pages;
        return;
      }
      const splitGroup = pdfUrl.split("/");
      if (/download\.\w+\.custouch\.com/.test(pdfUrl)) {
        const index2 = splitGroup.indexOf("pdfviewer");
        if (~index2)
          splitGroup.splice(index2, 1);
        try {
          const { pages: pages2, pageSize } = await getPdfImgs(splitGroup.join("/"));
          if (pages2.length) {
            numPages.value = pageSize;
            imgPages.value = pages2;
            return;
          }
        } catch {
        }
        source = await getPdfSource(splitGroup.join("/"));
      }
      pdfPromise.value = createLoadingTask(source);
      const pdf2 = await pdfPromise.value;
      numPages.value = pdf2.numPages;
    } catch (error) {
      if (error instanceof Error) {
        errorMsg.value = error.message;
        console.error(errorMsg.value);
      }
    }
  }
  onUnmounted(close);
  return {
    createPdfTask,
    calMaxPage,
    isLimit,
    pdfPromise,
    imgPages,
    numPages,
    errorMsg
  };
};
function addPicWM({
  textAlign = "center",
  textBaseline = "middle",
  content = "\u6C34\u5370",
  font = {
    size: 20,
    weight: "normal",
    style: "normal",
    color: "#000",
    lineHeight: 3
  }
} = {}) {
  const canvas = document.createElement("canvas");
  const { size: size2, weight, style: style2, lineHeight = 3 } = font;
  const width2 = getTextWidth(content, font) * 1.5;
  const height2 = size2 * lineHeight;
  canvas.width = width2;
  canvas.height = height2;
  const ctx = canvas.getContext("2d");
  if (!ctx)
    return "";
  ctx.textAlign = textAlign;
  ctx.textBaseline = textBaseline;
  ctx.fillStyle = font.color;
  ctx.font = `${weight} ${style2} ${size2}px sans-serif`;
  ctx.fillText(content, parseFloat(String(width2)) / 2, parseFloat(String(height2)) / 2);
  return canvas.toDataURL();
}
function getTextWidth(content, font) {
  const canvas = document.createElement("canvas");
  canvas.width = 10;
  canvas.height = 10;
  const ctx = canvas.getContext("2d");
  if (!ctx)
    return 0;
  const { size: size2, weight, style: style2 } = font;
  ctx.font = `${weight} ${style2} ${size2}px sans-serif`;
  const { width: width2 } = ctx.measureText(content);
  return width2;
}
var useMw = (wmOptions) => {
  const wmStyle = computed(() => {
    const { rotate = 0, opacity = 0.3, multi, content, type } = wmOptions.value || {};
    if (!content) {
      return;
    }
    if (type === "img") {
      if (!wmOptions.value.img)
        return;
      const { placement, width: width2 } = wmOptions.value.img;
      let top, right, left, bottom, othertTransform = "";
      const DEFAULT_PADDING = { y: "16px", x: "8px" };
      switch (placement) {
        case "tl":
          top = DEFAULT_PADDING.y;
          left = DEFAULT_PADDING.x;
          break;
        case "tr":
          top = DEFAULT_PADDING.y;
          right = DEFAULT_PADDING.x;
          break;
        case "bl":
          bottom = DEFAULT_PADDING.y;
          left = DEFAULT_PADDING.x;
          break;
        case "br":
          bottom = DEFAULT_PADDING.y;
          right = DEFAULT_PADDING.x;
          break;
        default:
          top = "50%";
          left = "50%";
          othertTransform = "translate(-50%,-50%)";
      }
      return {
        opacity,
        transform: `${othertTransform} rotate(${rotate}deg)`,
        width: (width2 || 40) + "px",
        top,
        right,
        left,
        bottom
      };
    } else {
      const watermark = addPicWM(wmOptions.value);
      let transform = `rotate(${rotate}deg)`, width2 = "100%", height2 = "100%", backgroundPosition = "center", backgroundRepeat = "repeat-x";
      if (multi) {
        transform = "translate(-25%,-25%) " + transform;
        width2 = height2 = "200%";
        backgroundPosition = "";
        backgroundRepeat = "repeat";
      }
      return {
        opacity,
        transform,
        backgroundImage: `url('${watermark}')`,
        backgroundPosition,
        backgroundRepeat,
        width: width2,
        height: height2
      };
    }
  });
  return {
    wmStyle
  };
};
const _hoisted_1$5 = {
  key: 0,
  class: "cp-relative"
};
const _hoisted_2$4 = ["src", "onLoad"];
const _hoisted_3$3 = ["src"];
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  props: {
    pdfUrl: null,
    wmOptions: null,
    pages: null,
    maxPage: null,
    offset: { default: 150 }
  },
  emits: ["end", "progress", "loaded", "error"],
  setup(__props, { expose, emit: emit2 }) {
    const props = __props;
    const DEFAULT_STEP = 1, { wmStyle } = useMw(toRef(props, "wmOptions")), { createPdfTask, pdfPromise, imgPages, numPages, errorMsg, calMaxPage, isLimit } = usePdfTask(emit2, props.pdfUrl, {
      pages: props.pages,
      maxPage: toRef(props, "maxPage")
    });
    watch(() => errorMsg, (v) => {
      v && emit2("error", v);
    }, { immediate: true });
    async function createPdf() {
      await createPdfTask();
      updateRange();
      watch(() => props.maxPage, (v) => !v && updateRange());
    }
    const canvasHeight = reactive([]), remainPages = ref(4);
    let stopLoad = false;
    const whenLoaded = (page, element) => {
      if (element && canvasHeight[page] === void 0) {
        canvasHeight[page] = element.offsetHeight;
      }
      if (!stopLoad) {
        stopLoad = !loadMore();
      }
      setRemainPagesAmount(canvasHeight[page]);
    };
    function setRemainPagesAmount(h2) {
      if (h2 === void 0)
        return;
      const { offsetHeight } = root.value;
      remainPages.value = Math.ceil(3 * offsetHeight / h2);
    }
    let scrollEl;
    onMounted(() => {
      if (!root.value)
        return;
      const scrollTarget = findScrollWrapper(root.value);
      scrollTarget.addEventListener("scroll", () => loadMore());
      scrollEl = scrollTarget === window ? document.documentElement : scrollTarget;
    });
    function findScrollWrapper(el) {
      while (el instanceof Element) {
        let isScrollEl = false;
        if ("computedStyleMap" in el) {
          isScrollEl = el.computedStyleMap().get("overflow-y").value === "auto";
        } else {
          isScrollEl = el.style.getPropertyValue("overflow-y") === "auto" || !!el.offsetHeight && el.scrollHeight > el.offsetHeight;
        }
        if (isScrollEl) {
          return el;
        }
        el = el == null ? void 0 : el.parentNode;
      }
      return window;
    }
    function loadMore() {
      let res = false;
      if (res = canLoadMorePage()) {
        updateRange();
      }
      setActivePage();
      return res;
    }
    const { loadChange, getLoadingPageAmount, onImgLoad, sizeArr } = useLoadList({
      whenLoaded
    }, emit2);
    const range = ref(0), pageSize = [], currentPage = ref(0);
    function setActivePage() {
      let totalTop = 0;
      const el = root.value;
      if (!el || range.value <= 0)
        return;
      let { scrollTop } = el;
      let i = 0;
      while (++i <= range.value) {
        const t2 = el.children[i - 1];
        if (!t2) {
          break;
        }
        if (!pageSize[i]) {
          const { offsetHeight } = t2;
          pageSize[i] = offsetHeight;
        }
        totalTop += pageSize[i];
        if (totalTop >= scrollTop) {
          currentPage.value = i + 1;
          break;
        }
      }
    }
    const root = ref();
    function canLoadMorePage() {
      if (!scrollEl || calMaxPage.value <= range.value || getLoadingPageAmount() > DEFAULT_STEP)
        return false;
      const { scrollTop, scrollHeight, clientHeight } = scrollEl;
      return props.offset + scrollTop + clientHeight > scrollHeight;
    }
    function updateRange(value = DEFAULT_STEP) {
      range.value = Math.min(calMaxPage.value, range.value + value);
    }
    function emitEnd() {
      emit2("end", { maxPage: props.maxPage, total: numPages.value });
    }
    setViewPort(true, { minimum: 1, maximum: MAX_SCALE_RATE, initial: 1 });
    createPdf();
    expose({
      range
    });
    return (_ctx, _cache) => {
      return unref(errorMsg) ? (openBlock(), createBlock(_sfc_main$7, {
        key: 0,
        text: unref(errorMsg)
      }, null, 8, ["text"])) : (openBlock(), createElementBlock("div", {
        key: 1,
        ref_key: "root",
        ref: root,
        class: "cp-divide-y-8"
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(range.value, (page) => {
          var _a2;
          return openBlock(), createElementBlock(Fragment, { key: page }, [
            unref(imgPages) ? (openBlock(), createElementBlock("div", _hoisted_1$5, [
              createBaseVNode("img", {
                src: unref(imgPages)[page - 1],
                class: "cp-w-full cp-pointer-events-none",
                onLoad: ($event) => unref(onImgLoad)(page, range.value, $event.target)
              }, null, 40, _hoisted_2$4),
              ((_a2 = __props.wmOptions) == null ? void 0 : _a2.content) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                __props.wmOptions.type === "img" ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  src: __props.wmOptions.content,
                  style: normalizeStyle(unref(wmStyle)),
                  class: "cp-object-contain cp-absolute"
                }, null, 12, _hoisted_3$3)) : unref(sizeArr)[page] ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  class: "cp-overflow-hidden cp-absolute cp-left-0 cp-top-0 cp-z-10 cp-pointer-events-none w-full h-full",
                  style: normalizeStyle({ width: unref(sizeArr)[page].width + "px", height: unref(sizeArr)[page].height + "px" })
                }, [
                  createBaseVNode("div", {
                    style: normalizeStyle(unref(wmStyle))
                  }, null, 4)
                ], 4)) : createCommentVNode("", true)
              ], 64)) : createCommentVNode("", true)
            ])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              Math.abs(page - currentPage.value) <= remainPages.value ? (openBlock(), createBlock(_sfc_main$6, {
                key: 0,
                pdf: unref(pdfPromise),
                page,
                onChange: unref(loadChange)
              }, null, 8, ["pdf", "page", "onChange"])) : (openBlock(), createElementBlock("div", {
                key: 1,
                style: normalizeStyle({ height: unref(canvasHeight)[page] + "px" }),
                class: "cp-w-full"
              }, null, 4))
            ], 64))
          ], 64);
        }), 128)),
        unref(isLimit) ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "cp-w-full cp-bg-gray-400 cp-text-white cp-text-center cp-py-md",
          onClick: emitEnd
        }, "\u67E5\u770B\u66F4\u591A")) : createCommentVNode("", true)
      ], 512));
    };
  }
});
var hammer = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(module2) {
  (function(window2, document2, exportName, undefined$1) {
    var VENDOR_PREFIXES = ["", "webkit", "Moz", "MS", "ms", "o"];
    var TEST_ELEMENT = document2.createElement("div");
    var TYPE_FUNCTION = "function";
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    function setTimeoutContext(fn, timeout, context) {
      return setTimeout(bindFn(fn, context), timeout);
    }
    function invokeArrayArg(arg, fn, context) {
      if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
      }
      return false;
    }
    function each(obj, iterator, context) {
      var i;
      if (!obj) {
        return;
      }
      if (obj.forEach) {
        obj.forEach(iterator, context);
      } else if (obj.length !== undefined$1) {
        i = 0;
        while (i < obj.length) {
          iterator.call(context, obj[i], i, obj);
          i++;
        }
      } else {
        for (i in obj) {
          obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
      }
    }
    function deprecate(method, name2, message) {
      var deprecationMessage = "DEPRECATED METHOD: " + name2 + "\n" + message + " AT \n";
      return function() {
        var e = new Error("get-stack-trace");
        var stack2 = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
        var log = window2.console && (window2.console.warn || window2.console.log);
        if (log) {
          log.call(window2.console, deprecationMessage, stack2);
        }
        return method.apply(this, arguments);
      };
    }
    var assign;
    if (typeof Object.assign !== "function") {
      assign = function assign2(target) {
        if (target === undefined$1 || target === null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var output = Object(target);
        for (var index2 = 1; index2 < arguments.length; index2++) {
          var source = arguments[index2];
          if (source !== undefined$1 && source !== null) {
            for (var nextKey in source) {
              if (source.hasOwnProperty(nextKey)) {
                output[nextKey] = source[nextKey];
              }
            }
          }
        }
        return output;
      };
    } else {
      assign = Object.assign;
    }
    var extend2 = deprecate(function extend22(dest, src, merge22) {
      var keys = Object.keys(src);
      var i = 0;
      while (i < keys.length) {
        if (!merge22 || merge22 && dest[keys[i]] === undefined$1) {
          dest[keys[i]] = src[keys[i]];
        }
        i++;
      }
      return dest;
    }, "extend", "Use `assign`.");
    var merge2 = deprecate(function merge22(dest, src) {
      return extend2(dest, src, true);
    }, "merge", "Use `assign`.");
    function inherit(child, base2, properties) {
      var baseP = base2.prototype, childP;
      childP = child.prototype = Object.create(baseP);
      childP.constructor = child;
      childP._super = baseP;
      if (properties) {
        assign(childP, properties);
      }
    }
    function bindFn(fn, context) {
      return function boundFn() {
        return fn.apply(context, arguments);
      };
    }
    function boolOrFn(val, args) {
      if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined$1 : undefined$1, args);
      }
      return val;
    }
    function ifUndefined(val1, val2) {
      return val1 === undefined$1 ? val2 : val1;
    }
    function addEventListeners(target, types, handler) {
      each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
      });
    }
    function removeEventListeners(target, types, handler) {
      each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
      });
    }
    function hasParent(node, parent) {
      while (node) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    }
    function inStr(str, find) {
      return str.indexOf(find) > -1;
    }
    function splitStr(str) {
      return str.trim().split(/\s+/g);
    }
    function inArray(src, find, findByKey) {
      if (src.indexOf && !findByKey) {
        return src.indexOf(find);
      } else {
        var i = 0;
        while (i < src.length) {
          if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) {
            return i;
          }
          i++;
        }
        return -1;
      }
    }
    function toArray(obj) {
      return Array.prototype.slice.call(obj, 0);
    }
    function uniqueArray(src, key, sort) {
      var results = [];
      var values = [];
      var i = 0;
      while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
          results.push(src[i]);
        }
        values[i] = val;
        i++;
      }
      if (sort) {
        if (!key) {
          results = results.sort();
        } else {
          results = results.sort(function sortUniqueArray(a, b) {
            return a[key] > b[key];
          });
        }
      }
      return results;
    }
    function prefixed(obj, property) {
      var prefix, prop;
      var camelProp = property[0].toUpperCase() + property.slice(1);
      var i = 0;
      while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = prefix ? prefix + camelProp : property;
        if (prop in obj) {
          return prop;
        }
        i++;
      }
      return undefined$1;
    }
    var _uniqueId = 1;
    function uniqueId() {
      return _uniqueId++;
    }
    function getWindowForElement(element) {
      var doc2 = element.ownerDocument || element;
      return doc2.defaultView || doc2.parentWindow || window2;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = "ontouchstart" in window2;
    var SUPPORT_POINTER_EVENTS = prefixed(window2, "PointerEvent") !== undefined$1;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = "touch";
    var INPUT_TYPE_PEN = "pen";
    var INPUT_TYPE_MOUSE = "mouse";
    var INPUT_TYPE_KINECT = "kinect";
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = ["x", "y"];
    var PROPS_CLIENT_XY = ["clientX", "clientY"];
    function Input(manager, callback) {
      var self2 = this;
      this.manager = manager;
      this.callback = callback;
      this.element = manager.element;
      this.target = manager.options.inputTarget;
      this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
          self2.handler(ev);
        }
      };
      this.init();
    }
    Input.prototype = {
      handler: function() {
      },
      init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
      },
      destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
      }
    };
    function createInputInstance(manager) {
      var Type;
      var inputClass = manager.options.inputClass;
      if (inputClass) {
        Type = inputClass;
      } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
      } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
      } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
      } else {
        Type = TouchMouseInput;
      }
      return new Type(manager, inputHandler);
    }
    function inputHandler(manager, eventType, input) {
      var pointersLen = input.pointers.length;
      var changedPointersLen = input.changedPointers.length;
      var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
      var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
      input.isFirst = !!isFirst;
      input.isFinal = !!isFinal;
      if (isFirst) {
        manager.session = {};
      }
      input.eventType = eventType;
      computeInputData(manager, input);
      manager.emit("hammer.input", input);
      manager.recognize(input);
      manager.session.prevInput = input;
    }
    function computeInputData(manager, input) {
      var session = manager.session;
      var pointers = input.pointers;
      var pointersLength = pointers.length;
      if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
      }
      if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
      } else if (pointersLength === 1) {
        session.firstMultiple = false;
      }
      var firstInput = session.firstInput;
      var firstMultiple = session.firstMultiple;
      var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
      var center = input.center = getCenter(pointers);
      input.timeStamp = now();
      input.deltaTime = input.timeStamp - firstInput.timeStamp;
      input.angle = getAngle(offsetCenter, center);
      input.distance = getDistance(offsetCenter, center);
      computeDeltaXY(session, input);
      input.offsetDirection = getDirection2(input.deltaX, input.deltaY);
      var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
      input.overallVelocityX = overallVelocity.x;
      input.overallVelocityY = overallVelocity.y;
      input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
      input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
      input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
      input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
      computeIntervalInputData(session, input);
      var target = manager.element;
      if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
      }
      input.target = target;
    }
    function computeDeltaXY(session, input) {
      var center = input.center;
      var offset = session.offsetDelta || {};
      var prevDelta = session.prevDelta || {};
      var prevInput = session.prevInput || {};
      if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
          x: prevInput.deltaX || 0,
          y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
          x: center.x,
          y: center.y
        };
      }
      input.deltaX = prevDelta.x + (center.x - offset.x);
      input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    function computeIntervalInputData(session, input) {
      var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
      if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined$1)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
        direction = getDirection2(deltaX, deltaY);
        session.lastInterval = input;
      } else {
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
      }
      input.velocity = velocity;
      input.velocityX = velocityX;
      input.velocityY = velocityY;
      input.direction = direction;
    }
    function simpleCloneInputData(input) {
      var pointers = [];
      var i = 0;
      while (i < input.pointers.length) {
        pointers[i] = {
          clientX: round(input.pointers[i].clientX),
          clientY: round(input.pointers[i].clientY)
        };
        i++;
      }
      return {
        timeStamp: now(),
        pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
      };
    }
    function getCenter(pointers) {
      var pointersLength = pointers.length;
      if (pointersLength === 1) {
        return {
          x: round(pointers[0].clientX),
          y: round(pointers[0].clientY)
        };
      }
      var x = 0, y = 0, i = 0;
      while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
      }
      return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
      };
    }
    function getVelocity(deltaTime, x, y) {
      return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
      };
    }
    function getDirection2(x, y) {
      if (x === y) {
        return DIRECTION_NONE;
      }
      if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
      }
      return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    function getDistance(p1, p2, props) {
      if (!props) {
        props = PROPS_XY;
      }
      var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
      return Math.sqrt(x * x + y * y);
    }
    function getAngle(p1, p2, props) {
      if (!props) {
        props = PROPS_XY;
      }
      var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
      return Math.atan2(y, x) * 180 / Math.PI;
    }
    function getRotation(start, end) {
      return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    function getScale(start, end) {
      return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
      mousedown: INPUT_START,
      mousemove: INPUT_MOVE,
      mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = "mousedown";
    var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
    function MouseInput() {
      this.evEl = MOUSE_ELEMENT_EVENTS;
      this.evWin = MOUSE_WINDOW_EVENTS;
      this.pressed = false;
      Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
      handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];
        if (eventType & INPUT_START && ev.button === 0) {
          this.pressed = true;
        }
        if (eventType & INPUT_MOVE && ev.which !== 1) {
          eventType = INPUT_END;
        }
        if (!this.pressed) {
          return;
        }
        if (eventType & INPUT_END) {
          this.pressed = false;
        }
        this.callback(this.manager, eventType, {
          pointers: [ev],
          changedPointers: [ev],
          pointerType: INPUT_TYPE_MOUSE,
          srcEvent: ev
        });
      }
    });
    var POINTER_INPUT_MAP = {
      pointerdown: INPUT_START,
      pointermove: INPUT_MOVE,
      pointerup: INPUT_END,
      pointercancel: INPUT_CANCEL,
      pointerout: INPUT_CANCEL
    };
    var IE10_POINTER_TYPE_ENUM = {
      2: INPUT_TYPE_TOUCH,
      3: INPUT_TYPE_PEN,
      4: INPUT_TYPE_MOUSE,
      5: INPUT_TYPE_KINECT
    };
    var POINTER_ELEMENT_EVENTS = "pointerdown";
    var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
    if (window2.MSPointerEvent && !window2.PointerEvent) {
      POINTER_ELEMENT_EVENTS = "MSPointerDown";
      POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
    }
    function PointerEventInput() {
      this.evEl = POINTER_ELEMENT_EVENTS;
      this.evWin = POINTER_WINDOW_EVENTS;
      Input.apply(this, arguments);
      this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
      handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch = pointerType == INPUT_TYPE_TOUCH;
        var storeIndex = inArray(store, ev.pointerId, "pointerId");
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
          if (storeIndex < 0) {
            store.push(ev);
            storeIndex = store.length - 1;
          }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
          removePointer = true;
        }
        if (storeIndex < 0) {
          return;
        }
        store[storeIndex] = ev;
        this.callback(this.manager, eventType, {
          pointers: store,
          changedPointers: [ev],
          pointerType,
          srcEvent: ev
        });
        if (removePointer) {
          store.splice(storeIndex, 1);
        }
      }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
      touchstart: INPUT_START,
      touchmove: INPUT_MOVE,
      touchend: INPUT_END,
      touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
    var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
    function SingleTouchInput() {
      this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
      this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
      this.started = false;
      Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
      handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
        if (type === INPUT_START) {
          this.started = true;
        }
        if (!this.started) {
          return;
        }
        var touches = normalizeSingleTouches.call(this, ev, type);
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
          this.started = false;
        }
        this.callback(this.manager, type, {
          pointers: touches[0],
          changedPointers: touches[1],
          pointerType: INPUT_TYPE_TOUCH,
          srcEvent: ev
        });
      }
    });
    function normalizeSingleTouches(ev, type) {
      var all2 = toArray(ev.touches);
      var changed = toArray(ev.changedTouches);
      if (type & (INPUT_END | INPUT_CANCEL)) {
        all2 = uniqueArray(all2.concat(changed), "identifier", true);
      }
      return [all2, changed];
    }
    var TOUCH_INPUT_MAP = {
      touchstart: INPUT_START,
      touchmove: INPUT_MOVE,
      touchend: INPUT_END,
      touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
    function TouchInput() {
      this.evTarget = TOUCH_TARGET_EVENTS;
      this.targetIds = {};
      Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
      handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
          return;
        }
        this.callback(this.manager, type, {
          pointers: touches[0],
          changedPointers: touches[1],
          pointerType: INPUT_TYPE_TOUCH,
          srcEvent: ev
        });
      }
    });
    function getTouches(ev, type) {
      var allTouches = toArray(ev.touches);
      var targetIds = this.targetIds;
      if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
      }
      var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
      targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
      });
      if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
          targetIds[targetTouches[i].identifier] = true;
          i++;
        }
      }
      i = 0;
      while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
          changedTargetTouches.push(changedTouches[i]);
        }
        if (type & (INPUT_END | INPUT_CANCEL)) {
          delete targetIds[changedTouches[i].identifier];
        }
        i++;
      }
      if (!changedTargetTouches.length) {
        return;
      }
      return [
        uniqueArray(targetTouches.concat(changedTargetTouches), "identifier", true),
        changedTargetTouches
      ];
    }
    var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
      Input.apply(this, arguments);
      var handler = bindFn(this.handler, this);
      this.touch = new TouchInput(this.manager, handler);
      this.mouse = new MouseInput(this.manager, handler);
      this.primaryTouch = null;
      this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
      handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
          return;
        }
        if (isTouch) {
          recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
          return;
        }
        this.callback(manager, inputEvent, inputData);
      },
      destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
      }
    });
    function recordTouches(eventType, eventData) {
      if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
      } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
      }
    }
    function setLastTouch(eventData) {
      var touch = eventData.changedPointers[0];
      if (touch.identifier === this.primaryTouch) {
        var lastTouch = { x: touch.clientX, y: touch.clientY };
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
          var i = lts.indexOf(lastTouch);
          if (i > -1) {
            lts.splice(i, 1);
          }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
      }
    }
    function isSyntheticEvent(eventData) {
      var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
      for (var i = 0; i < this.lastTouches.length; i++) {
        var t2 = this.lastTouches[i];
        var dx = Math.abs(x - t2.x), dy = Math.abs(y - t2.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
          return true;
        }
      }
      return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined$1;
    var TOUCH_ACTION_COMPUTE = "compute";
    var TOUCH_ACTION_AUTO = "auto";
    var TOUCH_ACTION_MANIPULATION = "manipulation";
    var TOUCH_ACTION_NONE = "none";
    var TOUCH_ACTION_PAN_X = "pan-x";
    var TOUCH_ACTION_PAN_Y = "pan-y";
    var TOUCH_ACTION_MAP = getTouchActionProps();
    function TouchAction(manager, value) {
      this.manager = manager;
      this.set(value);
    }
    TouchAction.prototype = {
      set: function(value) {
        if (value == TOUCH_ACTION_COMPUTE) {
          value = this.compute();
        }
        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
          this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
      },
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
          if (boolOrFn(recognizer.options.enable, [recognizer])) {
            actions = actions.concat(recognizer.getTouchAction());
          }
        });
        return cleanTouchActions(actions.join(" "));
      },
      preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;
        if (this.manager.session.prevented) {
          srcEvent.preventDefault();
          return;
        }
        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
        if (hasNone) {
          var isTapPointer = input.pointers.length === 1;
          var isTapMovement = input.distance < 2;
          var isTapTouchTime = input.deltaTime < 250;
          if (isTapPointer && isTapMovement && isTapTouchTime) {
            return;
          }
        }
        if (hasPanX && hasPanY) {
          return;
        }
        if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) {
          return this.preventSrc(srcEvent);
        }
      },
      preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
      }
    };
    function cleanTouchActions(actions) {
      if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
      }
      var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
      var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
      if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
      }
      if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
      }
      if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
      }
      return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
      if (!NATIVE_TOUCH_ACTION) {
        return false;
      }
      var touchMap = {};
      var cssSupports = window2.CSS && window2.CSS.supports;
      ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(val) {
        touchMap[val] = cssSupports ? window2.CSS.supports("touch-action", val) : true;
      });
      return touchMap;
    }
    var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    function Recognizer(options) {
      this.options = assign({}, this.defaults, options || {});
      this.id = uniqueId();
      this.manager = null;
      this.options.enable = ifUndefined(this.options.enable, true);
      this.state = STATE_POSSIBLE;
      this.simultaneous = {};
      this.requireFail = [];
    }
    Recognizer.prototype = {
      defaults: {},
      set: function(options) {
        assign(this.options, options);
        this.manager && this.manager.touchAction.update();
        return this;
      },
      recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) {
          return this;
        }
        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
          simultaneous[otherRecognizer.id] = otherRecognizer;
          otherRecognizer.recognizeWith(this);
        }
        return this;
      },
      dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) {
          return this;
        }
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
      },
      requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "requireFailure", this)) {
          return this;
        }
        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
          requireFail.push(otherRecognizer);
          otherRecognizer.requireFailure(this);
        }
        return this;
      },
      dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) {
          return this;
        }
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index2 = inArray(this.requireFail, otherRecognizer);
        if (index2 > -1) {
          this.requireFail.splice(index2, 1);
        }
        return this;
      },
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
      },
      emit: function(input) {
        var self2 = this;
        var state2 = this.state;
        function emit2(event) {
          self2.manager.emit(event, input);
        }
        if (state2 < STATE_ENDED) {
          emit2(self2.options.event + stateStr(state2));
        }
        emit2(self2.options.event);
        if (input.additionalEvent) {
          emit2(input.additionalEvent);
        }
        if (state2 >= STATE_ENDED) {
          emit2(self2.options.event + stateStr(state2));
        }
      },
      tryEmit: function(input) {
        if (this.canEmit()) {
          return this.emit(input);
        }
        this.state = STATE_FAILED;
      },
      canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
          if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
            return false;
          }
          i++;
        }
        return true;
      },
      recognize: function(inputData) {
        var inputDataClone = assign({}, inputData);
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
          this.reset();
          this.state = STATE_FAILED;
          return;
        }
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
          this.state = STATE_POSSIBLE;
        }
        this.state = this.process(inputDataClone);
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
          this.tryEmit(inputDataClone);
        }
      },
      process: function(inputData) {
      },
      getTouchAction: function() {
      },
      reset: function() {
      }
    };
    function stateStr(state2) {
      if (state2 & STATE_CANCELLED) {
        return "cancel";
      } else if (state2 & STATE_ENDED) {
        return "end";
      } else if (state2 & STATE_CHANGED) {
        return "move";
      } else if (state2 & STATE_BEGAN) {
        return "start";
      }
      return "";
    }
    function directionStr(direction) {
      if (direction == DIRECTION_DOWN) {
        return "down";
      } else if (direction == DIRECTION_UP) {
        return "up";
      } else if (direction == DIRECTION_LEFT) {
        return "left";
      } else if (direction == DIRECTION_RIGHT) {
        return "right";
      }
      return "";
    }
    function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
      var manager = recognizer.manager;
      if (manager) {
        return manager.get(otherRecognizer);
      }
      return otherRecognizer;
    }
    function AttrRecognizer() {
      Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
      defaults: {
        pointers: 1
      },
      attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
      },
      process: function(input) {
        var state2 = this.state;
        var eventType = input.eventType;
        var isRecognized = state2 & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
          return state2 | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
          if (eventType & INPUT_END) {
            return state2 | STATE_ENDED;
          } else if (!(state2 & STATE_BEGAN)) {
            return STATE_BEGAN;
          }
          return state2 | STATE_CHANGED;
        }
        return STATE_FAILED;
      }
    });
    function PanRecognizer() {
      AttrRecognizer.apply(this, arguments);
      this.pX = null;
      this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
      },
      getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
          actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
          actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
      },
      directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;
        if (!(direction & options.direction)) {
          if (options.direction & DIRECTION_HORIZONTAL) {
            direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
            hasMoved = x != this.pX;
            distance = Math.abs(input.deltaX);
          } else {
            direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
            hasMoved = y != this.pY;
            distance = Math.abs(input.deltaY);
          }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
      },
      attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
      },
      emit: function(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = directionStr(input.direction);
        if (direction) {
          input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
      }
    });
    function PinchRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
      },
      attrTest: function(input) {
        return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
      },
      emit: function(input) {
        if (input.scale !== 1) {
          var inOut = input.scale < 1 ? "in" : "out";
          input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
      }
    });
    function PressRecognizer() {
      Recognizer.apply(this, arguments);
      this._timer = null;
      this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        threshold: 9
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
      },
      process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;
        this._input = input;
        if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) {
          this.reset();
        } else if (input.eventType & INPUT_START) {
          this.reset();
          this._timer = setTimeoutContext(function() {
            this.state = STATE_RECOGNIZED;
            this.tryEmit();
          }, options.time, this);
        } else if (input.eventType & INPUT_END) {
          return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
          return;
        }
        if (input && input.eventType & INPUT_END) {
          this.manager.emit(this.options.event + "up", input);
        } else {
          this._input.timeStamp = now();
          this.manager.emit(this.options.event, this._input);
        }
      }
    });
    function RotateRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
      },
      attrTest: function(input) {
        return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
      }
    });
    function SwipeRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
      },
      getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
      },
      attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;
        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
          velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
          velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
          velocity = input.overallVelocityY;
        }
        return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
      },
      emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
          this.manager.emit(this.options.event + direction, input);
        }
        this.manager.emit(this.options.event, input);
      }
    });
    function TapRecognizer() {
      Recognizer.apply(this, arguments);
      this.pTime = false;
      this.pCenter = false;
      this._timer = null;
      this._input = null;
      this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        time: 250,
        threshold: 9,
        posThreshold: 10
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
      },
      process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;
        this.reset();
        if (input.eventType & INPUT_START && this.count === 0) {
          return this.failTimeout();
        }
        if (validMovement && validTouchTime && validPointers) {
          if (input.eventType != INPUT_END) {
            return this.failTimeout();
          }
          var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
          var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
          this.pTime = input.timeStamp;
          this.pCenter = input.center;
          if (!validMultiTap || !validInterval) {
            this.count = 1;
          } else {
            this.count += 1;
          }
          this._input = input;
          var tapCount = this.count % options.taps;
          if (tapCount === 0) {
            if (!this.hasRequireFailures()) {
              return STATE_RECOGNIZED;
            } else {
              this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
              }, options.interval, this);
              return STATE_BEGAN;
            }
          }
        }
        return STATE_FAILED;
      },
      failTimeout: function() {
        this._timer = setTimeoutContext(function() {
          this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        if (this.state == STATE_RECOGNIZED) {
          this._input.tapCount = this.count;
          this.manager.emit(this.options.event, this._input);
        }
      }
    });
    function Hammer(element, options) {
      options = options || {};
      options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
      return new Manager(element, options);
    }
    Hammer.VERSION = "2.0.7";
    Hammer.defaults = {
      domEvents: false,
      touchAction: TOUCH_ACTION_COMPUTE,
      enable: true,
      inputTarget: null,
      inputClass: null,
      preset: [
        [RotateRecognizer, { enable: false }],
        [PinchRecognizer, { enable: false }, ["rotate"]],
        [SwipeRecognizer, { direction: DIRECTION_HORIZONTAL }],
        [PanRecognizer, { direction: DIRECTION_HORIZONTAL }, ["swipe"]],
        [TapRecognizer],
        [TapRecognizer, { event: "doubletap", taps: 2 }, ["tap"]],
        [PressRecognizer]
      ],
      cssProps: {
        userSelect: "none",
        touchSelect: "none",
        touchCallout: "none",
        contentZooming: "none",
        userDrag: "none",
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    function Manager(element, options) {
      this.options = assign({}, Hammer.defaults, options || {});
      this.options.inputTarget = this.options.inputTarget || element;
      this.handlers = {};
      this.session = {};
      this.recognizers = [];
      this.oldCssProps = {};
      this.element = element;
      this.input = createInputInstance(this);
      this.touchAction = new TouchAction(this, this.options.touchAction);
      toggleCssProps(this, true);
      each(this.options.recognizers, function(item) {
        var recognizer = this.add(new item[0](item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
      }, this);
    }
    Manager.prototype = {
      set: function(options) {
        assign(this.options, options);
        if (options.touchAction) {
          this.touchAction.update();
        }
        if (options.inputTarget) {
          this.input.destroy();
          this.input.target = options.inputTarget;
          this.input.init();
        }
        return this;
      },
      stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
      },
      recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
          return;
        }
        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers;
        var curRecognizer = session.curRecognizer;
        if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
          curRecognizer = session.curRecognizer = null;
        }
        var i = 0;
        while (i < recognizers.length) {
          recognizer = recognizers[i];
          if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || recognizer.canRecognizeWith(curRecognizer))) {
            recognizer.recognize(inputData);
          } else {
            recognizer.reset();
          }
          if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
            curRecognizer = session.curRecognizer = recognizer;
          }
          i++;
        }
      },
      get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
          return recognizer;
        }
        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
          if (recognizers[i].options.event == recognizer) {
            return recognizers[i];
          }
        }
        return null;
      },
      add: function(recognizer) {
        if (invokeArrayArg(recognizer, "add", this)) {
          return this;
        }
        var existing = this.get(recognizer.options.event);
        if (existing) {
          this.remove(existing);
        }
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
      },
      remove: function(recognizer) {
        if (invokeArrayArg(recognizer, "remove", this)) {
          return this;
        }
        recognizer = this.get(recognizer);
        if (recognizer) {
          var recognizers = this.recognizers;
          var index2 = inArray(recognizers, recognizer);
          if (index2 !== -1) {
            recognizers.splice(index2, 1);
            this.touchAction.update();
          }
        }
        return this;
      },
      on: function(events, handler) {
        if (events === undefined$1) {
          return;
        }
        if (handler === undefined$1) {
          return;
        }
        var handlers = this.handlers;
        each(splitStr(events), function(event) {
          handlers[event] = handlers[event] || [];
          handlers[event].push(handler);
        });
        return this;
      },
      off: function(events, handler) {
        if (events === undefined$1) {
          return;
        }
        var handlers = this.handlers;
        each(splitStr(events), function(event) {
          if (!handler) {
            delete handlers[event];
          } else {
            handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
          }
        });
        return this;
      },
      emit: function(event, data2) {
        if (this.options.domEvents) {
          triggerDomEvent(event, data2);
        }
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
          return;
        }
        data2.type = event;
        data2.preventDefault = function() {
          data2.srcEvent.preventDefault();
        };
        var i = 0;
        while (i < handlers.length) {
          handlers[i](data2);
          i++;
        }
      },
      destroy: function() {
        this.element && toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
      }
    };
    function toggleCssProps(manager, add2) {
      var element = manager.element;
      if (!element.style) {
        return;
      }
      var prop;
      each(manager.options.cssProps, function(value, name2) {
        prop = prefixed(element.style, name2);
        if (add2) {
          manager.oldCssProps[prop] = element.style[prop];
          element.style[prop] = value;
        } else {
          element.style[prop] = manager.oldCssProps[prop] || "";
        }
      });
      if (!add2) {
        manager.oldCssProps = {};
      }
    }
    function triggerDomEvent(event, data2) {
      var gestureEvent = document2.createEvent("Event");
      gestureEvent.initEvent(event, true, true);
      gestureEvent.gesture = data2;
      data2.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
      INPUT_START,
      INPUT_MOVE,
      INPUT_END,
      INPUT_CANCEL,
      STATE_POSSIBLE,
      STATE_BEGAN,
      STATE_CHANGED,
      STATE_ENDED,
      STATE_RECOGNIZED,
      STATE_CANCELLED,
      STATE_FAILED,
      DIRECTION_NONE,
      DIRECTION_LEFT,
      DIRECTION_RIGHT,
      DIRECTION_UP,
      DIRECTION_DOWN,
      DIRECTION_HORIZONTAL,
      DIRECTION_VERTICAL,
      DIRECTION_ALL,
      Manager,
      Input,
      TouchAction,
      TouchInput,
      MouseInput,
      PointerEventInput,
      TouchMouseInput,
      SingleTouchInput,
      Recognizer,
      AttrRecognizer,
      Tap: TapRecognizer,
      Pan: PanRecognizer,
      Swipe: SwipeRecognizer,
      Pinch: PinchRecognizer,
      Rotate: RotateRecognizer,
      Press: PressRecognizer,
      on: addEventListeners,
      off: removeEventListeners,
      each,
      merge: merge2,
      extend: extend2,
      assign,
      inherit,
      bindFn,
      prefixed
    });
    var freeGlobal = typeof window2 !== "undefined" ? window2 : typeof self !== "undefined" ? self : {};
    freeGlobal.Hammer = Hammer;
    if (typeof undefined$1 === "function" && undefined$1.amd) {
      undefined$1(function() {
        return Hammer;
      });
    } else if (module2.exports) {
      module2.exports = Hammer;
    } else {
      window2[exportName] = Hammer;
    }
  })(window, document, "Hammer");
})(hammer);
var useGesture = (slideTo, MAX_SCALE_RATE2) => {
  let iniScale = 1, el;
  const transform = reactive(getIniTransform());
  const transformStyle = reactive({ transform: "", transformOrigin: "" });
  function getIniTransform() {
    return {
      scale: 1,
      translate: { x: 0, y: 0, startX: 0, startY: 0 },
      origin: "center"
    };
  }
  let elSize = {
    w: 0,
    h: 0
  };
  function bindEvent(bindElement) {
    el = bindElement;
    elSize = {
      w: el.offsetWidth,
      h: el.offsetHeight
    };
    const mc = new hammer.exports.Manager(bindElement);
    mc.add(new hammer.exports.Pan({ threshold: 0, pointers: 0 }));
    mc.add(new hammer.exports.Swipe()).recognizeWith(mc.get("pan"));
    mc.add(new hammer.exports.Pinch({ threshold: 0 }).recognizeWith(mc.get("pan")));
    mc.add(new hammer.exports.Tap({ event: "doubletap", taps: 2 }));
    mc.on("panstart panmove", onPan);
    mc.on("pinchstart pinchmove", onPinch);
    mc.on("doubletap", onDoulebleTap);
    mc.on("swipe", onSwipe);
  }
  function getOrigin(center) {
    return {
      x: center.x - el.offsetLeft,
      y: center.y - el.offsetTop
    };
  }
  function updateTransformStyle() {
    const { scale, translate, origin } = transform;
    Object.assign(transformStyle, {
      transform: `translate(${translate.x}px,${translate.y}px) scale(${scale})`,
      transformOrigin: typeof origin === "string" ? origin : `${origin.x}px ${origin.y}px`
    });
  }
  function onPan(e) {
    const { translate, scale, origin } = transform;
    if (typeof origin === "string")
      return;
    if (e.type === "panstart") {
      const { x, y } = transform.translate;
      [
        transform.translate.startX,
        transform.translate.startY
      ] = [x, y];
    }
    if (scale > 1) {
      const { startX, startY } = translate;
      const [dx, dy] = [startX + e.deltaX, startY + e.deltaY];
      Object.assign(transform.translate, {
        x: dx > 0 ? Math.min(origin.x * (scale - 1), dx) : Math.max((origin.x - elSize.w) * (scale - 1), dx),
        y: dy > 0 ? Math.min(origin.y * (scale - 1), dy) : Math.max((origin.y - elSize.h) * (scale - 1), dy)
      });
    }
    updateTransformStyle();
  }
  function onPinch(e) {
    if (e.type === "pinchstart") {
      iniScale = transform.scale;
      transform.origin = getOrigin(e.center);
    }
    transform.scale = Math.max(1, +Math.min(iniScale * e.scale, MAX_SCALE_RATE2).toFixed(2));
    if (transform.scale == 1) {
      ResetTransformStyle();
      return;
    }
    updateTransformStyle();
  }
  function onSwipe(e) {
    if (transform.scale > 1 || slideTo === void 0)
      return;
    const direction = e.offsetDirection;
    if (direction == 2) {
      slideTo(1);
    } else if (direction == 4) {
      slideTo(-1);
    }
  }
  function onDoulebleTap(e) {
    if (transform.scale == 1) {
      transform.origin = getOrigin(e.center);
      transform.scale = 3;
      updateTransformStyle();
    } else {
      ResetTransformStyle();
    }
  }
  function ResetTransformStyle() {
    Object.assign(transform, getIniTransform());
    updateTransformStyle();
  }
  return {
    bindEvent,
    transform,
    transformStyle
  };
};
const _hoisted_1$4 = { class: "cp-flex cp-justify-between cp-items-center cp-w-1/2 cp-relative cp-top-1 cp-select-none" };
const _hoisted_2$3 = { class: "cp-h-xs cp-w-md cp-bg-gray-200" };
const _hoisted_3$2 = { class: "cp-mx-md" };
const _hoisted_4$2 = { class: "cp-h-xs cp-w-md cp-bg-gray-200" };
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  props: {
    pagination: null
  },
  emits: ["change"],
  setup(__props, { emit: emit2 }) {
    function submitEmit(plus) {
      emit2("change", plus);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$4, [
        withDirectives(createBaseVNode("div", {
          class: "cp-arrow-md-l cp-border-gray-500 cp-cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event) => submitEmit(-1))
        }, null, 512), [
          [vShow, __props.pagination.index > 1]
        ]),
        withDirectives(createBaseVNode("div", _hoisted_2$3, null, 512), [
          [vShow, __props.pagination.index <= 1]
        ]),
        createBaseVNode("div", _hoisted_3$2, toDisplayString(__props.pagination.index) + "/" + toDisplayString(__props.pagination.total), 1),
        withDirectives(createBaseVNode("div", {
          class: "cp-arrow-md-r cp-border-gray-500 cp-cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event) => submitEmit(1))
        }, null, 512), [
          [vShow, __props.pagination.index < __props.pagination.total]
        ]),
        withDirectives(createBaseVNode("div", _hoisted_4$2, null, 512), [
          [vShow, __props.pagination.index >= __props.pagination.total]
        ])
      ]);
    };
  }
});
const _hoisted_1$3 = ["src"];
const Animation_Duration = 1e3;
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  props: {
    src: null,
    size: null
  },
  setup(__props, { expose }) {
    const animationName = ref(), pagingLoading = ref(false);
    function paging(name2) {
      if (pagingLoading.value)
        return false;
      pagingLoading.value = true;
      animationName.value = name2;
      sleep$1(Animation_Duration).then(() => {
        pagingLoading.value = false;
        animationName.value = "";
      });
      return true;
    }
    expose({
      pageNext: () => paging("next"),
      pagePrev: () => paging("prev")
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("img", {
        src: __props.src,
        style: normalizeStyle({
          width: __props.size.width + "px",
          height: __props.size.height + "px"
        }),
        class: normalizeClass([
          animationName.value,
          { "cp-invisible": !pagingLoading.value },
          "filp-item cp-pointer-events-none cp-z-10 cp-absolute cp-left-0 cp-origin-left cp-object-contain cp-bg-white"
        ])
      }, null, 14, _hoisted_1$3);
    };
  }
});
const _hoisted_1$2 = {
  key: 1,
  class: "cp-h-full cp-flex cp-flex-col cp-justify-between cp-overflow-hidden"
};
const _hoisted_2$2 = {
  key: 0,
  class: "shadow-book cp-h-full cp-pointer-events-none cp-w-full cp-my-auto"
};
const _hoisted_3$1 = ["src"];
const _hoisted_4$1 = ["src", "onLoad"];
const _hoisted_5$1 = {
  key: 0,
  class: "cp-mt-md cp-mb-xl cp-flex cp-justify-center cp-bg-white"
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  props: {
    pdfUrl: null,
    wmOptions: null,
    pages: null,
    maxPage: null
  },
  emits: ["end", "progress", "loaded", "error"],
  setup(__props, { expose, emit: emit2 }) {
    const props = __props;
    const { createPdfTask, pdfPromise, imgPages, numPages, errorMsg, calMaxPage } = usePdfTask(emit2, props.pdfUrl, {
      pages: props.pages,
      maxPage: toRef(props, "maxPage")
    });
    watch(errorMsg, (v) => {
      v && emit2("error", v);
    }, { immediate: true });
    const range = reactive([]), activePage = ref(0), oldPage = ref(0), pagination = reactive({
      index: activePage,
      total: numPages
    }), { wmStyle } = useMw(toRef(props, "wmOptions"));
    async function createPdf() {
      await createPdfTask();
      if (calMaxPage.value <= 0)
        return;
      oldPage.value = activePage.value = 1;
      fillRange(2);
    }
    function fillRange(page) {
      range.splice(0, range.length, page - 1, page, page + 1);
    }
    const { loadChange, onImgLoad, sizeArr } = useLoadList(void 0, emit2);
    const shadowStyle = computed(() => {
      const t2 = sizeArr[activePage.value];
      if (!t2)
        return;
      const { width: width2, height: height2 } = t2;
      return {
        width: width2 + "px",
        height: height2 + "px",
        "--shadow-width": width2 + "px"
      };
    });
    const paging = ref(), rootClass = ref(), shadowClass = ref();
    async function slideBy(plus) {
      if (rootClass.value || shadowClass.value) {
        rootClass.value = shadowClass.value = "";
        await sleep$1(50);
      }
      let target = activePage.value + plus, canAnime = true;
      const { value: total } = calMaxPage;
      if (target > total) {
        target = total;
        canAnime = false;
        emit2("end", { maxPage: props.maxPage, total: numPages.value });
      } else if (target < 1) {
        target = 1;
        canAnime = false;
      }
      if (canAnime) {
        const pageSuccess = plus > 0 ? pageNext() : pagePrev();
        if (!pageSuccess)
          return;
        if (imgPages.value) {
          if (plus < 0) {
            oldPage.value = target;
            await sleep$1(Animation_Duration);
          } else {
            sleep$1(Animation_Duration).then(() => oldPage.value = target);
          }
        }
        if (activePage.value !== target) {
          fillRange(activePage.value + plus);
          activePage.value = target;
        }
      }
    }
    function pageNext() {
      var _a2;
      if (imgPages.value) {
        const t2 = (_a2 = paging.value) == null ? void 0 : _a2.pageNext();
        t2 && (shadowClass.value = "move-shadow-next");
        return t2;
      } else {
        rootClass.value = "move-next";
      }
      return true;
    }
    function pagePrev() {
      var _a2;
      if (imgPages.value) {
        const t2 = (_a2 = paging.value) == null ? void 0 : _a2.pagePrev();
        t2 && (shadowClass.value = "move-shadow-prev");
        return t2;
      } else {
        rootClass.value = "move-prev";
      }
      return true;
    }
    setViewPort(false);
    createPdf();
    const { bindEvent, transformStyle } = useGesture(slideBy, 3);
    const renderRoot = ref();
    onMounted(() => {
      renderRoot.value && bindEvent(renderRoot.value);
    });
    expose({
      slideBy,
      activePage
    });
    return (_ctx, _cache) => {
      var _a2;
      return unref(errorMsg) ? (openBlock(), createBlock(_sfc_main$7, {
        key: 0,
        text: unref(errorMsg)
      }, null, 8, ["text"])) : (openBlock(), createElementBlock("div", _hoisted_1$2, [
        createBaseVNode("div", {
          ref_key: "renderRoot",
          ref: renderRoot,
          class: normalizeClass([rootClass.value, "cp-flex-auto cp-relative cp-overflow-hidden cp-overflow-y-auto cp-h-full cp-flex"]),
          style: normalizeStyle(unref(transformStyle))
        }, [
          unref(imgPages) ? (openBlock(), createElementBlock("div", _hoisted_2$2, [
            unref(sizeArr)[oldPage.value] ? (openBlock(), createBlock(_sfc_main$3, {
              key: 0,
              ref_key: "paging",
              ref: paging,
              src: unref(imgPages)[oldPage.value - 1],
              size: unref(sizeArr)[oldPage.value]
            }, null, 8, ["src", "size"])) : createCommentVNode("", true),
            ((_a2 = __props.wmOptions) == null ? void 0 : _a2.content) ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              __props.wmOptions.type === "img" ? (openBlock(), createElementBlock("img", {
                key: 0,
                src: __props.wmOptions.content,
                style: normalizeStyle(unref(wmStyle)),
                class: "cp-object-contain cp-absolute"
              }, null, 12, _hoisted_3$1)) : (openBlock(), createElementBlock("div", {
                key: 1,
                class: "cp-overflow-hidden cp-absolute cp-left-0 cp-z-10 cp-pointer-events-none",
                style: normalizeStyle(unref(shadowStyle))
              }, [
                createBaseVNode("div", {
                  style: normalizeStyle(unref(wmStyle))
                }, null, 4)
              ], 4))
            ], 64)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(range), (page) => {
              return openBlock(), createElementBlock("img", {
                key: page,
                src: unref(imgPages)[page - 1],
                class: normalizeClass([
                  "cp-w-full cp-h-full cp-object-contain",
                  { "cp-invisible cp-absolute cp-left-0 cp-top-0": page != activePage.value }
                ]),
                onLoad: ($event) => unref(onImgLoad)(page, unref(range).length, $event.target)
              }, null, 42, _hoisted_4$1);
            }), 128))
          ])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(unref(range), (page) => {
            return openBlock(), createBlock(_sfc_main$6, mergeProps({
              key: page,
              type: "svg",
              class: [{ "cp-invisible cp-absolute cp-left-0 cp-top-0": page != activePage.value }],
              page,
              pdf: unref(pdfPromise)
            }, _ctx.$attrs, { onChange: unref(loadChange) }), null, 16, ["class", "page", "pdf", "onChange"]);
          }), 128))
        ], 6),
        unref(range).length ? (openBlock(), createElementBlock("div", _hoisted_5$1, [
          createVNode(_sfc_main$4, {
            pagination: unref(pagination),
            onChange: slideBy
          }, null, 8, ["pagination"])
        ])) : createCommentVNode("", true)
      ]));
    };
  }
});
const _hoisted_1$1$1 = {
  key: 0,
  class: "cp-text-xs"
};
const _hoisted_2$1$1 = ["onClick"];
const _hoisted_3$5 = ["src"];
const _hoisted_4$4 = /* @__PURE__ */ createBaseVNode("div", { class: "cp-invisible cp-p-xs" }, "h", -1);
const _sfc_main$1$1 = /* @__PURE__ */ defineComponent({
  props: {
    buttonOptions: null,
    pdfUrl: null
  },
  emits: ["button-clicked"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const buttonToggleProps = computed(() => {
      const { buttonIcons } = props.buttonOptions;
      return {
        src: buttonVisible.value ? buttonIcons.toggleFalseIcon : buttonIcons.toggleTrueIcon
      };
    });
    const buttonStyle = computed(() => {
      const { buttonIcons, type } = props.buttonOptions;
      let dynamicStyle = {}, marginStyle = {};
      if (type === "vertical") {
        dynamicStyle = {
          width: buttonIcons.width + "px",
          flexDirection: "column",
          alignItems: "center"
        };
        marginStyle = {
          marginTop: buttonIcons.spacing + "px"
        };
      } else {
        dynamicStyle = {
          flexDirection: "row",
          alignItems: "flex-start"
        };
        marginStyle = {
          marginLeft: buttonIcons.spacing + "px"
        };
      }
      return {
        size: {
          width: buttonIcons.width + "px",
          height: buttonIcons.height + "px"
        },
        wrapper: __spreadValues({
          [buttonIcons.position.x.key]: buttonIcons.position.x.value + "px",
          [buttonIcons.position.y.key]: buttonIcons.position.y.value + "px"
        }, dynamicStyle),
        margin: marginStyle
      };
    });
    const isWx = isWeixin$1(), buttonVisible = ref(true);
    const hasVisibleButton = computed(() => props.buttonOptions.actions.some((t2) => t2.visible));
    function clickButton(item) {
      if (item.id == 2) {
        switchShareVisible();
      }
      emitButton(item);
    }
    function emitButton(item) {
      emit2("button-clicked", item);
    }
    function switchButtonVisible() {
      buttonVisible.value = !buttonVisible.value;
    }
    const shareVisible = ref(false);
    function switchShareVisible() {
      shareVisible.value = !shareVisible.value;
    }
    return (_ctx, _cache) => {
      return unref(hasVisibleButton) ? (openBlock(), createElementBlock("div", _hoisted_1$1$1, [
        createBaseVNode("div", {
          class: "cp-fixed cp-flex",
          style: normalizeStyle(unref(buttonStyle).wrapper)
        }, [
          createBaseVNode("div", {
            class: normalizeClass(["cp-flex", { "cp-invisible": !buttonVisible.value }]),
            style: normalizeStyle({ flexDirection: unref(buttonStyle).wrapper.flexDirection })
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.buttonOptions.actions, (item) => {
              return withDirectives((openBlock(), createElementBlock("div", {
                key: item.id,
                class: "cp-flex cp-flex-col cp-items-center cp-cursor-pointer",
                style: normalizeStyle(unref(buttonStyle).margin),
                onClick: ($event) => clickButton(item)
              }, [
                item.icon ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  src: item.icon,
                  style: normalizeStyle(unref(buttonStyle).size),
                  class: "cp-object-contain cp-mb-xs cp-filter cp-drop-shadow"
                }, null, 12, _hoisted_3$5)) : createCommentVNode("", true),
                withDirectives(createBaseVNode("div", { class: "cp-min-w-12 cp-text-center cp-bg-white cp-text-xs cp-p-xs cp-rounded-sm cp-shadow cp-whitespace-nowrap" }, toDisplayString(item.text), 513), [
                  [vShow, item.showText]
                ])
              ], 12, _hoisted_2$1$1)), [
                [vShow, (item.id == 2 ? unref(isWx) : true) && item.visible]
              ]);
            }), 128))
          ], 6),
          createBaseVNode("div", {
            class: "flex flex-col",
            style: normalizeStyle(unref(buttonStyle).margin)
          }, [
            createBaseVNode("img", mergeProps(unref(buttonToggleProps), {
              style: unref(buttonStyle).size,
              class: "cp-cursor-pointer cp-object-contain cp-object-center cp-filter cp-drop-shadow cp-mb-xs",
              onClick: switchButtonVisible
            }), null, 16),
            _hoisted_4$4
          ], 4)
        ], 4),
        (openBlock(), createBlock(Teleport, { to: "body" }, [
          createVNode(Transition, { name: "fade" }, {
            default: withCtx(() => [
              withDirectives(createBaseVNode("div", {
                class: "cp-fixed cp-left-0 cp-top-0 cp-h-screen cp-w-screen cp-bg-black cp-bg-opacity-70 cp-p-xl cp-flex cp-justify-end",
                onClick: switchShareVisible
              }, [
                createBaseVNode("div", {
                  class: "cp-w-1/2 cp-h-1/2 cp-bg-contain cp-bg-no-repeat cp-bg-top",
                  style: normalizeStyle({
                    backgroundImage: "url(https://oss.cloud.custouch.com/cus_files/custouch/site/image/share-cover.png)"
                  })
                }, null, 4)
              ], 512), [
                [vShow, shareVisible.value]
              ])
            ]),
            _: 1
          })
        ]))
      ])) : createCommentVNode("", true);
    };
  }
});
const _hoisted_1$9 = { class: "cp-relative" };
const _hoisted_2$7 = {
  key: 0,
  class: "cp-absolute cp-left-0 cp-top-0 cp-z-20 cp-w-screen cp-h-screen cp-flex cp-justify-center cp-items-center cp-bg-gray-200"
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  props: {
    type: { default: "fullPage" },
    showLoading: { type: Boolean, default: true },
    buttonOptions: null,
    maxPage: { default: 0 },
    pdfUrl: null,
    wmOptions: { default: () => ({}) },
    pages: { default: () => [] }
  },
  emits: ["end", "button-clicked", "loaded"],
  setup(__props, { expose, emit: emit2 }) {
    const props = __props;
    const showProgress = ref(true);
    const progressVal = ref(0);
    function onProgress(p2) {
      progressVal.value = p2;
    }
    const startTime = Date.now();
    function loaded(page) {
      emit2("loaded", page);
      hideProgress();
    }
    async function hideProgress() {
      await sleep$1(1e3 - (Date.now() - startTime));
      showProgress.value = false;
    }
    function onError() {
      hideProgress();
    }
    const renderView = computed(() => props.type === "book" ? _sfc_main$2 : _sfc_main$5);
    function slideBy(input) {
      var _a2, _b;
      (_b = (_a2 = renderViewRef.value).slideBy) == null ? void 0 : _b.call(_a2, input);
    }
    const renderViewRef = ref();
    expose({
      slideBy,
      activeIndex: computed(() => {
        var _a2;
        return (_a2 = renderViewRef.value) == null ? void 0 : _a2.activePage;
      }),
      range: computed(() => {
        var _a2;
        return (_a2 = renderViewRef.value) == null ? void 0 : _a2.range;
      })
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$9, [
        __props.showLoading && showProgress.value ? (openBlock(), createElementBlock("div", _hoisted_2$7, [
          createVNode(_sfc_main$8, {
            modelValue: progressVal.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => progressVal.value = $event)
          }, null, 8, ["modelValue"])
        ])) : createCommentVNode("", true),
        (openBlock(), createBlock(resolveDynamicComponent(unref(renderView)), {
          ref_key: "renderViewRef",
          ref: renderViewRef,
          "pdf-url": __props.pdfUrl,
          "wm-options": __props.wmOptions,
          pages: __props.pages,
          "max-page": __props.maxPage,
          onLoaded: loaded,
          onProgress,
          onEnd: _cache[1] || (_cache[1] = (t2) => emit2("end", t2)),
          onError
        }, null, 8, ["pdf-url", "wm-options", "pages", "max-page"])),
        renderSlot(_ctx.$slots, "buttons", {}, () => [
          !__props.maxPage && __props.buttonOptions ? (openBlock(), createBlock(_sfc_main$1$1, {
            key: 0,
            "pdf-url": __props.pdfUrl,
            buttonOptions: __props.buttonOptions,
            onButtonClicked: _cache[2] || (_cache[2] = (t2) => emit2("button-clicked", t2))
          }, null, 8, ["pdf-url", "buttonOptions"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
const style = "";
function noop() {
}
const extend$1 = Object.assign;
const inBrowser$1 = typeof window !== "undefined";
function get(object, path) {
  const keys = path.split(".");
  let result = object;
  keys.forEach((key) => {
    var _a2;
    result = (_a2 = result[key]) != null ? _a2 : "";
  });
  return result;
}
function pick(obj, keys, ignoreUndefined) {
  return keys.reduce((ret, key) => {
    if (!ignoreUndefined || obj[key] !== void 0) {
      ret[key] = obj[key];
    }
    return ret;
  }, {});
}
const unknownProp = null;
const numericProp = [Number, String];
const truthProp = {
  type: Boolean,
  default: true
};
const makeStringProp = (defaultVal) => ({
  type: String,
  default: defaultVal
});
var inBrowser = typeof window !== "undefined";
var isWindow = (val) => val === window;
var makeDOMRect = (width2, height2) => ({
  top: 0,
  left: 0,
  right: width2,
  bottom: height2,
  width: width2,
  height: height2
});
var useRect = (elementOrRef) => {
  const element = unref(elementOrRef);
  if (isWindow(element)) {
    const width2 = element.innerWidth;
    const height2 = element.innerHeight;
    return makeDOMRect(width2, height2);
  }
  if (element == null ? void 0 : element.getBoundingClientRect) {
    return element.getBoundingClientRect();
  }
  return makeDOMRect(0, 0);
};
function useParent(key) {
  const parent = inject(key, null);
  if (parent) {
    const instance2 = getCurrentInstance();
    const { link, unlink, internalChildren } = parent;
    link(instance2);
    onUnmounted(() => unlink(instance2));
    const index2 = computed(() => internalChildren.indexOf(instance2));
    return {
      parent,
      index: index2
    };
  }
  return {
    parent: null,
    index: ref(-1)
  };
}
function flattenVNodes(children) {
  const result = [];
  const traverse2 = (children2) => {
    if (Array.isArray(children2)) {
      children2.forEach((child) => {
        var _a2;
        if (isVNode(child)) {
          result.push(child);
          if ((_a2 = child.component) == null ? void 0 : _a2.subTree) {
            result.push(child.component.subTree);
            traverse2(child.component.subTree.children);
          }
          if (child.children) {
            traverse2(child.children);
          }
        }
      });
    }
  };
  traverse2(children);
  return result;
}
function sortChildren(parent, publicChildren, internalChildren) {
  const vnodes = flattenVNodes(parent.subTree.children);
  internalChildren.sort((a, b) => vnodes.indexOf(a.vnode) - vnodes.indexOf(b.vnode));
  const orderedPublicChildren = internalChildren.map((item) => item.proxy);
  publicChildren.sort((a, b) => {
    const indexA = orderedPublicChildren.indexOf(a);
    const indexB = orderedPublicChildren.indexOf(b);
    return indexA - indexB;
  });
}
function useChildren(key) {
  const publicChildren = reactive([]);
  const internalChildren = reactive([]);
  const parent = getCurrentInstance();
  const linkChildren = (value) => {
    const link = (child) => {
      if (child.proxy) {
        internalChildren.push(child);
        publicChildren.push(child.proxy);
        sortChildren(parent, publicChildren, internalChildren);
      }
    };
    const unlink = (child) => {
      const index2 = internalChildren.indexOf(child);
      publicChildren.splice(index2, 1);
      internalChildren.splice(index2, 1);
    };
    provide(key, Object.assign({
      link,
      unlink,
      children: publicChildren,
      internalChildren
    }, value));
  };
  return {
    children: publicChildren,
    linkChildren
  };
}
function onMountedOrActivated(hook) {
  let mounted;
  onMounted(() => {
    hook();
    nextTick(() => {
      mounted = true;
    });
  });
  onActivated(() => {
    if (mounted) {
      hook();
    }
  });
}
function useEventListener(type, listener, options = {}) {
  if (!inBrowser) {
    return;
  }
  const { target = window, passive = false, capture = false } = options;
  let attached;
  const add2 = (target2) => {
    const element = unref(target2);
    if (element && !attached) {
      element.addEventListener(type, listener, { capture, passive });
      attached = true;
    }
  };
  const remove2 = (target2) => {
    const element = unref(target2);
    if (element && attached) {
      element.removeEventListener(type, listener, capture);
      attached = false;
    }
  };
  onUnmounted(() => remove2(target));
  onDeactivated(() => remove2(target));
  onMountedOrActivated(() => add2(target));
  if (isRef(target)) {
    watch(target, (val, oldVal) => {
      remove2(oldVal);
      add2(val);
    });
  }
}
var width;
var height;
function useWindowSize() {
  if (!width) {
    width = ref(0);
    height = ref(0);
    if (inBrowser) {
      const update = () => {
        width.value = window.innerWidth;
        height.value = window.innerHeight;
      };
      update();
      window.addEventListener("resize", update, { passive: true });
      window.addEventListener("orientationchange", update, { passive: true });
    }
  }
  return { width, height };
}
var overflowScrollReg = /scroll|auto/i;
var defaultRoot = inBrowser ? window : void 0;
function isElement(node) {
  const ELEMENT_NODE_TYPE = 1;
  return node.tagName !== "HTML" && node.tagName !== "BODY" && node.nodeType === ELEMENT_NODE_TYPE;
}
function getScrollParent(el, root = defaultRoot) {
  let node = el;
  while (node && node !== root && isElement(node)) {
    const { overflowY } = window.getComputedStyle(node);
    if (overflowScrollReg.test(overflowY)) {
      return node;
    }
    node = node.parentNode;
  }
  return root;
}
const isDef = (val) => val !== void 0 && val !== null;
const isFunction$1 = (val) => typeof val === "function";
const isObject$1 = (val) => val !== null && typeof val === "object";
const isPromise = (val) => isObject$1(val) && isFunction$1(val.then) && isFunction$1(val.catch);
const isNumeric = (val) => typeof val === "number" || /^\d+(\.\d+)?$/.test(val);
const isIOS = () => inBrowser$1 ? /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) : false;
isIOS();
const stopPropagation = (event) => event.stopPropagation();
function preventDefault(event, isStopPropagation) {
  if (typeof event.cancelable !== "boolean" || event.cancelable) {
    event.preventDefault();
  }
  if (isStopPropagation) {
    stopPropagation(event);
  }
}
useWindowSize();
function addUnit(value) {
  if (isDef(value)) {
    return isNumeric(value) ? `${value}px` : String(value);
  }
  return void 0;
}
function getSizeStyle(originSize) {
  if (isDef(originSize)) {
    if (Array.isArray(originSize)) {
      return {
        width: addUnit(originSize[0]),
        height: addUnit(originSize[1])
      };
    }
    const size2 = addUnit(originSize);
    return {
      width: size2,
      height: size2
    };
  }
}
function getZIndexStyle(zIndex) {
  const style2 = {};
  if (zIndex !== void 0) {
    style2.zIndex = +zIndex;
  }
  return style2;
}
const camelizeRE = /-(\w)/g;
const camelize = (str) => str.replace(camelizeRE, (_, c) => c.toUpperCase());
const kebabCase = (str) => str.replace(/([A-Z])/g, "-$1").toLowerCase().replace(/^-/, "");
const { hasOwnProperty } = Object.prototype;
function assignKey(to, from, key) {
  const val = from[key];
  if (!isDef(val)) {
    return;
  }
  if (!hasOwnProperty.call(to, key) || !isObject$1(val)) {
    to[key] = val;
  } else {
    to[key] = deepAssign(Object(to[key]), val);
  }
}
function deepAssign(to, from) {
  Object.keys(from).forEach((key) => {
    assignKey(to, from, key);
  });
  return to;
}
var stdin_default$a = {
  name: "\u59D3\u540D",
  tel: "\u7535\u8BDD",
  save: "\u4FDD\u5B58",
  confirm: "\u786E\u8BA4",
  cancel: "\u53D6\u6D88",
  delete: "\u5220\u9664",
  loading: "\u52A0\u8F7D\u4E2D...",
  noCoupon: "\u6682\u65E0\u4F18\u60E0\u5238",
  nameEmpty: "\u8BF7\u586B\u5199\u59D3\u540D",
  addContact: "\u6DFB\u52A0\u8054\u7CFB\u4EBA",
  telInvalid: "\u8BF7\u586B\u5199\u6B63\u786E\u7684\u7535\u8BDD",
  vanCalendar: {
    end: "\u7ED3\u675F",
    start: "\u5F00\u59CB",
    title: "\u65E5\u671F\u9009\u62E9",
    weekdays: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
    monthTitle: (year, month) => `${year}\u5E74${month}\u6708`,
    rangePrompt: (maxRange) => `\u6700\u591A\u9009\u62E9 ${maxRange} \u5929`
  },
  vanCascader: {
    select: "\u8BF7\u9009\u62E9"
  },
  vanPagination: {
    prev: "\u4E0A\u4E00\u9875",
    next: "\u4E0B\u4E00\u9875"
  },
  vanPullRefresh: {
    pulling: "\u4E0B\u62C9\u5373\u53EF\u5237\u65B0...",
    loosing: "\u91CA\u653E\u5373\u53EF\u5237\u65B0..."
  },
  vanSubmitBar: {
    label: "\u5408\u8BA1:"
  },
  vanCoupon: {
    unlimited: "\u65E0\u95E8\u69DB",
    discount: (discount) => `${discount}\u6298`,
    condition: (condition) => `\u6EE1${condition}\u5143\u53EF\u7528`
  },
  vanCouponCell: {
    title: "\u4F18\u60E0\u5238",
    count: (count) => `${count}\u5F20\u53EF\u7528`
  },
  vanCouponList: {
    exchange: "\u5151\u6362",
    close: "\u4E0D\u4F7F\u7528",
    enable: "\u53EF\u7528",
    disabled: "\u4E0D\u53EF\u7528",
    placeholder: "\u8F93\u5165\u4F18\u60E0\u7801"
  },
  vanAddressEdit: {
    area: "\u5730\u533A",
    postal: "\u90AE\u653F\u7F16\u7801",
    areaEmpty: "\u8BF7\u9009\u62E9\u5730\u533A",
    addressEmpty: "\u8BF7\u586B\u5199\u8BE6\u7EC6\u5730\u5740",
    postalEmpty: "\u90AE\u653F\u7F16\u7801\u4E0D\u6B63\u786E",
    addressDetail: "\u8BE6\u7EC6\u5730\u5740",
    defaultAddress: "\u8BBE\u4E3A\u9ED8\u8BA4\u6536\u8D27\u5730\u5740"
  },
  vanAddressList: {
    add: "\u65B0\u589E\u5730\u5740"
  }
};
const lang = ref("zh-CN");
const messages = reactive({
  "zh-CN": stdin_default$a
});
const Locale = {
  messages() {
    return messages[lang.value];
  },
  use(newLang, newMessages) {
    lang.value = newLang;
    this.add({ [newLang]: newMessages });
  },
  add(newMessages = {}) {
    deepAssign(messages, newMessages);
  }
};
var stdin_default$9 = Locale;
function createTranslate(name2) {
  const prefix = camelize(name2) + ".";
  return (path, ...args) => {
    const messages2 = stdin_default$9.messages();
    const message = get(messages2, prefix + path) || get(messages2, path);
    return isFunction$1(message) ? message(...args) : message;
  };
}
function genBem(name2, mods) {
  if (!mods) {
    return "";
  }
  if (typeof mods === "string") {
    return ` ${name2}--${mods}`;
  }
  if (Array.isArray(mods)) {
    return mods.reduce((ret, item) => ret + genBem(name2, item), "");
  }
  return Object.keys(mods).reduce((ret, key) => ret + (mods[key] ? genBem(name2, key) : ""), "");
}
function createBEM(name2) {
  return (el, mods) => {
    if (el && typeof el !== "string") {
      mods = el;
      el = "";
    }
    el = el ? `${name2}__${el}` : name2;
    return `${el}${genBem(el, mods)}`;
  };
}
function createNamespace(name2) {
  const prefixedName = `van-${name2}`;
  return [
    prefixedName,
    createBEM(prefixedName),
    createTranslate(prefixedName)
  ];
}
const BORDER = "van-hairline";
const BORDER_TOP = `${BORDER}--top`;
const BORDER_LEFT = `${BORDER}--left`;
const BORDER_SURROUND = `${BORDER}--surround`;
const HAPTICS_FEEDBACK = "van-haptics-feedback";
function callInterceptor(interceptor, {
  args = [],
  done,
  canceled
}) {
  if (interceptor) {
    const returnVal = interceptor.apply(null, args);
    if (isPromise(returnVal)) {
      returnVal.then((value) => {
        if (value) {
          done();
        } else if (canceled) {
          canceled();
        }
      }).catch(noop);
    } else if (returnVal) {
      done();
    } else if (canceled) {
      canceled();
    }
  } else {
    done();
  }
}
function withInstall(options) {
  options.install = (app) => {
    const { name: name2 } = options;
    app.component(name2, options);
    app.component(camelize(`-${name2}`), options);
  };
  return options;
}
const useHeight = (element) => {
  const height2 = ref();
  const setHeight = () => {
    height2.value = useRect(element).height;
  };
  onMounted(() => {
    nextTick(setHeight);
    setTimeout(setHeight, 100);
  });
  return height2;
};
function usePlaceholder(contentRef, bem2) {
  const height2 = useHeight(contentRef);
  return (renderContent) => createVNode("div", {
    "class": bem2("placeholder"),
    "style": {
      height: height2.value ? `${height2.value}px` : void 0
    }
  }, [renderContent()]);
}
const [name$9, bem$9] = createNamespace("action-bar");
const ACTION_BAR_KEY = Symbol(name$9);
const actionBarProps = {
  placeholder: Boolean,
  safeAreaInsetBottom: truthProp
};
var stdin_default$8 = defineComponent({
  name: name$9,
  props: actionBarProps,
  setup(props, {
    slots
  }) {
    const root = ref();
    const renderPlaceholder = usePlaceholder(root, bem$9);
    const {
      linkChildren
    } = useChildren(ACTION_BAR_KEY);
    linkChildren();
    const renderActionBar = () => {
      var _a2;
      return createVNode("div", {
        "ref": root,
        "class": [bem$9(), {
          "van-safe-area-bottom": props.safeAreaInsetBottom
        }]
      }, [(_a2 = slots.default) == null ? void 0 : _a2.call(slots)]);
    };
    return () => {
      if (props.placeholder) {
        return renderPlaceholder(renderActionBar);
      }
      return renderActionBar();
    };
  }
});
const ActionBar = withInstall(stdin_default$8);
function useExpose(apis) {
  const instance2 = getCurrentInstance();
  if (instance2) {
    extend$1(instance2.proxy, apis);
  }
}
const routeProps = {
  to: [String, Object],
  url: String,
  replace: Boolean
};
function route({
  to,
  url,
  replace,
  $router: router
}) {
  if (to && router) {
    router[replace ? "replace" : "push"](to);
  } else if (url) {
    replace ? location.replace(url) : location.href = url;
  }
}
function useRoute() {
  const vm = getCurrentInstance().proxy;
  return () => route(vm);
}
const [name$8, bem$8] = createNamespace("badge");
const badgeProps = {
  dot: Boolean,
  max: numericProp,
  tag: makeStringProp("div"),
  color: String,
  offset: Array,
  content: numericProp,
  showZero: truthProp,
  position: makeStringProp("top-right")
};
var stdin_default$7 = defineComponent({
  name: name$8,
  props: badgeProps,
  setup(props, {
    slots
  }) {
    const hasContent = () => {
      if (slots.content) {
        return true;
      }
      const {
        content,
        showZero
      } = props;
      return isDef(content) && content !== "" && (showZero || content !== 0);
    };
    const renderContent = () => {
      const {
        dot,
        max,
        content
      } = props;
      if (!dot && hasContent()) {
        if (slots.content) {
          return slots.content();
        }
        if (isDef(max) && isNumeric(content) && +content > max) {
          return `${max}+`;
        }
        return content;
      }
    };
    const style2 = computed(() => {
      const style22 = {
        background: props.color
      };
      if (props.offset) {
        const [x, y] = props.offset;
        if (slots.default) {
          style22.top = addUnit(y);
          if (typeof x === "number") {
            style22.right = addUnit(-x);
          } else {
            style22.right = x.startsWith("-") ? x.replace("-", "") : `-${x}`;
          }
        } else {
          style22.marginTop = addUnit(y);
          style22.marginLeft = addUnit(x);
        }
      }
      return style22;
    });
    const renderBadge = () => {
      if (hasContent() || props.dot) {
        return createVNode("div", {
          "class": bem$8([props.position, {
            dot: props.dot,
            fixed: !!slots.default
          }]),
          "style": style2.value
        }, [renderContent()]);
      }
    };
    return () => {
      if (slots.default) {
        const {
          tag
        } = props;
        return createVNode(tag, {
          "class": bem$8("wrapper")
        }, {
          default: () => [slots.default(), renderBadge()]
        });
      }
      return renderBadge();
    };
  }
});
const Badge = withInstall(stdin_default$7);
const [name$7, bem$7] = createNamespace("config-provider");
const CONFIG_PROVIDER_KEY = Symbol(name$7);
const configProviderProps = {
  tag: makeStringProp("div"),
  themeVars: Object,
  iconPrefix: String
};
function mapThemeVarsToCSSVars(themeVars) {
  const cssVars = {};
  Object.keys(themeVars).forEach((key) => {
    cssVars[`--van-${kebabCase(key)}`] = themeVars[key];
  });
  return cssVars;
}
defineComponent({
  name: name$7,
  props: configProviderProps,
  setup(props, {
    slots
  }) {
    const style2 = computed(() => {
      if (props.themeVars) {
        return mapThemeVarsToCSSVars(props.themeVars);
      }
    });
    provide(CONFIG_PROVIDER_KEY, props);
    return () => createVNode(props.tag, {
      "class": bem$7(),
      "style": style2.value
    }, {
      default: () => {
        var _a2;
        return [(_a2 = slots.default) == null ? void 0 : _a2.call(slots)];
      }
    });
  }
});
const [name$6, bem$6] = createNamespace("icon");
const isImage = (name2) => name2 == null ? void 0 : name2.includes("/");
const iconProps = {
  dot: Boolean,
  tag: makeStringProp("i"),
  name: String,
  size: numericProp,
  badge: numericProp,
  color: String,
  badgeProps: Object,
  classPrefix: String
};
var stdin_default$6 = defineComponent({
  name: name$6,
  props: iconProps,
  setup(props, {
    slots
  }) {
    const config2 = inject(CONFIG_PROVIDER_KEY, null);
    const classPrefix = computed(() => props.classPrefix || (config2 == null ? void 0 : config2.iconPrefix) || bem$6());
    return () => {
      const {
        tag,
        dot,
        name: name2,
        size: size2,
        badge,
        color
      } = props;
      const isImageIcon = isImage(name2);
      return createVNode(Badge, mergeProps({
        "dot": dot,
        "tag": tag,
        "class": [classPrefix.value, isImageIcon ? "" : `${classPrefix.value}-${name2}`],
        "style": {
          color,
          fontSize: addUnit(size2)
        },
        "content": badge
      }, props.badgeProps), {
        default: () => {
          var _a2;
          return [(_a2 = slots.default) == null ? void 0 : _a2.call(slots), isImageIcon && createVNode("img", {
            "class": bem$6("image"),
            "src": name2
          }, null)];
        }
      });
    };
  }
});
const Icon = withInstall(stdin_default$6);
const [name$5, bem$5] = createNamespace("loading");
const SpinIcon = Array(12).fill(null).map((_, index2) => createVNode("i", {
  "class": bem$5("line", String(index2 + 1))
}, null));
const CircularIcon = createVNode("svg", {
  "class": bem$5("circular"),
  "viewBox": "25 25 50 50"
}, [createVNode("circle", {
  "cx": "50",
  "cy": "50",
  "r": "20",
  "fill": "none"
}, null)]);
const loadingProps = {
  size: numericProp,
  type: makeStringProp("circular"),
  color: String,
  vertical: Boolean,
  textSize: numericProp,
  textColor: String
};
var stdin_default$5 = defineComponent({
  name: name$5,
  props: loadingProps,
  setup(props, {
    slots
  }) {
    const spinnerStyle = computed(() => extend$1({
      color: props.color
    }, getSizeStyle(props.size)));
    const renderText = () => {
      var _a2;
      if (slots.default) {
        return createVNode("span", {
          "class": bem$5("text"),
          "style": {
            fontSize: addUnit(props.textSize),
            color: (_a2 = props.textColor) != null ? _a2 : props.color
          }
        }, [slots.default()]);
      }
    };
    return () => {
      const {
        type,
        vertical
      } = props;
      return createVNode("div", {
        "class": bem$5([type, {
          vertical
        }]),
        "aria-live": "polite",
        "aria-busy": true
      }, [createVNode("span", {
        "class": bem$5("spinner", type),
        "style": spinnerStyle.value
      }, [type === "spinner" ? SpinIcon : CircularIcon]), renderText()]);
    };
  }
});
const Loading = withInstall(stdin_default$5);
const [name$4, bem$4] = createNamespace("button");
const buttonProps = extend$1({}, routeProps, {
  tag: makeStringProp("button"),
  text: String,
  icon: String,
  type: makeStringProp("default"),
  size: makeStringProp("normal"),
  color: String,
  block: Boolean,
  plain: Boolean,
  round: Boolean,
  square: Boolean,
  loading: Boolean,
  hairline: Boolean,
  disabled: Boolean,
  iconPrefix: String,
  nativeType: makeStringProp("button"),
  loadingSize: numericProp,
  loadingText: String,
  loadingType: String,
  iconPosition: makeStringProp("left")
});
var stdin_default$4 = defineComponent({
  name: name$4,
  props: buttonProps,
  emits: ["click"],
  setup(props, {
    emit: emit2,
    slots
  }) {
    const route2 = useRoute();
    const renderLoadingIcon = () => {
      if (slots.loading) {
        return slots.loading();
      }
      return createVNode(Loading, {
        "size": props.loadingSize,
        "type": props.loadingType,
        "class": bem$4("loading")
      }, null);
    };
    const renderIcon = () => {
      if (props.loading) {
        return renderLoadingIcon();
      }
      if (slots.icon) {
        return createVNode("div", {
          "class": bem$4("icon")
        }, [slots.icon()]);
      }
      if (props.icon) {
        return createVNode(Icon, {
          "name": props.icon,
          "class": bem$4("icon"),
          "classPrefix": props.iconPrefix
        }, null);
      }
    };
    const renderText = () => {
      let text;
      if (props.loading) {
        text = props.loadingText;
      } else {
        text = slots.default ? slots.default() : props.text;
      }
      if (text) {
        return createVNode("span", {
          "class": bem$4("text")
        }, [text]);
      }
    };
    const getStyle = () => {
      const {
        color,
        plain
      } = props;
      if (color) {
        const style2 = {
          color: plain ? color : "white"
        };
        if (!plain) {
          style2.background = color;
        }
        if (color.includes("gradient")) {
          style2.border = 0;
        } else {
          style2.borderColor = color;
        }
        return style2;
      }
    };
    const onClick = (event) => {
      if (props.loading) {
        preventDefault(event);
      } else if (!props.disabled) {
        emit2("click", event);
        route2();
      }
    };
    return () => {
      const {
        tag,
        type,
        size: size2,
        block,
        round,
        plain,
        square,
        loading,
        disabled,
        hairline,
        nativeType,
        iconPosition
      } = props;
      const classes = [bem$4([type, size2, {
        plain,
        block,
        round,
        square,
        loading,
        disabled,
        hairline
      }]), {
        [BORDER_SURROUND]: hairline
      }];
      return createVNode(tag, {
        "type": nativeType,
        "class": classes,
        "style": getStyle(),
        "disabled": disabled,
        "onClick": onClick
      }, {
        default: () => [createVNode("div", {
          "class": bem$4("content")
        }, [iconPosition === "left" && renderIcon(), renderText(), iconPosition === "right" && renderIcon()])]
      });
    };
  }
});
const Button = withInstall(stdin_default$4);
const [name$3, bem$3] = createNamespace("action-bar-button");
const actionBarButtonProps = extend$1({}, routeProps, {
  type: String,
  text: String,
  icon: String,
  color: String,
  loading: Boolean,
  disabled: Boolean
});
var stdin_default$3 = defineComponent({
  name: name$3,
  props: actionBarButtonProps,
  setup(props, {
    slots
  }) {
    const route2 = useRoute();
    const {
      parent,
      index: index2
    } = useParent(ACTION_BAR_KEY);
    const isFirst = computed(() => {
      if (parent) {
        const prev = parent.children[index2.value - 1];
        return !(prev && "isButton" in prev);
      }
    });
    const isLast = computed(() => {
      if (parent) {
        const next = parent.children[index2.value + 1];
        return !(next && "isButton" in next);
      }
    });
    useExpose({
      isButton: true
    });
    return () => {
      const {
        type,
        icon,
        text,
        color,
        loading,
        disabled
      } = props;
      return createVNode(Button, {
        "class": bem$3([type, {
          last: isLast.value,
          first: isFirst.value
        }]),
        "size": "large",
        "type": type,
        "icon": icon,
        "color": color,
        "loading": loading,
        "disabled": disabled,
        "onClick": route2
      }, {
        default: () => [slots.default ? slots.default() : text]
      });
    };
  }
});
const ActionBarButton = withInstall(stdin_default$3);
const popupSharedProps = {
  show: Boolean,
  zIndex: numericProp,
  overlay: truthProp,
  duration: numericProp,
  teleport: [String, Object],
  lockScroll: truthProp,
  lazyRender: truthProp,
  beforeClose: Function,
  overlayStyle: Object,
  overlayClass: unknownProp,
  transitionAppear: Boolean,
  closeOnClickOverlay: truthProp
};
const popupSharedPropKeys = Object.keys(popupSharedProps);
function getDirection(x, y) {
  if (x > y) {
    return "horizontal";
  }
  if (y > x) {
    return "vertical";
  }
  return "";
}
function useTouch() {
  const startX = ref(0);
  const startY = ref(0);
  const deltaX = ref(0);
  const deltaY = ref(0);
  const offsetX = ref(0);
  const offsetY = ref(0);
  const direction = ref("");
  const isVertical = () => direction.value === "vertical";
  const isHorizontal = () => direction.value === "horizontal";
  const reset2 = () => {
    deltaX.value = 0;
    deltaY.value = 0;
    offsetX.value = 0;
    offsetY.value = 0;
    direction.value = "";
  };
  const start = (event) => {
    reset2();
    startX.value = event.touches[0].clientX;
    startY.value = event.touches[0].clientY;
  };
  const move = (event) => {
    const touch = event.touches[0];
    deltaX.value = (touch.clientX < 0 ? 0 : touch.clientX) - startX.value;
    deltaY.value = touch.clientY - startY.value;
    offsetX.value = Math.abs(deltaX.value);
    offsetY.value = Math.abs(deltaY.value);
    const LOCK_DIRECTION_DISTANCE = 10;
    if (!direction.value || offsetX.value < LOCK_DIRECTION_DISTANCE && offsetY.value < LOCK_DIRECTION_DISTANCE) {
      direction.value = getDirection(offsetX.value, offsetY.value);
    }
  };
  return {
    move,
    start,
    reset: reset2,
    startX,
    startY,
    deltaX,
    deltaY,
    offsetX,
    offsetY,
    direction,
    isVertical,
    isHorizontal
  };
}
let totalLockCount = 0;
const BODY_LOCK_CLASS = "van-overflow-hidden";
function useLockScroll(rootRef, shouldLock) {
  const touch = useTouch();
  const onTouchMove = (event) => {
    touch.move(event);
    const direction = touch.deltaY.value > 0 ? "10" : "01";
    const el = getScrollParent(event.target, rootRef.value);
    const { scrollHeight, offsetHeight, scrollTop } = el;
    let status = "11";
    if (scrollTop === 0) {
      status = offsetHeight >= scrollHeight ? "00" : "01";
    } else if (scrollTop + offsetHeight >= scrollHeight) {
      status = "10";
    }
    if (status !== "11" && touch.isVertical() && !(parseInt(status, 2) & parseInt(direction, 2))) {
      preventDefault(event, true);
    }
  };
  const lock = () => {
    document.addEventListener("touchstart", touch.start);
    document.addEventListener("touchmove", onTouchMove, { passive: false });
    if (!totalLockCount) {
      document.body.classList.add(BODY_LOCK_CLASS);
    }
    totalLockCount++;
  };
  const unlock = () => {
    if (totalLockCount) {
      document.removeEventListener("touchstart", touch.start);
      document.removeEventListener("touchmove", onTouchMove);
      totalLockCount--;
      if (!totalLockCount) {
        document.body.classList.remove(BODY_LOCK_CLASS);
      }
    }
  };
  const init = () => shouldLock() && lock();
  const destroy = () => shouldLock() && unlock();
  onMountedOrActivated(init);
  onDeactivated(destroy);
  onBeforeUnmount(destroy);
  watch(shouldLock, (value) => {
    value ? lock() : unlock();
  });
}
function useLazyRender(show) {
  const inited = ref(false);
  watch(show, (value) => {
    if (value) {
      inited.value = value;
    }
  }, { immediate: true });
  return (render2) => () => inited.value ? render2() : null;
}
const POPUP_TOGGLE_KEY = Symbol();
const [name$2, bem$2] = createNamespace("overlay");
const overlayProps = {
  show: Boolean,
  zIndex: numericProp,
  duration: numericProp,
  className: unknownProp,
  lockScroll: truthProp,
  lazyRender: truthProp,
  customStyle: Object
};
var stdin_default$2 = defineComponent({
  name: name$2,
  props: overlayProps,
  setup(props, {
    slots
  }) {
    const lazyRender = useLazyRender(() => props.show || !props.lazyRender);
    const preventTouchMove = (event) => {
      preventDefault(event, true);
    };
    const renderOverlay = lazyRender(() => {
      var _a2;
      const style2 = extend$1(getZIndexStyle(props.zIndex), props.customStyle);
      if (isDef(props.duration)) {
        style2.animationDuration = `${props.duration}s`;
      }
      return withDirectives(createVNode("div", {
        "style": style2,
        "class": [bem$2(), props.className],
        "onTouchmove": props.lockScroll ? preventTouchMove : noop
      }, [(_a2 = slots.default) == null ? void 0 : _a2.call(slots)]), [[vShow, props.show]]);
    });
    return () => createVNode(Transition, {
      "name": "van-fade",
      "appear": true
    }, {
      default: renderOverlay
    });
  }
});
const Overlay = withInstall(stdin_default$2);
const popupProps = extend$1({}, popupSharedProps, {
  round: Boolean,
  position: makeStringProp("center"),
  closeIcon: makeStringProp("cross"),
  closeable: Boolean,
  transition: String,
  iconPrefix: String,
  closeOnPopstate: Boolean,
  closeIconPosition: makeStringProp("top-right"),
  safeAreaInsetTop: Boolean,
  safeAreaInsetBottom: Boolean
});
const [name$1, bem$1] = createNamespace("popup");
let globalZIndex = 2e3;
var stdin_default$1 = defineComponent({
  name: name$1,
  inheritAttrs: false,
  props: popupProps,
  emits: ["open", "close", "opened", "closed", "keydown", "update:show", "click-overlay", "click-close-icon"],
  setup(props, {
    emit: emit2,
    attrs,
    slots
  }) {
    let opened;
    let shouldReopen;
    const zIndex = ref();
    const popupRef = ref();
    const lazyRender = useLazyRender(() => props.show || !props.lazyRender);
    const style2 = computed(() => {
      const style22 = {
        zIndex: zIndex.value
      };
      if (isDef(props.duration)) {
        const key = props.position === "center" ? "animationDuration" : "transitionDuration";
        style22[key] = `${props.duration}s`;
      }
      return style22;
    });
    const open = () => {
      if (!opened) {
        if (props.zIndex !== void 0) {
          globalZIndex = +props.zIndex;
        }
        opened = true;
        zIndex.value = ++globalZIndex;
        emit2("open");
      }
    };
    const close = () => {
      if (opened) {
        callInterceptor(props.beforeClose, {
          done() {
            opened = false;
            emit2("close");
            emit2("update:show", false);
          }
        });
      }
    };
    const onClickOverlay = (event) => {
      emit2("click-overlay", event);
      if (props.closeOnClickOverlay) {
        close();
      }
    };
    const renderOverlay = () => {
      if (props.overlay) {
        return createVNode(Overlay, {
          "show": props.show,
          "class": props.overlayClass,
          "zIndex": zIndex.value,
          "duration": props.duration,
          "customStyle": props.overlayStyle,
          "onClick": onClickOverlay
        }, {
          default: slots["overlay-content"]
        });
      }
    };
    const onClickCloseIcon = (event) => {
      emit2("click-close-icon", event);
      close();
    };
    const renderCloseIcon = () => {
      if (props.closeable) {
        return createVNode(Icon, {
          "role": "button",
          "tabindex": 0,
          "name": props.closeIcon,
          "class": [bem$1("close-icon", props.closeIconPosition), HAPTICS_FEEDBACK],
          "classPrefix": props.iconPrefix,
          "onClick": onClickCloseIcon
        }, null);
      }
    };
    const onOpened = () => emit2("opened");
    const onClosed = () => emit2("closed");
    const onKeydown = (event) => emit2("keydown", event);
    const renderPopup = lazyRender(() => {
      var _a2;
      const {
        round,
        position,
        safeAreaInsetTop,
        safeAreaInsetBottom
      } = props;
      return withDirectives(createVNode("div", mergeProps({
        "ref": popupRef,
        "style": style2.value,
        "class": [bem$1({
          round,
          [position]: position
        }), {
          "van-safe-area-top": safeAreaInsetTop,
          "van-safe-area-bottom": safeAreaInsetBottom
        }],
        "onKeydown": onKeydown
      }, attrs), [(_a2 = slots.default) == null ? void 0 : _a2.call(slots), renderCloseIcon()]), [[vShow, props.show]]);
    });
    const renderTransition = () => {
      const {
        position,
        transition,
        transitionAppear
      } = props;
      const name2 = position === "center" ? "van-fade" : `van-popup-slide-${position}`;
      return createVNode(Transition, {
        "name": transition || name2,
        "appear": transitionAppear,
        "onAfterEnter": onOpened,
        "onAfterLeave": onClosed
      }, {
        default: renderPopup
      });
    };
    watch(() => props.show, (show) => {
      if (show && !opened) {
        open();
        if (attrs.tabindex === 0) {
          nextTick(() => {
            var _a2;
            (_a2 = popupRef.value) == null ? void 0 : _a2.focus();
          });
        }
      }
      if (!show && opened) {
        opened = false;
        emit2("close");
      }
    });
    useExpose({
      popupRef
    });
    useLockScroll(popupRef, () => props.show && props.lockScroll);
    useEventListener("popstate", () => {
      if (props.closeOnPopstate) {
        close();
        shouldReopen = false;
      }
    });
    onMounted(() => {
      if (props.show) {
        open();
      }
    });
    onActivated(() => {
      if (shouldReopen) {
        emit2("update:show", true);
        shouldReopen = false;
      }
    });
    onDeactivated(() => {
      if (props.show && props.teleport) {
        close();
        shouldReopen = true;
      }
    });
    provide(POPUP_TOGGLE_KEY, () => props.show);
    return () => {
      if (props.teleport) {
        return createVNode(Teleport, {
          "to": props.teleport
        }, {
          default: () => [renderOverlay(), renderTransition()]
        });
      }
      return createVNode(Fragment, null, [renderOverlay(), renderTransition()]);
    };
  }
});
const Popup = withInstall(stdin_default$1);
function usePopupState() {
  const state2 = reactive({
    show: false
  });
  const toggle = (show) => {
    state2.show = show;
  };
  const open = (props) => {
    extend$1(state2, props, { transitionAppear: true });
    toggle(true);
  };
  const close = () => toggle(false);
  useExpose({ open, close, toggle });
  return {
    open,
    close,
    state: state2,
    toggle
  };
}
function mountComponent(RootComponent) {
  const app = createApp(RootComponent);
  const root = document.createElement("div");
  document.body.appendChild(root);
  return {
    instance: app.mount(root),
    unmount() {
      app.unmount();
      document.body.removeChild(root);
    }
  };
}
const [name, bem, t] = createNamespace("dialog");
const dialogProps = extend$1({}, popupSharedProps, {
  title: String,
  theme: String,
  width: numericProp,
  message: [String, Function],
  callback: Function,
  allowHtml: Boolean,
  className: unknownProp,
  transition: makeStringProp("van-dialog-bounce"),
  messageAlign: String,
  closeOnPopstate: truthProp,
  showCancelButton: Boolean,
  cancelButtonText: String,
  cancelButtonColor: String,
  cancelButtonDisabled: Boolean,
  confirmButtonText: String,
  confirmButtonColor: String,
  confirmButtonDisabled: Boolean,
  showConfirmButton: truthProp,
  closeOnClickOverlay: Boolean
});
const popupInheritKeys = [...popupSharedPropKeys, "transition", "closeOnPopstate"];
var stdin_default = defineComponent({
  name,
  props: dialogProps,
  emits: ["confirm", "cancel", "keydown", "update:show"],
  setup(props, {
    emit: emit2,
    slots
  }) {
    const root = ref();
    const loading = reactive({
      confirm: false,
      cancel: false
    });
    const updateShow = (value) => emit2("update:show", value);
    const close = (action) => {
      var _a2;
      updateShow(false);
      (_a2 = props.callback) == null ? void 0 : _a2.call(props, action);
    };
    const getActionHandler = (action) => () => {
      if (!props.show) {
        return;
      }
      emit2(action);
      if (props.beforeClose) {
        loading[action] = true;
        callInterceptor(props.beforeClose, {
          args: [action],
          done() {
            close(action);
            loading[action] = false;
          },
          canceled() {
            loading[action] = false;
          }
        });
      } else {
        close(action);
      }
    };
    const onCancel = getActionHandler("cancel");
    const onConfirm = getActionHandler("confirm");
    const onKeydown = withKeys((event) => {
      var _a2, _b;
      if (event.target !== ((_b = (_a2 = root.value) == null ? void 0 : _a2.popupRef) == null ? void 0 : _b.value)) {
        return;
      }
      const onEventType = {
        Enter: props.showConfirmButton ? onConfirm : noop,
        Escape: props.showCancelButton ? onCancel : noop
      };
      onEventType[event.key]();
      emit2("keydown", event);
    }, ["enter", "esc"]);
    const renderTitle = () => {
      const title = slots.title ? slots.title() : props.title;
      if (title) {
        return createVNode("div", {
          "class": bem("header", {
            isolated: !props.message && !slots.default
          })
        }, [title]);
      }
    };
    const renderMessage = (hasTitle) => {
      const {
        message,
        allowHtml,
        messageAlign
      } = props;
      const classNames = bem("message", {
        "has-title": hasTitle,
        [messageAlign]: messageAlign
      });
      const content = isFunction$1(message) ? message() : message;
      if (allowHtml && typeof content === "string") {
        return createVNode("div", {
          "class": classNames,
          "innerHTML": content
        }, null);
      }
      return createVNode("div", {
        "class": classNames
      }, [content]);
    };
    const renderContent = () => {
      if (slots.default) {
        return createVNode("div", {
          "class": bem("content")
        }, [slots.default()]);
      }
      const {
        title,
        message,
        allowHtml
      } = props;
      if (message) {
        const hasTitle = !!(title || slots.title);
        return createVNode("div", {
          "key": allowHtml ? 1 : 0,
          "class": bem("content", {
            isolated: !hasTitle
          })
        }, [renderMessage(hasTitle)]);
      }
    };
    const renderButtons = () => createVNode("div", {
      "class": [BORDER_TOP, bem("footer")]
    }, [props.showCancelButton && createVNode(Button, {
      "size": "large",
      "text": props.cancelButtonText || t("cancel"),
      "class": bem("cancel"),
      "style": {
        color: props.cancelButtonColor
      },
      "loading": loading.cancel,
      "disabled": props.cancelButtonDisabled,
      "onClick": onCancel
    }, null), props.showConfirmButton && createVNode(Button, {
      "size": "large",
      "text": props.confirmButtonText || t("confirm"),
      "class": [bem("confirm"), {
        [BORDER_LEFT]: props.showCancelButton
      }],
      "style": {
        color: props.confirmButtonColor
      },
      "loading": loading.confirm,
      "disabled": props.confirmButtonDisabled,
      "onClick": onConfirm
    }, null)]);
    const renderRoundButtons = () => createVNode(ActionBar, {
      "class": bem("footer")
    }, {
      default: () => [props.showCancelButton && createVNode(ActionBarButton, {
        "type": "warning",
        "text": props.cancelButtonText || t("cancel"),
        "class": bem("cancel"),
        "color": props.cancelButtonColor,
        "loading": loading.cancel,
        "disabled": props.cancelButtonDisabled,
        "onClick": onCancel
      }, null), props.showConfirmButton && createVNode(ActionBarButton, {
        "type": "danger",
        "text": props.confirmButtonText || t("confirm"),
        "class": bem("confirm"),
        "color": props.confirmButtonColor,
        "loading": loading.confirm,
        "disabled": props.confirmButtonDisabled,
        "onClick": onConfirm
      }, null)]
    });
    const renderFooter = () => {
      if (slots.footer) {
        return slots.footer();
      }
      return props.theme === "round-button" ? renderRoundButtons() : renderButtons();
    };
    return () => {
      const {
        width: width2,
        title,
        theme,
        message,
        className
      } = props;
      return createVNode(Popup, mergeProps({
        "ref": root,
        "role": "dialog",
        "class": [bem([theme]), className],
        "style": {
          width: addUnit(width2)
        },
        "tabindex": 0,
        "aria-labelledby": title || message,
        "onKeydown": onKeydown,
        "onUpdate:show": updateShow
      }, pick(props, popupInheritKeys)), {
        default: () => [renderTitle(), renderContent(), renderFooter()]
      });
    };
  }
});
let instance;
function initInstance() {
  const Wrapper = {
    setup() {
      const {
        state: state2,
        toggle
      } = usePopupState();
      return () => createVNode(stdin_default, mergeProps(state2, {
        "onUpdate:show": toggle
      }), null);
    }
  };
  ({
    instance
  } = mountComponent(Wrapper));
}
function Dialog(options) {
  if (!inBrowser$1) {
    return Promise.resolve();
  }
  return new Promise((resolve2, reject) => {
    if (!instance) {
      initInstance();
    }
    instance.open(extend$1({}, Dialog.currentOptions, options, {
      callback: (action) => {
        (action === "confirm" ? resolve2 : reject)(action);
      }
    }));
  });
}
Dialog.defaultOptions = {
  title: "",
  width: "",
  theme: null,
  message: "",
  overlay: true,
  callback: null,
  teleport: "body",
  className: "",
  allowHtml: false,
  lockScroll: true,
  transition: void 0,
  beforeClose: null,
  overlayClass: "",
  overlayStyle: void 0,
  messageAlign: "",
  cancelButtonText: "",
  cancelButtonColor: null,
  cancelButtonDisabled: false,
  confirmButtonText: "",
  confirmButtonColor: null,
  confirmButtonDisabled: false,
  showConfirmButton: true,
  showCancelButton: false,
  closeOnPopstate: true,
  closeOnClickOverlay: false
};
Dialog.currentOptions = extend$1({}, Dialog.defaultOptions);
Dialog.alert = Dialog;
Dialog.confirm = (options) => Dialog(extend$1({
  showCancelButton: true
}, options));
Dialog.close = () => {
  if (instance) {
    instance.toggle(false);
  }
};
Dialog.setDefaultOptions = (options) => {
  extend$1(Dialog.currentOptions, options);
};
Dialog.resetDefaultOptions = () => {
  Dialog.currentOptions = extend$1({}, Dialog.defaultOptions);
};
Dialog.Component = withInstall(stdin_default);
Dialog.install = (app) => {
  app.use(Dialog.Component);
  app.config.globalProperties.$dialog = Dialog;
};
const isProduction = window.location.host.includes(".cloud.");
const isInFrame = window.top !== self;
const isFrame = () => config.checkFrame ? isInFrame : false;
const config = {
  checkFrame: true,
  defaultAccess: {
    wechatLimit: "userinfo",
    notWechatLimit: "nothing"
  },
  formOpen: `https://form.${isProduction ? "cloud" : "beta"}.custouch.com/open/v1/form`,
  appId: "",
  uaId: "",
  logo: "",
  errorSession: null,
  accessType: "site",
  onMemberError: null,
  actionPrefix: document.title,
  trackOriginOpenId: true,
  debug: false,
  proxyRequest: null,
  SsoLink: ""
};
function setConfig(options) {
  return Object.assign(config, options);
}
function concatURI(link, params) {
  if (!params)
    return link;
  const [pureUrl, searchParams] = link.split("?");
  if (!pureUrl)
    return "";
  const query = [], qs = new URLSearchParams(searchParams), qsDic = {};
  qs.forEach((v, k) => {
    qsDic[k] = v;
  });
  Object.assign(qsDic, params);
  for (const [key, value] of Object.entries(qsDic)) {
    let val = value;
    if (typeof value !== "string") {
      val = value === null || value === void 0 ? void 0 : value.toString();
    }
    if (val != null) {
      query.push(`${key}=${encodeURIComponent(val)}`);
    }
  }
  return pureUrl + "?" + query.join("&");
}
function sleep(time) {
  return new Promise((resolve2) => {
    setTimeout(resolve2, time);
  });
}
function concatWithSymbol(arr, symbol = "-") {
  let res = "", lastChar = "";
  arr.forEach((t2) => {
    if (t2 != null) {
      lastChar = res.charAt(res.length - 1);
      if (lastChar && lastChar !== symbol) {
        res += symbol + t2;
      } else {
        res += t2;
      }
    }
  });
  return res;
}
function isSafeURI(url) {
  return typeof url === "string" && url.startsWith("https");
}
var StorageType;
(function(StorageType2) {
  StorageType2[StorageType2["local"] = 0] = "local";
  StorageType2[StorageType2["session"] = 1] = "session";
})(StorageType || (StorageType = {}));
function getStorageTarget(type) {
  return type === StorageType.local ? window.localStorage : window.sessionStorage;
}
function setStorage(key, value, concat, type = StorageType.local) {
  if (!value || !key)
    return null;
  let res;
  const storage = getStorageTarget(type);
  if (concat) {
    let v, putValue;
    const oldData = storage.getItem(key);
    if (oldData) {
      v = JSON.parse(oldData);
    } else {
      v = [];
    }
    if (!Array.isArray(value)) {
      putValue = [value];
    } else {
      putValue = value;
    }
    const t2 = Array.isArray(v) ? v.concat(putValue) : putValue;
    res = storage.setItem(key, getStorageValue(t2));
  } else {
    res = storage.setItem(key, getStorageValue(value));
  }
  return res;
}
function getStorageValue(value) {
  return JSON.stringify(value);
}
function getStorage(key, type = StorageType.local) {
  const storage = getStorageTarget(type);
  const item = storage.getItem(key);
  return item != null ? JSON.parse(item) : item;
}
const utmKey = concatWithSymbol([config.uaId, "utm"]);
function analyzeSearchParams() {
  const query = window.location.hash.split("?")[1];
  if (query) {
    const searchParams = new URLSearchParams(query);
    setUtm(searchParams);
    config.trackOriginOpenId && setOriginOpenId(searchParams);
  }
}
function setUtm(searchParams) {
  const res = {};
  searchParams.forEach((v, k) => {
    if (v && /^utm_|^source$/.test(k)) {
      res[k] = decodeURIComponent(v);
    }
  });
  if (Object.keys(res).length) {
    setStorage(utmKey, res, false, StorageType.session);
  }
}
const opKey = concatWithSymbol([config.uaId, "originOpenId("]);
function setOriginOpenId(searchParams) {
  let originOpenId = "";
  searchParams.forEach((v, k) => {
    if (v && k === "originOpenId") {
      originOpenId = decodeURIComponent(v);
    }
  });
  if (originOpenId) {
    setStorage(opKey, originOpenId, false, StorageType.session);
  }
}
function getOriginOpenId() {
  return getStorage(opKey, StorageType.session);
}
setTimeout(analyzeSearchParams, 0);
const agentType = {
  isWx: void 0,
  isIphone: void 0,
  isMobile: void 0
};
function isWeixin() {
  var _a2;
  return (_a2 = agentType.isWx) !== null && _a2 !== void 0 ? _a2 : agentType.isWx = /MicroMessenger/i.test(window.navigator.userAgent);
}
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var ReturnCode;
(function(ReturnCode2) {
  ReturnCode2["Succees"] = "200";
  ReturnCode2["NotLogin"] = "401";
  ReturnCode2["NotAllow"] = "403";
  ReturnCode2["NotFound"] = "404";
})(ReturnCode || (ReturnCode = {}));
function proxyApi(options) {
  return new Promise((resolve2, reject) => {
    window.cw("ajax", "proxy", (data2) => {
      if (data2.result && data2.result.error) {
        reject(data2.result.error);
      } else {
        resolve2(data2.result);
      }
    }, reject, options);
  });
}
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
config.uaId + "ACCOUNT_TOKEN";
var SSO_Query_Status;
(function(SSO_Query_Status2) {
  SSO_Query_Status2[SSO_Query_Status2["Logout"] = 0] = "Logout";
})(SSO_Query_Status || (SSO_Query_Status = {}));
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var LeadsSorts;
(function(LeadsSorts2) {
  LeadsSorts2[LeadsSorts2["CreateTimeDesc"] = 1] = "CreateTimeDesc";
  LeadsSorts2[LeadsSorts2["CreateTimeAsc"] = 2] = "CreateTimeAsc";
  LeadsSorts2[LeadsSorts2["ScoresDesc"] = 4] = "ScoresDesc";
  LeadsSorts2[LeadsSorts2["ScoresAsc"] = 8] = "ScoresAsc";
  LeadsSorts2[LeadsSorts2["UpdateTimeDesc"] = 16] = "UpdateTimeDesc";
  LeadsSorts2[LeadsSorts2["UpdateTimeAsc"] = 32] = "UpdateTimeAsc";
})(LeadsSorts || (LeadsSorts = {}));
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __awaiter$2 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const state = /* @__PURE__ */ new Map();
function useState(name2, request3, refresh = false) {
  return __awaiter$2(this, void 0, void 0, function* () {
    if (!state.has(name2)) {
      state.set(name2, {
        promise: null,
        data: null
      });
    }
    const info = state.get(name2);
    if (refresh && !info.promise) {
      info.data = null;
    }
    if (info.data == null) {
      if (!info.promise) {
        info.promise = request3();
      }
      try {
        info.data = yield info.promise;
      } finally {
        info.promise = null;
      }
    }
    return info.data;
  });
}
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var Sex;
(function(Sex2) {
  Sex2[Sex2["Girl"] = 0] = "Girl";
  Sex2[Sex2["Boy"] = 1] = "Boy";
})(Sex || (Sex = {}));
var Subscribe;
(function(Subscribe2) {
  Subscribe2[Subscribe2["NotSubscribe"] = 0] = "NotSubscribe";
  Subscribe2[Subscribe2["Subscribe"] = 1] = "Subscribe";
})(Subscribe || (Subscribe = {}));
var LoginCode;
(function(LoginCode2) {
  LoginCode2[LoginCode2["Success"] = 200] = "Success";
  LoginCode2[LoginCode2["Subscribe"] = 412] = "Subscribe";
})(LoginCode || (LoginCode = {}));
const LoginState = Symbol();
function cwLogin(refresh) {
  return useState(LoginState, () => promisifyCw("login"), refresh);
}
function promisifyCw(name2) {
  return new Promise((resolve2, reject) => {
    window.cw(name2, resolve2, reject);
  });
}
var __awaiter$1 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var AccessCode;
(function(AccessCode2) {
  AccessCode2["Success"] = "200";
  AccessCode2["Accepted"] = "202";
  AccessCode2["Found"] = "302";
  AccessCode2["Recommend"] = "306";
  AccessCode2["Forbidden"] = "403";
})(AccessCode || (AccessCode = {}));
function findLimit(uaId = config.uaId, type = config.accessType) {
  if (uaId) {
    return proxyApi({
      module: "site",
      target: "findLimit",
      data: {
        type,
        uaId
      },
      freeLogin: 1
    });
  } else {
    return null;
  }
}
function getAccess(uaId = config.uaId, type = config.accessType) {
  if (uaId) {
    return proxyApi({
      module: "site",
      target: "access",
      data: {
        type,
        uaId
      }
    });
  } else {
    return { code: AccessCode.Success, redirect: "" };
  }
}
const AccessCodeText = {
  [AccessCode.Success]: "\u6210\u529F",
  [AccessCode.Accepted]: "\u4FE1\u606F\u5BA1\u6838\u4E2D\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85",
  [AccessCode.Found]: "\u586B\u5199\u95EE\u5377\u89C2\u770B\u540E\u7EED\u5185\u5BB9",
  [AccessCode.Recommend]: "\u6682\u672A\u5173\u6CE8",
  [AccessCode.Forbidden]: "\u60A8\u6682\u65F6\u6CA1\u6709\u6743\u9650\u8BBF\u95EE"
};
const access = {};
function checkAccess(uaId = config.uaId, type = config.accessType, { autoReturn = false } = {}) {
  return __awaiter$1(this, void 0, void 0, function* () {
    if (uaId in access)
      return access[uaId];
    let freeLogin = false, redirect, code = AccessCode.Forbidden, text = "";
    const limit = yield findLimit(uaId, type);
    let detail;
    if (!((limit === null || limit === void 0 ? void 0 : limit.detail) && Object.keys(limit.detail).length)) {
      detail = config.defaultAccess;
    } else {
      detail = limit.detail;
    }
    if (isWeixin()) {
      switch (detail.wechatLimit) {
        case "userinfo":
          window.cw("login_scope", "snsapi_userinfo");
          break;
        case "base":
          window.cw("login_scope", "snsapi_base");
          break;
        default:
          freeLogin = true;
      }
    } else {
      switch (detail.notWechatLimit) {
        case "userinfo":
          window.cw("login_scope", "snsapi_userinfo");
          window.cw("allowScanLogin", 1);
          break;
        case "base":
          window.cw("login_scope", "snsapi_base");
          break;
        default:
          freeLogin = true;
      }
    }
    if (freeLogin || isFrame()) {
      code = AccessCode.Success;
    } else {
      try {
        yield cwLogin();
        const t2 = yield _checkAccess(uaId, type);
        if (t2.code) {
          code = t2.code;
        }
        if (t2.redirect) {
          redirect = concatURI(t2.redirect, {
            "c_default_redirect": autoReturn ? window.location.href : null
          });
        }
        text = t2.text;
      } catch (error) {
        if ((error === null || error === void 0 ? void 0 : error.code) === LoginCode.Subscribe) {
          code = AccessCode.Success;
        }
      }
    }
    return access[uaId] = {
      success: code === AccessCode.Success,
      limitType: isWeixin() ? detail.wechatLimit : detail.notWechatLimit,
      code,
      redirect,
      text: text || AccessCodeText[AccessCode.Forbidden]
    };
  });
}
function _checkAccess(uaId, type) {
  return __awaiter$1(this, void 0, void 0, function* () {
    const accessRsp = yield getAccess(uaId, type);
    const text = accessRsp.code ? AccessCodeText[accessRsp.code] : "";
    switch (accessRsp.code) {
      case AccessCode.Accepted:
        return Object.assign(Object.assign({}, accessRsp), { text });
      case AccessCode.Success:
      case AccessCode.Found:
      case AccessCode.Recommend:
      case AccessCode.Forbidden:
    }
    return Object.assign(Object.assign({}, accessRsp), { text });
  });
}
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const img = new Image();
img.crossOrigin = "Anonymous";
const documentview = (action) => actionView("documentview", action);
const downloadview = (action) => actionView("downloadview", action);
const shareview = (action) => actionView("shareview", action);
const mailDocview = (action) => actionView("mailDoc", action);
function actionView(type, action) {
  const utm = getStorage(utmKey, StorageType.session) || {};
  const mergedInfo = Object.assign(Object.assign({ path: window.location.href, uaId: config.uaId }, utm), action);
  if (config.trackOriginOpenId) {
    const originOpenId = getOriginOpenId();
    originOpenId && Object.assign(mergedInfo, { originOpenId });
  }
  if (!mergedInfo.title) {
    throw Error("title is not defined");
  }
  mergedInfo.title = concatWithSymbol([config.actionPrefix, mergedInfo.title]);
  window.cw("action", type, mergedInfo);
  if (type === "pageview") {
    window.ca("set", "cms", mergedInfo.cms);
    window.ca("set", "tag", mergedInfo.tagIds);
    window.ca("set", "originOpenId", mergedInfo.originOpenId);
    if (Object.keys(utm).length) {
      const utmArr = [];
      for (const [k, v] of Object.entries(utm)) {
        utmArr.push(`${k}=${v}`);
      }
      window.ca("set", "utm", utmArr.join("&"));
    }
    window.ca("send", type, { title: mergedInfo.title });
  }
}
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var axios$3 = { exports: {} };
var axios$2 = { exports: {} };
var bind$2 = function bind2(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
function isArray(val) {
  return toString.call(val) === "[object Array]";
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$8 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$7 = utils$8;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$1 = function buildURL2(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$7.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$7.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$7.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$7.forEach(val, function parseValue(v) {
        if (utils$7.isDate(v)) {
          v = v.toISOString();
        } else if (utils$7.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$6 = utils$8;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$6.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn(h2);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$5 = utils$8;
var normalizeHeaderName = function normalizeHeaderName2(headers, normalizedName) {
  utils$5.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var enhanceError = function enhanceError2(error, config2, code, request3, response) {
  error.config = config2;
  if (code) {
    error.code = code;
  }
  error.request = request3;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var createError;
var hasRequiredCreateError;
function requireCreateError() {
  if (hasRequiredCreateError)
    return createError;
  hasRequiredCreateError = 1;
  var enhanceError$1 = enhanceError;
  createError = function createError2(message, config2, code, request3, response) {
    var error = new Error(message);
    return enhanceError$1(error, config2, code, request3, response);
  };
  return createError;
}
var settle;
var hasRequiredSettle;
function requireSettle() {
  if (hasRequiredSettle)
    return settle;
  hasRequiredSettle = 1;
  var createError2 = requireCreateError();
  settle = function settle2(resolve2, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve2(response);
    } else {
      reject(createError2(
        "Request failed with status code " + response.status,
        response.config,
        null,
        response.request,
        response
      ));
    }
  };
  return settle;
}
var cookies;
var hasRequiredCookies;
function requireCookies() {
  if (hasRequiredCookies)
    return cookies;
  hasRequiredCookies = 1;
  var utils2 = utils$8;
  cookies = utils2.isStandardBrowserEnv() ? function standardBrowserEnv() {
    return {
      write: function write(name2, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name2 + "=" + encodeURIComponent(value));
        if (utils2.isNumber(expires)) {
          cookie.push("expires=" + new Date(expires).toGMTString());
        }
        if (utils2.isString(path)) {
          cookie.push("path=" + path);
        }
        if (utils2.isString(domain)) {
          cookie.push("domain=" + domain);
        }
        if (secure === true) {
          cookie.push("secure");
        }
        document.cookie = cookie.join("; ");
      },
      read: function read(name2) {
        var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
      },
      remove: function remove2(name2) {
        this.write(name2, "", Date.now() - 864e5);
      }
    };
  }() : function nonStandardBrowserEnv() {
    return {
      write: function write() {
      },
      read: function read() {
        return null;
      },
      remove: function remove2() {
      }
    };
  }();
  return cookies;
}
var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;
function requireIsAbsoluteURL() {
  if (hasRequiredIsAbsoluteURL)
    return isAbsoluteURL;
  hasRequiredIsAbsoluteURL = 1;
  isAbsoluteURL = function isAbsoluteURL2(url) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
  };
  return isAbsoluteURL;
}
var combineURLs;
var hasRequiredCombineURLs;
function requireCombineURLs() {
  if (hasRequiredCombineURLs)
    return combineURLs;
  hasRequiredCombineURLs = 1;
  combineURLs = function combineURLs2(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
  };
  return combineURLs;
}
var buildFullPath;
var hasRequiredBuildFullPath;
function requireBuildFullPath() {
  if (hasRequiredBuildFullPath)
    return buildFullPath;
  hasRequiredBuildFullPath = 1;
  var isAbsoluteURL2 = requireIsAbsoluteURL();
  var combineURLs2 = requireCombineURLs();
  buildFullPath = function buildFullPath2(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL2(requestedURL)) {
      return combineURLs2(baseURL, requestedURL);
    }
    return requestedURL;
  };
  return buildFullPath;
}
var parseHeaders;
var hasRequiredParseHeaders;
function requireParseHeaders() {
  if (hasRequiredParseHeaders)
    return parseHeaders;
  hasRequiredParseHeaders = 1;
  var utils2 = utils$8;
  var ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  parseHeaders = function parseHeaders2(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) {
      return parsed;
    }
    utils2.forEach(headers.split("\n"), function parser(line) {
      i = line.indexOf(":");
      key = utils2.trim(line.substr(0, i)).toLowerCase();
      val = utils2.trim(line.substr(i + 1));
      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }
        if (key === "set-cookie") {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
      }
    });
    return parsed;
  };
  return parseHeaders;
}
var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;
function requireIsURLSameOrigin() {
  if (hasRequiredIsURLSameOrigin)
    return isURLSameOrigin;
  hasRequiredIsURLSameOrigin = 1;
  var utils2 = utils$8;
  isURLSameOrigin = utils2.isStandardBrowserEnv() ? function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    function resolveURL(url) {
      var href = url;
      if (msie) {
        urlParsingNode.setAttribute("href", href);
        href = urlParsingNode.href;
      }
      urlParsingNode.setAttribute("href", href);
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
      };
    }
    originURL = resolveURL(window.location.href);
    return function isURLSameOrigin2(requestURL) {
      var parsed = utils2.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }() : function nonStandardBrowserEnv() {
    return function isURLSameOrigin2() {
      return true;
    };
  }();
  return isURLSameOrigin;
}
var Cancel_1;
var hasRequiredCancel;
function requireCancel() {
  if (hasRequiredCancel)
    return Cancel_1;
  hasRequiredCancel = 1;
  function Cancel2(message) {
    this.message = message;
  }
  Cancel2.prototype.toString = function toString2() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  };
  Cancel2.prototype.__CANCEL__ = true;
  Cancel_1 = Cancel2;
  return Cancel_1;
}
var xhr;
var hasRequiredXhr;
function requireXhr() {
  if (hasRequiredXhr)
    return xhr;
  hasRequiredXhr = 1;
  var utils2 = utils$8;
  var settle2 = requireSettle();
  var cookies2 = requireCookies();
  var buildURL3 = buildURL$1;
  var buildFullPath2 = requireBuildFullPath();
  var parseHeaders2 = requireParseHeaders();
  var isURLSameOrigin2 = requireIsURLSameOrigin();
  var createError2 = requireCreateError();
  var defaults2 = requireDefaults();
  var Cancel2 = requireCancel();
  xhr = function xhrAdapter(config2) {
    return new Promise(function dispatchXhrRequest(resolve2, reject) {
      var requestData = config2.data;
      var requestHeaders = config2.headers;
      var responseType = config2.responseType;
      var onCanceled;
      function done() {
        if (config2.cancelToken) {
          config2.cancelToken.unsubscribe(onCanceled);
        }
        if (config2.signal) {
          config2.signal.removeEventListener("abort", onCanceled);
        }
      }
      if (utils2.isFormData(requestData)) {
        delete requestHeaders["Content-Type"];
      }
      var request3 = new XMLHttpRequest();
      if (config2.auth) {
        var username = config2.auth.username || "";
        var password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
        requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
      }
      var fullPath = buildFullPath2(config2.baseURL, config2.url);
      request3.open(config2.method.toUpperCase(), buildURL3(fullPath, config2.params, config2.paramsSerializer), true);
      request3.timeout = config2.timeout;
      function onloadend() {
        if (!request3) {
          return;
        }
        var responseHeaders = "getAllResponseHeaders" in request3 ? parseHeaders2(request3.getAllResponseHeaders()) : null;
        var responseData = !responseType || responseType === "text" || responseType === "json" ? request3.responseText : request3.response;
        var response = {
          data: responseData,
          status: request3.status,
          statusText: request3.statusText,
          headers: responseHeaders,
          config: config2,
          request: request3
        };
        settle2(function _resolve(value) {
          resolve2(value);
          done();
        }, function _reject(err) {
          reject(err);
          done();
        }, response);
        request3 = null;
      }
      if ("onloadend" in request3) {
        request3.onloadend = onloadend;
      } else {
        request3.onreadystatechange = function handleLoad() {
          if (!request3 || request3.readyState !== 4) {
            return;
          }
          if (request3.status === 0 && !(request3.responseURL && request3.responseURL.indexOf("file:") === 0)) {
            return;
          }
          setTimeout(onloadend);
        };
      }
      request3.onabort = function handleAbort() {
        if (!request3) {
          return;
        }
        reject(createError2("Request aborted", config2, "ECONNABORTED", request3));
        request3 = null;
      };
      request3.onerror = function handleError2() {
        reject(createError2("Network Error", config2, null, request3));
        request3 = null;
      };
      request3.ontimeout = function handleTimeout() {
        var timeoutErrorMessage = config2.timeout ? "timeout of " + config2.timeout + "ms exceeded" : "timeout exceeded";
        var transitional2 = config2.transitional || defaults2.transitional;
        if (config2.timeoutErrorMessage) {
          timeoutErrorMessage = config2.timeoutErrorMessage;
        }
        reject(createError2(
          timeoutErrorMessage,
          config2,
          transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          request3
        ));
        request3 = null;
      };
      if (utils2.isStandardBrowserEnv()) {
        var xsrfValue = (config2.withCredentials || isURLSameOrigin2(fullPath)) && config2.xsrfCookieName ? cookies2.read(config2.xsrfCookieName) : void 0;
        if (xsrfValue) {
          requestHeaders[config2.xsrfHeaderName] = xsrfValue;
        }
      }
      if ("setRequestHeader" in request3) {
        utils2.forEach(requestHeaders, function setRequestHeader(val, key) {
          if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
            delete requestHeaders[key];
          } else {
            request3.setRequestHeader(key, val);
          }
        });
      }
      if (!utils2.isUndefined(config2.withCredentials)) {
        request3.withCredentials = !!config2.withCredentials;
      }
      if (responseType && responseType !== "json") {
        request3.responseType = config2.responseType;
      }
      if (typeof config2.onDownloadProgress === "function") {
        request3.addEventListener("progress", config2.onDownloadProgress);
      }
      if (typeof config2.onUploadProgress === "function" && request3.upload) {
        request3.upload.addEventListener("progress", config2.onUploadProgress);
      }
      if (config2.cancelToken || config2.signal) {
        onCanceled = function(cancel) {
          if (!request3) {
            return;
          }
          reject(!cancel || cancel && cancel.type ? new Cancel2("canceled") : cancel);
          request3.abort();
          request3 = null;
        };
        config2.cancelToken && config2.cancelToken.subscribe(onCanceled);
        if (config2.signal) {
          config2.signal.aborted ? onCanceled() : config2.signal.addEventListener("abort", onCanceled);
        }
      }
      if (!requestData) {
        requestData = null;
      }
      request3.send(requestData);
    });
  };
  return xhr;
}
var defaults_1;
var hasRequiredDefaults;
function requireDefaults() {
  if (hasRequiredDefaults)
    return defaults_1;
  hasRequiredDefaults = 1;
  var utils2 = utils$8;
  var normalizeHeaderName$1 = normalizeHeaderName;
  var enhanceError$1 = enhanceError;
  var DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
  };
  function setContentTypeIfUnset(headers, value) {
    if (!utils2.isUndefined(headers) && utils2.isUndefined(headers["Content-Type"])) {
      headers["Content-Type"] = value;
    }
  }
  function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") {
      adapter = requireXhr();
    } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
      adapter = requireXhr();
    }
    return adapter;
  }
  function stringifySafely(rawValue, parser, encoder) {
    if (utils2.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils2.trim(rawValue);
      } catch (e) {
        if (e.name !== "SyntaxError") {
          throw e;
        }
      }
    }
    return (encoder || JSON.stringify)(rawValue);
  }
  var defaults2 = {
    transitional: {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false
    },
    adapter: getDefaultAdapter(),
    transformRequest: [function transformRequest(data2, headers) {
      normalizeHeaderName$1(headers, "Accept");
      normalizeHeaderName$1(headers, "Content-Type");
      if (utils2.isFormData(data2) || utils2.isArrayBuffer(data2) || utils2.isBuffer(data2) || utils2.isStream(data2) || utils2.isFile(data2) || utils2.isBlob(data2)) {
        return data2;
      }
      if (utils2.isArrayBufferView(data2)) {
        return data2.buffer;
      }
      if (utils2.isURLSearchParams(data2)) {
        setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
        return data2.toString();
      }
      if (utils2.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
        setContentTypeIfUnset(headers, "application/json");
        return stringifySafely(data2);
      }
      return data2;
    }],
    transformResponse: [function transformResponse(data2) {
      var transitional2 = this.transitional || defaults2.transitional;
      var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
      var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
      if (strictJSONParsing || forcedJSONParsing && utils2.isString(data2) && data2.length) {
        try {
          return JSON.parse(data2);
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === "SyntaxError") {
              throw enhanceError$1(e, this, "E_JSON_PARSE");
            }
            throw e;
          }
        }
      }
      return data2;
    }],
    timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },
    headers: {
      common: {
        "Accept": "application/json, text/plain, */*"
      }
    }
  };
  utils2.forEach(["delete", "get", "head"], function forEachMethodNoData2(method) {
    defaults2.headers[method] = {};
  });
  utils2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
    defaults2.headers[method] = utils2.merge(DEFAULT_CONTENT_TYPE);
  });
  defaults_1 = defaults2;
  return defaults_1;
}
var utils$4 = utils$8;
var defaults$2 = requireDefaults();
var transformData$1 = function transformData2(data2, headers, fns) {
  var context = this || defaults$2;
  utils$4.forEach(fns, function transform(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1;
var hasRequiredIsCancel;
function requireIsCancel() {
  if (hasRequiredIsCancel)
    return isCancel$1;
  hasRequiredIsCancel = 1;
  isCancel$1 = function isCancel2(value) {
    return !!(value && value.__CANCEL__);
  };
  return isCancel$1;
}
var utils$3 = utils$8;
var transformData = transformData$1;
var isCancel = requireIsCancel();
var defaults$1 = requireDefaults();
var Cancel = requireCancel();
function throwIfCancellationRequested(config2) {
  if (config2.cancelToken) {
    config2.cancelToken.throwIfRequested();
  }
  if (config2.signal && config2.signal.aborted) {
    throw new Cancel("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest2(config2) {
  throwIfCancellationRequested(config2);
  config2.headers = config2.headers || {};
  config2.data = transformData.call(
    config2,
    config2.data,
    config2.headers,
    config2.transformRequest
  );
  config2.headers = utils$3.merge(
    config2.headers.common || {},
    config2.headers[config2.method] || {},
    config2.headers
  );
  utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config2.headers[method];
    }
  );
  var adapter = config2.adapter || defaults$1.adapter;
  return adapter(config2).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config2);
    response.data = transformData.call(
      config2,
      response.data,
      response.headers,
      config2.transformResponse
    );
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config2);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config2,
          reason.response.data,
          reason.response.headers,
          config2.transformResponse
        );
      }
    }
    return Promise.reject(reason);
  });
};
var utils$2 = utils$8;
var mergeConfig$2 = function mergeConfig2(config1, config2) {
  config2 = config2 || {};
  var config3 = {};
  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$2.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config3[prop] = configValue);
  });
  return config3;
};
var data;
var hasRequiredData;
function requireData() {
  if (hasRequiredData)
    return data;
  hasRequiredData = 1;
  data = {
    "version": "0.24.0"
  };
  return data;
}
var VERSION = requireData().version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$1 = utils$8;
var buildURL = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request2(config2) {
  if (typeof config2 === "string") {
    config2 = arguments[1] || {};
    config2.url = arguments[0];
  } else {
    config2 = config2 || {};
  }
  config2 = mergeConfig$1(this.defaults, config2);
  if (config2.method) {
    config2.method = config2.method.toLowerCase();
  } else if (this.defaults.method) {
    config2.method = this.defaults.method.toLowerCase();
  } else {
    config2.method = "get";
  }
  var transitional2 = config2.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config2);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config2;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config2) {
  config2 = mergeConfig$1(this.defaults, config2);
  return buildURL(config2.url, config2.params, config2.paramsSerializer).replace(/^\?/, "");
};
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios$1.prototype[method] = function(url, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url,
      data: (config2 || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  Axios$1.prototype[method] = function(url, data2, config2) {
    return this.request(mergeConfig$1(config2 || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var CancelToken_1;
var hasRequiredCancelToken;
function requireCancelToken() {
  if (hasRequiredCancelToken)
    return CancelToken_1;
  hasRequiredCancelToken = 1;
  var Cancel2 = requireCancel();
  function CancelToken(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve2) {
      resolvePromise = resolve2;
    });
    var token = this;
    this.promise.then(function(cancel) {
      if (!token._listeners)
        return;
      var i;
      var l = token._listeners.length;
      for (i = 0; i < l; i++) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = function(onfulfilled) {
      var _resolve;
      var promise = new Promise(function(resolve2) {
        token.subscribe(resolve2);
        _resolve = resolve2;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message) {
      if (token.reason) {
        return;
      }
      token.reason = new Cancel2(message);
      resolvePromise(token.reason);
    });
  }
  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };
  CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  };
  CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    var index2 = this._listeners.indexOf(listener);
    if (index2 !== -1) {
      this._listeners.splice(index2, 1);
    }
  };
  CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  };
  CancelToken_1 = CancelToken;
  return CancelToken_1;
}
var spread;
var hasRequiredSpread;
function requireSpread() {
  if (hasRequiredSpread)
    return spread;
  hasRequiredSpread = 1;
  spread = function spread2(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };
  return spread;
}
var isAxiosError;
var hasRequiredIsAxiosError;
function requireIsAxiosError() {
  if (hasRequiredIsAxiosError)
    return isAxiosError;
  hasRequiredIsAxiosError = 1;
  isAxiosError = function isAxiosError2(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
  };
  return isAxiosError;
}
var utils = utils$8;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = requireDefaults();
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance2 = bind(Axios.prototype.request, context);
  utils.extend(instance2, Axios.prototype, context);
  utils.extend(instance2, context);
  instance2.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance2;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = requireCancel();
axios$1.CancelToken = requireCancelToken();
axios$1.isCancel = requireIsCancel();
axios$1.VERSION = requireData().version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = requireSpread();
axios$1.isAxiosError = requireIsAxiosError();
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
(function(module2) {
  module2.exports = axios$2.exports;
})(axios$3);
const axios = /* @__PURE__ */ getDefaultExportFromCjs(axios$3.exports);
const requestCreate = (config2, errHandler) => {
  const request3 = axios.create(config2);
  request3.interceptors.response.use((response) => {
    return response.data;
  }, errHandler);
  return request3;
};
requestCreate({
  timeout: 0
});
var __awaiter = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var VideoAccessType;
(function(VideoAccessType2) {
  VideoAccessType2["Immediate"] = "0";
  VideoAccessType2["AfterPreivew"] = "1";
})(VideoAccessType || (VideoAccessType = {}));
var DocumentAccess;
(function(DocumentAccess2) {
  DocumentAccess2["Immediate"] = "0";
  DocumentAccess2["ClickDownload"] = "1";
  DocumentAccess2["PreviewEnd"] = "2";
})(DocumentAccess || (DocumentAccess = {}));
function resourceApi(target, data2, freeLogin) {
  return proxyApi({ module: "resource", target, data: data2, freeLogin });
}
function getDocumentConfig(hashId = config.uaId) {
  return resourceApi("documentDetail", {
    hashId
  }, 1);
}
function sendDoc2Mail(resourceIds, email, freeLogin = 1) {
  return __awaiter(this, void 0, void 0, function* () {
    return resourceApi("documentSendToMail", {
      resourceIds,
      email
    }, freeLogin);
  });
}
var SendVaildCodeStatus;
(function(SendVaildCodeStatus2) {
  SendVaildCodeStatus2["Ok"] = "0";
  SendVaildCodeStatus2["NoNeed"] = "1";
  SendVaildCodeStatus2["TryAgainLater"] = "2";
})(SendVaildCodeStatus || (SendVaildCodeStatus = {}));
var StaffLoginStatus;
(function(StaffLoginStatus2) {
  StaffLoginStatus2["Error"] = "-1";
  StaffLoginStatus2["Ok"] = "200";
  StaffLoginStatus2["NotFoundStaff"] = "404";
  StaffLoginStatus2["ErrorPhoneValidCode"] = "409";
  StaffLoginStatus2["ErrorMailboxValidCode"] = "410";
})(StaffLoginStatus || (StaffLoginStatus = {}));
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var AuditStatus;
(function(AuditStatus2) {
  AuditStatus2["pending"] = "0";
  AuditStatus2["fullfilled"] = "1";
  AuditStatus2["reject"] = "-1";
})(AuditStatus || (AuditStatus = {}));
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var PointRecodsType;
(function(PointRecodsType2) {
  PointRecodsType2[PointRecodsType2["Manual"] = 0] = "Manual";
  PointRecodsType2[PointRecodsType2["PlaceOrder"] = 1] = "PlaceOrder";
  PointRecodsType2[PointRecodsType2["TriggerPointRule"] = 2] = "TriggerPointRule";
  PointRecodsType2[PointRecodsType2["Import"] = 3] = "Import";
  PointRecodsType2[PointRecodsType2["ThirdParty"] = 4] = "ThirdParty";
})(PointRecodsType || (PointRecodsType = {}));
var OrderState;
(function(OrderState2) {
  OrderState2["CheckPending"] = "0";
  OrderState2["Rejected"] = "1";
  OrderState2["NotShipped"] = "2";
  OrderState2["Shipped"] = "3";
})(OrderState || (OrderState = {}));
var ActionStatus;
(function(ActionStatus2) {
  ActionStatus2["inactive"] = "0";
  ActionStatus2["active"] = "1";
})(ActionStatus || (ActionStatus = {}));
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve2) {
      resolve2(value);
    });
  }
  return new (P || (P = Promise))(function(resolve2, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var LogStatus;
(function(LogStatus2) {
  LogStatus2[LogStatus2["pending"] = 0] = "pending";
  LogStatus2[LogStatus2["fullfilled"] = 1] = "fullfilled";
  LogStatus2[LogStatus2["reject"] = 2] = "reject";
})(LogStatus || (LogStatus = {}));
const Send_Document_Mail = "Send_Document_Mail";
const _hoisted_1$1 = { class: "cp-px-8 cp-py-4 cp-w-80" };
const _hoisted_2$1 = /* @__PURE__ */ createBaseVNode("h4", { class: "cp-text-center cp-font-medium cp-mb-4" }, "\u53D1\u9001\u81F3\u90AE\u7BB1", -1);
const _hoisted_3 = ["onKeyup"];
const _hoisted_4 = { class: "cp-w-full cp-flex cp-justify-between cp-px-4 cp-mt-2" };
const _hoisted_5 = /* @__PURE__ */ createTextVNode("\u53D6\u6D88");
const _hoisted_6 = /* @__PURE__ */ createTextVNode("\u53D1\u9001");
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "MailModal",
  props: {
    config: null,
    show: { type: Boolean }
  },
  emits: ["update:show"],
  setup(__props, { emit: emit2 }) {
    const props = __props;
    const mail = ref(getStorage(Send_Document_Mail) || ""), mailVisible = computed({
      get: () => props.show,
      set(v) {
        emit2("update:show", v);
      }
    }), errorText = ref(""), mailRef = ref();
    function switchMailVisible() {
      mailVisible.value = !mailVisible.value;
      if (mailVisible.value) {
        nextTick(() => {
          var _a2;
          return (_a2 = mailRef.value) == null ? void 0 : _a2.focus();
        });
      }
    }
    const loading = ref(false);
    async function sendMail() {
      try {
        loading.value = true;
        if (/^[\w-.]+@[a-z0-9-_.]+\.+\w+$/.test(mail.value)) {
          errorText.value = "";
          if (!props.config.hashId)
            return;
          const { limitType } = await checkAccess();
          await sendDoc2Mail([props.config.hashId], mail.value, isInFrame ? 1 : limitType === "nothing" ? 1 : 0);
          mailDocview({
            title: document.title,
            name: props.config.name,
            source: props.config.source,
            mail: mail.value
          });
          switchMailVisible();
          setStorage(Send_Document_Mail, mail.value);
          Dialog({ title: "\u90AE\u4EF6\u53D1\u9001\u6210\u529F", message: "\u8BF7\u81F3\u90AE\u7BB1\u67E5\u6536" });
        } else {
          errorText.value = "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7BB1";
        }
      } finally {
        loading.value = false;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Popup), {
        show: unref(mailVisible),
        "onUpdate:show": _cache[1] || (_cache[1] = ($event) => isRef(mailVisible) ? mailVisible.value = $event : null),
        round: ""
      }, {
        default: withCtx(() => [
          createBaseVNode("div", _hoisted_1$1, [
            _hoisted_2$1,
            withDirectives(createBaseVNode("input", {
              ref_key: "mailRef",
              ref: mailRef,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => mail.value = $event),
              type: "text",
              placeholder: "\u8BF7\u8F93\u5165\u90AE\u7BB1\u5730\u5740",
              class: "cp-w-full cp-border cp-rounded cp-py-2 cp-pl-2",
              onKeyup: withKeys(sendMail, ["enter"])
            }, null, 40, _hoisted_3), [
              [vModelText, mail.value]
            ]),
            withDirectives(createBaseVNode("span", { class: "cp-text-xs cp-text-red-600" }, toDisplayString(errorText.value), 513), [
              [vShow, errorText.value]
            ]),
            createBaseVNode("div", _hoisted_4, [
              createVNode(unref(Button), { onClick: switchMailVisible }, {
                default: withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              createVNode(unref(Button), {
                type: "primary",
                loading: loading.value,
                onClick: sendMail
              }, {
                default: withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"]);
    };
  }
});
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
  key: 1,
  class: "cp-fixed cp-left-0 cp-top-0 cp-w-full cp-h-full cp-flex cp-justify-center cp-items-center cp-bg-gray-200 cp-text-2xl"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RenderView",
  props: {
    source: null,
    uaId: null,
    pdfInfo: null,
    onLoaded: null,
    onEnd: null,
    onButtonClicked: null,
    viewParams: null,
    iniPageAmout: null,
    offset: null
  },
  setup(__props) {
    const props = __props;
    const baseImgUrl = "https://custouch-cloud.oss-cn-hangzhou.aliyuncs.com/cus_files/custouch/site/image/resource-pdf/v1/";
    const defaultButtonOptions = {
      type: "vertical",
      accessType: DocumentAccess.Immediate,
      maxPage: 0,
      buttonIcons: {
        toggleTrueIcon: baseImgUrl + "toggleTrue.png",
        toggleFalseIcon: baseImgUrl + "toggleFalse.png",
        width: 46,
        height: 46,
        position: {
          x: {
            key: "right",
            value: 16
          },
          y: {
            key: "bottom",
            value: 46
          }
        },
        spacing: 16
      },
      actions: [
        {
          id: 0,
          icon: baseImgUrl + "download.png",
          text: "\u4E0B\u8F7D",
          showText: true,
          visible: false
        },
        {
          id: 1,
          icon: baseImgUrl + "email.png",
          text: "\u53D1\u9001\u81F3\u90AE\u7BB1",
          showText: true,
          visible: false
        },
        {
          id: 2,
          icon: baseImgUrl + "share.png",
          text: "\u5206\u4EAB",
          showText: true,
          visible: false
        }
      ]
    };
    const pdfUrl = computed(() => {
      var _a2;
      return props.uaId ? (_a2 = pdfInfo.value) == null ? void 0 : _a2.downloadUrl : props.source;
    }), buttonOptions = computed(() => {
      var _a2, _b, _c, _d, _e, _f, _g, _h;
      let originConfig = ((_c = (_b = (_a2 = pdfInfo.value) == null ? void 0 : _a2.documentConfigDto) == null ? void 0 : _b.detail) == null ? void 0 : _c.type) ? (_e = (_d = pdfInfo.value) == null ? void 0 : _d.documentConfigDto) == null ? void 0 : _e.detail : defaultButtonOptions;
      if (!((_f = pdfInfo.value) == null ? void 0 : _f.documentConfigDto) || ((_h = (_g = pdfInfo.value) == null ? void 0 : _g.documentConfigDto) == null ? void 0 : _h.isByDefault)) {
        ["showDownload", "showMail", "showShare"].forEach((oldKey, index2) => {
          var _a3;
          const k = oldKey;
          const oldValue = (_a3 = config2.value) == null ? void 0 : _a3[k];
          if (oldValue != null) {
            originConfig.actions[index2].visible = oldValue;
          }
        });
        ["accessType", "maxPage"].forEach((oldKey) => {
          var _a3;
          const k = oldKey;
          const oldValue = (_a3 = config2.value) == null ? void 0 : _a3[k];
          if (oldValue != null) {
            originConfig[k] = oldValue;
          }
        });
        return originConfig;
      }
      return pdfInfo.value.documentConfigDto.detail;
    });
    const isValid = ref(false), isLoaded = ref(false);
    const fetchedPdfInfo = ref();
    const pdfInfo = computed(() => {
      var _a2;
      return (_a2 = props.pdfInfo) != null ? _a2 : fetchedPdfInfo.value;
    });
    const config2 = computed(() => {
      var _a2;
      return (_a2 = pdfInfo.value) == null ? void 0 : _a2.config;
    });
    const isType0 = computed(() => {
      var _a2;
      return ((_a2 = buttonOptions.value) == null ? void 0 : _a2.accessType) === DocumentAccess.Immediate;
    });
    const isType1 = computed(() => {
      var _a2;
      return ((_a2 = buttonOptions.value) == null ? void 0 : _a2.accessType) === DocumentAccess.ClickDownload;
    });
    const isType2 = computed(() => {
      var _a2;
      return ((_a2 = buttonOptions.value) == null ? void 0 : _a2.accessType) === DocumentAccess.PreviewEnd;
    });
    const maxPage = ref();
    let redirect, hasRight = false;
    async function init() {
      var _a2, _b;
      if (props.uaId) {
        const res = await checkAccess(props.uaId);
        redirect = res.redirect;
        hasRight = res.success;
        if (isType0.value) {
          isValid.value = hasRight;
          goRedirect();
        } else {
          isValid.value = true;
        }
        if (isValid.value) {
          if (!props.pdfInfo) {
            fetchedPdfInfo.value = await getDocumentConfig(props.uaId);
          }
          maxPage.value = isType2.value ? (_a2 = buttonOptions.value) == null ? void 0 : _a2.maxPage : void 0;
          if (!pdfInfo.value)
            return;
          const t2 = {
            title: pdfInfo.value.name,
            source: pdfInfo.value.source,
            name: pdfInfo.value.name
          };
          if (!isFrame()) {
            ((_b = props.viewParams) == null ? void 0 : _b.uaId) && documentview(Object.assign({}, t2, props.viewParams));
            documentview(t2);
          }
        } else if (!redirect) {
          isLoaded.value = true;
        }
      } else {
        isValid.value = true;
      }
    }
    function goRedirect() {
      return redirect && (window.location.href = concatURI(redirect, { c_default_redirect: window.location.href }));
    }
    const showMailModal = ref(false);
    async function buttonClicked(item) {
      var _a2, _b;
      if (item.id == 0) {
        isType1.value && goRedirect();
        hasRight && goDownload();
      } else if (item.id == 1) {
        showMailModal.value = true;
      } else if (item.id == 2 && pdfInfo.value) {
        const t2 = {
          title: pdfInfo.value.name,
          remark: "\u5206\u4EAB\u6587\u6863"
        };
        ((_a2 = props.viewParams) == null ? void 0 : _a2.uaId) && shareview(Object.assign({}, t2, props.viewParams));
        shareview(t2);
      }
      (_b = props.onButtonClicked) == null ? void 0 : _b.call(props, item);
    }
    function onLoad(page) {
      var _a2;
      (_a2 = props.onLoaded) == null ? void 0 : _a2.call(props, page);
    }
    async function goDownload() {
      var _a2;
      if (pdfInfo.value) {
        const t2 = {
          title: pdfInfo.value.name,
          source: pdfInfo.value.source,
          name: pdfInfo.value.name
        };
        ((_a2 = props.viewParams) == null ? void 0 : _a2.uaId) && downloadview(Object.assign({}, t2, props.viewParams));
        downloadview(t2);
        await sleep(50);
      }
      if (props.source) {
        window.location.href = props.source;
      }
    }
    let checkLoading = false;
    async function onEnd(params) {
      var _a2;
      (_a2 = props.onEnd) == null ? void 0 : _a2.call(props, params);
      if (params.maxPage >= params.total || checkLoading)
        return;
      checkLoading = true;
      if (isType2.value) {
        const { redirect: redirect2, success } = await checkAccess();
        if (success) {
          maxPage.value = void 0;
          return;
        }
        try {
          if (redirect2) {
            await Dialog.confirm({
              message: "\u63D0\u4EA4\u5B8C\u95EE\u5377\u624D\u80FD\u7EE7\u7EED\u6D4F\u89C8\u54E6",
              confirmButtonText: "\u53BB\u586B\u5199"
            });
            window.location.replace(redirect2);
          } else {
            Dialog.alert({
              message: "\u6682\u65F6\u65E0\u6CD5\u67E5\u770B\u66F4\u591A"
            });
          }
        } catch {
          return;
        } finally {
          checkLoading = false;
        }
      }
    }
    init();
    return (_ctx, _cache) => {
      var _a2, _b, _c, _d, _e;
      return isValid.value ? (openBlock(), createElementBlock("div", _hoisted_1, [
        unref(pdfUrl) ? (openBlock(), createBlock(unref(_sfc_main$9), {
          key: 0,
          "hash-id": __props.uaId,
          "pdf-url": unref(pdfUrl),
          pages: (_b = (_a2 = unref(pdfInfo)) == null ? void 0 : _a2.pdfInfo) == null ? void 0 : _b.pages,
          "max-page": maxPage.value,
          "button-options": unref(buttonOptions),
          "wm-options": ((_d = (_c = unref(config2)) == null ? void 0 : _c.wmOptions) == null ? void 0 : _d.enabled) ? unref(config2).wmOptions : void 0,
          type: (_e = unref(config2)) == null ? void 0 : _e.type,
          "ini-page-amout": __props.iniPageAmout,
          offset: __props.offset,
          onButtonClicked: buttonClicked,
          onEnd,
          onLoaded: onLoad
        }, null, 8, ["hash-id", "pdf-url", "pages", "max-page", "button-options", "wm-options", "type", "ini-page-amout", "offset"])) : createCommentVNode("", true),
        unref(pdfInfo) ? (openBlock(), createBlock(_sfc_main$1, {
          key: 1,
          show: showMailModal.value,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event) => showMailModal.value = $event),
          config: unref(pdfInfo)
        }, null, 8, ["show", "config"])) : createCommentVNode("", true)
      ])) : isLoaded.value ? (openBlock(), createElementBlock("div", _hoisted_2, " Access Denied ")) : createCommentVNode("", true);
    };
  }
});
const apps = {};
const render = (selector, props) => {
  var _a2;
  const source = props.source;
  let container;
  if (typeof selector === "string") {
    container = document.querySelector(selector);
  } else {
    container = selector;
  }
  if (!container)
    return;
  const UAID = source.startsWith("https://download.") ? (_a2 = source.split("?")[0].match(/[^/]+$/)) == null ? void 0 : _a2[0] : isSafeURI(source) ? void 0 : source;
  if (UAID) {
    setConfig({ accessType: "system_document", uaId: UAID, actionPrefix: "" });
  }
  if (apps[source]) {
    apps[source].unmount();
  }
  apps[source] = createApp(_sfc_main, Object.assign(props, { uaId: UAID }));
  return { instance: apps[source].mount(container), unmount: () => unmount(source) };
};
function unmount(source) {
  if (source) {
    apps[source].unmount();
  } else {
    for (const app of Object.values(apps)) {
      app.unmount();
    }
  }
}
const useRenderView = { render, unmount };
export {
  useRenderView as pdfRender,
  reactive
};
